// ref : https://github.com/e-MediSkill/eMediSkill-webApp/blob/version2/src/assets/countryCode.json
export const countryWithRegions = [
    {
        "countryCode": "+91",
        "value": "India",
        "label": "India",
        "regions": [
            {
                "value": "Andaman and Nicobar Islands",
                "label": "Andaman and Nicobar Islands",
                "shortCode": "AN"
            },
            {
                "value": "Andhra Pradesh",
                "label": "Andhra Pradesh",
                "shortCode": "AP"
            },
            {
                "value": "Arunachal Pradesh",
                "label": "Arunachal Pradesh",
                "shortCode": "AR"
            },
            {
                "value": "Assam",
                "label": "Assam",
                "shortCode": "AS"
            },
            {
                "value": "Bihar",
                "label": "Bihar",
                "shortCode": "BR"
            },
            {
                "value": "Chandigarh",
                "label": "Chandigarh",
                "shortCode": "CH"
            },
            {
                "value": "Chhattisgarh",
                "label": "Chhattisgarh",
                "shortCode": "CT"
            },
            {
                "value": "Dadra and Nagar Haveli and Daman and Diu",
                "label": "Dadra and Nagar Haveli and Daman and Diu",
                "shortCode": "DH"
            },
            {
                "value": "Delhi",
                "label": "Delhi",
                "shortCode": "DL"
            },
            {
                "value": "Goa",
                "label": "Goa",
                "shortCode": "GA"
            },
            {
                "value": "Gujarat",
                "label": "Gujarat",
                "shortCode": "GJ"
            },
            {
                "value": "Haryana",
                "label": "Haryana",
                "shortCode": "HR"
            },
            {
                "value": "Himachal Pradesh",
                "label": "Himachal Pradesh",
                "shortCode": "HP"
            },
            {
                "value": "Jammu and Kashmir",
                "label": "Jammu and Kashmir",
                "shortCode": "JK"
            },
            {
                "value": "Jharkhand",
                "label": "Jharkhand",
                "shortCode": "JH"
            },
            {
                "value": "Karnataka",
                "label": "Karnataka",
                "shortCode": "KA"
            },
            {
                "value": "Kerala",
                "label": "Kerala",
                "shortCode": "KL"
            },
            {
                "value": "Ladakh",
                "label": "Ladakh",
                "shortCode": "LA"
            },
            {
                "value": "Lakshadweep",
                "label": "Lakshadweep",
                "shortCode": "LD"
            },
            {
                "value": "Madhya Pradesh",
                "label": "Madhya Pradesh",
                "shortCode": "MP"
            },
            {
                "value": "Maharashtra",
                "label": "Maharashtra",
                "shortCode": "MH"
            },
            {
                "value": "Manipur",
                "label": "Manipur",
                "shortCode": "MN"
            },
            {
                "value": "Meghalaya",
                "label": "Meghalaya",
                "shortCode": "ML"
            },
            {
                "value": "Mizoram",
                "label": "Mizoram",
                "shortCode": "MZ"
            },
            {
                "value": "Nagaland",
                "label": "Nagaland",
                "shortCode": "NL"
            },
            {
                "value": "Odisha",
                "label": "Odisha",
                "shortCode": "OR"
            },
            {
                "value": "Puducherry",
                "label": "Puducherry",
                "shortCode": "PY"
            },
            {
                "value": "Punjab",
                "label": "Punjab",
                "shortCode": "PB"
            },
            {
                "value": "Rajasthan",
                "label": "Rajasthan",
                "shortCode": "RJ"
            },
            {
                "value": "Sikkim",
                "label": "Sikkim",
                "shortCode": "SK"
            },
            {
                "value": "Tamil Nadu",
                "label": "Tamil Nadu",
                "shortCode": "TN"
            },
            {
                "value": "Telangana",
                "label": "Telangana",
                "shortCode": "TG"
            },
            {
                "value": "Tripura",
                "label": "Tripura",
                "shortCode": "TR"
            },
            {
                "value": "Uttarakhand",
                "label": "Uttarakhand",
                "shortCode": "UT"
            },
            {
                "value": "Uttar Pradesh",
                "label": "Uttar Pradesh",
                "shortCode": "UP"
            },
            {
                "value": "West Bengal",
                "label": "West Bengal",
                "shortCode": "WB"
            }
        ]
    },
    {
        "countryCode": "+93",
        "value": "Afghanistan",
        "label": "Afghanistan",
        "regions": [
            {
                "value": "Badakhshan",
                "label": "Badakhshan",
                "shortCode": "BDS"
            },
            {
                "value": "Badghis",
                "label": "Badghis",
                "shortCode": "BDG"
            },
            {
                "value": "Baghlan",
                "label": "Baghlan",
                "shortCode": "BGL"
            },
            {
                "value": "Balkh",
                "label": "Balkh",
                "shortCode": "BAL"
            },
            {
                "value": "Bamyan",
                "label": "Bamyan",
                "shortCode": "BAM"
            },
            {
                "value": "Daykundi",
                "label": "Daykundi",
                "shortCode": "DAY"
            },
            {
                "value": "Farah",
                "label": "Farah",
                "shortCode": "FRA"
            },
            {
                "value": "Faryab",
                "label": "Faryab",
                "shortCode": "FYB"
            },
            {
                "value": "Ghazni",
                "label": "Ghazni",
                "shortCode": "GHA"
            },
            {
                "value": "Ghor",
                "label": "Ghor",
                "shortCode": "GHO"
            },
            {
                "value": "Helmand",
                "label": "Helmand",
                "shortCode": "HEL"
            },
            {
                "value": "Herat",
                "label": "Herat",
                "shortCode": "HER"
            },
            {
                "value": "Jowzjan",
                "label": "Jowzjan",
                "shortCode": "JOW"
            },
            {
                "value": "Kabul",
                "label": "Kabul",
                "shortCode": "KAB"
            },
            {
                "value": "Kandahar",
                "label": "Kandahar",
                "shortCode": "KAN"
            },
            {
                "value": "Kapisa",
                "label": "Kapisa",
                "shortCode": "KAP"
            },
            {
                "value": "Khost",
                "label": "Khost",
                "shortCode": "KHO"
            },
            {
                "value": "Kunar",
                "label": "Kunar",
                "shortCode": "KNR"
            },
            {
                "value": "Kunduz",
                "label": "Kunduz",
                "shortCode": "KDZ"
            },
            {
                "value": "Laghman",
                "label": "Laghman",
                "shortCode": "LAG"
            },
            {
                "value": "Logar",
                "label": "Logar",
                "shortCode": "LOW"
            },
            {
                "value": "Maidan Wardak",
                "label": "Maidan Wardak",
                "shortCode": "WAR"
            },
            {
                "value": "Nangarhar",
                "label": "Nangarhar",
                "shortCode": "NAN"
            },
            {
                "value": "Nimruz",
                "label": "Nimruz",
                "shortCode": "NIM"
            },
            {
                "value": "Nuristan",
                "label": "Nuristan",
                "shortCode": "NUR"
            },
            {
                "value": "Paktia",
                "label": "Paktia",
                "shortCode": "PIA"
            },
            {
                "value": "Paktika",
                "label": "Paktika",
                "shortCode": "PKA"
            },
            {
                "value": "Panjshir",
                "label": "Panjshir",
                "shortCode": "PAN"
            },
            {
                "value": "Parwan",
                "label": "Parwan",
                "shortCode": "PAR"
            },
            {
                "value": "Samangan",
                "label": "Samangan",
                "shortCode": "SAM"
            },
            {
                "value": "Sar-e Pol",
                "label": "Sar-e Pol",
                "shortCode": "SAR"
            },
            {
                "value": "Takhar",
                "label": "Takhar",
                "shortCode": "TAK"
            },
            {
                "value": "Urozgan",
                "label": "Urozgan",
                "shortCode": "ORU"
            },
            {
                "value": "Zabul",
                "label": "Zabul",
                "shortCode": "ZAB"
            }
        ]
    },
    {
        "countryCode": "+355",
        "value": "Albania",
        "label": "Albania",
        "regions": [
            {
                "value": "Berat",
                "label": "Berat",
                "shortCode": "01"
            },
            {
                "value": "Dibër",
                "label": "Dibër",
                "shortCode": "09"
            },
            {
                "value": "Durrës",
                "label": "Durrës",
                "shortCode": "02"
            },
            {
                "value": "Elbasan",
                "label": "Elbasan",
                "shortCode": "03"
            },
            {
                "value": "Fier",
                "label": "Fier",
                "shortCode": "04"
            },
            {
                "value": "Gjirokastër",
                "label": "Gjirokastër",
                "shortCode": "05"
            },
            {
                "value": "Korçë",
                "label": "Korçë",
                "shortCode": "06"
            },
            {
                "value": "Kukës",
                "label": "Kukës",
                "shortCode": "07"
            },
            {
                "value": "Lezhë",
                "label": "Lezhë",
                "shortCode": "08"
            },
            {
                "value": "Shkodër",
                "label": "Shkodër",
                "shortCode": "10"
            },
            {
                "value": "Tirana",
                "label": "Tirana",
                "shortCode": "11"
            },
            {
                "value": "Vlorë",
                "label": "Vlorë",
                "shortCode": "12"
            }
        ]
    },
    {
        "countryCode": "+213",
        "value": "Algeria",
        "label": "Algeria",
        "regions": [
            {
                "value": "Adrar",
                "label": "Adrar",
                "shortCode": "01"
            },
            {
                "value": "Aïn Defla",
                "label": "Aïn Defla",
                "shortCode": "44"
            },
            {
                "value": "Aïn Témouchent",
                "label": "Aïn Témouchent",
                "shortCode": "46"
            },
            {
                "value": "Algiers",
                "label": "Algiers",
                "shortCode": "16"
            },
            {
                "value": "Annaba",
                "label": "Annaba",
                "shortCode": "23"
            },
            {
                "value": "Batna",
                "label": "Batna",
                "shortCode": "05"
            },
            {
                "value": "Béchar",
                "label": "Béchar",
                "shortCode": "08"
            },
            {
                "value": "Béjaïa",
                "label": "Béjaïa",
                "shortCode": "06"
            },
            {
                "value": "Biskra",
                "label": "Biskra",
                "shortCode": "07"
            },
            {
                "value": "Blida",
                "label": "Blida",
                "shortCode": "09"
            },
            {
                "value": "Bordj Bou Arréridj",
                "label": "Bordj Bou Arréridj",
                "shortCode": "34"
            },
            {
                "value": "Bouïra",
                "label": "Bouïra",
                "shortCode": "10"
            },
            {
                "value": "Boumerdès",
                "label": "Boumerdès",
                "shortCode": "35"
            },
            {
                "value": "Chlef",
                "label": "Chlef",
                "shortCode": "02"
            },
            {
                "value": "Constantine",
                "label": "Constantine",
                "shortCode": "25"
            },
            {
                "value": "Djelfa",
                "label": "Djelfa",
                "shortCode": "17"
            },
            {
                "value": "El Bayadh",
                "label": "El Bayadh",
                "shortCode": "32"
            },
            {
                "value": "El Oued",
                "label": "El Oued",
                "shortCode": "39"
            },
            {
                "value": "El Tarf",
                "label": "El Tarf",
                "shortCode": "36"
            },
            {
                "value": "Ghardaïa",
                "label": "Ghardaïa",
                "shortCode": "47"
            },
            {
                "value": "Guelma",
                "label": "Guelma",
                "shortCode": "24"
            },
            {
                "value": "Illizi",
                "label": "Illizi",
                "shortCode": "33"
            },
            {
                "value": "Jijel",
                "label": "Jijel",
                "shortCode": "18"
            },
            {
                "value": "Khenchela",
                "label": "Khenchela",
                "shortCode": "40"
            },
            {
                "value": "Laghouat",
                "label": "Laghouat",
                "shortCode": "03"
            },
            {
                "value": "Mascara",
                "label": "Mascara",
                "shortCode": "29"
            },
            {
                "value": "Médéa",
                "label": "Médéa",
                "shortCode": "26"
            },
            {
                "value": "Mila",
                "label": "Mila",
                "shortCode": "43"
            },
            {
                "value": "Mostaganem",
                "label": "Mostaganem",
                "shortCode": "27"
            },
            {
                "value": "Msila",
                "label": "Msila",
                "shortCode": "28"
            },
            {
                "value": "Naâma",
                "label": "Naâma",
                "shortCode": "45"
            },
            {
                "value": "Oran",
                "label": "Oran",
                "shortCode": "31"
            },
            {
                "value": "Ouargla",
                "label": "Ouargla",
                "shortCode": "30"
            },
            {
                "value": "Oum el Bouaghi",
                "label": "Oum el Bouaghi",
                "shortCode": "04"
            },
            {
                "value": "Relizane",
                "label": "Relizane",
                "shortCode": "48"
            },
            {
                "value": "Saïda",
                "label": "Saïda",
                "shortCode": "20"
            },
            {
                "value": "Sétif",
                "label": "Sétif",
                "shortCode": "19"
            },
            {
                "value": "Sidi Bel Abbès",
                "label": "Sidi Bel Abbès",
                "shortCode": "22"
            },
            {
                "value": "Skikda",
                "label": "Skikda",
                "shortCode": "21"
            },
            {
                "value": "Souk Ahras",
                "label": "Souk Ahras",
                "shortCode": "41"
            },
            {
                "value": "Tamanghasset",
                "label": "Tamanghasset",
                "shortCode": "11"
            },
            {
                "value": "Tébessa",
                "label": "Tébessa",
                "shortCode": "12"
            },
            {
                "value": "Tiaret",
                "label": "Tiaret",
                "shortCode": "14"
            },
            {
                "value": "Tindouf",
                "label": "Tindouf",
                "shortCode": "37"
            },
            {
                "value": "Tipaza",
                "label": "Tipaza",
                "shortCode": "42"
            },
            {
                "value": "Tissemsilt",
                "label": "Tissemsilt",
                "shortCode": "38"
            },
            {
                "value": "Tizi Ouzou",
                "label": "Tizi Ouzou",
                "shortCode": "15"
            },
            {
                "value": "Tlemcen",
                "label": "Tlemcen",
                "shortCode": "13"
            }
        ]
    },
    {
        "countryCode": "+1 684",
        "value": "American Samoa",
        "label": "American Samoa",
        "regions": [
            {
                "value": "Tutuila",
                "label": "Tutuila",
                "shortCode": "01"
            },
            {
                "value": "Aunu'u",
                "label": "Aunu'u",
                "shortCode": "02"
            },
            {
                "value": "Ta'ū",
                "label": "Ta'ū",
                "shortCode": "03"
            },
            {
                "value": "Ofu‑Olosega",
                "label": "Ofu‑Olosega",
                "shortCode": "04"
            },
            {
                "value": "Rose Atoll",
                "label": "Rose Atoll",
                "shortCode": "21"
            },
            {
                "value": "Swains Island",
                "label": "Swains Island",
                "shortCode": "22"
            }
        ]
    },
    {
        "countryCode": "+376",
        "value": "Andorra",
        "label": "Andorra",
        "regions": [
            {
                "value": "Andorra la Vella",
                "label": "Andorra la Vella",
                "shortCode": "07"
            },
            {
                "value": "Canillo",
                "label": "Canillo",
                "shortCode": "02"
            },
            {
                "value": "Encamp",
                "label": "Encamp",
                "shortCode": "03"
            },
            {
                "value": "Escaldes-Engordany",
                "label": "Escaldes-Engordany",
                "shortCode": "08"
            },
            {
                "value": "La Massana",
                "label": "La Massana",
                "shortCode": "04"
            },
            {
                "value": "Ordino",
                "label": "Ordino",
                "shortCode": "05"
            },
            {
                "value": "Sant Julià de Lòria",
                "label": "Sant Julià de Lòria",
                "shortCode": "06"
            }
        ]
    },
    {
        "countryCode": "+244",
        "value": "Angola",
        "label": "Angola",
        "regions": [
            {
                "value": "Bengo",
                "label": "Bengo",
                "shortCode": "BGO"
            },
            {
                "value": "Benguela",
                "label": "Benguela",
                "shortCode": "BGU"
            },
            {
                "value": "Bié",
                "label": "Bié",
                "shortCode": "BIE"
            },
            {
                "value": "Cabinda",
                "label": "Cabinda",
                "shortCode": "CAB"
            },
            {
                "value": "Cuando Cubango",
                "label": "Cuando Cubango",
                "shortCode": "CCU"
            },
            {
                "value": "Cuanza Norte",
                "label": "Cuanza Norte",
                "shortCode": "CNO"
            },
            {
                "value": "Cuanza Sul",
                "label": "Cuanza Sul",
                "shortCode": "CUS"
            },
            {
                "value": "Cunene",
                "label": "Cunene",
                "shortCode": "CNN"
            },
            {
                "value": "Huambo",
                "label": "Huambo",
                "shortCode": "HUA"
            },
            {
                "value": "Huíla",
                "label": "Huíla",
                "shortCode": "HUI"
            },
            {
                "value": "Luanda",
                "label": "Luanda",
                "shortCode": "LUA"
            },
            {
                "value": "Lunda Norte",
                "label": "Lunda Norte",
                "shortCode": "LNO"
            },
            {
                "value": "Lunda Sul",
                "label": "Lunda Sul",
                "shortCode": "LSU"
            },
            {
                "value": "Malanje",
                "label": "Malanje",
                "shortCode": "MAL"
            },
            {
                "value": "Moxico",
                "label": "Moxico",
                "shortCode": "MOX"
            },
            {
                "value": "Namibe",
                "label": "Namibe",
                "shortCode": "NAM"
            },
            {
                "value": "Uíge",
                "label": "Uíge",
                "shortCode": "UIG"
            },
            {
                "value": "Zaire",
                "label": "Zaire",
                "shortCode": "ZAI"
            }
        ]
    },
    {
        "countryCode": "+1 264",
        "value": "Anguilla",
        "label": "Anguilla",
        "regions": [
            {
                "value": "Anguilla",
                "label": "Anguilla",
                "shortCode": "01"
            },
            {
                "value": "Anguillita Island",
                "label": "Anguillita Island",
                "shortCode": "02"
            },
            {
                "value": "Blowing Rock",
                "label": "Blowing Rock",
                "shortCode": "03"
            },
            {
                "value": "Cove Cay",
                "label": "Cove Cay",
                "shortCode": "04"
            },
            {
                "value": "Crocus Cay",
                "label": "Crocus Cay",
                "shortCode": "05"
            },
            {
                "value": "Deadman's Cay",
                "label": "Deadman's Cay",
                "shortCode": "06"
            },
            {
                "value": "Dog Island",
                "label": "Dog Island",
                "shortCode": "07"
            },
            {
                "value": "East Cay",
                "label": "East Cay",
                "shortCode": "08"
            },
            {
                "value": "Little Island",
                "label": "Little Island",
                "shortCode": "09"
            },
            {
                "value": "Little Scrub Island",
                "label": "Little Scrub Island",
                "shortCode": "10"
            },
            {
                "value": "Mid Cay",
                "label": "Mid Cay",
                "shortCode": "11"
            },
            {
                "value": "North Cay",
                "label": "North Cay",
                "shortCode": "12"
            },
            {
                "value": "Prickly Pear Cays",
                "label": "Prickly Pear Cays",
                "shortCode": "13"
            },
            {
                "value": "Rabbit Island",
                "label": "Rabbit Island",
                "shortCode": "14"
            },
            {
                "value": "Sandy Island/Sand Island",
                "label": "Sandy Island/Sand Island",
                "shortCode": "15"
            },
            {
                "value": "Scilly Cay",
                "label": "Scilly Cay",
                "shortCode": "16"
            },
            {
                "value": "Scrub Island",
                "label": "Scrub Island",
                "shortCode": "17"
            },
            {
                "value": "Seal Island",
                "label": "Seal Island",
                "shortCode": "18"
            },
            {
                "value": "Sombrero/Hat Island",
                "label": "Sombrero/Hat Island",
                "shortCode": "19"
            },
            {
                "value": "South Cay",
                "label": "South Cay",
                "shortCode": "20"
            },
            {
                "value": "South Wager Island",
                "label": "South Wager Island",
                "shortCode": "21"
            },
            {
                "value": "West Cay",
                "label": "West Cay",
                "shortCode": "22"
            }
        ]
    },
    {
        "countryCode": "+1 268",
        "value": "Antigua and Barbuda",
        "label": "Antigua and Barbuda",
        "regions": [
            {
                "value": "Antigua Island",
                "label": "Antigua Island",
                "shortCode": "01"
            },
            {
                "value": "Barbuda Island",
                "label": "Barbuda Island",
                "shortCode": "02"
            },
            {
                "value": "Bird Island",
                "label": "Bird Island",
                "shortCode": "04"
            },
            {
                "value": "Bishop Island",
                "label": "Bishop Island",
                "shortCode": "05"
            },
            {
                "value": "Blake Island",
                "label": "Blake Island",
                "shortCode": "06"
            },
            {
                "value": "Crump Island",
                "label": "Crump Island",
                "shortCode": "09"
            },
            {
                "value": "Dulcina Island",
                "label": "Dulcina Island",
                "shortCode": "10"
            },
            {
                "value": "Exchange Island",
                "label": "Exchange Island",
                "shortCode": "11"
            },
            {
                "value": "Five Islands",
                "label": "Five Islands",
                "shortCode": "12"
            },
            {
                "value": "Great Bird Island",
                "label": "Great Bird Island",
                "shortCode": "13"
            },
            {
                "value": "Green Island",
                "label": "Green Island",
                "shortCode": "14"
            },
            {
                "value": "Guiana Island",
                "label": "Guiana Island",
                "shortCode": "15"
            },
            {
                "value": "Hawes Island",
                "label": "Hawes Island",
                "shortCode": "17"
            },
            {
                "value": "Hells Gate Island",
                "label": "Hells Gate Island",
                "shortCode": "16"
            },
            {
                "value": "Henry Island",
                "label": "Henry Island",
                "shortCode": "18"
            },
            {
                "value": "Johnson Island",
                "label": "Johnson Island",
                "shortCode": "19"
            },
            {
                "value": "Kid Island",
                "label": "Kid Island",
                "shortCode": "20"
            },
            {
                "value": "Lobster Island",
                "label": "Lobster Island",
                "shortCode": "22"
            },
            {
                "value": "Maiden Island",
                "label": "Maiden Island",
                "shortCode": "24"
            },
            {
                "value": "Moor Island",
                "label": "Moor Island",
                "shortCode": "25"
            },
            {
                "value": "Nanny Island",
                "label": "Nanny Island",
                "shortCode": "26"
            },
            {
                "value": "Pelican Island",
                "label": "Pelican Island",
                "shortCode": "27"
            },
            {
                "value": "Prickly Pear Island",
                "label": "Prickly Pear Island",
                "shortCode": "28"
            },
            {
                "value": "Rabbit Island",
                "label": "Rabbit Island",
                "shortCode": "29"
            },
            {
                "value": "Red Head Island",
                "label": "Red Head Island",
                "shortCode": "31"
            },
            {
                "value": "Redonda Island",
                "label": "Redonda Island",
                "shortCode": "03"
            },
            {
                "value": "Sandy Island",
                "label": "Sandy Island",
                "shortCode": "32"
            },
            {
                "value": "Smith Island",
                "label": "Smith Island",
                "shortCode": "33"
            },
            {
                "value": "The Sisters",
                "label": "The Sisters",
                "shortCode": "34"
            },
            {
                "value": "Vernon Island",
                "label": "Vernon Island",
                "shortCode": "35"
            },
            {
                "value": "Wicked Will Island",
                "label": "Wicked Will Island",
                "shortCode": "36"
            },
            {
                "value": "York Island",
                "label": "York Island",
                "shortCode": "37"
            }
        ]
    },
    {
        "countryCode": "+54",
        "value": "Argentina",
        "label": "Argentina",
        "regions": [
            {
                "value": "Buenos Aires",
                "label": "Buenos Aires",
                "shortCode": "B"
            },
            {
                "value": "Capital Federal",
                "label": "Capital Federal",
                "shortCode": "C"
            },
            {
                "value": "Catamarca",
                "label": "Catamarca",
                "shortCode": "K"
            },
            {
                "value": "Chaco",
                "label": "Chaco",
                "shortCode": "H"
            },
            {
                "value": "Chubut",
                "label": "Chubut",
                "shortCode": "U"
            },
            {
                "value": "Córdoba",
                "label": "Córdoba",
                "shortCode": "X"
            },
            {
                "value": "Corrientes",
                "label": "Corrientes",
                "shortCode": "W"
            },
            {
                "value": "Entre Ríos",
                "label": "Entre Ríos",
                "shortCode": "E"
            },
            {
                "value": "Formosa",
                "label": "Formosa",
                "shortCode": "P"
            },
            {
                "value": "Jujuy",
                "label": "Jujuy",
                "shortCode": "Y"
            },
            {
                "value": "La Pampa",
                "label": "La Pampa",
                "shortCode": "L"
            },
            {
                "value": "La Rioja",
                "label": "La Rioja",
                "shortCode": "F"
            },
            {
                "value": "Mendoza",
                "label": "Mendoza",
                "shortCode": "M"
            },
            {
                "value": "Misiones",
                "label": "Misiones",
                "shortCode": "N"
            },
            {
                "value": "Neuquén",
                "label": "Neuquén",
                "shortCode": "Q"
            },
            {
                "value": "Río Negro",
                "label": "Río Negro",
                "shortCode": "R"
            },
            {
                "value": "Salta",
                "label": "Salta",
                "shortCode": "A"
            },
            {
                "value": "San Juan",
                "label": "San Juan",
                "shortCode": "J"
            },
            {
                "value": "San Luis",
                "label": "San Luis",
                "shortCode": "D"
            },
            {
                "value": "Santa Cruz",
                "label": "Santa Cruz",
                "shortCode": "Z"
            },
            {
                "value": "Santa Fe",
                "label": "Santa Fe",
                "shortCode": "S"
            },
            {
                "value": "Santiago del Estero",
                "label": "Santiago del Estero",
                "shortCode": "G"
            },
            {
                "value": "Tierra del Fuego",
                "label": "Tierra del Fuego",
                "shortCode": "V"
            },
            {
                "value": "Tucumán",
                "label": "Tucumán",
                "shortCode": "T"
            }
        ]
    },
    {
        "countryCode": "+374",
        "value": "Armenia",
        "label": "Armenia",
        "regions": [
            {
                "value": "Aragatsotn",
                "label": "Aragatsotn",
                "shortCode": "AG"
            },
            {
                "value": "Ararat",
                "label": "Ararat",
                "shortCode": "AR"
            },
            {
                "value": "Armavir",
                "label": "Armavir",
                "shortCode": "AV"
            },
            {
                "value": "Gegharkunik",
                "label": "Gegharkunik",
                "shortCode": "GR"
            },
            {
                "value": "Kotayk",
                "label": "Kotayk",
                "shortCode": "KT"
            },
            {
                "value": "Lori",
                "label": "Lori",
                "shortCode": "LO"
            },
            {
                "value": "Shirak",
                "label": "Shirak",
                "shortCode": "SH"
            },
            {
                "value": "Syunik",
                "label": "Syunik",
                "shortCode": "SU"
            },
            {
                "value": "Tavush",
                "label": "Tavush",
                "shortCode": "TV"
            },
            {
                "value": "Vayots Dzor",
                "label": "Vayots Dzor",
                "shortCode": "VD"
            },
            {
                "value": "Yerevan",
                "label": "Yerevan",
                "shortCode": "ER"
            }
        ]
    },
    {
        "countryCode": "+297",
        "value": "Aruba",
        "label": "Aruba",
        "regions": [
            {
                "value": "Aruba",
                "label": "Aruba",
                "shortCode": "AW"
            }
        ]
    },
    {
        "countryCode": "+61",
        "value": "Australia",
        "label": "Australia",
        "regions": [
            {
                "value": "Australian Capital Territory",
                "label": "Australian Capital Territory",
                "shortCode": "ACT"
            },
            {
                "value": "New South Wales",
                "label": "New South Wales",
                "shortCode": "NSW"
            },
            {
                "value": "Northern Territory",
                "label": "Northern Territory",
                "shortCode": "NT"
            },
            {
                "value": "Queensland",
                "label": "Queensland",
                "shortCode": "QLD"
            },
            {
                "value": "South Australia",
                "label": "South Australia",
                "shortCode": "SA"
            },
            {
                "value": "Tasmania",
                "label": "Tasmania",
                "shortCode": "TAS"
            },
            {
                "value": "Victoria",
                "label": "Victoria",
                "shortCode": "VIC"
            },
            {
                "value": "Western Australia",
                "label": "Western Australia",
                "shortCode": "WA"
            }
        ]
    },
    {
        "countryCode": "+43",
        "value": "Austria",
        "label": "Austria",
        "regions": [
            {
                "value": "Burgenland",
                "label": "Burgenland",
                "shortCode": "1"
            },
            {
                "value": "Kärnten",
                "label": "Kärnten",
                "shortCode": "2"
            },
            {
                "value": "Niederösterreich",
                "label": "Niederösterreich",
                "shortCode": "3"
            },
            {
                "value": "Oberösterreich",
                "label": "Oberösterreich",
                "shortCode": "4"
            },
            {
                "value": "Salzburg",
                "label": "Salzburg",
                "shortCode": "5"
            },
            {
                "value": "Steiermark",
                "label": "Steiermark",
                "shortCode": "6"
            },
            {
                "value": "Tirol",
                "label": "Tirol",
                "shortCode": "7"
            },
            {
                "value": "Vorarlberg",
                "label": "Vorarlberg",
                "shortCode": "8"
            },
            {
                "value": "Wien",
                "label": "Wien",
                "shortCode": "9"
            }
        ]
    },
    {
        "countryCode": "+994",
        "value": "Azerbaijan",
        "label": "Azerbaijan",
        "regions": [
            {
                "value": "Abşeron",
                "label": "Abşeron",
                "shortCode": "ABS"
            },
            {
                "value": "Ağcabədi",
                "label": "Ağcabədi",
                "shortCode": "AGC"
            },
            {
                "value": "Ağdam",
                "label": "Ağdam",
                "shortCode": "AGM"
            },
            {
                "value": "Ağdaş",
                "label": "Ağdaş",
                "shortCode": "AGS"
            },
            {
                "value": "Ağstafa",
                "label": "Ağstafa",
                "shortCode": "AGA"
            },
            {
                "value": "Ağsu",
                "label": "Ağsu",
                "shortCode": "AGU"
            },
            {
                "value": "Astara",
                "label": "Astara",
                "shortCode": "AST"
            },
            {
                "value": "Bakı",
                "label": "Bakı",
                "shortCode": "BAK"
            },
            {
                "value": "Babək",
                "label": "Babək",
                "shortCode": "BAB"
            },
            {
                "value": "Balakən",
                "label": "Balakən",
                "shortCode": "BAL"
            },
            {
                "value": "Bərdə",
                "label": "Bərdə",
                "shortCode": "BAR"
            },
            {
                "value": "Beyləqan",
                "label": "Beyləqan",
                "shortCode": "BEY"
            },
            {
                "value": "Biləsuvar",
                "label": "Biləsuvar",
                "shortCode": "BIL"
            },
            {
                "value": "Cəbrayıl",
                "label": "Cəbrayıl",
                "shortCode": "CAB"
            },
            {
                "value": "Cəlilabad",
                "label": "Cəlilabad",
                "shortCode": "CAL"
            },
            {
                "value": "Culfa",
                "label": "Culfa",
                "shortCode": "CUL"
            },
            {
                "value": "Daşkəsən",
                "label": "Daşkəsən",
                "shortCode": "DAS"
            },
            {
                "value": "Füzuli",
                "label": "Füzuli",
                "shortCode": "FUZ"
            },
            {
                "value": "Gədəbəy",
                "label": "Gədəbəy",
                "shortCode": "GAD"
            },
            {
                "value": "Goranboy",
                "label": "Goranboy",
                "shortCode": "GOR"
            },
            {
                "value": "Göyçay",
                "label": "Göyçay",
                "shortCode": "GOY"
            },
            {
                "value": "Göygöl",
                "label": "Göygöl",
                "shortCode": "GYG"
            },
            {
                "value": "Hacıqabul",
                "label": "Hacıqabul",
                "shortCode": "HAC"
            },
            {
                "value": "İmişli",
                "label": "İmişli",
                "shortCode": "IMI"
            },
            {
                "value": "İsmayıllı",
                "label": "İsmayıllı",
                "shortCode": "ISM"
            },
            {
                "value": "Kəlbəcər",
                "label": "Kəlbəcər",
                "shortCode": "KAL"
            },
            {
                "value": "Kǝngǝrli",
                "label": "Kǝngǝrli",
                "shortCode": "KAN"
            },
            {
                "value": "Kürdəmir",
                "label": "Kürdəmir",
                "shortCode": "KUR"
            },
            {
                "value": "Laçın",
                "label": "Laçın",
                "shortCode": "LAC"
            },
            {
                "value": "Lənkəran",
                "label": "Lənkəran",
                "shortCode": "LAN"
            },
            {
                "value": "Lerik",
                "label": "Lerik",
                "shortCode": "LER"
            },
            {
                "value": "Masallı",
                "label": "Masallı",
                "shortCode": "MAS"
            },
            {
                "value": "Neftçala",
                "label": "Neftçala",
                "shortCode": "NEF"
            },
            {
                "value": "Oğuz",
                "label": "Oğuz",
                "shortCode": "OGU"
            },
            {
                "value": "Ordubad",
                "label": "Ordubad",
                "shortCode": "ORD"
            },
            {
                "value": "Qəbələ",
                "label": "Qəbələ",
                "shortCode": "QAB"
            },
            {
                "value": "Qax",
                "label": "Qax",
                "shortCode": "QAX"
            },
            {
                "value": "Qazax",
                "label": "Qazax",
                "shortCode": "QAZ"
            },
            {
                "value": "Qobustan",
                "label": "Qobustan",
                "shortCode": "QOB"
            },
            {
                "value": "Quba",
                "label": "Quba",
                "shortCode": "QBA"
            },
            {
                "value": "Qubadli",
                "label": "Qubadli",
                "shortCode": "QBI"
            },
            {
                "value": "Qusar",
                "label": "Qusar",
                "shortCode": "QUS"
            },
            {
                "value": "Saatlı",
                "label": "Saatlı",
                "shortCode": "SAT"
            },
            {
                "value": "Sabirabad",
                "label": "Sabirabad",
                "shortCode": "SAB"
            },
            {
                "value": "Şabran",
                "label": "Şabran",
                "shortCode": "SBN"
            },
            {
                "value": "Sədərək",
                "label": "Sədərək",
                "shortCode": "SAD"
            },
            {
                "value": "Şahbuz",
                "label": "Şahbuz",
                "shortCode": "SAH"
            },
            {
                "value": "Şəki",
                "label": "Şəki",
                "shortCode": "SAK"
            },
            {
                "value": "Salyan",
                "label": "Salyan",
                "shortCode": "SAL"
            },
            {
                "value": "Şamaxı",
                "label": "Şamaxı",
                "shortCode": "SMI"
            },
            {
                "value": "Şəmkir",
                "label": "Şəmkir",
                "shortCode": "SKR"
            },
            {
                "value": "Samux",
                "label": "Samux",
                "shortCode": "SMX"
            },
            {
                "value": "Şərur",
                "label": "Şərur",
                "shortCode": "SAR"
            },
            {
                "value": "Siyəzən",
                "label": "Siyəzən",
                "shortCode": "SIY"
            },
            {
                "value": "Şuşa",
                "label": "Şuşa",
                "shortCode": "SUS"
            },
            {
                "value": "Tərtər",
                "label": "Tərtər",
                "shortCode": "TAR"
            },
            {
                "value": "Tovuz",
                "label": "Tovuz",
                "shortCode": "TOV"
            },
            {
                "value": "Ucar",
                "label": "Ucar",
                "shortCode": "UCA"
            },
            {
                "value": "Xaçmaz",
                "label": "Xaçmaz",
                "shortCode": "XAC"
            },
            {
                "value": "Xızı",
                "label": "Xızı",
                "shortCode": "XIZ"
            },
            {
                "value": "Xocalı",
                "label": "Xocalı",
                "shortCode": "XCI"
            },
            {
                "value": "Xocavənd",
                "label": "Xocavənd",
                "shortCode": "XVD"
            },
            {
                "value": "Yardımlı",
                "label": "Yardımlı",
                "shortCode": "YAR"
            },
            {
                "value": "Yevlax",
                "label": "Yevlax",
                "shortCode": "YEV"
            },
            {
                "value": "Zəngilan",
                "label": "Zəngilan",
                "shortCode": "ZAN"
            },
            {
                "value": "Zaqatala",
                "label": "Zaqatala",
                "shortCode": "ZAQ"
            },
            {
                "value": "Zərdab",
                "label": "Zərdab",
                "shortCode": "ZAR"
            }
        ]
    },
    {
        "countryCode": "+1 242",
        "value": "Bahamas",
        "label": "Bahamas",
        "regions": [
            {
                "value": "Acklins Island",
                "label": "Acklins Island",
                "shortCode": "01"
            },
            {
                "value": "Berry Islands",
                "label": "Berry Islands",
                "shortCode": "22"
            },
            {
                "value": "Bimini",
                "label": "Bimini",
                "shortCode": "02"
            },
            {
                "value": "Black Point",
                "label": "Black Point",
                "shortCode": "23"
            },
            {
                "value": "Cat Island",
                "label": "Cat Island",
                "shortCode": "03"
            },
            {
                "value": "Central Abaco",
                "label": "Central Abaco",
                "shortCode": "24"
            },
            {
                "value": "Crooked Island and Long Cay",
                "label": "Crooked Island and Long Cay",
                "shortCode": "28"
            },
            {
                "value": "East Grand Bahama",
                "label": "East Grand Bahama",
                "shortCode": "29"
            },
            {
                "value": "Exuma",
                "label": "Exuma",
                "shortCode": "04"
            },
            {
                "value": "Freeport",
                "label": "Freeport",
                "shortCode": "05"
            },
            {
                "value": "Fresh Creek",
                "label": "Fresh Creek",
                "shortCode": "06"
            },
            {
                "value": "Governor's Harbour",
                "label": "Governor's Harbour",
                "shortCode": "07"
            },
            {
                "value": "Green Turtle Cay",
                "label": "Green Turtle Cay",
                "shortCode": "08"
            },
            {
                "value": "Harbour Island",
                "label": "Harbour Island",
                "shortCode": "09"
            },
            {
                "value": "High Rock",
                "label": "High Rock",
                "shortCode": "10"
            },
            {
                "value": "Inagua",
                "label": "Inagua",
                "shortCode": "11"
            },
            {
                "value": "Kemps Bay",
                "label": "Kemps Bay",
                "shortCode": "12"
            },
            {
                "value": "Long Island",
                "label": "Long Island",
                "shortCode": "13"
            },
            {
                "value": "Marsh Harbour",
                "label": "Marsh Harbour",
                "shortCode": "14"
            },
            {
                "value": "Mayaguana",
                "label": "Mayaguana",
                "shortCode": "15"
            },
            {
                "value": "Moore’s Island",
                "label": "Moore’s Island",
                "shortCode": "40"
            },
            {
                "value": "New Providence",
                "label": "New Providence",
                "shortCode": "16"
            },
            {
                "value": "Nichollstown and Berry Islands",
                "label": "Nichollstown and Berry Islands",
                "shortCode": "17"
            },
            {
                "value": "North Abaco",
                "label": "North Abaco",
                "shortCode": "42"
            },
            {
                "value": "North Andros",
                "label": "North Andros",
                "shortCode": "41"
            },
            {
                "value": "North Eleuthera",
                "label": "North Eleuthera",
                "shortCode": "33"
            },
            {
                "value": "Ragged Island",
                "label": "Ragged Island",
                "shortCode": "18"
            },
            {
                "value": "Rock Sound",
                "label": "Rock Sound",
                "shortCode": "19"
            },
            {
                "value": "San Salvador and Rum Cay",
                "label": "San Salvador and Rum Cay",
                "shortCode": "20"
            },
            {
                "value": "Sandy Point",
                "label": "Sandy Point",
                "shortCode": "21"
            },
            {
                "value": "South Abaco",
                "label": "South Abaco",
                "shortCode": "35"
            },
            {
                "value": "South Andros",
                "label": "South Andros",
                "shortCode": "36"
            },
            {
                "value": "South Eleuthera",
                "label": "South Eleuthera",
                "shortCode": "37"
            },
            {
                "value": "West Grand Bahama",
                "label": "West Grand Bahama",
                "shortCode": "39"
            }
        ]
    },
    {
        "countryCode": "+973",
        "value": "Bahrain",
        "label": "Bahrain",
        "regions": [
            {
                "value": "Al Janūbīyah",
                "label": "Al Janūbīyah",
                "shortCode": "14"
            },
            {
                "value": "Al Manāmah",
                "label": "Al Manāmah",
                "shortCode": "13"
            },
            {
                "value": "Al Muḩarraq",
                "label": "Al Muḩarraq",
                "shortCode": "15"
            },
            {
                "value": "Al Wusţá",
                "label": "Al Wusţá",
                "shortCode": "16"
            },
            {
                "value": "Ash Shamālīyah",
                "label": "Ash Shamālīyah",
                "shortCode": "17"
            }
        ]
    },
    {
        "countryCode": "+880",
        "value": "Bangladesh",
        "label": "Bangladesh",
        "regions": [
            {
                "value": "Barisal",
                "label": "Barisal",
                "shortCode": "A"
            },
            {
                "value": "Chittagong",
                "label": "Chittagong",
                "shortCode": "B"
            },
            {
                "value": "Dhaka",
                "label": "Dhaka",
                "shortCode": "C"
            },
            {
                "value": "Khulna",
                "label": "Khulna",
                "shortCode": "D"
            },
            {
                "value": "Mymensingh",
                "label": "Mymensingh",
                "shortCode": "M"
            },
            {
                "value": "Rajshahi",
                "label": "Rajshahi",
                "shortCode": "E"
            },
            {
                "value": "Rangpur",
                "label": "Rangpur",
                "shortCode": "F"
            },
            {
                "value": "Sylhet",
                "label": "Sylhet",
                "shortCode": "G"
            }
        ]
    },
    {
        "countryCode": "+1 246",
        "value": "Barbados",
        "label": "Barbados",
        "regions": [
            {
                "value": "Christ Church",
                "label": "Christ Church",
                "shortCode": "01"
            },
            {
                "value": "Saint Andrew",
                "label": "Saint Andrew",
                "shortCode": "02"
            },
            {
                "value": "Saint George",
                "label": "Saint George",
                "shortCode": "03"
            },
            {
                "value": "Saint James",
                "label": "Saint James",
                "shortCode": "04"
            },
            {
                "value": "Saint John",
                "label": "Saint John",
                "shortCode": "05"
            },
            {
                "value": "Saint Joseph",
                "label": "Saint Joseph",
                "shortCode": "06"
            },
            {
                "value": "Saint Lucy",
                "label": "Saint Lucy",
                "shortCode": "07"
            },
            {
                "value": "Saint Michael",
                "label": "Saint Michael",
                "shortCode": "08"
            },
            {
                "value": "Saint Peter",
                "label": "Saint Peter",
                "shortCode": "09"
            },
            {
                "value": "Saint Philip",
                "label": "Saint Philip",
                "shortCode": "10"
            },
            {
                "value": "Saint Thomas",
                "label": "Saint Thomas",
                "shortCode": "11"
            }
        ]
    },
    {
        "countryCode": "+375",
        "value": "Belarus",
        "label": "Belarus",
        "regions": [
            {
                "value": "Brest voblast",
                "label": "Brest voblast",
                "shortCode": "BR"
            },
            {
                "value": "Gorod Minsk",
                "label": "Gorod Minsk",
                "shortCode": "HM"
            },
            {
                "value": "Homiel voblast",
                "label": "Homiel voblast",
                "shortCode": "HO"
            },
            {
                "value": "Hrodna voblast",
                "label": "Hrodna voblast",
                "shortCode": "HR"
            },
            {
                "value": "Mahilyow voblast",
                "label": "Mahilyow voblast",
                "shortCode": "MA"
            },
            {
                "value": "Minsk voblast",
                "label": "Minsk voblast",
                "shortCode": "MI"
            },
            {
                "value": "Vitsebsk voblast",
                "label": "Vitsebsk voblast",
                "shortCode": "VI"
            }
        ]
    },
    {
        "countryCode": "+32",
        "value": "Belgium",
        "label": "Belgium",
        "regions": [
            {
                "value": "Brussels",
                "label": "Brussels",
                "shortCode": "BRU"
            },
            {
                "value": "Flanders",
                "label": "Flanders",
                "shortCode": "VLG"
            },
            {
                "value": "Wallonia",
                "label": "Wallonia",
                "shortCode": "WAL"
            }
        ]
    },
    {
        "countryCode": "+501",
        "value": "Belize",
        "label": "Belize",
        "regions": [
            {
                "value": "Belize District",
                "label": "Belize District",
                "shortCode": "BZ"
            },
            {
                "value": "Cayo District",
                "label": "Cayo District",
                "shortCode": "CY"
            },
            {
                "value": "Corozal District",
                "label": "Corozal District",
                "shortCode": "CZL"
            },
            {
                "value": "Orange Walk District",
                "label": "Orange Walk District",
                "shortCode": "OW"
            },
            {
                "value": "Stann Creek District",
                "label": "Stann Creek District",
                "shortCode": "SC"
            },
            {
                "value": "Toledo District",
                "label": "Toledo District",
                "shortCode": "TOL"
            }
        ]
    },
    {
        "countryCode": "+229",
        "value": "Benin",
        "label": "Benin",
        "regions": [
            {
                "value": "Alibori",
                "label": "Alibori",
                "shortCode": "AL"
            },
            {
                "value": "Atakora",
                "label": "Atakora",
                "shortCode": "AK"
            },
            {
                "value": "Atlantique",
                "label": "Atlantique",
                "shortCode": "AQ"
            },
            {
                "value": "Borgou",
                "label": "Borgou",
                "shortCode": "BO"
            },
            {
                "value": "Collines Department",
                "label": "Collines Department",
                "shortCode": "CO"
            },
            {
                "value": "Donga",
                "label": "Donga",
                "shortCode": "DO"
            },
            {
                "value": "Kouffo",
                "label": "Kouffo",
                "shortCode": "KO"
            },
            {
                "value": "Littoral Department",
                "label": "Littoral Department",
                "shortCode": "LI"
            },
            {
                "value": "Mono Department",
                "label": "Mono Department",
                "shortCode": "MO"
            },
            {
                "value": "Ouémé",
                "label": "Ouémé",
                "shortCode": "OU"
            },
            {
                "value": "Plateau",
                "label": "Plateau",
                "shortCode": "PL"
            },
            {
                "value": "Zou",
                "label": "Zou",
                "shortCode": "ZO"
            }
        ]
    },
    {
        "countryCode": "+1 441",
        "value": "Bermuda",
        "label": "Bermuda",
        "regions": [
            {
                "value": "City of Hamilton",
                "label": "City of Hamilton",
                "shortCode": "03"
            },
            {
                "value": "Devonshire Parish",
                "label": "Devonshire Parish",
                "shortCode": "01"
            },
            {
                "value": "Hamilton Parish",
                "label": "Hamilton Parish",
                "shortCode": "02"
            },
            {
                "value": "Paget Parish",
                "label": "Paget Parish",
                "shortCode": "04"
            },
            {
                "value": "Pembroke Parish",
                "label": "Pembroke Parish",
                "shortCode": "05"
            },
            {
                "value": "Sandys Parish",
                "label": "Sandys Parish",
                "shortCode": "08"
            },
            {
                "value": "Smith's Parish",
                "label": "Smith's Parish",
                "shortCode": "09"
            },
            {
                "value": "Southampton Parish",
                "label": "Southampton Parish",
                "shortCode": "10"
            },
            {
                "value": "St. George's Parish",
                "label": "St. George's Parish",
                "shortCode": "07"
            },
            {
                "value": "Town of St. George",
                "label": "Town of St. George",
                "shortCode": "06"
            },
            {
                "value": "Warwick Parish",
                "label": "Warwick Parish",
                "shortCode": "11"
            }
        ]
    },
    {
        "countryCode": "+975",
        "value": "Bhutan",
        "label": "Bhutan",
        "regions": [
            {
                "value": "Bumthang",
                "label": "Bumthang",
                "shortCode": "33"
            },
            {
                "value": "Chhukha",
                "label": "Chhukha",
                "shortCode": "12"
            },
            {
                "value": "Dagana",
                "label": "Dagana",
                "shortCode": "22"
            },
            {
                "value": "Gasa",
                "label": "Gasa",
                "shortCode": "GA"
            },
            {
                "value": "Haa",
                "label": "Haa",
                "shortCode": "13"
            },
            {
                "value": "Lhuntse",
                "label": "Lhuntse",
                "shortCode": "44"
            },
            {
                "value": "Mongar",
                "label": "Mongar",
                "shortCode": "42"
            },
            {
                "value": "Paro",
                "label": "Paro",
                "shortCode": "11"
            },
            {
                "value": "Pemagatshel",
                "label": "Pemagatshel",
                "shortCode": "43"
            },
            {
                "value": "Punakha",
                "label": "Punakha",
                "shortCode": "23"
            },
            {
                "value": "Samdrup Jongkhar",
                "label": "Samdrup Jongkhar",
                "shortCode": "45"
            },
            {
                "value": "Samtse",
                "label": "Samtse",
                "shortCode": "14"
            },
            {
                "value": "Sarpang",
                "label": "Sarpang",
                "shortCode": "31"
            },
            {
                "value": "Thimphu",
                "label": "Thimphu",
                "shortCode": "15"
            },
            {
                "value": "Trashigang",
                "label": "Trashigang",
                "shortCode": "41"
            },
            {
                "value": "Trashiyangtse",
                "label": "Trashiyangtse",
                "shortCode": "TY"
            },
            {
                "value": "Trongsa",
                "label": "Trongsa",
                "shortCode": "32"
            },
            {
                "value": "Tsirang",
                "label": "Tsirang",
                "shortCode": "21"
            },
            {
                "value": "Wangdue Phodrang",
                "label": "Wangdue Phodrang",
                "shortCode": "24"
            },
            {
                "value": "Zhemgang",
                "label": "Zhemgang",
                "shortCode": "34"
            }
        ]
    },
    {
        "countryCode": "+591",
        "value": "Bolivia",
        "label": "Bolivia",
        "regions": [
            {
                "value": "Beni",
                "label": "Beni",
                "shortCode": "BE"
            },
            {
                "value": "Chuquisaca",
                "label": "Chuquisaca",
                "shortCode": "CH"
            },
            {
                "value": "Cochabamba",
                "label": "Cochabamba",
                "shortCode": "CB"
            },
            {
                "value": "La Paz",
                "label": "La Paz",
                "shortCode": "LP"
            },
            {
                "value": "Oruro",
                "label": "Oruro",
                "shortCode": "OR"
            },
            {
                "value": "Pando",
                "label": "Pando",
                "shortCode": "PD"
            },
            {
                "value": "Potosí",
                "label": "Potosí",
                "shortCode": "PT"
            },
            {
                "value": "Santa Cruz",
                "label": "Santa Cruz",
                "shortCode": "SC"
            },
            {
                "value": "Tarija",
                "label": "Tarija",
                "shortCode": "TJ"
            }
        ]
    },
    {
        "countryCode": "+387",
        "value": "Bosnia and Herzegovina",
        "label": "Bosnia and Herzegovina",
        "regions": [
            {
                "value": "Brčko Distrikt",
                "label": "Brčko Distrikt",
                "shortCode": "BRC"
            },
            {
                "value": "Federacija Bosne i Hercegovine",
                "label": "Federacija Bosne i Hercegovine",
                "shortCode": "BIH"
            },
            {
                "value": "Republika Srpska",
                "label": "Republika Srpska",
                "shortCode": "SRP"
            }
        ]
    },
    {
        "countryCode": "+267",
        "value": "Botswana",
        "label": "Botswana",
        "regions": [
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "CE"
            },
            {
                "value": "Ghanzi",
                "label": "Ghanzi",
                "shortCode": "GH"
            },
            {
                "value": "Kgalagadi",
                "label": "Kgalagadi",
                "shortCode": "KG"
            },
            {
                "value": "Kgatleng",
                "label": "Kgatleng",
                "shortCode": "KL"
            },
            {
                "value": "Kweneng",
                "label": "Kweneng",
                "shortCode": "KW"
            },
            {
                "value": "North West",
                "label": "North West",
                "shortCode": "NW"
            },
            {
                "value": "North-East",
                "label": "North-East",
                "shortCode": "NE"
            },
            {
                "value": "South East",
                "label": "South East",
                "shortCode": "SE"
            },
            {
                "value": "Southern",
                "label": "Southern",
                "shortCode": "SO"
            }
        ]
    },
    {
        "countryCode": "+55",
        "value": "Brazil",
        "label": "Brazil",
        "regions": [
            {
                "value": "Acre",
                "label": "Acre",
                "shortCode": "AC"
            },
            {
                "value": "Alagoas",
                "label": "Alagoas",
                "shortCode": "AL"
            },
            {
                "value": "Amapá",
                "label": "Amapá",
                "shortCode": "AP"
            },
            {
                "value": "Amazonas",
                "label": "Amazonas",
                "shortCode": "AM"
            },
            {
                "value": "Bahia",
                "label": "Bahia",
                "shortCode": "BA"
            },
            {
                "value": "Ceará",
                "label": "Ceará",
                "shortCode": "CE"
            },
            {
                "value": "Distrito Federal",
                "label": "Distrito Federal",
                "shortCode": "DF"
            },
            {
                "value": "Espírito Santo",
                "label": "Espírito Santo",
                "shortCode": "ES"
            },
            {
                "value": "Goiás",
                "label": "Goiás",
                "shortCode": "GO"
            },
            {
                "value": "Maranhão",
                "label": "Maranhão",
                "shortCode": "MA"
            },
            {
                "value": "Mato Grosso",
                "label": "Mato Grosso",
                "shortCode": "MT"
            },
            {
                "value": "Mato Grosso do Sul",
                "label": "Mato Grosso do Sul",
                "shortCode": "MS"
            },
            {
                "value": "Minas Gerais",
                "label": "Minas Gerais",
                "shortCode": "MG"
            },
            {
                "value": "Pará",
                "label": "Pará",
                "shortCode": "PA"
            },
            {
                "value": "Paraíba",
                "label": "Paraíba",
                "shortCode": "PB"
            },
            {
                "value": "Paraná",
                "label": "Paraná",
                "shortCode": "PR"
            },
            {
                "value": "Pernambuco",
                "label": "Pernambuco",
                "shortCode": "PE"
            },
            {
                "value": "Piauí",
                "label": "Piauí",
                "shortCode": "PI"
            },
            {
                "value": "Rio de Janeiro",
                "label": "Rio de Janeiro",
                "shortCode": "RJ"
            },
            {
                "value": "Rio Grande do Norte",
                "label": "Rio Grande do Norte",
                "shortCode": "RN"
            },
            {
                "value": "Rio Grande do Sul",
                "label": "Rio Grande do Sul",
                "shortCode": "RS"
            },
            {
                "value": "Rondônia",
                "label": "Rondônia",
                "shortCode": "RO"
            },
            {
                "value": "Roraima",
                "label": "Roraima",
                "shortCode": "RR"
            },
            {
                "value": "Santa Catarina",
                "label": "Santa Catarina",
                "shortCode": "SC"
            },
            {
                "value": "São Paulo",
                "label": "São Paulo",
                "shortCode": "SP"
            },
            {
                "value": "Sergipe",
                "label": "Sergipe",
                "shortCode": "SE"
            },
            {
                "value": "Tocantins",
                "label": "Tocantins",
                "shortCode": "TO"
            }
        ]
    },
    {
        "countryCode": "+246",
        "value": "British Indian Ocean Territory",
        "label": "British Indian Ocean Territory",
        "regions": [
            {
                "value": "British Indian Ocean Territory",
                "label": "British Indian Ocean Territory",
                "shortCode": "IO"
            }
        ]
    },
    {
        "countryCode": "+673",
        "value": "Brunei Darussalam",
        "label": "Brunei Darussalam",
        "regions": [
            {
                "value": "Belait",
                "label": "Belait",
                "shortCode": "BE"
            },
            {
                "value": "Brunei Muara",
                "label": "Brunei Muara",
                "shortCode": "BM"
            },
            {
                "value": "Temburong",
                "label": "Temburong",
                "shortCode": "TE"
            },
            {
                "value": "Tutong",
                "label": "Tutong",
                "shortCode": "TU"
            }
        ]
    },
    {
        "countryCode": "+359",
        "value": "Bulgaria",
        "label": "Bulgaria",
        "regions": [
            {
                "value": "Blagoevgrad",
                "label": "Blagoevgrad",
                "shortCode": "01"
            },
            {
                "value": "Burgas",
                "label": "Burgas",
                "shortCode": "02"
            },
            {
                "value": "Dobrich",
                "label": "Dobrich",
                "shortCode": "08"
            },
            {
                "value": "Gabrovo",
                "label": "Gabrovo",
                "shortCode": "07"
            },
            {
                "value": "Jambol",
                "label": "Jambol",
                "shortCode": "28"
            },
            {
                "value": "Khaskovo",
                "label": "Khaskovo",
                "shortCode": "26"
            },
            {
                "value": "Kjustendil",
                "label": "Kjustendil",
                "shortCode": "10"
            },
            {
                "value": "Kurdzhali",
                "label": "Kurdzhali",
                "shortCode": "09"
            },
            {
                "value": "Lovech",
                "label": "Lovech",
                "shortCode": "11"
            },
            {
                "value": "Montana",
                "label": "Montana",
                "shortCode": "12"
            },
            {
                "value": "Pazardzhik",
                "label": "Pazardzhik",
                "shortCode": "13"
            },
            {
                "value": "Pernik",
                "label": "Pernik",
                "shortCode": "14"
            },
            {
                "value": "Pleven",
                "label": "Pleven",
                "shortCode": "15"
            },
            {
                "value": "Plovdiv",
                "label": "Plovdiv",
                "shortCode": "16"
            },
            {
                "value": "Razgrad",
                "label": "Razgrad",
                "shortCode": "17"
            },
            {
                "value": "Ruse",
                "label": "Ruse",
                "shortCode": "18"
            },
            {
                "value": "Shumen",
                "label": "Shumen",
                "shortCode": "27"
            },
            {
                "value": "Silistra",
                "label": "Silistra",
                "shortCode": "19"
            },
            {
                "value": "Sliven",
                "label": "Sliven",
                "shortCode": "20"
            },
            {
                "value": "Smoljan",
                "label": "Smoljan",
                "shortCode": "21"
            },
            {
                "value": "Sofija",
                "label": "Sofija",
                "shortCode": "23"
            },
            {
                "value": "Sofija-Grad",
                "label": "Sofija-Grad",
                "shortCode": "22"
            },
            {
                "value": "Stara Zagora",
                "label": "Stara Zagora",
                "shortCode": "24"
            },
            {
                "value": "Turgovishhe",
                "label": "Turgovishhe",
                "shortCode": "25"
            },
            {
                "value": "Varna",
                "label": "Varna",
                "shortCode": "03"
            },
            {
                "value": "Veliko Turnovo",
                "label": "Veliko Turnovo",
                "shortCode": "04"
            },
            {
                "value": "Vidin",
                "label": "Vidin",
                "shortCode": "05"
            },
            {
                "value": "Vraca",
                "label": "Vraca",
                "shortCode": "06"
            }
        ]
    },
    {
        "countryCode": "+226",
        "value": "Burkina Faso",
        "label": "Burkina Faso",
        "regions": [
            {
                "value": "Balé",
                "label": "Balé",
                "shortCode": "BAL"
            },
            {
                "value": "Bam/Lake Bam",
                "label": "Bam/Lake Bam",
                "shortCode": "BAM"
            },
            {
                "value": "Banwa Province",
                "label": "Banwa Province",
                "shortCode": "BAN"
            },
            {
                "value": "Bazèga",
                "label": "Bazèga",
                "shortCode": "BAZ"
            },
            {
                "value": "Bougouriba",
                "label": "Bougouriba",
                "shortCode": "BGR"
            },
            {
                "value": "Boulgou Province",
                "label": "Boulgou Province",
                "shortCode": "BLG"
            },
            {
                "value": "Boulkiemdé",
                "label": "Boulkiemdé",
                "shortCode": "BLK"
            },
            {
                "value": "Comoé/Komoe",
                "label": "Comoé/Komoe",
                "shortCode": "COM"
            },
            {
                "value": "Ganzourgou Province",
                "label": "Ganzourgou Province",
                "shortCode": "GAN"
            },
            {
                "value": "Gnagna",
                "label": "Gnagna",
                "shortCode": "GNA"
            },
            {
                "value": "Gourma Province",
                "label": "Gourma Province",
                "shortCode": "GOU"
            },
            {
                "value": "Houet",
                "label": "Houet",
                "shortCode": "HOU"
            },
            {
                "value": "Ioba",
                "label": "Ioba",
                "shortCode": "IOB"
            },
            {
                "value": "Kadiogo",
                "label": "Kadiogo",
                "shortCode": "KAD"
            },
            {
                "value": "Kénédougou",
                "label": "Kénédougou",
                "shortCode": "KEN"
            },
            {
                "value": "Komondjari",
                "label": "Komondjari",
                "shortCode": "KMD"
            },
            {
                "value": "Kompienga",
                "label": "Kompienga",
                "shortCode": "KMP"
            },
            {
                "value": "Kossi Province",
                "label": "Kossi Province",
                "shortCode": "KOS"
            },
            {
                "value": "Koulpélogo",
                "label": "Koulpélogo",
                "shortCode": "KOP"
            },
            {
                "value": "Kouritenga",
                "label": "Kouritenga",
                "shortCode": "KOT"
            },
            {
                "value": "Kourwéogo",
                "label": "Kourwéogo",
                "shortCode": "KOW"
            },
            {
                "value": "Léraba",
                "label": "Léraba",
                "shortCode": "LER"
            },
            {
                "value": "Loroum",
                "label": "Loroum",
                "shortCode": "LOR"
            },
            {
                "value": "Mouhoun",
                "label": "Mouhoun",
                "shortCode": "MOU"
            },
            {
                "value": "Namentenga",
                "label": "Namentenga",
                "shortCode": "NAM"
            },
            {
                "value": "Naouri/Nahouri",
                "label": "Naouri/Nahouri",
                "shortCode": "NAO"
            },
            {
                "value": "Nayala",
                "label": "Nayala",
                "shortCode": "NAY"
            },
            {
                "value": "Noumbiel",
                "label": "Noumbiel",
                "shortCode": "NOU"
            },
            {
                "value": "Oubritenga",
                "label": "Oubritenga",
                "shortCode": "OUB"
            },
            {
                "value": "Oudalan",
                "label": "Oudalan",
                "shortCode": "OUD"
            },
            {
                "value": "Passoré",
                "label": "Passoré",
                "shortCode": "PAS"
            },
            {
                "value": "Poni",
                "label": "Poni",
                "shortCode": "PON"
            },
            {
                "value": "Sanguié",
                "label": "Sanguié",
                "shortCode": "SNG"
            },
            {
                "value": "Sanmatenga",
                "label": "Sanmatenga",
                "shortCode": "SMT"
            },
            {
                "value": "Séno",
                "label": "Séno",
                "shortCode": "SEN"
            },
            {
                "value": "Sissili",
                "label": "Sissili",
                "shortCode": "SIS"
            },
            {
                "value": "Soum",
                "label": "Soum",
                "shortCode": "SOM"
            },
            {
                "value": "Sourou",
                "label": "Sourou",
                "shortCode": "SOR"
            },
            {
                "value": "Tapoa",
                "label": "Tapoa",
                "shortCode": "TAP"
            },
            {
                "value": "Tui/Tuy",
                "label": "Tui/Tuy",
                "shortCode": "TUI"
            },
            {
                "value": "Yagha",
                "label": "Yagha",
                "shortCode": "YAG"
            },
            {
                "value": "Yatenga",
                "label": "Yatenga",
                "shortCode": "YAT"
            },
            {
                "value": "Ziro",
                "label": "Ziro",
                "shortCode": "ZIR"
            },
            {
                "value": "Zondoma",
                "label": "Zondoma",
                "shortCode": "ZON"
            },
            {
                "value": "Zoundwéogo",
                "label": "Zoundwéogo",
                "shortCode": "ZOU"
            }
        ]
    },
    {
        "countryCode": "+257",
        "value": "Burundi",
        "label": "Burundi",
        "regions": [
            {
                "value": "Bubanza",
                "label": "Bubanza",
                "shortCode": "BB"
            },
            {
                "value": "Bujumbura Mairie",
                "label": "Bujumbura Mairie",
                "shortCode": "BM"
            },
            {
                "value": "Bujumbura Rural",
                "label": "Bujumbura Rural",
                "shortCode": "BL"
            },
            {
                "value": "Bururi",
                "label": "Bururi",
                "shortCode": "BR"
            },
            {
                "value": "Cankuzo",
                "label": "Cankuzo",
                "shortCode": "CA"
            },
            {
                "value": "Cibitoke",
                "label": "Cibitoke",
                "shortCode": "CI"
            },
            {
                "value": "Gitega",
                "label": "Gitega",
                "shortCode": "GI"
            },
            {
                "value": "Karuzi",
                "label": "Karuzi",
                "shortCode": "KR"
            },
            {
                "value": "Kayanza",
                "label": "Kayanza",
                "shortCode": "KY"
            },
            {
                "value": "Kirundo",
                "label": "Kirundo",
                "shortCode": "KI"
            },
            {
                "value": "Makamba",
                "label": "Makamba",
                "shortCode": "MA"
            },
            {
                "value": "Muramvya",
                "label": "Muramvya",
                "shortCode": "MU"
            },
            {
                "value": "Muyinga",
                "label": "Muyinga",
                "shortCode": "MY"
            },
            {
                "value": "Mwaro",
                "label": "Mwaro",
                "shortCode": "MW"
            },
            {
                "value": "Ngozi",
                "label": "Ngozi",
                "shortCode": "NG"
            },
            {
                "value": "Rutana",
                "label": "Rutana",
                "shortCode": "RT"
            },
            {
                "value": "Ruyigi",
                "label": "Ruyigi",
                "shortCode": "RY"
            }
        ]
    },
    {
        "countryCode": "+855",
        "value": "Cambodia",
        "label": "Cambodia",
        "regions": [
            {
                "value": "Baat Dambang",
                "label": "Baat Dambang",
                "shortCode": "2"
            },
            {
                "value": "Banteay Mean Chey",
                "label": "Banteay Mean Chey",
                "shortCode": "1"
            },
            {
                "value": "Kampong Chaam",
                "label": "Kampong Chaam",
                "shortCode": "3"
            },
            {
                "value": "Kampong Chhnang",
                "label": "Kampong Chhnang",
                "shortCode": "4"
            },
            {
                "value": "Kampong Spueu",
                "label": "Kampong Spueu",
                "shortCode": "5"
            },
            {
                "value": "Kampong Thum",
                "label": "Kampong Thum",
                "shortCode": "6"
            },
            {
                "value": "Kampot",
                "label": "Kampot",
                "shortCode": "7"
            },
            {
                "value": "Kandaal",
                "label": "Kandaal",
                "shortCode": "8"
            },
            {
                "value": "Kaoh Kong",
                "label": "Kaoh Kong",
                "shortCode": "9"
            },
            {
                "value": "Kracheh",
                "label": "Kracheh",
                "shortCode": "10"
            },
            {
                "value": "Krong Kaeb",
                "label": "Krong Kaeb",
                "shortCode": "23"
            },
            {
                "value": "Krong Pailin",
                "label": "Krong Pailin",
                "shortCode": "24"
            },
            {
                "value": "Krong Preah Sihanouk",
                "label": "Krong Preah Sihanouk",
                "shortCode": "18"
            },
            {
                "value": "Mondol Kiri",
                "label": "Mondol Kiri",
                "shortCode": "11"
            },
            {
                "value": "Otdar Mean Chey",
                "label": "Otdar Mean Chey",
                "shortCode": "22"
            },
            {
                "value": "Phnom Penh",
                "label": "Phnom Penh",
                "shortCode": "12"
            },
            {
                "value": "Pousaat",
                "label": "Pousaat",
                "shortCode": "15"
            },
            {
                "value": "Preah Vihear",
                "label": "Preah Vihear",
                "shortCode": "13"
            },
            {
                "value": "Prey Veaeng",
                "label": "Prey Veaeng",
                "shortCode": "14"
            },
            {
                "value": "Rotanah Kiri",
                "label": "Rotanah Kiri",
                "shortCode": "16"
            },
            {
                "value": "Siem Reab",
                "label": "Siem Reab",
                "shortCode": "17"
            },
            {
                "value": "Stueng Treng",
                "label": "Stueng Treng",
                "shortCode": "19"
            },
            {
                "value": "Svaay Rieng",
                "label": "Svaay Rieng",
                "shortCode": "20"
            },
            {
                "value": "Taakaev",
                "label": "Taakaev",
                "shortCode": "21"
            },
            {
                "value": "Tbong Khmum",
                "label": "Tbong Khmum",
                "shortCode": "25"
            }
        ]
    },
    {
        "countryCode": "+237",
        "value": "Cameroon",
        "label": "Cameroon",
        "regions": [
            {
                "value": "Adamaoua",
                "label": "Adamaoua",
                "shortCode": "AD"
            },
            {
                "value": "Centre",
                "label": "Centre",
                "shortCode": "CE"
            },
            {
                "value": "Est",
                "label": "Est",
                "shortCode": "ES"
            },
            {
                "value": "Extrême-Nord",
                "label": "Extrême-Nord",
                "shortCode": "EN"
            },
            {
                "value": "Littoral",
                "label": "Littoral",
                "shortCode": "LT"
            },
            {
                "value": "Nord",
                "label": "Nord",
                "shortCode": "NO"
            },
            {
                "value": "Nord-Ouest",
                "label": "Nord-Ouest",
                "shortCode": "NW"
            },
            {
                "value": "Ouest",
                "label": "Ouest",
                "shortCode": "OU"
            },
            {
                "value": "Sud",
                "label": "Sud",
                "shortCode": "SU"
            },
            {
                "value": "Sud-Ouest",
                "label": "Sud-Ouest",
                "shortCode": "SW"
            }
        ]
    },
    {
        "countryCode": "+1",
        "value": "Canada",
        "label": "Canada",
        "regions": [
            {
                "value": "Alberta",
                "label": "Alberta",
                "shortCode": "AB"
            },
            {
                "value": "British Columbia",
                "label": "British Columbia",
                "shortCode": "BC"
            },
            {
                "value": "Manitoba",
                "label": "Manitoba",
                "shortCode": "MB"
            },
            {
                "value": "New Brunswick",
                "label": "New Brunswick",
                "shortCode": "NB"
            },
            {
                "value": "Newfoundland and Labrador",
                "label": "Newfoundland and Labrador",
                "shortCode": "NL"
            },
            {
                "value": "Northwest Territories",
                "label": "Northwest Territories",
                "shortCode": "NT"
            },
            {
                "value": "Nova Scotia",
                "label": "Nova Scotia",
                "shortCode": "NS"
            },
            {
                "value": "Nunavut",
                "label": "Nunavut",
                "shortCode": "NU"
            },
            {
                "value": "Ontario",
                "label": "Ontario",
                "shortCode": "ON"
            },
            {
                "value": "Prince Edward Island",
                "label": "Prince Edward Island",
                "shortCode": "PE"
            },
            {
                "value": "Quebec",
                "label": "Quebec",
                "shortCode": "QC"
            },
            {
                "value": "Saskatchewan",
                "label": "Saskatchewan",
                "shortCode": "SK"
            },
            {
                "value": "Yukon",
                "label": "Yukon",
                "shortCode": "YT"
            }
        ]
    },
    {
        "countryCode": "+238",
        "value": "Cape Verde",
        "label": "Cape Verde",
        "regions": [
            {
                "value": "Boa Vista",
                "label": "Boa Vista",
                "shortCode": "BV"
            },
            {
                "value": "Brava",
                "label": "Brava",
                "shortCode": "BR"
            },
            {
                "value": "Calheta de São Miguel",
                "label": "Calheta de São Miguel",
                "shortCode": "CS"
            },
            {
                "value": "Maio",
                "label": "Maio",
                "shortCode": "MA"
            },
            {
                "value": "Mosteiros",
                "label": "Mosteiros",
                "shortCode": "MO"
            },
            {
                "value": "Paúl",
                "label": "Paúl",
                "shortCode": "PA"
            },
            {
                "value": "Porto Novo",
                "label": "Porto Novo",
                "shortCode": "PN"
            },
            {
                "value": "Praia",
                "label": "Praia",
                "shortCode": "PR"
            },
            {
                "value": "Ribeira Brava",
                "label": "Ribeira Brava",
                "shortCode": "RB"
            },
            {
                "value": "Ribeira Grande",
                "label": "Ribeira Grande",
                "shortCode": "RG"
            },
            {
                "value": "Sal",
                "label": "Sal",
                "shortCode": "SL"
            },
            {
                "value": "Santa Catarina",
                "label": "Santa Catarina",
                "shortCode": "CA"
            },
            {
                "value": "Santa Cruz",
                "label": "Santa Cruz",
                "shortCode": "CR"
            },
            {
                "value": "São Domingos",
                "label": "São Domingos",
                "shortCode": "SD"
            },
            {
                "value": "São Filipe",
                "label": "São Filipe",
                "shortCode": "SF"
            },
            {
                "value": "São Nicolau",
                "label": "São Nicolau",
                "shortCode": "SN"
            },
            {
                "value": "São Vicente",
                "label": "São Vicente",
                "shortCode": "SV"
            },
            {
                "value": "Tarrafal",
                "label": "Tarrafal",
                "shortCode": "TA"
            },
            {
                "value": "Tarrafal de São Nicolau",
                "label": "Tarrafal de São Nicolau",
                "shortCode": "TS"
            }
        ]
    },
    {
        "countryCode": "+1 345",
        "value": "Cayman Islands",
        "label": "Cayman Islands",
        "regions": [
            {
                "value": "Creek",
                "label": "Creek"
            },
            {
                "value": "Eastern",
                "label": "Eastern"
            },
            {
                "value": "Midland",
                "label": "Midland"
            },
            {
                "value": "South Town",
                "label": "South Town"
            },
            {
                "value": "Spot Bay",
                "label": "Spot Bay"
            },
            {
                "value": "Stake Bay",
                "label": "Stake Bay"
            },
            {
                "value": "West End",
                "label": "West End"
            },
            {
                "value": "Western",
                "label": "Western"
            }
        ]
    },
    {
        "countryCode": "+236",
        "value": "Central African Republic",
        "label": "Central African Republic",
        "regions": [
            {
                "value": "Bamingui-Bangoran",
                "label": "Bamingui-Bangoran",
                "shortCode": "BB"
            },
            {
                "value": "Bangui",
                "label": "Bangui",
                "shortCode": "BGF"
            },
            {
                "value": "Basse-Kotto",
                "label": "Basse-Kotto",
                "shortCode": "BK"
            },
            {
                "value": "Haute-Kotto",
                "label": "Haute-Kotto",
                "shortCode": "HK"
            },
            {
                "value": "Haut-Mbomou",
                "label": "Haut-Mbomou",
                "shortCode": "HM"
            },
            {
                "value": "Kémo",
                "label": "Kémo",
                "shortCode": "KG"
            },
            {
                "value": "Lobaye",
                "label": "Lobaye",
                "shortCode": "LB"
            },
            {
                "value": "Mambéré-Kadéï",
                "label": "Mambéré-Kadéï",
                "shortCode": "HS"
            },
            {
                "value": "Mbomou",
                "label": "Mbomou",
                "shortCode": "MB"
            },
            {
                "value": "Nana-Grebizi",
                "label": "Nana-Grebizi",
                "shortCode": "10"
            },
            {
                "value": "Nana-Mambéré",
                "label": "Nana-Mambéré",
                "shortCode": "NM"
            },
            {
                "value": "Ombella-M'Poko",
                "label": "Ombella-M'Poko",
                "shortCode": "MP"
            },
            {
                "value": "Ouaka",
                "label": "Ouaka",
                "shortCode": "UK"
            },
            {
                "value": "Ouham",
                "label": "Ouham",
                "shortCode": "AC"
            },
            {
                "value": "Ouham Péndé",
                "label": "Ouham Péndé",
                "shortCode": "OP"
            },
            {
                "value": "Sangha-Mbaéré",
                "label": "Sangha-Mbaéré",
                "shortCode": "SE"
            },
            {
                "value": "Vakaga",
                "label": "Vakaga",
                "shortCode": "VK"
            }
        ]
    },
    {
        "countryCode": "+235",
        "value": "Chad",
        "label": "Chad",
        "regions": [
            {
                "value": "Bahr el Ghazal",
                "label": "Bahr el Ghazal",
                "shortCode": "BG"
            },
            {
                "value": "Batha",
                "label": "Batha",
                "shortCode": "BA"
            },
            {
                "value": "Borkou",
                "label": "Borkou",
                "shortCode": "BO"
            },
            {
                "value": "Chari-Baguirmi",
                "label": "Chari-Baguirmi",
                "shortCode": "CB"
            },
            {
                "value": "Ennedi-Est",
                "label": "Ennedi-Est",
                "shortCode": "EE"
            },
            {
                "value": "Ennedi-Ouest",
                "label": "Ennedi-Ouest",
                "shortCode": "EO"
            },
            {
                "value": "Guéra",
                "label": "Guéra",
                "shortCode": "GR"
            },
            {
                "value": "Hadjer Lamis",
                "label": "Hadjer Lamis",
                "shortCode": "HL"
            },
            {
                "value": "Kanem",
                "label": "Kanem",
                "shortCode": "KA"
            },
            {
                "value": "Lac",
                "label": "Lac",
                "shortCode": "LC"
            },
            {
                "value": "Logone Occidental",
                "label": "Logone Occidental",
                "shortCode": "LO"
            },
            {
                "value": "Logone Oriental",
                "label": "Logone Oriental",
                "shortCode": "LR"
            },
            {
                "value": "Mondoul",
                "label": "Mondoul",
                "shortCode": "MA"
            },
            {
                "value": "Mayo-Kébbi-Est",
                "label": "Mayo-Kébbi-Est",
                "shortCode": "ME"
            },
            {
                "value": "Moyen-Chari",
                "label": "Moyen-Chari",
                "shortCode": "MC"
            },
            {
                "value": "Ouaddai",
                "label": "Ouaddai",
                "shortCode": "OD"
            },
            {
                "value": "Salamat",
                "label": "Salamat",
                "shortCode": "SA"
            },
            {
                "value": "Sila",
                "label": "Sila",
                "shortCode": "SI"
            },
            {
                "value": "Tandjilé",
                "label": "Tandjilé",
                "shortCode": "TA"
            },
            {
                "value": "Tibesti",
                "label": "Tibesti",
                "shortCode": "TI"
            },
            {
                "value": "Ville de Ndjamena",
                "label": "Ville de Ndjamena",
                "shortCode": "ND"
            },
            {
                "value": "Wadi Fira",
                "label": "Wadi Fira",
                "shortCode": "WF"
            }
        ]
    },
    {
        "countryCode": "+56",
        "value": "Chile",
        "label": "Chile",
        "regions": [
            {
                "value": "Aisén del General Carlos Ibáñez del Campo",
                "label": "Aisén del General Carlos Ibáñez del Campo",
                "shortCode": "AI"
            },
            {
                "value": "Antofagasta",
                "label": "Antofagasta",
                "shortCode": "AN"
            },
            {
                "value": "Araucanía",
                "label": "Araucanía",
                "shortCode": "AR"
            },
            {
                "value": "Arica y Parinacota",
                "label": "Arica y Parinacota",
                "shortCode": "AP"
            },
            {
                "value": "Atacama",
                "label": "Atacama",
                "shortCode": "AT"
            },
            {
                "value": "Bío-Bío",
                "label": "Bío-Bío",
                "shortCode": "BI"
            },
            {
                "value": "Coquimbo",
                "label": "Coquimbo",
                "shortCode": "CO"
            },
            {
                "value": "Libertador General Bernardo O'Higgins",
                "label": "Libertador General Bernardo O'Higgins",
                "shortCode": "LI"
            },
            {
                "value": "Los Lagos",
                "label": "Los Lagos",
                "shortCode": "LL"
            },
            {
                "value": "Los Ríos",
                "label": "Los Ríos",
                "shortCode": "LR"
            },
            {
                "value": "Magallanes y Antartica Chilena",
                "label": "Magallanes y Antartica Chilena",
                "shortCode": "MA"
            },
            {
                "value": "Marga-Marga",
                "label": "Marga-Marga",
                "shortCode": ""
            },
            {
                "value": "Maule",
                "label": "Maule",
                "shortCode": "ML"
            },
            {
                "value": "Ñuble",
                "label": "Ñuble",
                "shortCode": "NB"
            },
            {
                "value": "Región Metropolitana de Santiago",
                "label": "Región Metropolitana de Santiago",
                "shortCode": "RM"
            },
            {
                "value": "Tarapacá",
                "label": "Tarapacá",
                "shortCode": "TA"
            },
            {
                "value": "Valparaíso",
                "label": "Valparaíso",
                "shortCode": "VS"
            }
        ]
    },
    {
        "countryCode": "+86",
        "value": "China",
        "label": "China",
        "regions": [
            {
                "value": "Anhui",
                "label": "Anhui",
                "shortCode": "AH"
            },
            {
                "value": "Beijing",
                "label": "Beijing",
                "shortCode": "BJ"
            },
            {
                "value": "Chongqing",
                "label": "Chongqing",
                "shortCode": "CQ"
            },
            {
                "value": "Fujian",
                "label": "Fujian",
                "shortCode": "FJ"
            },
            {
                "value": "Gansu",
                "label": "Gansu",
                "shortCode": "GS"
            },
            {
                "value": "Guangdong",
                "label": "Guangdong",
                "shortCode": "GD"
            },
            {
                "value": "Guangxi",
                "label": "Guangxi",
                "shortCode": "GX"
            },
            {
                "value": "Guizhou",
                "label": "Guizhou",
                "shortCode": "GZ"
            },
            {
                "value": "Hainan",
                "label": "Hainan",
                "shortCode": "HI"
            },
            {
                "value": "Hebei",
                "label": "Hebei",
                "shortCode": "HE"
            },
            {
                "value": "Heilongjiang",
                "label": "Heilongjiang",
                "shortCode": "HL"
            },
            {
                "value": "Henan",
                "label": "Henan",
                "shortCode": "HA"
            },
            {
                "value": "Hong Kong",
                "label": "Hong Kong",
                "shortCode": "HK"
            },
            {
                "value": "Hubei",
                "label": "Hubei",
                "shortCode": "HB"
            },
            {
                "value": "Hunan",
                "label": "Hunan",
                "shortCode": "HN"
            },
            {
                "value": "Inner Mongolia",
                "label": "Inner Mongolia",
                "shortCode": "NM"
            },
            {
                "value": "Jiangsu",
                "label": "Jiangsu",
                "shortCode": "JS"
            },
            {
                "value": "Jiangxi",
                "label": "Jiangxi",
                "shortCode": "JX"
            },
            {
                "value": "Jilin",
                "label": "Jilin",
                "shortCode": "JL"
            },
            {
                "value": "Liaoning",
                "label": "Liaoning",
                "shortCode": "LN"
            },
            {
                "value": "Macau",
                "label": "Macau",
                "shortCode": "MO"
            },
            {
                "value": "Ningxia",
                "label": "Ningxia",
                "shortCode": "NX"
            },
            {
                "value": "Qinghai",
                "label": "Qinghai",
                "shortCode": "QH"
            },
            {
                "value": "Shaanxi",
                "label": "Shaanxi",
                "shortCode": "SN"
            },
            {
                "value": "Shandong",
                "label": "Shandong",
                "shortCode": "SD"
            },
            {
                "value": "Shanghai",
                "label": "Shanghai",
                "shortCode": "SH"
            },
            {
                "value": "Shanxi",
                "label": "Shanxi",
                "shortCode": "SX"
            },
            {
                "value": "Sichuan",
                "label": "Sichuan",
                "shortCode": "SC"
            },
            {
                "value": "Tianjin",
                "label": "Tianjin",
                "shortCode": "TJ"
            },
            {
                "value": "Tibet",
                "label": "Tibet",
                "shortCode": "XZ"
            },
            {
                "value": "Xinjiang",
                "label": "Xinjiang",
                "shortCode": "XJ"
            },
            {
                "value": "Yunnan",
                "label": "Yunnan",
                "shortCode": "YN"
            },
            {
                "value": "Zhejiang",
                "label": "Zhejiang",
                "shortCode": "ZJ"
            }
        ]
    },
    {
        "countryCode": "+61 89164",
        "value": "Christmas Island",
        "label": "Christmas Island",
        "regions": [
            {
                "value": "Christmas Island",
                "label": "Christmas Island",
                "shortCode": "CX"
            }
        ]
    },
    {
        "countryCode": "+61 89162",
        "value": "Cocos (Keeling) Islands",
        "label": "Cocos (Keeling) Islands",
        "regions": [
            {
                "value": "Direction Island",
                "label": "Direction Island",
                "shortCode": "DI"
            },
            {
                "value": "Home Island",
                "label": "Home Island",
                "shortCode": "HM"
            },
            {
                "value": "Horsburgh Island",
                "label": "Horsburgh Island",
                "shortCode": "HR"
            },
            {
                "value": "North Keeling Island",
                "label": "North Keeling Island",
                "shortCode": "NK"
            },
            {
                "value": "South Island",
                "label": "South Island",
                "shortCode": "SI"
            },
            {
                "value": "West Island",
                "label": "West Island",
                "shortCode": "WI"
            }
        ]
    },
    {
        "countryCode": "+57",
        "value": "Colombia",
        "label": "Colombia",
        "regions": [
            {
                "value": "Amazonas",
                "label": "Amazonas",
                "shortCode": "AMA"
            },
            {
                "value": "Antioquia",
                "label": "Antioquia",
                "shortCode": "ANT"
            },
            {
                "value": "Arauca",
                "label": "Arauca",
                "shortCode": "ARA"
            },
            {
                "value": "Archipiélago de San Andrés",
                "label": "Archipiélago de San Andrés",
                "shortCode": "SAP"
            },
            {
                "value": "Atlántico",
                "label": "Atlántico",
                "shortCode": "ATL"
            },
            {
                "value": "Bogotá D.C.",
                "label": "Bogotá D.C.",
                "shortCode": "DC"
            },
            {
                "value": "Bolívar",
                "label": "Bolívar",
                "shortCode": "BOL"
            },
            {
                "value": "Boyacá",
                "label": "Boyacá",
                "shortCode": "BOY"
            },
            {
                "value": "Caldas",
                "label": "Caldas",
                "shortCode": "CAL"
            },
            {
                "value": "Caquetá",
                "label": "Caquetá",
                "shortCode": "CAQ"
            },
            {
                "value": "Casanare",
                "label": "Casanare",
                "shortCode": "CAS"
            },
            {
                "value": "Cauca",
                "label": "Cauca",
                "shortCode": "CAU"
            },
            {
                "value": "Cesar",
                "label": "Cesar",
                "shortCode": "CES"
            },
            {
                "value": "Chocó",
                "label": "Chocó",
                "shortCode": "CHO"
            },
            {
                "value": "Córdoba",
                "label": "Córdoba",
                "shortCode": "COR"
            },
            {
                "value": "Cundinamarca",
                "label": "Cundinamarca",
                "shortCode": "CUN"
            },
            {
                "value": "Guainía",
                "label": "Guainía",
                "shortCode": "GUA"
            },
            {
                "value": "Guaviare",
                "label": "Guaviare",
                "shortCode": "GUV"
            },
            {
                "value": "Huila",
                "label": "Huila",
                "shortCode": "HUI"
            },
            {
                "value": "La Guajira",
                "label": "La Guajira",
                "shortCode": "LAG"
            },
            {
                "value": "Magdalena",
                "label": "Magdalena",
                "shortCode": "MAG"
            },
            {
                "value": "Meta",
                "label": "Meta",
                "shortCode": "MET"
            },
            {
                "value": "Nariño",
                "label": "Nariño",
                "shortCode": "NAR"
            },
            {
                "value": "Norte de Santander",
                "label": "Norte de Santander",
                "shortCode": "NSA"
            },
            {
                "value": "Putumayo",
                "label": "Putumayo",
                "shortCode": "PUT"
            },
            {
                "value": "Quindío",
                "label": "Quindío",
                "shortCode": "QUI"
            },
            {
                "value": "Risaralda",
                "label": "Risaralda",
                "shortCode": "RIS"
            },
            {
                "value": "Santander",
                "label": "Santander",
                "shortCode": "SAN"
            },
            {
                "value": "Sucre",
                "label": "Sucre",
                "shortCode": "SUC"
            },
            {
                "value": "Tolima",
                "label": "Tolima",
                "shortCode": "TOL"
            },
            {
                "value": "Valle del Cauca",
                "label": "Valle del Cauca",
                "shortCode": "VAC"
            },
            {
                "value": "Vaupés",
                "label": "Vaupés",
                "shortCode": "VAU"
            },
            {
                "value": "Vichada",
                "label": "Vichada",
                "shortCode": "VID"
            }
        ]
    },
    {
        "countryCode": "+269",
        "value": "Comoros",
        "label": "Comoros",
        "regions": [
            {
                "value": "Andjazîdja",
                "label": "Andjazîdja",
                "shortCode": "G"
            },
            {
                "value": "Andjouân",
                "label": "Andjouân",
                "shortCode": "A"
            },
            {
                "value": "Moûhîlî",
                "label": "Moûhîlî",
                "shortCode": "M"
            }
        ]
    },
    {
        "countryCode": "+682",
        "value": "Cook Islands",
        "label": "Cook Islands",
        "regions": [
            {
                "value": "Aitutaki",
                "label": "Aitutaki"
            },
            {
                "value": "Atiu",
                "label": "Atiu"
            },
            {
                "value": "Avarua",
                "label": "Avarua"
            },
            {
                "value": "Mangaia",
                "label": "Mangaia"
            },
            {
                "value": "Manihiki",
                "label": "Manihiki"
            },
            {
                "value": "Ma'uke",
                "label": "Ma'uke"
            },
            {
                "value": "Mitiaro",
                "label": "Mitiaro"
            },
            {
                "value": "Nassau",
                "label": "Nassau"
            },
            {
                "value": "Palmerston",
                "label": "Palmerston"
            },
            {
                "value": "Penrhyn",
                "label": "Penrhyn"
            },
            {
                "value": "Pukapuka",
                "label": "Pukapuka"
            },
            {
                "value": "Rakahanga",
                "label": "Rakahanga"
            }
        ]
    },
    {
        "countryCode": "+506",
        "value": "Costa Rica",
        "label": "Costa Rica",
        "regions": [
            {
                "value": "Alajuela",
                "label": "Alajuela",
                "shortCode": "2"
            },
            {
                "value": "Cartago",
                "label": "Cartago",
                "shortCode": "3"
            },
            {
                "value": "Guanacaste",
                "label": "Guanacaste",
                "shortCode": "5"
            },
            {
                "value": "Heredia",
                "label": "Heredia",
                "shortCode": "4"
            },
            {
                "value": "Limón",
                "label": "Limón",
                "shortCode": "7"
            },
            {
                "value": "Puntarenas",
                "label": "Puntarenas",
                "shortCode": "6"
            },
            {
                "value": "San José",
                "label": "San José",
                "shortCode": "1"
            }
        ]
    },
    {
        "countryCode": "+385",
        "value": "Croatia",
        "label": "Croatia",
        "regions": [
            {
                "value": "Bjelovarsko-bilogorska županija",
                "label": "Bjelovarsko-bilogorska županija",
                "shortCode": "07"
            },
            {
                "value": "Brodsko-posavska županija",
                "label": "Brodsko-posavska županija",
                "shortCode": "12"
            },
            {
                "value": "Dubrovačko-neretvanska županija",
                "label": "Dubrovačko-neretvanska županija",
                "shortCode": "19"
            },
            {
                "value": "Grad Zagreb",
                "label": "Grad Zagreb",
                "shortCode": "21"
            },
            {
                "value": "Istarska županija",
                "label": "Istarska županija",
                "shortCode": "18"
            },
            {
                "value": "Karlovačka županija",
                "label": "Karlovačka županija",
                "shortCode": "04"
            },
            {
                "value": "Koprivničko-križevačka županija",
                "label": "Koprivničko-križevačka županija",
                "shortCode": "06"
            },
            {
                "value": "Krapinsko-zagorska županija",
                "label": "Krapinsko-zagorska županija",
                "shortCode": "02"
            },
            {
                "value": "Ličko-senjska županija",
                "label": "Ličko-senjska županija",
                "shortCode": "09"
            },
            {
                "value": "Međimurska županija",
                "label": "Međimurska županija",
                "shortCode": "20"
            },
            {
                "value": "Osječko-baranjska županija",
                "label": "Osječko-baranjska županija",
                "shortCode": "14"
            },
            {
                "value": "Požeško-slavonska županija",
                "label": "Požeško-slavonska županija",
                "shortCode": "11"
            },
            {
                "value": "Primorsko-goranska županija",
                "label": "Primorsko-goranska županija",
                "shortCode": "08"
            },
            {
                "value": "Sisačko-moslavačka županija",
                "label": "Sisačko-moslavačka županija",
                "shortCode": "03"
            },
            {
                "value": "Splitsko-dalmatinska županija",
                "label": "Splitsko-dalmatinska županija",
                "shortCode": "17"
            },
            {
                "value": "Šibensko-kninska županija",
                "label": "Šibensko-kninska županija",
                "shortCode": "15"
            },
            {
                "value": "Varaždinska županija",
                "label": "Varaždinska županija",
                "shortCode": "05"
            },
            {
                "value": "Virovitičko-podravska županija",
                "label": "Virovitičko-podravska županija",
                "shortCode": "10"
            },
            {
                "value": "Vukovarsko-srijemska županija",
                "label": "Vukovarsko-srijemska županija",
                "shortCode": "16"
            },
            {
                "value": "Zadarska županija",
                "label": "Zadarska županija",
                "shortCode": "13"
            },
            {
                "value": "Zagrebačka županija",
                "label": "Zagrebačka županija",
                "shortCode": "01"
            }
        ]
    },
    {
        "countryCode": "+53",
        "value": "Cuba",
        "label": "Cuba",
        "regions": [
            {
                "value": "Artemisa",
                "label": "Artemisa",
                "shortCode": "15"
            },
            {
                "value": "Camagüey",
                "label": "Camagüey",
                "shortCode": "09"
            },
            {
                "value": "Ciego de Ávila",
                "label": "Ciego de Ávila",
                "shortCode": "08"
            },
            {
                "value": "Cienfuegos",
                "label": "Cienfuegos",
                "shortCode": "06"
            },
            {
                "value": "Granma",
                "label": "Granma",
                "shortCode": "12"
            },
            {
                "value": "Guantánamo",
                "label": "Guantánamo",
                "shortCode": "14"
            },
            {
                "value": "Holguín",
                "label": "Holguín",
                "shortCode": "11"
            },
            {
                "value": "Isla de la Juventud",
                "label": "Isla de la Juventud",
                "shortCode": "99"
            },
            {
                "value": "La Habana",
                "label": "La Habana",
                "shortCode": "03"
            },
            {
                "value": "Las Tunas",
                "label": "Las Tunas",
                "shortCode": "10"
            },
            {
                "value": "Matanzas",
                "label": "Matanzas",
                "shortCode": "04"
            },
            {
                "value": "Mayabeque",
                "label": "Mayabeque",
                "shortCode": "16"
            },
            {
                "value": "Pinar del Río",
                "label": "Pinar del Río",
                "shortCode": "01"
            },
            {
                "value": "Sancti Spíritus",
                "label": "Sancti Spíritus",
                "shortCode": "07"
            },
            {
                "value": "Santiago de Cuba",
                "label": "Santiago de Cuba",
                "shortCode": "13"
            },
            {
                "value": "Villa Clara",
                "label": "Villa Clara",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+599 9",
        "value": "Curaçao",
        "label": "Curaçao",
        "regions": [
            {
                "value": "Curaçao",
                "label": "Curaçao",
                "shortCode": "CW"
            }
        ]
    },
    {
        "countryCode": "+357",
        "value": "Cyprus",
        "label": "Cyprus",
        "regions": [
            {
                "value": "Ammochostos",
                "label": "Ammochostos",
                "shortCode": "04"
            },
            {
                "value": "Keryneia",
                "label": "Keryneia",
                "shortCode": "06"
            },
            {
                "value": "Larnaka",
                "label": "Larnaka",
                "shortCode": "03"
            },
            {
                "value": "Lefkosia",
                "label": "Lefkosia",
                "shortCode": "01"
            },
            {
                "value": "Lemesos",
                "label": "Lemesos",
                "shortCode": "02"
            },
            {
                "value": "Pafos",
                "label": "Pafos",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+420",
        "value": "Czech Republic",
        "label": "Czech Republic",
        "regions": [
            {
                "value": "Hlavní město Praha",
                "label": "Hlavní město Praha",
                "shortCode": "10"
            },
            {
                "value": "Jihočeský kraj",
                "label": "Jihočeský kraj",
                "shortCode": "31"
            },
            {
                "value": "Jihomoravský kraj",
                "label": "Jihomoravský kraj",
                "shortCode": "64"
            },
            {
                "value": "Karlovarský kraj",
                "label": "Karlovarský kraj",
                "shortCode": "41"
            },
            {
                "value": "Královéhradecký kraj",
                "label": "Královéhradecký kraj",
                "shortCode": "52"
            },
            {
                "value": "Liberecký kraj",
                "label": "Liberecký kraj",
                "shortCode": "51"
            },
            {
                "value": "Moravskoslezský kraj",
                "label": "Moravskoslezský kraj",
                "shortCode": "80"
            },
            {
                "value": "Olomoucký kraj",
                "label": "Olomoucký kraj",
                "shortCode": "71"
            },
            {
                "value": "Pardubický kraj",
                "label": "Pardubický kraj",
                "shortCode": "53"
            },
            {
                "value": "Plzeňský kraj",
                "label": "Plzeňský kraj",
                "shortCode": "32"
            },
            {
                "value": "Středočeský kraj",
                "label": "Středočeský kraj",
                "shortCode": "20"
            },
            {
                "value": "Ústecký kraj",
                "label": "Ústecký kraj",
                "shortCode": "42"
            },
            {
                "value": "Vysočina",
                "label": "Vysočina",
                "shortCode": "63"
            },
            {
                "value": "Zlínský kraj",
                "label": "Zlínský kraj",
                "shortCode": "72"
            }
        ]
    },
    {
        "countryCode": "+45",
        "value": "Denmark",
        "label": "Denmark",
        "regions": [
            {
                "value": "Hovedstaden",
                "label": "Hovedstaden",
                "shortCode": "DK-84"
            },
            {
                "value": "Midtjylland",
                "label": "Midtjylland",
                "shortCode": "DK-82"
            },
            {
                "value": "Nordjylland",
                "label": "Nordjylland",
                "shortCode": "DK-81"
            },
            {
                "value": "Sjælland",
                "label": "Sjælland",
                "shortCode": "DK-85"
            },
            {
                "value": "Syddanmark",
                "label": "Syddanmark",
                "shortCode": "DK-83"
            }
        ]
    },
    {
        "countryCode": "+253",
        "value": "Djibouti",
        "label": "Djibouti",
        "regions": [
            {
                "value": "Ali Sabieh",
                "label": "Ali Sabieh",
                "shortCode": "AS"
            },
            {
                "value": "Arta",
                "label": "Arta",
                "shortCode": "AR"
            },
            {
                "value": "Dikhil",
                "label": "Dikhil",
                "shortCode": "DI"
            },
            {
                "value": "Obock",
                "label": "Obock",
                "shortCode": "OB"
            },
            {
                "value": "Tadjourah",
                "label": "Tadjourah",
                "shortCode": "TA"
            }
        ]
    },
    {
        "countryCode": "+1 767",
        "value": "Dominica",
        "label": "Dominica",
        "regions": [
            {
                "value": "Saint Andrew Parish",
                "label": "Saint Andrew Parish",
                "shortCode": "02"
            },
            {
                "value": "Saint David Parish",
                "label": "Saint David Parish",
                "shortCode": "03"
            },
            {
                "value": "Saint George Parish",
                "label": "Saint George Parish",
                "shortCode": "04"
            },
            {
                "value": "Saint John Parish",
                "label": "Saint John Parish",
                "shortCode": "05"
            },
            {
                "value": "Saint Joseph Parish",
                "label": "Saint Joseph Parish",
                "shortCode": "06"
            },
            {
                "value": "Saint Luke Parish",
                "label": "Saint Luke Parish",
                "shortCode": "07"
            },
            {
                "value": "Saint Mark Parish",
                "label": "Saint Mark Parish",
                "shortCode": "08"
            },
            {
                "value": "Saint Patrick Parish",
                "label": "Saint Patrick Parish",
                "shortCode": "09"
            },
            {
                "value": "Saint Paul Parish",
                "label": "Saint Paul Parish",
                "shortCode": "10"
            },
            {
                "value": "Saint Peter Parish",
                "label": "Saint Peter Parish",
                "shortCode": "11"
            }
        ]
    },
    {
        "countryCode": "+1 809, 1 829,\n1 849",
        "value": "Dominican Republic",
        "label": "Dominican Republic",
        "regions": [
            {
                "value": "Cibao Central",
                "label": "Cibao Central",
                "shortCode": "02"
            },
            {
                "value": "Del Valle",
                "label": "Del Valle",
                "shortCode": "37"
            },
            {
                "value": "Distrito Nacional",
                "label": "Distrito Nacional",
                "shortCode": "01"
            },
            {
                "value": "Enriquillo",
                "label": "Enriquillo",
                "shortCode": "38"
            },
            {
                "value": "Norcentral",
                "label": "Norcentral",
                "shortCode": "04"
            },
            {
                "value": "Nordeste",
                "label": "Nordeste",
                "shortCode": "33"
            },
            {
                "value": "Noroeste",
                "label": "Noroeste",
                "shortCode": "34"
            },
            {
                "value": "Norte",
                "label": "Norte",
                "shortCode": "35"
            },
            {
                "value": "Valdesia",
                "label": "Valdesia",
                "shortCode": "42"
            }
        ]
    },
    {
        "countryCode": "+593",
        "value": "Ecuador",
        "label": "Ecuador",
        "regions": [
            {
                "value": "Azuay",
                "label": "Azuay",
                "shortCode": "A"
            },
            {
                "value": "Bolívar",
                "label": "Bolívar",
                "shortCode": "B"
            },
            {
                "value": "Cañar",
                "label": "Cañar",
                "shortCode": "F"
            },
            {
                "value": "Carchi",
                "label": "Carchi",
                "shortCode": "C"
            },
            {
                "value": "Chimborazo",
                "label": "Chimborazo",
                "shortCode": "H"
            },
            {
                "value": "Cotopaxi",
                "label": "Cotopaxi",
                "shortCode": "X"
            },
            {
                "value": "El Oro",
                "label": "El Oro",
                "shortCode": "O"
            },
            {
                "value": "Esmeraldas",
                "label": "Esmeraldas",
                "shortCode": "E"
            },
            {
                "value": "Galápagos",
                "label": "Galápagos",
                "shortCode": "W"
            },
            {
                "value": "Guayas",
                "label": "Guayas",
                "shortCode": "G"
            },
            {
                "value": "Imbabura",
                "label": "Imbabura",
                "shortCode": "I"
            },
            {
                "value": "Loja",
                "label": "Loja",
                "shortCode": "L"
            },
            {
                "value": "Los Ríos",
                "label": "Los Ríos",
                "shortCode": "R"
            },
            {
                "value": "Manabí",
                "label": "Manabí",
                "shortCode": "M"
            },
            {
                "value": "Morona-Santiago",
                "label": "Morona-Santiago",
                "shortCode": "S"
            },
            {
                "value": "Napo",
                "label": "Napo",
                "shortCode": "N"
            },
            {
                "value": "Orellana",
                "label": "Orellana",
                "shortCode": "D"
            },
            {
                "value": "Pastaza",
                "label": "Pastaza",
                "shortCode": "Y"
            },
            {
                "value": "Pichincha",
                "label": "Pichincha",
                "shortCode": "P"
            },
            {
                "value": "Santa Elena",
                "label": "Santa Elena",
                "shortCode": "SE"
            },
            {
                "value": "Santo Domingo de los Tsáchilas",
                "label": "Santo Domingo de los Tsáchilas",
                "shortCode": "SD"
            },
            {
                "value": "Sucumbíos",
                "label": "Sucumbíos",
                "shortCode": "U"
            },
            {
                "value": "Tungurahua",
                "label": "Tungurahua",
                "shortCode": "T"
            },
            {
                "value": "Zamora-Chinchipe",
                "label": "Zamora-Chinchipe",
                "shortCode": "Z"
            }
        ]
    },
    {
        "countryCode": "+20",
        "value": "Egypt",
        "label": "Egypt",
        "regions": [
            {
                "value": "Alexandria",
                "label": "Alexandria",
                "shortCode": "ALX"
            },
            {
                "value": "Aswan",
                "label": "Aswan",
                "shortCode": "ASN"
            },
            {
                "value": "Asyout",
                "label": "Asyout",
                "shortCode": "AST"
            },
            {
                "value": "Bani Sueif",
                "label": "Bani Sueif",
                "shortCode": "BNS"
            },
            {
                "value": "Beheira",
                "label": "Beheira",
                "shortCode": "BH"
            },
            {
                "value": "Cairo",
                "label": "Cairo",
                "shortCode": "C"
            },
            {
                "value": "Daqahlia",
                "label": "Daqahlia",
                "shortCode": "DK"
            },
            {
                "value": "Dumiat",
                "label": "Dumiat",
                "shortCode": "DT"
            },
            {
                "value": "El Bahr El Ahmar",
                "label": "El Bahr El Ahmar",
                "shortCode": "BA"
            },
            {
                "value": "El Ismailia",
                "label": "El Ismailia",
                "shortCode": "IS"
            },
            {
                "value": "El Suez",
                "label": "El Suez",
                "shortCode": "SUZ"
            },
            {
                "value": "El Wadi El Gedeed",
                "label": "El Wadi El Gedeed",
                "shortCode": "WAD"
            },
            {
                "value": "Fayoum",
                "label": "Fayoum",
                "shortCode": "FYM"
            },
            {
                "value": "Gharbia",
                "label": "Gharbia",
                "shortCode": "GH"
            },
            {
                "value": "Giza",
                "label": "Giza",
                "shortCode": "GZ"
            },
            {
                "value": "Helwan",
                "label": "Helwan",
                "shortCode": "HU"
            },
            {
                "value": "Kafr El Sheikh",
                "label": "Kafr El Sheikh",
                "shortCode": "KFS"
            },
            {
                "value": "Luxor",
                "label": "Luxor",
                "shortCode": "LX"
            },
            {
                "value": "Matrouh",
                "label": "Matrouh",
                "shortCode": "MT"
            },
            {
                "value": "Menia",
                "label": "Menia",
                "shortCode": "MN"
            },
            {
                "value": "Menofia",
                "label": "Menofia",
                "shortCode": "MNF"
            },
            {
                "value": "North Sinai",
                "label": "North Sinai",
                "shortCode": "SIN"
            },
            {
                "value": "Port Said",
                "label": "Port Said",
                "shortCode": "PTS"
            },
            {
                "value": "Qalubia",
                "label": "Qalubia",
                "shortCode": "KB"
            },
            {
                "value": "Qena",
                "label": "Qena",
                "shortCode": "KN"
            },
            {
                "value": "Sharqia",
                "label": "Sharqia",
                "shortCode": "SHR"
            },
            {
                "value": "Sixth of October",
                "label": "Sixth of October",
                "shortCode": "SU"
            },
            {
                "value": "Sohag",
                "label": "Sohag",
                "shortCode": "SHG"
            },
            {
                "value": "South Sinai",
                "label": "South Sinai",
                "shortCode": "JS"
            }
        ]
    },
    {
        "countryCode": "+503",
        "value": "El Salvador",
        "label": "El Salvador",
        "regions": [
            {
                "value": "Ahuachapán",
                "label": "Ahuachapán",
                "shortCode": "AH"
            },
            {
                "value": "Cabañas",
                "label": "Cabañas",
                "shortCode": "CA"
            },
            {
                "value": "Cuscatlán",
                "label": "Cuscatlán",
                "shortCode": "CU"
            },
            {
                "value": "Chalatenango",
                "label": "Chalatenango",
                "shortCode": "CH"
            },
            {
                "value": "La Libertad",
                "label": "La Libertad",
                "shortCode": "LI"
            },
            {
                "value": "La Paz",
                "label": "La Paz",
                "shortCode": "PA"
            },
            {
                "value": "La Unión",
                "label": "La Unión",
                "shortCode": "UN"
            },
            {
                "value": "Morazán",
                "label": "Morazán",
                "shortCode": "MO"
            },
            {
                "value": "San Miguel",
                "label": "San Miguel",
                "shortCode": "SM"
            },
            {
                "value": "San Salvador",
                "label": "San Salvador",
                "shortCode": "SS"
            },
            {
                "value": "Santa Ana",
                "label": "Santa Ana",
                "shortCode": "SA"
            },
            {
                "value": "San Vicente",
                "label": "San Vicente",
                "shortCode": "SV"
            },
            {
                "value": "Sonsonate",
                "label": "Sonsonate",
                "shortCode": "SO"
            },
            {
                "value": "Usulután",
                "label": "Usulután",
                "shortCode": "US"
            }
        ]
    },
    {
        "countryCode": "+240",
        "value": "Equatorial Guinea",
        "label": "Equatorial Guinea",
        "regions": [
            {
                "value": "Annobón",
                "label": "Annobón",
                "shortCode": "AN"
            },
            {
                "value": "Bioko Norte",
                "label": "Bioko Norte",
                "shortCode": "BN"
            },
            {
                "value": "Bioko Sur",
                "label": "Bioko Sur",
                "shortCode": "BS"
            },
            {
                "value": "Centro Sur",
                "label": "Centro Sur",
                "shortCode": "CS"
            },
            {
                "value": "Kié-Ntem",
                "label": "Kié-Ntem",
                "shortCode": "KN"
            },
            {
                "value": "Litoral",
                "label": "Litoral",
                "shortCode": "LI"
            },
            {
                "value": "Wele-Nzas",
                "label": "Wele-Nzas",
                "shortCode": "WN"
            }
        ]
    },
    {
        "countryCode": "+291",
        "value": "Eritrea",
        "label": "Eritrea",
        "regions": [
            {
                "value": "Anseba",
                "label": "Anseba",
                "shortCode": "AN"
            },
            {
                "value": "Debub",
                "label": "Debub",
                "shortCode": "DU"
            },
            {
                "value": "Debub-Keih-Bahri",
                "label": "Debub-Keih-Bahri",
                "shortCode": "DK"
            },
            {
                "value": "Gash-Barka",
                "label": "Gash-Barka",
                "shortCode": "GB"
            },
            {
                "value": "Maekel",
                "label": "Maekel",
                "shortCode": "MA"
            },
            {
                "value": "Semien-Keih-Bahri",
                "label": "Semien-Keih-Bahri",
                "shortCode": "SK"
            }
        ]
    },
    {
        "countryCode": "+372",
        "value": "Estonia",
        "label": "Estonia",
        "regions": [
            {
                "value": "Harjumaa (Tallinn)",
                "label": "Harjumaa (Tallinn)",
                "shortCode": "37"
            },
            {
                "value": "Hiiumaa (Kardla)",
                "label": "Hiiumaa (Kardla)",
                "shortCode": "39"
            },
            {
                "value": "Ida-Virumaa (Johvi)",
                "label": "Ida-Virumaa (Johvi)",
                "shortCode": "44"
            },
            {
                "value": "Järvamaa (Paide)",
                "label": "Järvamaa (Paide)",
                "shortCode": "41"
            },
            {
                "value": "Jõgevamaa (Jogeva)",
                "label": "Jõgevamaa (Jogeva)",
                "shortCode": "49"
            },
            {
                "value": "Läänemaa",
                "label": "Läänemaa",
                "shortCode": "57"
            },
            {
                "value": "Lääne-Virumaa (Rakvere)",
                "label": "Lääne-Virumaa (Rakvere)",
                "shortCode": "59"
            },
            {
                "value": "Pärnumaa (Parnu)",
                "label": "Pärnumaa (Parnu)",
                "shortCode": "67"
            },
            {
                "value": "Põlvamaa (Polva)",
                "label": "Põlvamaa (Polva)",
                "shortCode": "65"
            },
            {
                "value": "Raplamaa (Rapla)",
                "label": "Raplamaa (Rapla)",
                "shortCode": "70"
            },
            {
                "value": "Saaremaa (Kuessaare)",
                "label": "Saaremaa (Kuessaare)",
                "shortCode": "74"
            },
            {
                "value": "Tartumaa (Tartu)",
                "label": "Tartumaa (Tartu)",
                "shortCode": "78"
            },
            {
                "value": "Valgamaa (Valga)",
                "label": "Valgamaa (Valga)",
                "shortCode": "82"
            },
            {
                "value": "Viljandimaa (Viljandi)",
                "label": "Viljandimaa (Viljandi)",
                "shortCode": "84"
            },
            {
                "value": "Võrumaa (Voru)",
                "label": "Võrumaa (Voru)",
                "shortCode": "86"
            }
        ]
    },
    {
        "countryCode": "+268",
        "value": "Eswatini",
        "label": "Eswatini",
        "regions": [
            {
                "value": "Hhohho",
                "label": "Hhohho",
                "shortCode": "HH"
            },
            {
                "value": "Lubombo",
                "label": "Lubombo",
                "shortCode": "LU"
            },
            {
                "value": "Manzini",
                "label": "Manzini",
                "shortCode": "MA"
            },
            {
                "value": "Shiselweni",
                "label": "Shiselweni",
                "shortCode": "SH"
            }
        ]
    },
    {
        "countryCode": "+251",
        "value": "Ethiopia",
        "label": "Ethiopia",
        "regions": [
            {
                "value": "Addis Ababa",
                "label": "Addis Ababa",
                "shortCode": "AA"
            },
            {
                "value": "Afar",
                "label": "Afar",
                "shortCode": "AF"
            },
            {
                "value": "Amhara",
                "label": "Amhara",
                "shortCode": "AM"
            },
            {
                "value": "Benshangul-Gumaz",
                "label": "Benshangul-Gumaz",
                "shortCode": "BE"
            },
            {
                "value": "Dire Dawa",
                "label": "Dire Dawa",
                "shortCode": "DD"
            },
            {
                "value": "Gambela",
                "label": "Gambela",
                "shortCode": "GA"
            },
            {
                "value": "Harari",
                "label": "Harari",
                "shortCode": "HA"
            },
            {
                "value": "Oromia",
                "label": "Oromia",
                "shortCode": "OR"
            },
            {
                "value": "Somali",
                "label": "Somali",
                "shortCode": "SO"
            },
            {
                "value": "Southern Nations Nationalities and People's Region",
                "label": "Southern Nations Nationalities and People's Region",
                "shortCode": "SN"
            },
            {
                "value": "Tigray",
                "label": "Tigray",
                "shortCode": "TI"
            }
        ]
    },
    {
        "countryCode": "+298",
        "value": "Faroe Islands",
        "label": "Faroe Islands",
        "regions": [
            {
                "value": "Bordoy",
                "label": "Bordoy"
            },
            {
                "value": "Eysturoy",
                "label": "Eysturoy"
            },
            {
                "value": "Mykines",
                "label": "Mykines"
            },
            {
                "value": "Sandoy",
                "label": "Sandoy"
            },
            {
                "value": "Skuvoy",
                "label": "Skuvoy"
            },
            {
                "value": "Streymoy",
                "label": "Streymoy"
            },
            {
                "value": "Suduroy",
                "label": "Suduroy"
            },
            {
                "value": "Tvoroyri",
                "label": "Tvoroyri"
            },
            {
                "value": "Vagar",
                "label": "Vagar"
            }
        ]
    },
    {
        "countryCode": "+679",
        "value": "Fiji",
        "label": "Fiji",
        "regions": [
            {
                "value": "Ba",
                "label": "Ba",
                "shortCode": "01"
            },
            {
                "value": "Bua",
                "label": "Bua",
                "shortCode": "02"
            },
            {
                "value": "Cakaudrove",
                "label": "Cakaudrove",
                "shortCode": "03"
            },
            {
                "value": "Kadavu",
                "label": "Kadavu",
                "shortCode": "04"
            },
            {
                "value": "Lau",
                "label": "Lau",
                "shortCode": "05"
            },
            {
                "value": "Lomaiviti",
                "label": "Lomaiviti",
                "shortCode": "06"
            },
            {
                "value": "Macuata",
                "label": "Macuata",
                "shortCode": "07"
            },
            {
                "value": "Nadroga and Navosa",
                "label": "Nadroga and Navosa",
                "shortCode": "08"
            },
            {
                "value": "Naitasiri",
                "label": "Naitasiri",
                "shortCode": "09"
            },
            {
                "value": "Namosi",
                "label": "Namosi",
                "shortCode": "10"
            },
            {
                "value": "Ra",
                "label": "Ra",
                "shortCode": "11"
            },
            {
                "value": "Rewa",
                "label": "Rewa",
                "shortCode": "12"
            },
            {
                "value": "Rotuma",
                "label": "Rotuma",
                "shortCode": "R"
            },
            {
                "value": "Serua",
                "label": "Serua",
                "shortCode": "13"
            },
            {
                "value": "Tailevu",
                "label": "Tailevu",
                "shortCode": "14"
            }
        ]
    },
    {
        "countryCode": "+358",
        "value": "Finland",
        "label": "Finland",
        "regions": [
            {
                "value": "Ahvenanmaan maakunta",
                "label": "Ahvenanmaan maakunta",
                "shortCode": "FI-01"
            },
            {
                "value": "Etelä-Karjala",
                "label": "Etelä-Karjala",
                "shortCode": "FI-02"
            },
            {
                "value": "Etelä-Pohjanmaa",
                "label": "Etelä-Pohjanmaa",
                "shortCode": "FI-03"
            },
            {
                "value": "Etelä-Savo",
                "label": "Etelä-Savo",
                "shortCode": "FI-04"
            },
            {
                "value": "Kainuu",
                "label": "Kainuu",
                "shortCode": "FI-05"
            },
            {
                "value": "Kanta-Häme",
                "label": "Kanta-Häme",
                "shortCode": "FI-06"
            },
            {
                "value": "Keski-Pohjanmaa",
                "label": "Keski-Pohjanmaa",
                "shortCode": "FI-07"
            },
            {
                "value": "Keski-Suomi",
                "label": "Keski-Suomi",
                "shortCode": "FI-08"
            },
            {
                "value": "Kymenlaakso",
                "label": "Kymenlaakso",
                "shortCode": "FI-09"
            },
            {
                "value": "Lappi",
                "label": "Lappi",
                "shortCode": "FI-10"
            },
            {
                "value": "Pirkanmaa",
                "label": "Pirkanmaa",
                "shortCode": "FI-11"
            },
            {
                "value": "Pohjanmaa",
                "label": "Pohjanmaa",
                "shortCode": "FI-12"
            },
            {
                "value": "Pohjois-Karjala",
                "label": "Pohjois-Karjala",
                "shortCode": "FI-13"
            },
            {
                "value": "Pohjois-Pohjanmaa",
                "label": "Pohjois-Pohjanmaa",
                "shortCode": "FI-14"
            },
            {
                "value": "Pohjois-Savo",
                "label": "Pohjois-Savo",
                "shortCode": "FI-15"
            },
            {
                "value": "Päijät-Häme",
                "label": "Päijät-Häme",
                "shortCode": "FI-16"
            },
            {
                "value": "Satakunta",
                "label": "Satakunta",
                "shortCode": "FI-17"
            },
            {
                "value": "Uusimaa",
                "label": "Uusimaa",
                "shortCode": "FI-18"
            },
            {
                "value": "Varsinais-Suomi",
                "label": "Varsinais-Suomi",
                "shortCode": "FI-19"
            }
        ]
    },
    {
        "countryCode": "+33",
        "value": "France",
        "label": "France",
        "regions": [
            {
                "value": "Auvergne-Rhône-Alpes",
                "label": "Auvergne-Rhône-Alpes",
                "shortCode": "ARA"
            },
            {
                "value": "Bourgogne-Franche-Comté",
                "label": "Bourgogne-Franche-Comté",
                "shortCode": "BFC"
            },
            {
                "value": "Bretagne",
                "label": "Bretagne",
                "shortCode": "BRE"
            },
            {
                "value": "Centre-Val de Loire",
                "label": "Centre-Val de Loire",
                "shortCode": "CVL"
            },
            {
                "value": "Corse",
                "label": "Corse",
                "shortCode": "COR"
            },
            {
                "value": "Grand Est",
                "label": "Grand Est",
                "shortCode": "GES"
            },
            {
                "value": "Hauts-de-France",
                "label": "Hauts-de-France",
                "shortCode": "HDF"
            },
            {
                "value": "Île-de-France",
                "label": "Île-de-France",
                "shortCode": "IDF"
            },
            {
                "value": "Normandie",
                "label": "Normandie",
                "shortCode": "NOR"
            },
            {
                "value": "Nouvelle-Aquitaine",
                "label": "Nouvelle-Aquitaine",
                "shortCode": "NAQ"
            },
            {
                "value": "Occitanie",
                "label": "Occitanie",
                "shortCode": "OCC"
            },
            {
                "value": "Pays de la Loire",
                "label": "Pays de la Loire",
                "shortCode": "PDL"
            },
            {
                "value": "Provence-Alpes-Cote d'Azur",
                "label": "Provence-Alpes-Cote d'Azur",
                "shortCode": "PAC"
            },
            {
                "value": "Clipperton",
                "label": "Clipperton",
                "shortCode": "CP"
            },
            {
                "value": "Guadeloupe",
                "label": "Guadeloupe",
                "shortCode": "GP"
            },
            {
                "value": "Guyane",
                "label": "Guyane",
                "shortCode": "GF"
            },
            {
                "value": "Martinique",
                "label": "Martinique",
                "shortCode": "MQ"
            },
            {
                "value": "Mayotte",
                "label": "Mayotte",
                "shortCode": "YT"
            },
            {
                "value": "Nouvelle-Calédonie",
                "label": "Nouvelle-Calédonie",
                "shortCode": "NC"
            },
            {
                "value": "Polynésie",
                "label": "Polynésie",
                "shortCode": "PF"
            },
            {
                "value": "Saint-Pierre-et-Miquelon",
                "label": "Saint-Pierre-et-Miquelon",
                "shortCode": "PM"
            },
            {
                "value": "Saint Barthélemy",
                "label": "Saint Barthélemy",
                "shortCode": "BL"
            },
            {
                "value": "Saint Martin",
                "label": "Saint Martin",
                "shortCode": "MF"
            },
            {
                "value": "Réunion",
                "label": "Réunion",
                "shortCode": "RE"
            },
            {
                "value": "Terres Australes Françaises",
                "label": "Terres Australes Françaises",
                "shortCode": "TF"
            },
            {
                "value": "Wallis-et-Futuna",
                "label": "Wallis-et-Futuna",
                "shortCode": "WF"
            }
        ]
    },
    {
        "countryCode": "+594",
        "value": "French Guiana",
        "label": "French Guiana",
        "regions": [
            {
                "value": "French Guiana",
                "label": "French Guiana"
            }
        ]
    },
    {
        "countryCode": "+689",
        "value": "French Polynesia",
        "label": "French Polynesia",
        "regions": [
            {
                "value": "Archipel des Marquises",
                "label": "Archipel des Marquises"
            },
            {
                "value": "Archipel des Tuamotu",
                "label": "Archipel des Tuamotu"
            },
            {
                "value": "Archipel des Tubuai",
                "label": "Archipel des Tubuai"
            },
            {
                "value": "Iles du Vent",
                "label": "Iles du Vent"
            },
            {
                "value": "Iles Sous-le-Vent",
                "label": "Iles Sous-le-Vent"
            }
        ]
    },
    {
        "countryCode": "+241",
        "value": "Gabon",
        "label": "Gabon",
        "regions": [
            {
                "value": "Estuaire",
                "label": "Estuaire",
                "shortCode": "1"
            },
            {
                "value": "Haut-Ogooué",
                "label": "Haut-Ogooué",
                "shortCode": "2"
            },
            {
                "value": "Moyen-Ogooué",
                "label": "Moyen-Ogooué",
                "shortCode": "3"
            },
            {
                "value": "Ngounié",
                "label": "Ngounié",
                "shortCode": "4"
            },
            {
                "value": "Nyanga",
                "label": "Nyanga",
                "shortCode": "5"
            },
            {
                "value": "Ogooué-Ivindo",
                "label": "Ogooué-Ivindo",
                "shortCode": "6"
            },
            {
                "value": "Ogooué-Lolo",
                "label": "Ogooué-Lolo",
                "shortCode": "7"
            },
            {
                "value": "Ogooué-Maritime",
                "label": "Ogooué-Maritime",
                "shortCode": "8"
            },
            {
                "value": "Woleu-Ntem",
                "label": "Woleu-Ntem",
                "shortCode": "9"
            }
        ]
    },
    {
        "countryCode": "+995",
        "value": "Georgia",
        "label": "Georgia",
        "regions": [
            {
                "value": "Abkhazia (Sokhumi)",
                "label": "Abkhazia (Sokhumi)",
                "shortCode": "AB"
            },
            {
                "value": "Ajaria (Bat'umi)",
                "label": "Ajaria (Bat'umi)",
                "shortCode": "AJ"
            },
            {
                "value": "Guria",
                "label": "Guria",
                "shortCode": "GU"
            },
            {
                "value": "Imereti",
                "label": "Imereti",
                "shortCode": "IM"
            },
            {
                "value": "K'akheti",
                "label": "K'akheti",
                "shortCode": "KA"
            },
            {
                "value": "Kvemo Kartli",
                "label": "Kvemo Kartli",
                "shortCode": "KK"
            },
            {
                "value": "Mtshkheta-Mtianeti",
                "label": "Mtshkheta-Mtianeti",
                "shortCode": "MM"
            },
            {
                "value": "Rach'a-Lexhkumi-KvemoSvaneti",
                "label": "Rach'a-Lexhkumi-KvemoSvaneti",
                "shortCode": "RL"
            },
            {
                "value": "Samegrelo-Zemo Svaneti",
                "label": "Samegrelo-Zemo Svaneti",
                "shortCode": "SZ"
            },
            {
                "value": "Samtskhe-Javakheti",
                "label": "Samtskhe-Javakheti",
                "shortCode": "SJ"
            },
            {
                "value": "Shida Kartli",
                "label": "Shida Kartli",
                "shortCode": "SK"
            },
            {
                "value": "Tbilisi",
                "label": "Tbilisi",
                "shortCode": "TB"
            }
        ]
    },
    {
        "countryCode": "+49",
        "value": "Germany",
        "label": "Germany",
        "regions": [
            {
                "value": "Baden-Württemberg",
                "label": "Baden-Württemberg",
                "shortCode": "BW"
            },
            {
                "value": "Bayern",
                "label": "Bayern",
                "shortCode": "BY"
            },
            {
                "value": "Berlin",
                "label": "Berlin",
                "shortCode": "BE"
            },
            {
                "value": "Brandenburg",
                "label": "Brandenburg",
                "shortCode": "BB"
            },
            {
                "value": "Bremen",
                "label": "Bremen",
                "shortCode": "HB"
            },
            {
                "value": "Hamburg",
                "label": "Hamburg",
                "shortCode": "HH"
            },
            {
                "value": "Hessen",
                "label": "Hessen",
                "shortCode": "HE"
            },
            {
                "value": "Mecklenburg-Vorpommern",
                "label": "Mecklenburg-Vorpommern",
                "shortCode": "MV"
            },
            {
                "value": "Niedersachsen",
                "label": "Niedersachsen",
                "shortCode": "NI"
            },
            {
                "value": "Nordrhein-Westfalen",
                "label": "Nordrhein-Westfalen",
                "shortCode": "NW"
            },
            {
                "value": "Rheinland-Pfalz",
                "label": "Rheinland-Pfalz",
                "shortCode": "RP"
            },
            {
                "value": "Saarland",
                "label": "Saarland",
                "shortCode": "SL"
            },
            {
                "value": "Sachsen",
                "label": "Sachsen",
                "shortCode": "SN"
            },
            {
                "value": "Sachsen-Anhalt",
                "label": "Sachsen-Anhalt",
                "shortCode": "ST"
            },
            {
                "value": "Schleswig-Holstein",
                "label": "Schleswig-Holstein",
                "shortCode": "SH"
            },
            {
                "value": "Thüringen",
                "label": "Thüringen",
                "shortCode": "TH"
            }
        ]
    },
    {
        "countryCode": "+233",
        "value": "Ghana",
        "label": "Ghana",
        "regions": [
            {
                "value": "Ahafo",
                "label": "Ahafo"
            },
            {
                "value": "Ashanti",
                "label": "Ashanti",
                "shortCode": "AH"
            },
            {
                "value": "Bono",
                "label": "Bono"
            },
            {
                "value": "Bono East",
                "label": "Bono East"
            },
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "CP"
            },
            {
                "value": "Eastern",
                "label": "Eastern",
                "shortCode": "EP"
            },
            {
                "value": "Greater Accra",
                "label": "Greater Accra",
                "shortCode": "AA"
            },
            {
                "value": "Northern",
                "label": "Northern",
                "shortCode": "NP"
            },
            {
                "value": "North East",
                "label": "North East"
            },
            {
                "value": "Oti",
                "label": "Oti"
            },
            {
                "value": "Savannah",
                "label": "Savannah"
            },
            {
                "value": "Upper East",
                "label": "Upper East",
                "shortCode": "UE"
            },
            {
                "value": "Upper West",
                "label": "Upper West",
                "shortCode": "UW"
            },
            {
                "value": "Volta",
                "label": "Volta",
                "shortCode": "TV"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "WP"
            },
            {
                "value": "Western North",
                "label": "Western North"
            }
        ]
    },
    {
        "countryCode": "+350",
        "value": "Gibraltar",
        "label": "Gibraltar",
        "regions": [
            {
                "value": "Gibraltar",
                "label": "Gibraltar"
            }
        ]
    },
    {
        "countryCode": "+30",
        "value": "Greece",
        "label": "Greece",
        "regions": [
            {
                "value": "Anatolikí Makedonía kai Thráki",
                "label": "Anatolikí Makedonía kai Thráki",
                "shortCode": "A"
            },
            {
                "value": "Attikḯ",
                "label": "Attikḯ",
                "shortCode": "I"
            },
            {
                "value": "Dytikí Elláda",
                "label": "Dytikí Elláda",
                "shortCode": "G"
            },
            {
                "value": "Dytikí Makedonía",
                "label": "Dytikí Makedonía",
                "shortCode": "C"
            },
            {
                "value": "Ionía Nísia",
                "label": "Ionía Nísia",
                "shortCode": "F"
            },
            {
                "value": "Kentrikí Makedonía",
                "label": "Kentrikí Makedonía",
                "shortCode": "B"
            },
            {
                "value": "Krítí",
                "label": "Krítí",
                "shortCode": "M"
            },
            {
                "value": "Notío Aigaío",
                "label": "Notío Aigaío",
                "shortCode": "L"
            },
            {
                "value": "Peloponnísos",
                "label": "Peloponnísos",
                "shortCode": "J"
            },
            {
                "value": "Stereá Elláda",
                "label": "Stereá Elláda",
                "shortCode": "H"
            },
            {
                "value": "Thessalía",
                "label": "Thessalía",
                "shortCode": "E"
            },
            {
                "value": "Voreío Aigaío",
                "label": "Voreío Aigaío",
                "shortCode": "K"
            },
            {
                "value": "Ípeiros",
                "label": "Ípeiros",
                "shortCode": "D"
            },
            {
                "value": "Ágion Óros",
                "label": "Ágion Óros",
                "shortCode": "69"
            }
        ]
    },
    {
        "countryCode": "+299",
        "value": "Greenland",
        "label": "Greenland",
        "regions": [
            {
                "value": "Kommune Kujalleq",
                "label": "Kommune Kujalleq",
                "shortCode": "KU"
            },
            {
                "value": "Kommuneqarfik Sermersooq",
                "label": "Kommuneqarfik Sermersooq",
                "shortCode": "SM"
            },
            {
                "value": "Qaasuitsup Kommunia",
                "label": "Qaasuitsup Kommunia",
                "shortCode": "QA"
            },
            {
                "value": "Qeqqata Kommunia",
                "label": "Qeqqata Kommunia",
                "shortCode": "QE"
            }
        ]
    },
    {
        "countryCode": "+1 473",
        "value": "Grenada",
        "label": "Grenada",
        "regions": [
            {
                "value": "Saint Andrew",
                "label": "Saint Andrew",
                "shortCode": "01"
            },
            {
                "value": "Saint David",
                "label": "Saint David",
                "shortCode": "02"
            },
            {
                "value": "Saint George",
                "label": "Saint George",
                "shortCode": "03"
            },
            {
                "value": "Saint John",
                "label": "Saint John",
                "shortCode": "04"
            },
            {
                "value": "Saint Mark",
                "label": "Saint Mark",
                "shortCode": "05"
            },
            {
                "value": "Saint Patrick",
                "label": "Saint Patrick",
                "shortCode": "06"
            },
            {
                "value": "Southern Grenadine Islands",
                "label": "Southern Grenadine Islands",
                "shortCode": "10"
            }
        ]
    },
    {
        "countryCode": "+590",
        "value": "Guadeloupe",
        "label": "Guadeloupe",
        "regions": [
            {
                "value": "Guadeloupe",
                "label": "Guadeloupe"
            }
        ]
    },
    {
        "countryCode": "+1 671",
        "value": "Guam",
        "label": "Guam",
        "regions": [
            {
                "value": "Guam",
                "label": "Guam"
            }
        ]
    },
    {
        "countryCode": "+502",
        "value": "Guatemala",
        "label": "Guatemala",
        "regions": [
            {
                "value": "Alta Verapaz",
                "label": "Alta Verapaz",
                "shortCode": "AV"
            },
            {
                "value": "Baja Verapaz",
                "label": "Baja Verapaz",
                "shortCode": "BV"
            },
            {
                "value": "Chimaltenango",
                "label": "Chimaltenango",
                "shortCode": "CM"
            },
            {
                "value": "Chiquimula",
                "label": "Chiquimula",
                "shortCode": "CQ"
            },
            {
                "value": "El Progreso",
                "label": "El Progreso",
                "shortCode": "PR"
            },
            {
                "value": "Escuintla",
                "label": "Escuintla",
                "shortCode": "ES"
            },
            {
                "value": "Guatemala",
                "label": "Guatemala",
                "shortCode": "GU"
            },
            {
                "value": "Huehuetenango",
                "label": "Huehuetenango",
                "shortCode": "HU"
            },
            {
                "value": "Izabal",
                "label": "Izabal",
                "shortCode": "IZ"
            },
            {
                "value": "Jalapa",
                "label": "Jalapa",
                "shortCode": "JA"
            },
            {
                "value": "Jutiapa",
                "label": "Jutiapa",
                "shortCode": "JU"
            },
            {
                "value": "Petén",
                "label": "Petén",
                "shortCode": "PE"
            },
            {
                "value": "Quetzaltenango",
                "label": "Quetzaltenango",
                "shortCode": "QZ"
            },
            {
                "value": "Quiché",
                "label": "Quiché",
                "shortCode": "QC"
            },
            {
                "value": "Retalhuleu",
                "label": "Retalhuleu",
                "shortCode": "Re"
            },
            {
                "value": "Sacatepéquez",
                "label": "Sacatepéquez",
                "shortCode": "SA"
            },
            {
                "value": "San Marcos",
                "label": "San Marcos",
                "shortCode": "SM"
            },
            {
                "value": "Santa Rosa",
                "label": "Santa Rosa",
                "shortCode": "SR"
            },
            {
                "value": "Sololá",
                "label": "Sololá",
                "shortCode": "SO"
            },
            {
                "value": "Suchitepéquez",
                "label": "Suchitepéquez",
                "shortCode": "SU"
            },
            {
                "value": "Totonicapán",
                "label": "Totonicapán",
                "shortCode": "TO"
            },
            {
                "value": "Zacapa",
                "label": "Zacapa",
                "shortCode": "ZA"
            }
        ]
    },
    {
        "countryCode": "+44 1481, 44 7781,\n44 7839, 44 7911",
        "value": "Guernsey",
        "label": "Guernsey",
        "regions": [
            {
                "value": "Castel",
                "label": "Castel"
            },
            {
                "value": "Forest",
                "label": "Forest"
            },
            {
                "value": "St. Andrew",
                "label": "St. Andrew"
            },
            {
                "value": "St. Martin",
                "label": "St. Martin"
            },
            {
                "value": "St. Peter Port",
                "label": "St. Peter Port"
            },
            {
                "value": "St. Pierre du Bois",
                "label": "St. Pierre du Bois"
            },
            {
                "value": "St. Sampson",
                "label": "St. Sampson"
            },
            {
                "value": "St. Saviour",
                "label": "St. Saviour"
            },
            {
                "value": "Torteval",
                "label": "Torteval"
            },
            {
                "value": "Vale",
                "label": "Vale"
            }
        ]
    },
    {
        "countryCode": "+224",
        "value": "Guinea",
        "label": "Guinea",
        "regions": [
            {
                "value": "Boké",
                "label": "Boké",
                "shortCode": "B"
            },
            {
                "value": "Conakry",
                "label": "Conakry",
                "shortCode": "C"
            },
            {
                "value": "Faranah",
                "label": "Faranah",
                "shortCode": "F"
            },
            {
                "value": "Kankan",
                "label": "Kankan",
                "shortCode": "K"
            },
            {
                "value": "Kindia",
                "label": "Kindia",
                "shortCode": "D"
            },
            {
                "value": "Labé",
                "label": "Labé",
                "shortCode": "L"
            },
            {
                "value": "Mamou",
                "label": "Mamou",
                "shortCode": "M"
            },
            {
                "value": "Nzérékoré",
                "label": "Nzérékoré",
                "shortCode": "N"
            }
        ]
    },
    {
        "countryCode": "+245",
        "value": "Guinea-Bissau",
        "label": "Guinea-Bissau",
        "regions": [
            {
                "value": "Bafatá",
                "label": "Bafatá",
                "shortCode": "BA"
            },
            {
                "value": "Biombo",
                "label": "Biombo",
                "shortCode": "BM"
            },
            {
                "value": "Bissau",
                "label": "Bissau",
                "shortCode": "BS"
            },
            {
                "value": "Bolama-Bijagos",
                "label": "Bolama-Bijagos",
                "shortCode": "BL"
            },
            {
                "value": "Cacheu",
                "label": "Cacheu",
                "shortCode": "CA"
            },
            {
                "value": "Gabú",
                "label": "Gabú",
                "shortCode": "GA"
            },
            {
                "value": "Oio",
                "label": "Oio",
                "shortCode": "OI"
            },
            {
                "value": "Quinara",
                "label": "Quinara",
                "shortCode": "QU"
            },
            {
                "value": "Tombali",
                "label": "Tombali",
                "shortCode": "TO"
            }
        ]
    },
    {
        "countryCode": "+592",
        "value": "Guyana",
        "label": "Guyana",
        "regions": [
            {
                "value": "Barima-Waini",
                "label": "Barima-Waini",
                "shortCode": "BA"
            },
            {
                "value": "Cuyuni-Mazaruni",
                "label": "Cuyuni-Mazaruni",
                "shortCode": "CU"
            },
            {
                "value": "Demerara-Mahaica",
                "label": "Demerara-Mahaica",
                "shortCode": "DE"
            },
            {
                "value": "East Berbice-Corentyne",
                "label": "East Berbice-Corentyne",
                "shortCode": "EB"
            },
            {
                "value": "Essequibo Islands-West Demerara",
                "label": "Essequibo Islands-West Demerara",
                "shortCode": "ES"
            },
            {
                "value": "Mahaica-Berbice",
                "label": "Mahaica-Berbice",
                "shortCode": "MA"
            },
            {
                "value": "Pomeroon-Supenaam",
                "label": "Pomeroon-Supenaam",
                "shortCode": "PM"
            },
            {
                "value": "Potaro-Siparuni",
                "label": "Potaro-Siparuni",
                "shortCode": "PT"
            },
            {
                "value": "Upper Demerara-Berbice",
                "label": "Upper Demerara-Berbice",
                "shortCode": "UD"
            },
            {
                "value": "Upper Takutu-Upper Essequibo",
                "label": "Upper Takutu-Upper Essequibo",
                "shortCode": "UT"
            }
        ]
    },
    {
        "countryCode": "+509",
        "value": "Haiti",
        "label": "Haiti",
        "regions": [
            {
                "value": "Artibonite",
                "label": "Artibonite",
                "shortCode": "AR"
            },
            {
                "value": "Centre",
                "label": "Centre",
                "shortCode": "CE"
            },
            {
                "value": "Grand'Anse",
                "label": "Grand'Anse",
                "shortCode": "GA"
            },
            {
                "value": "Nippes",
                "label": "Nippes",
                "shortCode": "NI"
            },
            {
                "value": "Nord",
                "label": "Nord",
                "shortCode": "ND"
            },
            {
                "value": "Nord-Est",
                "label": "Nord-Est",
                "shortCode": "NE"
            },
            {
                "value": "Nord-Ouest",
                "label": "Nord-Ouest",
                "shortCode": "NO"
            },
            {
                "value": "Ouest",
                "label": "Ouest",
                "shortCode": "OU"
            },
            {
                "value": "Sud",
                "label": "Sud",
                "shortCode": "SD"
            },
            {
                "value": "Sud-Est",
                "label": "Sud-Est",
                "shortCode": "SE"
            }
        ]
    },
    {
        "countryCode": "+504",
        "value": "Honduras",
        "label": "Honduras",
        "regions": [
            {
                "value": "Atlántida",
                "label": "Atlántida",
                "shortCode": "AT"
            },
            {
                "value": "Choluteca",
                "label": "Choluteca",
                "shortCode": "CH"
            },
            {
                "value": "Colón",
                "label": "Colón",
                "shortCode": "CL"
            },
            {
                "value": "Comayagua",
                "label": "Comayagua",
                "shortCode": "CM"
            },
            {
                "value": "Copán",
                "label": "Copán",
                "shortCode": "CP"
            },
            {
                "value": "Cortés",
                "label": "Cortés",
                "shortCode": "CR"
            },
            {
                "value": "El Paraíso",
                "label": "El Paraíso",
                "shortCode": "EP"
            },
            {
                "value": "Francisco Morazán",
                "label": "Francisco Morazán",
                "shortCode": "FM"
            },
            {
                "value": "Gracias a Dios",
                "label": "Gracias a Dios",
                "shortCode": "GD"
            },
            {
                "value": "Intibucá",
                "label": "Intibucá",
                "shortCode": "IN"
            },
            {
                "value": "Islas de la Bahía",
                "label": "Islas de la Bahía",
                "shortCode": "IB"
            },
            {
                "value": "La Paz",
                "label": "La Paz",
                "shortCode": "LP"
            },
            {
                "value": "Lempira",
                "label": "Lempira",
                "shortCode": "LE"
            },
            {
                "value": "Ocotepeque",
                "label": "Ocotepeque",
                "shortCode": "OC"
            },
            {
                "value": "Olancho",
                "label": "Olancho",
                "shortCode": "OL"
            },
            {
                "value": "Santa Bárbara",
                "label": "Santa Bárbara",
                "shortCode": "SB"
            },
            {
                "value": "Valle",
                "label": "Valle",
                "shortCode": "VA"
            },
            {
                "value": "Yoro",
                "label": "Yoro",
                "shortCode": "YO"
            }
        ]
    },
    {
        "countryCode": "+852",
        "value": "Hong Kong",
        "label": "Hong Kong",
        "regions": [
            {
                "value": "Hong Kong",
                "label": "Hong Kong",
                "shortCode": "HK"
            }
        ]
    },
    {
        "countryCode": "+36",
        "value": "Hungary",
        "label": "Hungary",
        "regions": [
            {
                "value": "Bács-Kiskun",
                "label": "Bács-Kiskun",
                "shortCode": "BK"
            },
            {
                "value": "Baranya",
                "label": "Baranya",
                "shortCode": "BA"
            },
            {
                "value": "Békés",
                "label": "Békés",
                "shortCode": "BE"
            },
            {
                "value": "Békéscsaba",
                "label": "Békéscsaba",
                "shortCode": "BC"
            },
            {
                "value": "Borsod-Abauj-Zemplen",
                "label": "Borsod-Abauj-Zemplen",
                "shortCode": "BZ"
            },
            {
                "value": "Budapest",
                "label": "Budapest",
                "shortCode": "BU"
            },
            {
                "value": "Csongrád",
                "label": "Csongrád",
                "shortCode": "CS"
            },
            {
                "value": "Debrecen",
                "label": "Debrecen",
                "shortCode": "DE"
            },
            {
                "value": "Dunaújváros",
                "label": "Dunaújváros",
                "shortCode": "DU"
            },
            {
                "value": "Eger",
                "label": "Eger",
                "shortCode": "EG"
            },
            {
                "value": "Érd",
                "label": "Érd",
                "shortCode": "ER"
            },
            {
                "value": "Fejér",
                "label": "Fejér",
                "shortCode": "FE"
            },
            {
                "value": "Győr",
                "label": "Győr",
                "shortCode": "GY"
            },
            {
                "value": "Győr-Moson-Sopron",
                "label": "Győr-Moson-Sopron",
                "shortCode": "GS"
            },
            {
                "value": "Hajdú-Bihar",
                "label": "Hajdú-Bihar",
                "shortCode": "HB"
            },
            {
                "value": "Heves",
                "label": "Heves",
                "shortCode": "HE"
            },
            {
                "value": "Hódmezővásárhely",
                "label": "Hódmezővásárhely",
                "shortCode": "HV"
            },
            {
                "value": "Jász-Nagykun-Szolnok",
                "label": "Jász-Nagykun-Szolnok",
                "shortCode": "N"
            },
            {
                "value": "Kaposvár",
                "label": "Kaposvár",
                "shortCode": "KV"
            },
            {
                "value": "Kecskemét",
                "label": "Kecskemét",
                "shortCode": "KM"
            },
            {
                "value": "Komárom-Esztergom",
                "label": "Komárom-Esztergom",
                "shortCode": "KE"
            },
            {
                "value": "Miskolc",
                "label": "Miskolc",
                "shortCode": "MI"
            },
            {
                "value": "Nagykanizsa",
                "label": "Nagykanizsa",
                "shortCode": "NK"
            },
            {
                "value": "Nógrád",
                "label": "Nógrád",
                "shortCode": "NO"
            },
            {
                "value": "Nyíregyháza",
                "label": "Nyíregyháza",
                "shortCode": "NY"
            },
            {
                "value": "Pécs",
                "label": "Pécs",
                "shortCode": "PS"
            },
            {
                "value": "Pest",
                "label": "Pest",
                "shortCode": "PE"
            },
            {
                "value": "Salgótarján",
                "label": "Salgótarján",
                "shortCode": "ST"
            },
            {
                "value": "Somogy",
                "label": "Somogy",
                "shortCode": "SO"
            },
            {
                "value": "Sopron",
                "label": "Sopron",
                "shortCode": "SN"
            },
            {
                "value": "Szabolcs-á-Bereg",
                "label": "Szabolcs-á-Bereg",
                "shortCode": "SZ"
            },
            {
                "value": "Szeged",
                "label": "Szeged",
                "shortCode": "SD"
            },
            {
                "value": "Székesfehérvár",
                "label": "Székesfehérvár",
                "shortCode": "SF"
            },
            {
                "value": "Szekszárd",
                "label": "Szekszárd",
                "shortCode": "SS"
            },
            {
                "value": "Szolnok",
                "label": "Szolnok",
                "shortCode": "SK"
            },
            {
                "value": "Szombathely",
                "label": "Szombathely",
                "shortCode": "SH"
            },
            {
                "value": "Tatabánya",
                "label": "Tatabánya",
                "shortCode": "TB"
            },
            {
                "value": "Tolna",
                "label": "Tolna",
                "shortCode": "TO"
            },
            {
                "value": "Vas",
                "label": "Vas",
                "shortCode": "VA"
            },
            {
                "value": "Veszprém",
                "label": "Veszprém",
                "shortCode": "VE"
            },
            {
                "value": "Veszprém (City)",
                "label": "Veszprém (City)",
                "shortCode": "VM"
            },
            {
                "value": "Zala",
                "label": "Zala",
                "shortCode": "ZA"
            },
            {
                "value": "Zalaegerszeg",
                "label": "Zalaegerszeg",
                "shortCode": "ZE"
            }
        ]
    },
    {
        "countryCode": "+354",
        "value": "Iceland",
        "label": "Iceland",
        "regions": [
            {
                "value": "Austurland",
                "label": "Austurland",
                "shortCode": "7"
            },
            {
                "value": "Höfuðborgarsvæði",
                "label": "Höfuðborgarsvæði",
                "shortCode": "1"
            },
            {
                "value": "Norðurland eystra",
                "label": "Norðurland eystra",
                "shortCode": "6"
            },
            {
                "value": "Norðurland vestra",
                "label": "Norðurland vestra",
                "shortCode": "5"
            },
            {
                "value": "Suðurland",
                "label": "Suðurland",
                "shortCode": "8"
            },
            {
                "value": "Suðurnes",
                "label": "Suðurnes",
                "shortCode": "2"
            },
            {
                "value": "Vestfirðir",
                "label": "Vestfirðir",
                "shortCode": "4"
            },
            {
                "value": "Vesturland",
                "label": "Vesturland",
                "shortCode": "3"
            }
        ]
    },
    {
        "countryCode": "+62",
        "value": "Indonesia",
        "label": "Indonesia",
        "regions": [
            {
                "value": "Aceh",
                "label": "Aceh",
                "shortCode": "AC"
            },
            {
                "value": "Bali",
                "label": "Bali",
                "shortCode": "BA"
            },
            {
                "value": "Bangka Belitung",
                "label": "Bangka Belitung",
                "shortCode": "BB"
            },
            {
                "value": "Banten",
                "label": "Banten",
                "shortCode": "BT"
            },
            {
                "value": "Bengkulu",
                "label": "Bengkulu",
                "shortCode": "BE"
            },
            {
                "value": "Gorontalo",
                "label": "Gorontalo",
                "shortCode": "GO"
            },
            {
                "value": "Jakarta Raya",
                "label": "Jakarta Raya",
                "shortCode": "JK"
            },
            {
                "value": "Jambi",
                "label": "Jambi",
                "shortCode": "JA"
            },
            {
                "value": "Jawa Barat",
                "label": "Jawa Barat",
                "shortCode": "JB"
            },
            {
                "value": "Jawa Tengah",
                "label": "Jawa Tengah",
                "shortCode": "JT"
            },
            {
                "value": "Jawa Timur",
                "label": "Jawa Timur",
                "shortCode": "JI"
            },
            {
                "value": "Kalimantan Barat",
                "label": "Kalimantan Barat",
                "shortCode": "KB"
            },
            {
                "value": "Kalimantan Selatan",
                "label": "Kalimantan Selatan",
                "shortCode": "KS"
            },
            {
                "value": "Kalimantan Tengah",
                "label": "Kalimantan Tengah",
                "shortCode": "KT"
            },
            {
                "value": "Kalimantan Timur",
                "label": "Kalimantan Timur",
                "shortCode": "KI"
            },
            {
                "value": "Kalimantan Utara",
                "label": "Kalimantan Utara",
                "shortCode": "KU"
            },
            {
                "value": "Kepulauan Riau",
                "label": "Kepulauan Riau",
                "shortCode": "KR"
            },
            {
                "value": "Lampung",
                "label": "Lampung",
                "shortCode": "LA"
            },
            {
                "value": "Maluku",
                "label": "Maluku",
                "shortCode": "MA"
            },
            {
                "value": "Maluku Utara",
                "label": "Maluku Utara",
                "shortCode": "MU"
            },
            {
                "value": "Nusa Tenggara Barat",
                "label": "Nusa Tenggara Barat",
                "shortCode": "NB"
            },
            {
                "value": "Nusa Tenggara Timur",
                "label": "Nusa Tenggara Timur",
                "shortCode": "NT"
            },
            {
                "value": "Papua",
                "label": "Papua",
                "shortCode": "PA"
            },
            {
                "value": "Papua Barat",
                "label": "Papua Barat",
                "shortCode": "PB"
            },
            {
                "value": "Riau",
                "label": "Riau",
                "shortCode": "RI"
            },
            {
                "value": "Sulawesi Selatan",
                "label": "Sulawesi Selatan",
                "shortCode": "SR"
            },
            {
                "value": "Sulawesi Tengah",
                "label": "Sulawesi Tengah",
                "shortCode": "ST"
            },
            {
                "value": "Sulawesi Tenggara",
                "label": "Sulawesi Tenggara",
                "shortCode": "SG"
            },
            {
                "value": "Sulawesi Utara",
                "label": "Sulawesi Utara",
                "shortCode": "SA"
            },
            {
                "value": "Sumatera Barat",
                "label": "Sumatera Barat",
                "shortCode": "SB"
            },
            {
                "value": "Sumatera Selatan",
                "label": "Sumatera Selatan",
                "shortCode": "SS"
            },
            {
                "value": "Sumatera Utara",
                "label": "Sumatera Utara",
                "shortCode": "SU"
            },
            {
                "value": "Yogyakarta",
                "label": "Yogyakarta",
                "shortCode": "YO"
            }
        ]
    },
    {
        "countryCode": "+964",
        "value": "Iraq",
        "label": "Iraq",
        "regions": [
            {
                "value": "Al Anbār",
                "label": "Al Anbār",
                "shortCode": "AN"
            },
            {
                "value": "Al Başrah",
                "label": "Al Başrah",
                "shortCode": "BA"
            },
            {
                "value": "Al Muthanná",
                "label": "Al Muthanná",
                "shortCode": "MU"
            },
            {
                "value": "Al Qādisīyah",
                "label": "Al Qādisīyah",
                "shortCode": "QA"
            },
            {
                "value": "An Najaf",
                "label": "An Najaf",
                "shortCode": "NA"
            },
            {
                "value": "Arbīl",
                "label": "Arbīl",
                "shortCode": "AR"
            },
            {
                "value": "As Sulaymānīyah",
                "label": "As Sulaymānīyah",
                "shortCode": "SU"
            },
            {
                "value": "Bābil",
                "label": "Bābil",
                "shortCode": "BB"
            },
            {
                "value": "Baghdād",
                "label": "Baghdād",
                "shortCode": "BG"
            },
            {
                "value": "Dohuk",
                "label": "Dohuk",
                "shortCode": "DA"
            },
            {
                "value": "Dhī Qār",
                "label": "Dhī Qār",
                "shortCode": "DQ"
            },
            {
                "value": "Diyālá",
                "label": "Diyālá",
                "shortCode": "DI"
            },
            {
                "value": "Karbalā'",
                "label": "Karbalā'",
                "shortCode": "KA"
            },
            {
                "value": "Kirkuk",
                "label": "Kirkuk",
                "shortCode": "KI"
            },
            {
                "value": "Maysān",
                "label": "Maysān",
                "shortCode": "MA"
            },
            {
                "value": "Nīnawá",
                "label": "Nīnawá",
                "shortCode": "NI"
            },
            {
                "value": "Şalāḩ ad Dīn",
                "label": "Şalāḩ ad Dīn",
                "shortCode": "SD"
            },
            {
                "value": "Wāsiţ",
                "label": "Wāsiţ",
                "shortCode": "WA"
            }
        ]
    },
    {
        "countryCode": "+353",
        "value": "Ireland",
        "label": "Ireland",
        "regions": [
            {
                "value": "Carlow",
                "label": "Carlow",
                "shortCode": "CW"
            },
            {
                "value": "Cavan",
                "label": "Cavan",
                "shortCode": "CN"
            },
            {
                "value": "Clare",
                "label": "Clare",
                "shortCode": "CE"
            },
            {
                "value": "Cork",
                "label": "Cork",
                "shortCode": "CO"
            },
            {
                "value": "Donegal",
                "label": "Donegal",
                "shortCode": "DL"
            },
            {
                "value": "Dublin",
                "label": "Dublin",
                "shortCode": "D"
            },
            {
                "value": "Galway",
                "label": "Galway",
                "shortCode": "G"
            },
            {
                "value": "Kerry",
                "label": "Kerry",
                "shortCode": "KY"
            },
            {
                "value": "Kildare",
                "label": "Kildare",
                "shortCode": "KE"
            },
            {
                "value": "Kilkenny",
                "label": "Kilkenny",
                "shortCode": "KK"
            },
            {
                "value": "Laois",
                "label": "Laois",
                "shortCode": "LS"
            },
            {
                "value": "Leitrim",
                "label": "Leitrim",
                "shortCode": "LM"
            },
            {
                "value": "Limerick",
                "label": "Limerick",
                "shortCode": "LK"
            },
            {
                "value": "Longford",
                "label": "Longford",
                "shortCode": "LD"
            },
            {
                "value": "Louth",
                "label": "Louth",
                "shortCode": "LH"
            },
            {
                "value": "Mayo",
                "label": "Mayo",
                "shortCode": "MO"
            },
            {
                "value": "Meath",
                "label": "Meath",
                "shortCode": "MH"
            },
            {
                "value": "Monaghan",
                "label": "Monaghan",
                "shortCode": "MN"
            },
            {
                "value": "Offaly",
                "label": "Offaly",
                "shortCode": "OY"
            },
            {
                "value": "Roscommon",
                "label": "Roscommon",
                "shortCode": "RN"
            },
            {
                "value": "Sligo",
                "label": "Sligo",
                "shortCode": "SO"
            },
            {
                "value": "Tipperary",
                "label": "Tipperary",
                "shortCode": "TA"
            },
            {
                "value": "Waterford",
                "label": "Waterford",
                "shortCode": "WD"
            },
            {
                "value": "Westmeath",
                "label": "Westmeath",
                "shortCode": "WH"
            },
            {
                "value": "Wexford",
                "label": "Wexford",
                "shortCode": "WX"
            },
            {
                "value": "Wicklow",
                "label": "Wicklow",
                "shortCode": "WW"
            }
        ]
    },
    {
        "countryCode": "+44 1624, 44 7524,\n44 7624, 44 7924",
        "value": "Isle of Man",
        "label": "Isle of Man",
        "regions": [
            {
                "value": "Isle of Man",
                "label": "Isle of Man"
            }
        ]
    },
    {
        "countryCode": "+972",
        "value": "Israel",
        "label": "Israel",
        "regions": [
            {
                "value": "HaDarom",
                "label": "HaDarom",
                "shortCode": "D"
            },
            {
                "value": "HaMerkaz",
                "label": "HaMerkaz",
                "shortCode": "M"
            },
            {
                "value": "HaTsafon",
                "label": "HaTsafon",
                "shortCode": "Z"
            },
            {
                "value": "H̱efa",
                "label": "H̱efa",
                "shortCode": "HA"
            },
            {
                "value": "Tel-Aviv",
                "label": "Tel-Aviv",
                "shortCode": "TA"
            },
            {
                "value": "Yerushalayim",
                "label": "Yerushalayim",
                "shortCode": "JM"
            }
        ]
    },
    {
        "countryCode": "+39",
        "value": "Italy",
        "label": "Italy",
        "regions": [
            {
                "value": "Abruzzo",
                "label": "Abruzzo",
                "shortCode": "65"
            },
            {
                "value": "Basilicata",
                "label": "Basilicata",
                "shortCode": "77"
            },
            {
                "value": "Calabria",
                "label": "Calabria",
                "shortCode": "78"
            },
            {
                "value": "Campania",
                "label": "Campania",
                "shortCode": "72"
            },
            {
                "value": "Emilia-Romagna",
                "label": "Emilia-Romagna",
                "shortCode": "45"
            },
            {
                "value": "Friuli-Venezia Giulia",
                "label": "Friuli-Venezia Giulia",
                "shortCode": "36"
            },
            {
                "value": "Lazio",
                "label": "Lazio",
                "shortCode": "62"
            },
            {
                "value": "Liguria",
                "label": "Liguria",
                "shortCode": "42"
            },
            {
                "value": "Lombardia",
                "label": "Lombardia",
                "shortCode": "25"
            },
            {
                "value": "Marche",
                "label": "Marche",
                "shortCode": "57"
            },
            {
                "value": "Molise",
                "label": "Molise",
                "shortCode": "67"
            },
            {
                "value": "Piemonte",
                "label": "Piemonte",
                "shortCode": "21"
            },
            {
                "value": "Puglia",
                "label": "Puglia",
                "shortCode": "75"
            },
            {
                "value": "Sardegna",
                "label": "Sardegna",
                "shortCode": "88"
            },
            {
                "value": "Sicilia",
                "label": "Sicilia",
                "shortCode": "82"
            },
            {
                "value": "Toscana",
                "label": "Toscana",
                "shortCode": "52"
            },
            {
                "value": "Trentino-Alto Adige",
                "label": "Trentino-Alto Adige",
                "shortCode": "32"
            },
            {
                "value": "Umbria",
                "label": "Umbria",
                "shortCode": "55"
            },
            {
                "value": "Valle d'Aosta",
                "label": "Valle d'Aosta",
                "shortCode": "23"
            },
            {
                "value": "Veneto",
                "label": "Veneto",
                "shortCode": "34"
            }
        ]
    },
    {
        "countryCode": "+1 658, 1 876",
        "value": "Jamaica",
        "label": "Jamaica",
        "regions": [
            {
                "value": "Clarendon",
                "label": "Clarendon",
                "shortCode": "13"
            },
            {
                "value": "Hanover",
                "label": "Hanover",
                "shortCode": "09"
            },
            {
                "value": "Kingston",
                "label": "Kingston",
                "shortCode": "01"
            },
            {
                "value": "Manchester",
                "label": "Manchester",
                "shortCode": "12"
            },
            {
                "value": "Portland",
                "label": "Portland",
                "shortCode": "04"
            },
            {
                "value": "Saint Andrew",
                "label": "Saint Andrew",
                "shortCode": "02"
            },
            {
                "value": "Saint Ann",
                "label": "Saint Ann",
                "shortCode": "06"
            },
            {
                "value": "Saint Catherine",
                "label": "Saint Catherine",
                "shortCode": "14"
            },
            {
                "value": "Saint Elizabeth",
                "label": "Saint Elizabeth",
                "shortCode": "11"
            },
            {
                "value": "Saint James",
                "label": "Saint James",
                "shortCode": "08"
            },
            {
                "value": "Saint Mary",
                "label": "Saint Mary",
                "shortCode": "05"
            },
            {
                "value": "Saint Thomas",
                "label": "Saint Thomas",
                "shortCode": "03"
            },
            {
                "value": "Trelawny",
                "label": "Trelawny",
                "shortCode": "07"
            },
            {
                "value": "Westmoreland",
                "label": "Westmoreland",
                "shortCode": "10"
            }
        ]
    },
    {
        "countryCode": "+81",
        "value": "Japan",
        "label": "Japan",
        "regions": [
            {
                "value": "Aichi",
                "label": "Aichi",
                "shortCode": "23"
            },
            {
                "value": "Akita",
                "label": "Akita",
                "shortCode": "05"
            },
            {
                "value": "Aomori",
                "label": "Aomori",
                "shortCode": "02"
            },
            {
                "value": "Chiba",
                "label": "Chiba",
                "shortCode": "12"
            },
            {
                "value": "Ehime",
                "label": "Ehime",
                "shortCode": "38"
            },
            {
                "value": "Fukui",
                "label": "Fukui",
                "shortCode": "18"
            },
            {
                "value": "Fukuoka",
                "label": "Fukuoka",
                "shortCode": "40"
            },
            {
                "value": "Fukushima",
                "label": "Fukushima",
                "shortCode": "07"
            },
            {
                "value": "Gifu",
                "label": "Gifu",
                "shortCode": "21"
            },
            {
                "value": "Gunma",
                "label": "Gunma",
                "shortCode": "10"
            },
            {
                "value": "Hiroshima",
                "label": "Hiroshima",
                "shortCode": "34"
            },
            {
                "value": "Hokkaido",
                "label": "Hokkaido",
                "shortCode": "01"
            },
            {
                "value": "Hyogo",
                "label": "Hyogo",
                "shortCode": "28"
            },
            {
                "value": "Ibaraki",
                "label": "Ibaraki",
                "shortCode": "08"
            },
            {
                "value": "Ishikawa",
                "label": "Ishikawa",
                "shortCode": "17"
            },
            {
                "value": "Iwate",
                "label": "Iwate",
                "shortCode": "03"
            },
            {
                "value": "Kagawa",
                "label": "Kagawa",
                "shortCode": "37"
            },
            {
                "value": "Kagoshima",
                "label": "Kagoshima",
                "shortCode": "46"
            },
            {
                "value": "Kanagawa",
                "label": "Kanagawa",
                "shortCode": "14"
            },
            {
                "value": "Kochi",
                "label": "Kochi",
                "shortCode": "39"
            },
            {
                "value": "Kumamoto",
                "label": "Kumamoto",
                "shortCode": "43"
            },
            {
                "value": "Kyoto",
                "label": "Kyoto",
                "shortCode": "26"
            },
            {
                "value": "Mie",
                "label": "Mie",
                "shortCode": "24"
            },
            {
                "value": "Miyagi",
                "label": "Miyagi",
                "shortCode": "04"
            },
            {
                "value": "Miyazaki",
                "label": "Miyazaki",
                "shortCode": "45"
            },
            {
                "value": "Nagano",
                "label": "Nagano",
                "shortCode": "20"
            },
            {
                "value": "Nagasaki",
                "label": "Nagasaki",
                "shortCode": "42"
            },
            {
                "value": "Nara",
                "label": "Nara",
                "shortCode": "29"
            },
            {
                "value": "Niigata",
                "label": "Niigata",
                "shortCode": "15"
            },
            {
                "value": "Oita",
                "label": "Oita",
                "shortCode": "44"
            },
            {
                "value": "Okayama",
                "label": "Okayama",
                "shortCode": "33"
            },
            {
                "value": "Okinawa",
                "label": "Okinawa",
                "shortCode": "47"
            },
            {
                "value": "Osaka",
                "label": "Osaka",
                "shortCode": "27"
            },
            {
                "value": "Saga",
                "label": "Saga",
                "shortCode": "41"
            },
            {
                "value": "Saitama",
                "label": "Saitama",
                "shortCode": "11"
            },
            {
                "value": "Shiga",
                "label": "Shiga",
                "shortCode": "25"
            },
            {
                "value": "Shimane",
                "label": "Shimane",
                "shortCode": "32"
            },
            {
                "value": "Shizuoka",
                "label": "Shizuoka",
                "shortCode": "22"
            },
            {
                "value": "Tochigi",
                "label": "Tochigi",
                "shortCode": "09"
            },
            {
                "value": "Tokushima",
                "label": "Tokushima",
                "shortCode": "36"
            },
            {
                "value": "Tokyo",
                "label": "Tokyo",
                "shortCode": "13"
            },
            {
                "value": "Tottori",
                "label": "Tottori",
                "shortCode": "31"
            },
            {
                "value": "Toyama",
                "label": "Toyama",
                "shortCode": "16"
            },
            {
                "value": "Wakayama",
                "label": "Wakayama",
                "shortCode": "30"
            },
            {
                "value": "Yamagata",
                "label": "Yamagata",
                "shortCode": "06"
            },
            {
                "value": "Yamaguchi",
                "label": "Yamaguchi",
                "shortCode": "35"
            },
            {
                "value": "Yamanashi",
                "label": "Yamanashi",
                "shortCode": "19"
            }
        ]
    },
    {
        "countryCode": "+44 1534",
        "value": "Jersey",
        "label": "Jersey",
        "regions": [
            {
                "value": "Jersey",
                "label": "Jersey"
            }
        ]
    },
    {
        "countryCode": "+962",
        "value": "Jordan",
        "label": "Jordan",
        "regions": [
            {
                "value": "‘Ajlūn",
                "label": "‘Ajlūn",
                "shortCode": "AJ"
            },
            {
                "value": "Al 'Aqabah",
                "label": "Al 'Aqabah",
                "shortCode": "AQ"
            },
            {
                "value": "Al Balqā’",
                "label": "Al Balqā’",
                "shortCode": "BA"
            },
            {
                "value": "Al Karak",
                "label": "Al Karak",
                "shortCode": "KA"
            },
            {
                "value": "Al Mafraq",
                "label": "Al Mafraq",
                "shortCode": "MA"
            },
            {
                "value": "Al ‘A̅şimah",
                "label": "Al ‘A̅şimah",
                "shortCode": "AM"
            },
            {
                "value": "Aţ Ţafīlah",
                "label": "Aţ Ţafīlah",
                "shortCode": "AT"
            },
            {
                "value": "Az Zarqā’",
                "label": "Az Zarqā’",
                "shortCode": "AZ"
            },
            {
                "value": "Irbid",
                "label": "Irbid",
                "shortCode": "IR"
            },
            {
                "value": "Jarash",
                "label": "Jarash",
                "shortCode": "JA"
            },
            {
                "value": "Ma‘ān",
                "label": "Ma‘ān",
                "shortCode": "MN"
            },
            {
                "value": "Mādabā",
                "label": "Mādabā",
                "shortCode": "MD"
            }
        ]
    },
    {
        "countryCode": "+997 (also 7 until 2025)",
        "value": "Kazakhstan",
        "label": "Kazakhstan",
        "regions": [
            {
                "value": "Almaty",
                "label": "Almaty",
                "shortCode": "ALA"
            },
            {
                "value": "Aqmola",
                "label": "Aqmola",
                "shortCode": "AKM"
            },
            {
                "value": "Aqtobe",
                "label": "Aqtobe",
                "shortCode": "AKT"
            },
            {
                "value": "Astana",
                "label": "Astana",
                "shortCode": "AST"
            },
            {
                "value": "Atyrau",
                "label": "Atyrau",
                "shortCode": "ATY"
            },
            {
                "value": "Batys Qazaqstan",
                "label": "Batys Qazaqstan",
                "shortCode": "ZAP"
            },
            {
                "value": "Bayqongyr",
                "label": "Bayqongyr"
            },
            {
                "value": "Mangghystau",
                "label": "Mangghystau",
                "shortCode": "MAN"
            },
            {
                "value": "Ongtustik Qazaqstan",
                "label": "Ongtustik Qazaqstan",
                "shortCode": "YUZ"
            },
            {
                "value": "Pavlodar",
                "label": "Pavlodar",
                "shortCode": "PAV"
            },
            {
                "value": "Qaraghandy",
                "label": "Qaraghandy",
                "shortCode": "KAR"
            },
            {
                "value": "Qostanay",
                "label": "Qostanay",
                "shortCode": "KUS"
            },
            {
                "value": "Qyzylorda",
                "label": "Qyzylorda",
                "shortCode": "KZY"
            },
            {
                "value": "Shyghys Qazaqstan",
                "label": "Shyghys Qazaqstan",
                "shortCode": "VOS"
            },
            {
                "value": "Soltustik Qazaqstan",
                "label": "Soltustik Qazaqstan",
                "shortCode": "SEV"
            },
            {
                "value": "Zhambyl",
                "label": "Zhambyl",
                "shortCode": "ZHA"
            }
        ]
    },
    {
        "countryCode": "+254",
        "value": "Kenya",
        "label": "Kenya",
        "regions": [
            {
                "value": "Baringo",
                "label": "Baringo",
                "shortCode": "01"
            },
            {
                "value": "Bomet",
                "label": "Bomet",
                "shortCode": "02"
            },
            {
                "value": "Bungoma",
                "label": "Bungoma",
                "shortCode": "03"
            },
            {
                "value": "Busia",
                "label": "Busia",
                "shortCode": "04"
            },
            {
                "value": "Eleyo/Marakwet",
                "label": "Eleyo/Marakwet",
                "shortCode": "05"
            },
            {
                "value": "Embu",
                "label": "Embu",
                "shortCode": "06"
            },
            {
                "value": "Garissa",
                "label": "Garissa",
                "shortCode": "07"
            },
            {
                "value": "Homa Bay",
                "label": "Homa Bay",
                "shortCode": "08"
            },
            {
                "value": "Isiolo",
                "label": "Isiolo",
                "shortCode": "09"
            },
            {
                "value": "Kajiado",
                "label": "Kajiado",
                "shortCode": "10"
            },
            {
                "value": "Kakamega",
                "label": "Kakamega",
                "shortCode": "11"
            },
            {
                "value": "Kericho",
                "label": "Kericho",
                "shortCode": "12"
            },
            {
                "value": "Kiambu",
                "label": "Kiambu",
                "shortCode": "13"
            },
            {
                "value": "Kilifi",
                "label": "Kilifi",
                "shortCode": "14"
            },
            {
                "value": "Kirinyaga",
                "label": "Kirinyaga",
                "shortCode": "15"
            },
            {
                "value": "Kisii",
                "label": "Kisii",
                "shortCode": "16"
            },
            {
                "value": "Kisumu",
                "label": "Kisumu",
                "shortCode": "17"
            },
            {
                "value": "Kitui",
                "label": "Kitui",
                "shortCode": "18"
            },
            {
                "value": "Kwale",
                "label": "Kwale",
                "shortCode": "19"
            },
            {
                "value": "Laikipia",
                "label": "Laikipia",
                "shortCode": "20"
            },
            {
                "value": "Lamu",
                "label": "Lamu",
                "shortCode": "21"
            },
            {
                "value": "Machakos",
                "label": "Machakos",
                "shortCode": "22"
            },
            {
                "value": "Makueni",
                "label": "Makueni",
                "shortCode": "23"
            },
            {
                "value": "Mandera",
                "label": "Mandera",
                "shortCode": "24"
            },
            {
                "value": "Marsabit",
                "label": "Marsabit",
                "shortCode": "25"
            },
            {
                "value": "Meru",
                "label": "Meru",
                "shortCode": "26"
            },
            {
                "value": "Migori",
                "label": "Migori",
                "shortCode": "27"
            },
            {
                "value": "Mombasa",
                "label": "Mombasa",
                "shortCode": "28"
            },
            {
                "value": "Murang'a",
                "label": "Murang'a",
                "shortCode": "29"
            },
            {
                "value": "Nairobi City",
                "label": "Nairobi City",
                "shortCode": "30"
            },
            {
                "value": "Nakuru",
                "label": "Nakuru",
                "shortCode": "31"
            },
            {
                "value": "Nandi",
                "label": "Nandi",
                "shortCode": "32"
            },
            {
                "value": "Narok",
                "label": "Narok",
                "shortCode": "33"
            },
            {
                "value": "Nyamira",
                "label": "Nyamira",
                "shortCode": "34"
            },
            {
                "value": "Nyandarua",
                "label": "Nyandarua",
                "shortCode": "35"
            },
            {
                "value": "Nyeri",
                "label": "Nyeri",
                "shortCode": "36"
            },
            {
                "value": "Samburu",
                "label": "Samburu",
                "shortCode": "37"
            },
            {
                "value": "Siaya",
                "label": "Siaya",
                "shortCode": "38"
            },
            {
                "value": "Taita/Taveta",
                "label": "Taita/Taveta",
                "shortCode": "39"
            },
            {
                "value": "Tana River",
                "label": "Tana River",
                "shortCode": "40"
            },
            {
                "value": "Tharaka-Nithi",
                "label": "Tharaka-Nithi",
                "shortCode": "41"
            },
            {
                "value": "Trans Nzoia",
                "label": "Trans Nzoia",
                "shortCode": "42"
            },
            {
                "value": "Turkana",
                "label": "Turkana",
                "shortCode": "43"
            },
            {
                "value": "Uasin Gishu",
                "label": "Uasin Gishu",
                "shortCode": "44"
            },
            {
                "value": "Vihiga",
                "label": "Vihiga",
                "shortCode": "45"
            },
            {
                "value": "Wajir",
                "label": "Wajir",
                "shortCode": "46"
            },
            {
                "value": "West Pokot",
                "label": "West Pokot",
                "shortCode": "47"
            }
        ]
    },
    {
        "countryCode": "+686",
        "value": "Kiribati",
        "label": "Kiribati",
        "regions": [
            {
                "value": "Abaiang",
                "label": "Abaiang"
            },
            {
                "value": "Abemama",
                "label": "Abemama"
            },
            {
                "value": "Aranuka",
                "label": "Aranuka"
            },
            {
                "value": "Arorae",
                "label": "Arorae"
            },
            {
                "value": "Banaba",
                "label": "Banaba"
            },
            {
                "value": "Beru",
                "label": "Beru"
            },
            {
                "value": "Butaritari",
                "label": "Butaritari"
            },
            {
                "value": "Central Gilberts",
                "label": "Central Gilberts"
            },
            {
                "value": "Gilbert Islands",
                "label": "Gilbert Islands",
                "shortCode": "G"
            },
            {
                "value": "Kanton",
                "label": "Kanton"
            },
            {
                "value": "Kiritimati",
                "label": "Kiritimati"
            },
            {
                "value": "Kuria",
                "label": "Kuria"
            },
            {
                "value": "Line Islands",
                "label": "Line Islands",
                "shortCode": "L"
            },
            {
                "value": "Maiana",
                "label": "Maiana"
            },
            {
                "value": "Makin",
                "label": "Makin"
            },
            {
                "value": "Marakei",
                "label": "Marakei"
            },
            {
                "value": "Nikunau",
                "label": "Nikunau"
            },
            {
                "value": "Nonouti",
                "label": "Nonouti"
            },
            {
                "value": "Northern Gilberts",
                "label": "Northern Gilberts"
            },
            {
                "value": "Onotoa",
                "label": "Onotoa"
            },
            {
                "value": "Phoenix Islands",
                "label": "Phoenix Islands",
                "shortCode": "P"
            },
            {
                "value": "Southern Gilberts",
                "label": "Southern Gilberts"
            },
            {
                "value": "Tabiteuea",
                "label": "Tabiteuea"
            },
            {
                "value": "Tabuaeran",
                "label": "Tabuaeran"
            },
            {
                "value": "Tamana",
                "label": "Tamana"
            },
            {
                "value": "Tarawa",
                "label": "Tarawa"
            },
            {
                "value": "Teraina",
                "label": "Teraina"
            }
        ]
    },
    {
        "countryCode": "+383",
        "value": "Kosovo",
        "label": "Kosovo",
        "regions": [
            {
                "value": "Farizaj",
                "label": "Farizaj",
                "shortCode": "FZ"
            },
            {
                "value": "Gjakova",
                "label": "Gjakova",
                "shortCode": "GK"
            },
            {
                "value": "Gjilan",
                "label": "Gjilan",
                "shortCode": "GL"
            },
            {
                "value": "Mitrovica",
                "label": "Mitrovica",
                "shortCode": "MI"
            },
            {
                "value": "Peja/Peć",
                "label": "Peja/Peć",
                "shortCode": "PE"
            },
            {
                "value": "Pristina",
                "label": "Pristina",
                "shortCode": "PR"
            },
            {
                "value": "Prizren",
                "label": "Prizren",
                "shortCode": "PZ"
            }
        ]
    },
    {
        "countryCode": "+965",
        "value": "Kuwait",
        "label": "Kuwait",
        "regions": [
            {
                "value": "Al Aḩmadi",
                "label": "Al Aḩmadi",
                "shortCode": "AH"
            },
            {
                "value": "Al Farwānīyah",
                "label": "Al Farwānīyah",
                "shortCode": "FA"
            },
            {
                "value": "Al Jahrā’",
                "label": "Al Jahrā’",
                "shortCode": "JA"
            },
            {
                "value": "Al ‘Āşimah",
                "label": "Al ‘Āşimah",
                "shortCode": "KU"
            },
            {
                "value": "Ḩawallī",
                "label": "Ḩawallī",
                "shortCode": "HA"
            },
            {
                "value": "Mubārak al Kabir",
                "label": "Mubārak al Kabir",
                "shortCode": "MU"
            }
        ]
    },
    {
        "countryCode": "+996",
        "value": "Kyrgyzstan",
        "label": "Kyrgyzstan",
        "regions": [
            {
                "value": "Batken Oblasty",
                "label": "Batken Oblasty",
                "shortCode": "B"
            },
            {
                "value": "Bishkek Shaary",
                "label": "Bishkek Shaary",
                "shortCode": "GB"
            },
            {
                "value": "Chuy Oblasty (Bishkek)",
                "label": "Chuy Oblasty (Bishkek)",
                "shortCode": "C"
            },
            {
                "value": "Jalal-Abad Oblasty",
                "label": "Jalal-Abad Oblasty",
                "shortCode": "J"
            },
            {
                "value": "Naryn Oblasty",
                "label": "Naryn Oblasty",
                "shortCode": "N"
            },
            {
                "value": "Osh Oblasty",
                "label": "Osh Oblasty",
                "shortCode": "O"
            },
            {
                "value": "Talas Oblasty",
                "label": "Talas Oblasty",
                "shortCode": "T"
            },
            {
                "value": "Ysyk-Kol Oblasty (Karakol)",
                "label": "Ysyk-Kol Oblasty (Karakol)",
                "shortCode": "Y"
            }
        ]
    },
    {
        "countryCode": "+856",
        "value": "Laos",
        "label": "Laos",
        "regions": [
            {
                "value": "Attapu",
                "label": "Attapu",
                "shortCode": "AT"
            },
            {
                "value": "Bokèo",
                "label": "Bokèo",
                "shortCode": "BK"
            },
            {
                "value": "Bolikhamxai",
                "label": "Bolikhamxai",
                "shortCode": "BL"
            },
            {
                "value": "Champasak",
                "label": "Champasak",
                "shortCode": "CH"
            },
            {
                "value": "Houaphan",
                "label": "Houaphan",
                "shortCode": "HO"
            },
            {
                "value": "Khammouan",
                "label": "Khammouan",
                "shortCode": "KH"
            },
            {
                "value": "Louang Namtha",
                "label": "Louang Namtha",
                "shortCode": "LM"
            },
            {
                "value": "Louangphabang",
                "label": "Louangphabang",
                "shortCode": "LP"
            },
            {
                "value": "Oudômxai",
                "label": "Oudômxai",
                "shortCode": "OU"
            },
            {
                "value": "Phôngsali",
                "label": "Phôngsali",
                "shortCode": "PH"
            },
            {
                "value": "Salavan",
                "label": "Salavan",
                "shortCode": "SL"
            },
            {
                "value": "Savannakhét",
                "label": "Savannakhét",
                "shortCode": "SV"
            },
            {
                "value": "Vientiane",
                "label": "Vientiane",
                "shortCode": "VI"
            },
            {
                "value": "Xaignabouli",
                "label": "Xaignabouli",
                "shortCode": "XA"
            },
            {
                "value": "Xékong",
                "label": "Xékong",
                "shortCode": "XE"
            },
            {
                "value": "Xaisomboun",
                "label": "Xaisomboun",
                "shortCode": "XS"
            },
            {
                "value": "Xiangkhouang",
                "label": "Xiangkhouang",
                "shortCode": "XI"
            }
        ]
    },
    {
        "countryCode": "+371",
        "value": "Latvia",
        "label": "Latvia",
        "regions": [
            {
                "value": "Aglona",
                "label": "Aglona",
                "shortCode": "001"
            },
            {
                "value": "Aizkraukle",
                "label": "Aizkraukle",
                "shortCode": "002"
            },
            {
                "value": "Aizpute",
                "label": "Aizpute",
                "shortCode": "003"
            },
            {
                "value": "Aknīste",
                "label": "Aknīste",
                "shortCode": "004"
            },
            {
                "value": "Aloja",
                "label": "Aloja",
                "shortCode": "005"
            },
            {
                "value": "Alsunga",
                "label": "Alsunga",
                "shortCode": "06"
            },
            {
                "value": "Alūksne",
                "label": "Alūksne",
                "shortCode": "007"
            },
            {
                "value": "Amata",
                "label": "Amata",
                "shortCode": "008"
            },
            {
                "value": "Ape",
                "label": "Ape",
                "shortCode": "009"
            },
            {
                "value": "Auce",
                "label": "Auce",
                "shortCode": "010"
            },
            {
                "value": "Ādaži",
                "label": "Ādaži",
                "shortCode": "011"
            },
            {
                "value": "Babīte",
                "label": "Babīte",
                "shortCode": "012"
            },
            {
                "value": "Baldone",
                "label": "Baldone",
                "shortCode": "013"
            },
            {
                "value": "Baltinava",
                "label": "Baltinava",
                "shortCode": "014"
            },
            {
                "value": "Balvi",
                "label": "Balvi",
                "shortCode": "015"
            },
            {
                "value": "Bauska",
                "label": "Bauska",
                "shortCode": "016"
            },
            {
                "value": "Beverīna",
                "label": "Beverīna",
                "shortCode": "017"
            },
            {
                "value": "Brocēni",
                "label": "Brocēni",
                "shortCode": "018"
            },
            {
                "value": "Burtnieki",
                "label": "Burtnieki",
                "shortCode": "019"
            },
            {
                "value": "Carnikava",
                "label": "Carnikava",
                "shortCode": "020"
            },
            {
                "value": "Cesvaine",
                "label": "Cesvaine",
                "shortCode": "021"
            },
            {
                "value": "Cēsis",
                "label": "Cēsis",
                "shortCode": "022"
            },
            {
                "value": "Cibla",
                "label": "Cibla",
                "shortCode": "023"
            },
            {
                "value": "Dagda",
                "label": "Dagda",
                "shortCode": "024"
            },
            {
                "value": "Daugavpils",
                "label": "Daugavpils",
                "shortCode": "025"
            },
            {
                "value": "Daugavpils (City)",
                "label": "Daugavpils (City)",
                "shortCode": "DGV"
            },
            {
                "value": "Dobele",
                "label": "Dobele",
                "shortCode": "026"
            },
            {
                "value": "Dundaga",
                "label": "Dundaga",
                "shortCode": "027"
            },
            {
                "value": "Durbe",
                "label": "Durbe",
                "shortCode": "028"
            },
            {
                "value": "Engure",
                "label": "Engure",
                "shortCode": "029"
            },
            {
                "value": "Ērgļi",
                "label": "Ērgļi",
                "shortCode": "030"
            },
            {
                "value": "Garkalne",
                "label": "Garkalne",
                "shortCode": "031"
            },
            {
                "value": "Grobiņa",
                "label": "Grobiņa",
                "shortCode": "032"
            },
            {
                "value": "Gulbene",
                "label": "Gulbene",
                "shortCode": "033"
            },
            {
                "value": "Iecava",
                "label": "Iecava",
                "shortCode": "034"
            },
            {
                "value": "Ikšķile",
                "label": "Ikšķile",
                "shortCode": "035"
            },
            {
                "value": "Ilūkste",
                "label": "Ilūkste",
                "shortCode": "036"
            },
            {
                "value": "Inčukalns",
                "label": "Inčukalns",
                "shortCode": "037"
            },
            {
                "value": "Jaunjelgava",
                "label": "Jaunjelgava",
                "shortCode": "038"
            },
            {
                "value": "Jaunpiebalga",
                "label": "Jaunpiebalga",
                "shortCode": "039"
            },
            {
                "value": "Jaunpils",
                "label": "Jaunpils",
                "shortCode": "040"
            },
            {
                "value": "Jelgava",
                "label": "Jelgava",
                "shortCode": "041"
            },
            {
                "value": "Jelgava (City)",
                "label": "Jelgava (City)",
                "shortCode": "JEL"
            },
            {
                "value": "Jēkabpils",
                "label": "Jēkabpils",
                "shortCode": "042"
            },
            {
                "value": "Jēkabpils (City)",
                "label": "Jēkabpils (City)",
                "shortCode": "JKB"
            },
            {
                "value": "Jūrmala (City)",
                "label": "Jūrmala (City)",
                "shortCode": "JUR"
            },
            {
                "value": "Kandava",
                "label": "Kandava",
                "shortCode": "043"
            },
            {
                "value": "Kārsava",
                "label": "Kārsava",
                "shortCode": "044"
            },
            {
                "value": "Kocēni",
                "label": "Kocēni",
                "shortCode": "045"
            },
            {
                "value": "Koknese",
                "label": "Koknese",
                "shortCode": "046"
            },
            {
                "value": "Krāslava",
                "label": "Krāslava",
                "shortCode": "047"
            },
            {
                "value": "Krimulda",
                "label": "Krimulda",
                "shortCode": "048"
            },
            {
                "value": "Krustpils",
                "label": "Krustpils",
                "shortCode": "049"
            },
            {
                "value": "Kuldīga",
                "label": "Kuldīga",
                "shortCode": "050"
            },
            {
                "value": "Ķegums",
                "label": "Ķegums",
                "shortCode": "051"
            },
            {
                "value": "Ķekava",
                "label": "Ķekava",
                "shortCode": "052"
            },
            {
                "value": "Lielvārde",
                "label": "Lielvārde",
                "shortCode": "053"
            },
            {
                "value": "Liepāja",
                "label": "Liepāja",
                "shortCode": "LPX"
            },
            {
                "value": "Limbaži",
                "label": "Limbaži",
                "shortCode": "054"
            },
            {
                "value": "Līgatne",
                "label": "Līgatne",
                "shortCode": "055"
            },
            {
                "value": "Līvāni",
                "label": "Līvāni",
                "shortCode": "056"
            },
            {
                "value": "Lubāna",
                "label": "Lubāna",
                "shortCode": "057"
            },
            {
                "value": "Ludza",
                "label": "Ludza",
                "shortCode": "058"
            },
            {
                "value": "Madona",
                "label": "Madona",
                "shortCode": "059"
            },
            {
                "value": "Mazsalaca",
                "label": "Mazsalaca",
                "shortCode": "060"
            },
            {
                "value": "Mālpils",
                "label": "Mālpils",
                "shortCode": "061"
            },
            {
                "value": "Mārupe",
                "label": "Mārupe",
                "shortCode": "062"
            },
            {
                "value": "Mērsrags",
                "label": "Mērsrags",
                "shortCode": "063"
            },
            {
                "value": "Naukšēni",
                "label": "Naukšēni",
                "shortCode": "064"
            },
            {
                "value": "Nereta",
                "label": "Nereta",
                "shortCode": "065"
            },
            {
                "value": "Nīca",
                "label": "Nīca",
                "shortCode": "066"
            },
            {
                "value": "Ogre",
                "label": "Ogre",
                "shortCode": "067"
            },
            {
                "value": "Olaine",
                "label": "Olaine",
                "shortCode": "068"
            },
            {
                "value": "Ozolnieki",
                "label": "Ozolnieki",
                "shortCode": "069"
            },
            {
                "value": "Pārgauja",
                "label": "Pārgauja",
                "shortCode": "070"
            },
            {
                "value": "Pāvilosta",
                "label": "Pāvilosta",
                "shortCode": "071"
            },
            {
                "value": "Pļaviņas",
                "label": "Pļaviņas",
                "shortCode": "072"
            },
            {
                "value": "Preiļi",
                "label": "Preiļi",
                "shortCode": "073"
            },
            {
                "value": "Priekule",
                "label": "Priekule",
                "shortCode": "074"
            },
            {
                "value": "Priekuļi",
                "label": "Priekuļi",
                "shortCode": "075"
            },
            {
                "value": "Rauna",
                "label": "Rauna",
                "shortCode": "076"
            },
            {
                "value": "Rēzekne",
                "label": "Rēzekne",
                "shortCode": "077"
            },
            {
                "value": "Rēzekne (City)",
                "label": "Rēzekne (City)",
                "shortCode": "REZ"
            },
            {
                "value": "Riebiņi",
                "label": "Riebiņi",
                "shortCode": "078"
            },
            {
                "value": "Rīga",
                "label": "Rīga",
                "shortCode": "RIX"
            },
            {
                "value": "Roja",
                "label": "Roja",
                "shortCode": "079"
            },
            {
                "value": "Ropaži",
                "label": "Ropaži",
                "shortCode": "080"
            },
            {
                "value": "Rucava",
                "label": "Rucava",
                "shortCode": "081"
            },
            {
                "value": "Rugāji",
                "label": "Rugāji",
                "shortCode": "082"
            },
            {
                "value": "Rundāle",
                "label": "Rundāle",
                "shortCode": "083"
            },
            {
                "value": "Rūjiena",
                "label": "Rūjiena",
                "shortCode": "084"
            },
            {
                "value": "Sala",
                "label": "Sala",
                "shortCode": "085"
            },
            {
                "value": "Salacgrīva",
                "label": "Salacgrīva",
                "shortCode": "086"
            },
            {
                "value": "Salaspils",
                "label": "Salaspils",
                "shortCode": "087"
            },
            {
                "value": "Saldus",
                "label": "Saldus",
                "shortCode": "088"
            },
            {
                "value": "Saulkrasti",
                "label": "Saulkrasti",
                "shortCode": "089"
            },
            {
                "value": "Sēja",
                "label": "Sēja",
                "shortCode": "090"
            },
            {
                "value": "Sigulda",
                "label": "Sigulda",
                "shortCode": "091"
            },
            {
                "value": "Skrīveri",
                "label": "Skrīveri",
                "shortCode": "092"
            },
            {
                "value": "Skrunda",
                "label": "Skrunda",
                "shortCode": "093"
            },
            {
                "value": "Smiltene",
                "label": "Smiltene",
                "shortCode": "094"
            },
            {
                "value": "Stopiņi",
                "label": "Stopiņi",
                "shortCode": "095"
            },
            {
                "value": "Strenči",
                "label": "Strenči",
                "shortCode": "096"
            },
            {
                "value": "Talsi",
                "label": "Talsi",
                "shortCode": "097"
            },
            {
                "value": "Tērvete",
                "label": "Tērvete",
                "shortCode": "098"
            },
            {
                "value": "Tukums",
                "label": "Tukums",
                "shortCode": "099"
            },
            {
                "value": "Vaiņode",
                "label": "Vaiņode",
                "shortCode": "100"
            },
            {
                "value": "Valka",
                "label": "Valka",
                "shortCode": "101"
            },
            {
                "value": "Valmiera",
                "label": "Valmiera",
                "shortCode": "VMR"
            },
            {
                "value": "Varakļāni",
                "label": "Varakļāni",
                "shortCode": "102"
            },
            {
                "value": "Vārkava",
                "label": "Vārkava",
                "shortCode": "103"
            },
            {
                "value": "Vecpiebalga",
                "label": "Vecpiebalga",
                "shortCode": "104"
            },
            {
                "value": "Vecumnieki",
                "label": "Vecumnieki",
                "shortCode": "105"
            },
            {
                "value": "Ventspils",
                "label": "Ventspils",
                "shortCode": "106"
            },
            {
                "value": "Ventspils (City)",
                "label": "Ventspils (City)",
                "shortCode": "VEN"
            },
            {
                "value": "Viesīte",
                "label": "Viesīte",
                "shortCode": "107"
            },
            {
                "value": "Viļaka",
                "label": "Viļaka",
                "shortCode": "108"
            },
            {
                "value": "Viļāni",
                "label": "Viļāni",
                "shortCode": "109"
            },
            {
                "value": "Zilupe",
                "label": "Zilupe",
                "shortCode": "110"
            }
        ]
    },
    {
        "countryCode": "+961",
        "value": "Lebanon",
        "label": "Lebanon",
        "regions": [
            {
                "value": "Aakkâr",
                "label": "Aakkâr",
                "shortCode": "AK"
            },
            {
                "value": "Baalbelk-Hermel",
                "label": "Baalbelk-Hermel",
                "shortCode": "BH"
            },
            {
                "value": "Béqaa",
                "label": "Béqaa",
                "shortCode": "BI"
            },
            {
                "value": "Beyrouth",
                "label": "Beyrouth",
                "shortCode": "BA"
            },
            {
                "value": "Liban-Nord",
                "label": "Liban-Nord",
                "shortCode": "AS"
            },
            {
                "value": "Liban-Sud",
                "label": "Liban-Sud",
                "shortCode": "JA"
            },
            {
                "value": "Mont-Liban",
                "label": "Mont-Liban",
                "shortCode": "JL"
            },
            {
                "value": "Nabatîyé",
                "label": "Nabatîyé",
                "shortCode": "NA"
            }
        ]
    },
    {
        "countryCode": "+266",
        "value": "Lesotho",
        "label": "Lesotho",
        "regions": [
            {
                "value": "Berea",
                "label": "Berea",
                "shortCode": "D"
            },
            {
                "value": "Butha-Buthe",
                "label": "Butha-Buthe",
                "shortCode": "B"
            },
            {
                "value": "Leribe",
                "label": "Leribe",
                "shortCode": "C"
            },
            {
                "value": "Mafeteng",
                "label": "Mafeteng",
                "shortCode": "E"
            },
            {
                "value": "Maseru",
                "label": "Maseru",
                "shortCode": "A"
            },
            {
                "value": "Mohales Hoek",
                "label": "Mohales Hoek",
                "shortCode": "F"
            },
            {
                "value": "Mokhotlong",
                "label": "Mokhotlong",
                "shortCode": "J"
            },
            {
                "value": "Qacha's Nek",
                "label": "Qacha's Nek",
                "shortCode": "H"
            },
            {
                "value": "Quthing",
                "label": "Quthing",
                "shortCode": "G"
            },
            {
                "value": "Thaba-Tseka",
                "label": "Thaba-Tseka",
                "shortCode": "K"
            }
        ]
    },
    {
        "countryCode": "+231",
        "value": "Liberia",
        "label": "Liberia",
        "regions": [
            {
                "value": "Bomi",
                "label": "Bomi",
                "shortCode": "BM"
            },
            {
                "value": "Bong",
                "label": "Bong",
                "shortCode": "BG"
            },
            {
                "value": "Gbarpolu",
                "label": "Gbarpolu",
                "shortCode": "GP"
            },
            {
                "value": "Grand Bassa",
                "label": "Grand Bassa",
                "shortCode": "GB"
            },
            {
                "value": "Grand Cape Mount",
                "label": "Grand Cape Mount",
                "shortCode": "CM"
            },
            {
                "value": "Grand Gedeh",
                "label": "Grand Gedeh",
                "shortCode": "GG"
            },
            {
                "value": "Grand Kru",
                "label": "Grand Kru",
                "shortCode": "GK"
            },
            {
                "value": "Lofa",
                "label": "Lofa",
                "shortCode": "LO"
            },
            {
                "value": "Margibi",
                "label": "Margibi",
                "shortCode": "MG"
            },
            {
                "value": "Maryland",
                "label": "Maryland",
                "shortCode": "MY"
            },
            {
                "value": "Montserrado",
                "label": "Montserrado",
                "shortCode": "MO"
            },
            {
                "value": "Nimba",
                "label": "Nimba",
                "shortCode": "NI"
            },
            {
                "value": "River Cess",
                "label": "River Cess",
                "shortCode": "RI"
            },
            {
                "value": "River Geee",
                "label": "River Geee",
                "shortCode": "RG"
            },
            {
                "value": "Sinoe",
                "label": "Sinoe",
                "shortCode": "SI"
            }
        ]
    },
    {
        "countryCode": "+218",
        "value": "Libya",
        "label": "Libya",
        "regions": [
            {
                "value": "Al Buţnān",
                "label": "Al Buţnān",
                "shortCode": "BU"
            },
            {
                "value": "Al Jabal al Akhḑar",
                "label": "Al Jabal al Akhḑar",
                "shortCode": "JA"
            },
            {
                "value": "Al Jabal al Gharbī",
                "label": "Al Jabal al Gharbī",
                "shortCode": "JG"
            },
            {
                "value": "Al Jafārah",
                "label": "Al Jafārah",
                "shortCode": "JI"
            },
            {
                "value": "Al Jufrah",
                "label": "Al Jufrah",
                "shortCode": "JU"
            },
            {
                "value": "Al Kufrah",
                "label": "Al Kufrah",
                "shortCode": "FK"
            },
            {
                "value": "Al Marj",
                "label": "Al Marj",
                "shortCode": "MJ"
            },
            {
                "value": "Al Marquab",
                "label": "Al Marquab",
                "shortCode": "MB"
            },
            {
                "value": "Al Wāḩāt",
                "label": "Al Wāḩāt",
                "shortCode": "WA"
            },
            {
                "value": "An Nuqaţ al Khams",
                "label": "An Nuqaţ al Khams",
                "shortCode": "NQ"
            },
            {
                "value": "Az Zāwiyah",
                "label": "Az Zāwiyah",
                "shortCode": "ZA"
            },
            {
                "value": "Banghāzī",
                "label": "Banghāzī",
                "shortCode": "BA"
            },
            {
                "value": "Darnah",
                "label": "Darnah",
                "shortCode": "DR"
            },
            {
                "value": "Ghāt",
                "label": "Ghāt",
                "shortCode": "GH"
            },
            {
                "value": "Mişrātah",
                "label": "Mişrātah",
                "shortCode": "MI"
            },
            {
                "value": "Murzuq",
                "label": "Murzuq",
                "shortCode": "MQ"
            },
            {
                "value": "Nālūt",
                "label": "Nālūt",
                "shortCode": "NL"
            },
            {
                "value": "Sabhā",
                "label": "Sabhā",
                "shortCode": "SB"
            },
            {
                "value": "Surt",
                "label": "Surt",
                "shortCode": "SR"
            },
            {
                "value": "Ţarābulus",
                "label": "Ţarābulus",
                "shortCode": "TB"
            },
            {
                "value": "Yafran",
                "label": "Yafran",
                "shortCode": "WD"
            },
            {
                "value": "Wādī ash Shāţiʾ",
                "label": "Wādī ash Shāţiʾ",
                "shortCode": "WS"
            }
        ]
    },
    {
        "countryCode": "+423",
        "value": "Liechtenstein",
        "label": "Liechtenstein",
        "regions": [
            {
                "value": "Balzers",
                "label": "Balzers",
                "shortCode": "01"
            },
            {
                "value": "Eschen",
                "label": "Eschen",
                "shortCode": "02"
            },
            {
                "value": "Gamprin",
                "label": "Gamprin",
                "shortCode": "03"
            },
            {
                "value": "Mauren",
                "label": "Mauren",
                "shortCode": "04"
            },
            {
                "value": "Planken",
                "label": "Planken",
                "shortCode": "05"
            },
            {
                "value": "Ruggell",
                "label": "Ruggell",
                "shortCode": "06"
            },
            {
                "value": "Schaan",
                "label": "Schaan",
                "shortCode": "07"
            },
            {
                "value": "Schellenberg",
                "label": "Schellenberg",
                "shortCode": "08"
            },
            {
                "value": "Triesen",
                "label": "Triesen",
                "shortCode": "09"
            },
            {
                "value": "Triesenberg",
                "label": "Triesenberg",
                "shortCode": "10"
            },
            {
                "value": "Vaduz",
                "label": "Vaduz",
                "shortCode": "11"
            }
        ]
    },
    {
        "countryCode": "+370",
        "value": "Lithuania",
        "label": "Lithuania",
        "regions": [
            {
                "value": "Alytaus",
                "label": "Alytaus",
                "shortCode": "AL"
            },
            {
                "value": "Kauno",
                "label": "Kauno",
                "shortCode": "KU"
            },
            {
                "value": "Klaipėdos",
                "label": "Klaipėdos",
                "shortCode": "KL"
            },
            {
                "value": "Marijampolės",
                "label": "Marijampolės",
                "shortCode": "MR"
            },
            {
                "value": "Panevėžio",
                "label": "Panevėžio",
                "shortCode": "PN"
            },
            {
                "value": "Šiaulių",
                "label": "Šiaulių",
                "shortCode": "SA"
            },
            {
                "value": "Tauragės",
                "label": "Tauragės",
                "shortCode": "TA"
            },
            {
                "value": "Telšių",
                "label": "Telšių",
                "shortCode": "TE"
            },
            {
                "value": "Utenos",
                "label": "Utenos",
                "shortCode": "UT"
            },
            {
                "value": "Vilniaus",
                "label": "Vilniaus",
                "shortCode": "VL"
            }
        ]
    },
    {
        "countryCode": "+352",
        "value": "Luxembourg",
        "label": "Luxembourg",
        "regions": [
            {
                "value": "Capellen",
                "label": "Capellen",
                "shortCode": "CA"
            },
            {
                "value": "Clevaux",
                "label": "Clevaux",
                "shortCode": "CL"
            },
            {
                "value": "Diekirch",
                "label": "Diekirch",
                "shortCode": "DI"
            },
            {
                "value": "Echternach",
                "label": "Echternach",
                "shortCode": "EC"
            },
            {
                "value": "Esch-sur-Alzette",
                "label": "Esch-sur-Alzette",
                "shortCode": "ES"
            },
            {
                "value": "Grevenmacher",
                "label": "Grevenmacher",
                "shortCode": "GR"
            },
            {
                "value": "Luxembourg",
                "label": "Luxembourg",
                "shortCode": "LU"
            },
            {
                "value": "Mersch",
                "label": "Mersch",
                "shortCode": "ME"
            },
            {
                "value": "Redange",
                "label": "Redange",
                "shortCode": "RD"
            },
            {
                "value": "Remich",
                "label": "Remich",
                "shortCode": "RM"
            },
            {
                "value": "Vianden",
                "label": "Vianden",
                "shortCode": "VD"
            },
            {
                "value": "Wiltz",
                "label": "Wiltz",
                "shortCode": "WI"
            }
        ]
    },
    {
        "countryCode": "+261",
        "value": "Madagascar",
        "label": "Madagascar",
        "regions": [
            {
                "value": "Antananarivo",
                "label": "Antananarivo",
                "shortCode": "T"
            },
            {
                "value": "Antsiranana",
                "label": "Antsiranana",
                "shortCode": "D"
            },
            {
                "value": "Fianarantsoa",
                "label": "Fianarantsoa",
                "shortCode": "F"
            },
            {
                "value": "Mahajanga",
                "label": "Mahajanga",
                "shortCode": "M"
            },
            {
                "value": "Toamasina",
                "label": "Toamasina",
                "shortCode": "A"
            },
            {
                "value": "Toliara",
                "label": "Toliara",
                "shortCode": "U"
            }
        ]
    },
    {
        "countryCode": "+265",
        "value": "Malawi",
        "label": "Malawi",
        "regions": [
            {
                "value": "Balaka",
                "label": "Balaka",
                "shortCode": "BA"
            },
            {
                "value": "Blantyre",
                "label": "Blantyre",
                "shortCode": "BL"
            },
            {
                "value": "Chikwawa",
                "label": "Chikwawa",
                "shortCode": "CK"
            },
            {
                "value": "Chiradzulu",
                "label": "Chiradzulu",
                "shortCode": "CR"
            },
            {
                "value": "Chitipa",
                "label": "Chitipa",
                "shortCode": "CT"
            },
            {
                "value": "Dedza",
                "label": "Dedza",
                "shortCode": "DE"
            },
            {
                "value": "Dowa",
                "label": "Dowa",
                "shortCode": "DO"
            },
            {
                "value": "Karonga",
                "label": "Karonga",
                "shortCode": "KR"
            },
            {
                "value": "Kasungu",
                "label": "Kasungu",
                "shortCode": "KS"
            },
            {
                "value": "Likoma",
                "label": "Likoma",
                "shortCode": "LK"
            },
            {
                "value": "Lilongwe",
                "label": "Lilongwe",
                "shortCode": "LI"
            },
            {
                "value": "Machinga",
                "label": "Machinga",
                "shortCode": "MH"
            },
            {
                "value": "Mangochi",
                "label": "Mangochi",
                "shortCode": "MG"
            },
            {
                "value": "Mchinji",
                "label": "Mchinji",
                "shortCode": "MC"
            },
            {
                "value": "Mulanje",
                "label": "Mulanje",
                "shortCode": "MU"
            },
            {
                "value": "Mwanza",
                "label": "Mwanza",
                "shortCode": "MW"
            },
            {
                "value": "Mzimba",
                "label": "Mzimba",
                "shortCode": "MZ"
            },
            {
                "value": "Nkhata Bay",
                "label": "Nkhata Bay",
                "shortCode": "NE"
            },
            {
                "value": "Nkhotakota",
                "label": "Nkhotakota",
                "shortCode": "NB"
            },
            {
                "value": "Nsanje",
                "label": "Nsanje",
                "shortCode": "NS"
            },
            {
                "value": "Ntcheu",
                "label": "Ntcheu",
                "shortCode": "NU"
            },
            {
                "value": "Ntchisi",
                "label": "Ntchisi",
                "shortCode": "NI"
            },
            {
                "value": "Phalombe",
                "label": "Phalombe",
                "shortCode": "PH"
            },
            {
                "value": "Rumphi",
                "label": "Rumphi",
                "shortCode": "RU"
            },
            {
                "value": "Salima",
                "label": "Salima",
                "shortCode": "SA"
            },
            {
                "value": "Thyolo",
                "label": "Thyolo",
                "shortCode": "TH"
            },
            {
                "value": "Zomba",
                "label": "Zomba",
                "shortCode": "ZO"
            }
        ]
    },
    {
        "countryCode": "+60",
        "value": "Malaysia",
        "label": "Malaysia",
        "regions": [
            {
                "value": "Johor",
                "label": "Johor",
                "shortCode": "01"
            },
            {
                "value": "Kedah",
                "label": "Kedah",
                "shortCode": "02"
            },
            {
                "value": "Kelantan",
                "label": "Kelantan",
                "shortCode": "03"
            },
            {
                "value": "Melaka",
                "label": "Melaka",
                "shortCode": "04"
            },
            {
                "value": "Negeri Sembilan",
                "label": "Negeri Sembilan",
                "shortCode": "05"
            },
            {
                "value": "Pahang",
                "label": "Pahang",
                "shortCode": "06"
            },
            {
                "value": "Perak",
                "label": "Perak",
                "shortCode": "08"
            },
            {
                "value": "Perlis",
                "label": "Perlis",
                "shortCode": "09"
            },
            {
                "value": "Pulau Pinang",
                "label": "Pulau Pinang",
                "shortCode": "07"
            },
            {
                "value": "Sabah",
                "label": "Sabah",
                "shortCode": "12"
            },
            {
                "value": "Sarawak",
                "label": "Sarawak",
                "shortCode": "13"
            },
            {
                "value": "Selangor",
                "label": "Selangor",
                "shortCode": "10"
            },
            {
                "value": "Terengganu",
                "label": "Terengganu",
                "shortCode": "11"
            },
            {
                "value": "Wilayah Persekutuan (Kuala Lumpur)",
                "label": "Wilayah Persekutuan (Kuala Lumpur)",
                "shortCode": "14"
            },
            {
                "value": "Wilayah Persekutuan (Labuan)",
                "label": "Wilayah Persekutuan (Labuan)",
                "shortCode": "15"
            },
            {
                "value": "Wilayah Persekutuan (Putrajaya)",
                "label": "Wilayah Persekutuan (Putrajaya)",
                "shortCode": "16"
            }
        ]
    },
    {
        "countryCode": "+960",
        "value": "Maldives",
        "label": "Maldives",
        "regions": [
            {
                "value": "Alifu Alifu",
                "label": "Alifu Alifu",
                "shortCode": "02"
            },
            {
                "value": "Alifu Dhaalu",
                "label": "Alifu Dhaalu",
                "shortCode": "00"
            },
            {
                "value": "Baa",
                "label": "Baa",
                "shortCode": "20"
            },
            {
                "value": "Dhaalu",
                "label": "Dhaalu",
                "shortCode": "17"
            },
            {
                "value": "Faafu",
                "label": "Faafu",
                "shortCode": "14"
            },
            {
                "value": "Gaafu Alifu",
                "label": "Gaafu Alifu",
                "shortCode": "27"
            },
            {
                "value": "Gaafu Dhaalu",
                "label": "Gaafu Dhaalu",
                "shortCode": "28"
            },
            {
                "value": "Gnaviyani",
                "label": "Gnaviyani",
                "shortCode": "29"
            },
            {
                "value": "Haa Alifu",
                "label": "Haa Alifu",
                "shortCode": "07"
            },
            {
                "value": "Haa Dhaalu",
                "label": "Haa Dhaalu",
                "shortCode": "23"
            },
            {
                "value": "Kaafu",
                "label": "Kaafu",
                "shortCode": "26"
            },
            {
                "value": "Laamu",
                "label": "Laamu",
                "shortCode": "05"
            },
            {
                "value": "Lhaviyani",
                "label": "Lhaviyani",
                "shortCode": "03"
            },
            {
                "value": "Malé",
                "label": "Malé",
                "shortCode": "MLE"
            },
            {
                "value": "Meemu",
                "label": "Meemu",
                "shortCode": "12"
            },
            {
                "value": "Noonu",
                "label": "Noonu",
                "shortCode": "25"
            },
            {
                "value": "Raa",
                "label": "Raa",
                "shortCode": "13"
            },
            {
                "value": "Seenu",
                "label": "Seenu",
                "shortCode": "01"
            },
            {
                "value": "Shaviyani",
                "label": "Shaviyani",
                "shortCode": "24"
            },
            {
                "value": "Thaa",
                "label": "Thaa",
                "shortCode": "08"
            },
            {
                "value": "Vaavu",
                "label": "Vaavu",
                "shortCode": "04"
            }
        ]
    },
    {
        "countryCode": "+223",
        "value": "Mali",
        "label": "Mali",
        "regions": [
            {
                "value": "Bamako",
                "label": "Bamako",
                "shortCode": "BKO"
            },
            {
                "value": "Gao",
                "label": "Gao",
                "shortCode": "7"
            },
            {
                "value": "Kayes",
                "label": "Kayes",
                "shortCode": "1"
            },
            {
                "value": "Kidal",
                "label": "Kidal",
                "shortCode": "8"
            },
            {
                "value": "Koulikoro",
                "label": "Koulikoro",
                "shortCode": "2"
            },
            {
                "value": "Mopti",
                "label": "Mopti",
                "shortCode": "5"
            },
            {
                "value": "Segou",
                "label": "Segou",
                "shortCode": "4"
            },
            {
                "value": "Sikasso",
                "label": "Sikasso",
                "shortCode": "3"
            },
            {
                "value": "Tombouctou",
                "label": "Tombouctou",
                "shortCode": "6"
            },
            {
                "value": "Taoudénit",
                "label": "Taoudénit",
                "shortCode": "9"
            },
            {
                "value": "Ménaka",
                "label": "Ménaka",
                "shortCode": "10"
            }
        ]
    },
    {
        "countryCode": "+356",
        "value": "Malta",
        "label": "Malta",
        "regions": [
            {
                "value": "Attard",
                "label": "Attard",
                "shortCode": "01"
            },
            {
                "value": "Balzan",
                "label": "Balzan",
                "shortCode": "02"
            },
            {
                "value": "Birgu",
                "label": "Birgu",
                "shortCode": "03"
            },
            {
                "value": "Birkirkara",
                "label": "Birkirkara",
                "shortCode": "04"
            },
            {
                "value": "Birżebbuġa",
                "label": "Birżebbuġa",
                "shortCode": "05"
            },
            {
                "value": "Bormla",
                "label": "Bormla",
                "shortCode": "06"
            },
            {
                "value": "Dingli",
                "label": "Dingli",
                "shortCode": "07"
            },
            {
                "value": "Fgura",
                "label": "Fgura",
                "shortCode": "08"
            },
            {
                "value": "Floriana",
                "label": "Floriana",
                "shortCode": "09"
            },
            {
                "value": "Fontana",
                "label": "Fontana",
                "shortCode": "10"
            },
            {
                "value": "Guda",
                "label": "Guda",
                "shortCode": "11"
            },
            {
                "value": "Gżira",
                "label": "Gżira",
                "shortCode": "12"
            },
            {
                "value": "Għajnsielem",
                "label": "Għajnsielem",
                "shortCode": "13"
            },
            {
                "value": "Għarb",
                "label": "Għarb",
                "shortCode": "14"
            },
            {
                "value": "Għargħur",
                "label": "Għargħur",
                "shortCode": "15"
            },
            {
                "value": "Għasri",
                "label": "Għasri",
                "shortCode": "16"
            },
            {
                "value": "Għaxaq",
                "label": "Għaxaq",
                "shortCode": "17"
            },
            {
                "value": "Ħamrun",
                "label": "Ħamrun",
                "shortCode": "18"
            },
            {
                "value": "Iklin",
                "label": "Iklin",
                "shortCode": "19"
            },
            {
                "value": "Isla",
                "label": "Isla",
                "shortCode": "20"
            },
            {
                "value": "Kalkara",
                "label": "Kalkara",
                "shortCode": "21"
            },
            {
                "value": "Kerċem",
                "label": "Kerċem",
                "shortCode": "22"
            },
            {
                "value": "Kirkop",
                "label": "Kirkop",
                "shortCode": "23"
            },
            {
                "value": "Lija",
                "label": "Lija",
                "shortCode": "24"
            },
            {
                "value": "Luqa",
                "label": "Luqa",
                "shortCode": "25"
            },
            {
                "value": "Marsa",
                "label": "Marsa",
                "shortCode": "26"
            },
            {
                "value": "Marsaskala",
                "label": "Marsaskala",
                "shortCode": "27"
            },
            {
                "value": "Marsaxlokk",
                "label": "Marsaxlokk",
                "shortCode": "28"
            },
            {
                "value": "Mdina",
                "label": "Mdina",
                "shortCode": "29"
            },
            {
                "value": "Mellieħa",
                "label": "Mellieħa",
                "shortCode": "30"
            },
            {
                "value": "Mġarr",
                "label": "Mġarr",
                "shortCode": "31"
            },
            {
                "value": "Mosta",
                "label": "Mosta",
                "shortCode": "32"
            },
            {
                "value": "Mqabba",
                "label": "Mqabba",
                "shortCode": "33"
            },
            {
                "value": "Msida",
                "label": "Msida",
                "shortCode": "34"
            },
            {
                "value": "Mtarfa",
                "label": "Mtarfa",
                "shortCode": "35"
            },
            {
                "value": "Munxar",
                "label": "Munxar",
                "shortCode": "36"
            },
            {
                "value": "Nadur",
                "label": "Nadur",
                "shortCode": "37"
            },
            {
                "value": "Naxxar",
                "label": "Naxxar",
                "shortCode": "38"
            },
            {
                "value": "Paola",
                "label": "Paola",
                "shortCode": "39"
            },
            {
                "value": "Pembroke",
                "label": "Pembroke",
                "shortCode": "40"
            },
            {
                "value": "Pietà",
                "label": "Pietà",
                "shortCode": "41"
            },
            {
                "value": "Qala",
                "label": "Qala",
                "shortCode": "42"
            },
            {
                "value": "Qormi",
                "label": "Qormi",
                "shortCode": "43"
            },
            {
                "value": "Qrendi",
                "label": "Qrendi",
                "shortCode": "44"
            },
            {
                "value": "Rabat Għawdex",
                "label": "Rabat Għawdex",
                "shortCode": "45"
            },
            {
                "value": "Rabat Malta",
                "label": "Rabat Malta",
                "shortCode": "46"
            },
            {
                "value": "Safi",
                "label": "Safi",
                "shortCode": "47"
            },
            {
                "value": "San Ġiljan",
                "label": "San Ġiljan",
                "shortCode": "48"
            },
            {
                "value": "San Ġwann",
                "label": "San Ġwann",
                "shortCode": "49"
            },
            {
                "value": "San Lawrenz",
                "label": "San Lawrenz",
                "shortCode": "50"
            },
            {
                "value": "San Pawl il-Baħar",
                "label": "San Pawl il-Baħar",
                "shortCode": "51"
            },
            {
                "value": "Sannat",
                "label": "Sannat",
                "shortCode": "52"
            },
            {
                "value": "Santa Luċija",
                "label": "Santa Luċija",
                "shortCode": "53"
            },
            {
                "value": "Santa Venera",
                "label": "Santa Venera",
                "shortCode": "54"
            },
            {
                "value": "Siġġiewi",
                "label": "Siġġiewi",
                "shortCode": "55"
            },
            {
                "value": "Sliema",
                "label": "Sliema",
                "shortCode": "56"
            },
            {
                "value": "Swieqi",
                "label": "Swieqi",
                "shortCode": "57"
            },
            {
                "value": "Tai Xbiex",
                "label": "Tai Xbiex",
                "shortCode": "58"
            },
            {
                "value": "Tarzien",
                "label": "Tarzien",
                "shortCode": "59"
            },
            {
                "value": "Valletta",
                "label": "Valletta",
                "shortCode": "60"
            },
            {
                "value": "Xagħra",
                "label": "Xagħra",
                "shortCode": "61"
            },
            {
                "value": "Xewkija",
                "label": "Xewkija",
                "shortCode": "62"
            },
            {
                "value": "Xgħajra",
                "label": "Xgħajra",
                "shortCode": "63"
            },
            {
                "value": "Żabbar",
                "label": "Żabbar",
                "shortCode": "64"
            },
            {
                "value": "Żebbuġ Għawde",
                "label": "Żebbuġ Għawde",
                "shortCode": "65"
            },
            {
                "value": "Żebbuġ Malta",
                "label": "Żebbuġ Malta",
                "shortCode": "66"
            },
            {
                "value": "Żejtun",
                "label": "Żejtun",
                "shortCode": "67"
            },
            {
                "value": "Żurrieq",
                "label": "Żurrieq",
                "shortCode": "68"
            }
        ]
    },
    {
        "countryCode": "+692",
        "value": "Marshall Islands",
        "label": "Marshall Islands",
        "regions": [
            {
                "value": "Ailinglaplap",
                "label": "Ailinglaplap",
                "shortCode": "ALL"
            },
            {
                "value": "Ailuk",
                "label": "Ailuk",
                "shortCode": "ALK"
            },
            {
                "value": "Arno",
                "label": "Arno",
                "shortCode": "ARN"
            },
            {
                "value": "Aur",
                "label": "Aur",
                "shortCode": "AUR"
            },
            {
                "value": "Bikini and Kili",
                "label": "Bikini and Kili",
                "shortCode": "KIL"
            },
            {
                "value": "Ebon",
                "label": "Ebon",
                "shortCode": "EBO"
            },
            {
                "value": "Jabat",
                "label": "Jabat",
                "shortCode": "JAB"
            },
            {
                "value": "Jaluit",
                "label": "Jaluit",
                "shortCode": "JAL"
            },
            {
                "value": "Kwajalein",
                "label": "Kwajalein",
                "shortCode": "KWA"
            },
            {
                "value": "Lae",
                "label": "Lae",
                "shortCode": "LAE"
            },
            {
                "value": "Lib",
                "label": "Lib",
                "shortCode": "LIB"
            },
            {
                "value": "Likiep",
                "label": "Likiep",
                "shortCode": "LIK"
            },
            {
                "value": "Majuro",
                "label": "Majuro",
                "shortCode": "MAJ"
            },
            {
                "value": "Maloelap",
                "label": "Maloelap",
                "shortCode": "MAL"
            },
            {
                "value": "Mejit",
                "label": "Mejit",
                "shortCode": "MEJ"
            },
            {
                "value": "Namdrik",
                "label": "Namdrik",
                "shortCode": "NMK"
            },
            {
                "value": "Namu",
                "label": "Namu",
                "shortCode": "NMU"
            },
            {
                "value": "Rongelap",
                "label": "Rongelap",
                "shortCode": "RON"
            },
            {
                "value": "Ujae",
                "label": "Ujae",
                "shortCode": "UJA"
            },
            {
                "value": "Utrik",
                "label": "Utrik",
                "shortCode": "UTI"
            },
            {
                "value": "Wotho",
                "label": "Wotho",
                "shortCode": "WTH"
            },
            {
                "value": "Wotje",
                "label": "Wotje",
                "shortCode": "WTJ"
            }
        ]
    },
    {
        "countryCode": "+596",
        "value": "Martinique",
        "label": "Martinique",
        "regions": [
            {
                "value": "Martinique",
                "label": "Martinique"
            }
        ]
    },
    {
        "countryCode": "+222",
        "value": "Mauritania",
        "label": "Mauritania",
        "regions": [
            {
                "value": "Adrar",
                "label": "Adrar",
                "shortCode": "07"
            },
            {
                "value": "Assaba",
                "label": "Assaba",
                "shortCode": "03"
            },
            {
                "value": "Brakna",
                "label": "Brakna",
                "shortCode": "05"
            },
            {
                "value": "Dakhlet Nouadhibou",
                "label": "Dakhlet Nouadhibou",
                "shortCode": "08"
            },
            {
                "value": "Gorgol",
                "label": "Gorgol",
                "shortCode": "04"
            },
            {
                "value": "Guidimaka",
                "label": "Guidimaka",
                "shortCode": "10"
            },
            {
                "value": "Hodh Ech Chargui",
                "label": "Hodh Ech Chargui",
                "shortCode": "01"
            },
            {
                "value": "Hodh El Gharbi",
                "label": "Hodh El Gharbi",
                "shortCode": "02"
            },
            {
                "value": "Inchiri",
                "label": "Inchiri",
                "shortCode": "12"
            },
            {
                "value": "Nouakchott Nord",
                "label": "Nouakchott Nord",
                "shortCode": "14"
            },
            {
                "value": "Nouakchott Ouest",
                "label": "Nouakchott Ouest",
                "shortCode": "13"
            },
            {
                "value": "Nouakchott Sud",
                "label": "Nouakchott Sud",
                "shortCode": "15"
            },
            {
                "value": "Tagant",
                "label": "Tagant",
                "shortCode": "09"
            },
            {
                "value": "Tiris Zemmour",
                "label": "Tiris Zemmour",
                "shortCode": "11"
            },
            {
                "value": "Trarza",
                "label": "Trarza",
                "shortCode": "06"
            }
        ]
    },
    {
        "countryCode": "+230",
        "value": "Mauritius",
        "label": "Mauritius",
        "regions": [
            {
                "value": "Agalega Islands",
                "label": "Agalega Islands",
                "shortCode": "AG"
            },
            {
                "value": "Beau Bassin-Rose Hill",
                "label": "Beau Bassin-Rose Hill",
                "shortCode": "BR"
            },
            {
                "value": "Black River",
                "label": "Black River",
                "shortCode": "BL"
            },
            {
                "value": "Cargados Carajos Shoals",
                "label": "Cargados Carajos Shoals",
                "shortCode": "CC"
            },
            {
                "value": "Curepipe",
                "label": "Curepipe",
                "shortCode": "CU"
            },
            {
                "value": "Flacq",
                "label": "Flacq",
                "shortCode": "FL"
            },
            {
                "value": "Grand Port",
                "label": "Grand Port",
                "shortCode": "GP"
            },
            {
                "value": "Moka",
                "label": "Moka",
                "shortCode": "MO"
            },
            {
                "value": "Pamplemousses",
                "label": "Pamplemousses",
                "shortCode": "PA"
            },
            {
                "value": "Plaines Wilhems",
                "label": "Plaines Wilhems",
                "shortCode": "PW"
            },
            {
                "value": "Port Louis (City)",
                "label": "Port Louis (City)",
                "shortCode": "PU"
            },
            {
                "value": "Port Louis",
                "label": "Port Louis",
                "shortCode": "PL"
            },
            {
                "value": "Riviere du Rempart",
                "label": "Riviere du Rempart",
                "shortCode": "RR"
            },
            {
                "value": "Rodrigues Island",
                "label": "Rodrigues Island",
                "shortCode": "RO"
            },
            {
                "value": "Savanne",
                "label": "Savanne",
                "shortCode": "SA"
            },
            {
                "value": "Vacoas-Phoenix",
                "label": "Vacoas-Phoenix",
                "shortCode": "CP"
            }
        ]
    },
    {
        "countryCode": "+262 269, 262 639",
        "value": "Mayotte",
        "label": "Mayotte",
        "regions": [
            {
                "value": "Dzaoudzi",
                "label": "Dzaoudzi",
                "shortCode": "01"
            },
            {
                "value": "Pamandzi",
                "label": "Pamandzi",
                "shortCode": "02"
            },
            {
                "value": "Mamoudzou",
                "label": "Mamoudzou",
                "shortCode": "03"
            },
            {
                "value": "Dembeni",
                "label": "Dembeni",
                "shortCode": "04"
            },
            {
                "value": "Bandrélé",
                "label": "Bandrélé",
                "shortCode": "05"
            },
            {
                "value": "Kani-Kéli",
                "label": "Kani-Kéli",
                "shortCode": "06"
            },
            {
                "value": "Bouéni",
                "label": "Bouéni",
                "shortCode": "07"
            },
            {
                "value": "Chirongui",
                "label": "Chirongui",
                "shortCode": "08"
            },
            {
                "value": "Sada",
                "label": "Sada",
                "shortCode": "09"
            },
            {
                "value": "Ouangani",
                "label": "Ouangani",
                "shortCode": "10"
            },
            {
                "value": "Chiconi",
                "label": "Chiconi",
                "shortCode": "11"
            },
            {
                "value": "Tsingoni",
                "label": "Tsingoni",
                "shortCode": "12"
            },
            {
                "value": "M'Tsangamouji",
                "label": "M'Tsangamouji",
                "shortCode": "13"
            },
            {
                "value": "Acoua",
                "label": "Acoua",
                "shortCode": "14"
            },
            {
                "value": "Mtsamboro",
                "label": "Mtsamboro",
                "shortCode": "15"
            },
            {
                "value": "Bandraboua",
                "label": "Bandraboua",
                "shortCode": "16"
            },
            {
                "value": "Koungou",
                "label": "Koungou",
                "shortCode": "17"
            }
        ]
    },
    {
        "countryCode": "+52",
        "value": "Mexico",
        "label": "Mexico",
        "regions": [
            {
                "value": "Aguascalientes",
                "label": "Aguascalientes",
                "shortCode": "AGU"
            },
            {
                "value": "Baja California",
                "label": "Baja California",
                "shortCode": "BCN"
            },
            {
                "value": "Baja California Sur",
                "label": "Baja California Sur",
                "shortCode": "BCS"
            },
            {
                "value": "Campeche",
                "label": "Campeche",
                "shortCode": "CAM"
            },
            {
                "value": "Ciudad de México",
                "label": "Ciudad de México",
                "shortCode": "CMX"
            },
            {
                "value": "Chiapas",
                "label": "Chiapas",
                "shortCode": "CHP"
            },
            {
                "value": "Chihuahua",
                "label": "Chihuahua",
                "shortCode": "CHH"
            },
            {
                "value": "Coahuila de Zaragoza",
                "label": "Coahuila de Zaragoza",
                "shortCode": "COA"
            },
            {
                "value": "Colima",
                "label": "Colima",
                "shortCode": "COL"
            },
            {
                "value": "Durango",
                "label": "Durango",
                "shortCode": "DUR"
            },
            {
                "value": "Estado de México",
                "label": "Estado de México",
                "shortCode": "MEX"
            },
            {
                "value": "Guanajuato",
                "label": "Guanajuato",
                "shortCode": "GUA"
            },
            {
                "value": "Guerrero",
                "label": "Guerrero",
                "shortCode": "GRO"
            },
            {
                "value": "Hidalgo",
                "label": "Hidalgo",
                "shortCode": "HID"
            },
            {
                "value": "Jalisco",
                "label": "Jalisco",
                "shortCode": "JAL"
            },
            {
                "value": "Michoacán de Ocampo",
                "label": "Michoacán de Ocampo",
                "shortCode": "MIC"
            },
            {
                "value": "Morelos",
                "label": "Morelos",
                "shortCode": "MOR"
            },
            {
                "value": "Nayarit",
                "label": "Nayarit",
                "shortCode": "NAY"
            },
            {
                "value": "Nuevo León",
                "label": "Nuevo León",
                "shortCode": "NLE"
            },
            {
                "value": "Oaxaca",
                "label": "Oaxaca",
                "shortCode": "OAX"
            },
            {
                "value": "Puebla",
                "label": "Puebla",
                "shortCode": "PUE"
            },
            {
                "value": "Querétaro de Arteaga",
                "label": "Querétaro de Arteaga",
                "shortCode": "QUE"
            },
            {
                "value": "Quintana Roo",
                "label": "Quintana Roo",
                "shortCode": "ROO"
            },
            {
                "value": "San Luis Potosí",
                "label": "San Luis Potosí",
                "shortCode": "SLP"
            },
            {
                "value": "Sinaloa",
                "label": "Sinaloa",
                "shortCode": "SIN"
            },
            {
                "value": "Sonora",
                "label": "Sonora",
                "shortCode": "SON"
            },
            {
                "value": "Tabasco",
                "label": "Tabasco",
                "shortCode": "TAB"
            },
            {
                "value": "Tamaulipas",
                "label": "Tamaulipas",
                "shortCode": "TAM"
            },
            {
                "value": "Tlaxcala",
                "label": "Tlaxcala",
                "shortCode": "TLA"
            },
            {
                "value": "Veracruz",
                "label": "Veracruz",
                "shortCode": "VER"
            },
            {
                "value": "Yucatán",
                "label": "Yucatán",
                "shortCode": "YUC"
            },
            {
                "value": "Zacatecas",
                "label": "Zacatecas",
                "shortCode": "ZAC"
            }
        ]
    },
    {
        "countryCode": "+691",
        "value": "Micronesia, Federated States of",
        "label": "Micronesia, Federated States of",
        "regions": [
            {
                "value": "Chuuk (Truk)",
                "label": "Chuuk (Truk)",
                "shortCode": "TRK"
            },
            {
                "value": "Kosrae",
                "label": "Kosrae",
                "shortCode": "KSA"
            },
            {
                "value": "Pohnpei",
                "label": "Pohnpei",
                "shortCode": "PNI"
            },
            {
                "value": "Yap",
                "label": "Yap",
                "shortCode": "YAP"
            }
        ]
    },
    {
        "countryCode": "+373",
        "value": "Moldova",
        "label": "Moldova",
        "regions": [
            {
                "value": "Aenii Noi",
                "label": "Aenii Noi",
                "shortCode": "AN"
            },
            {
                "value": "Basarabeasca",
                "label": "Basarabeasca",
                "shortCode": "BS"
            },
            {
                "value": "Bălți",
                "label": "Bălți",
                "shortCode": "BA"
            },
            {
                "value": "Bender",
                "label": "Bender",
                "shortCode": "BD"
            },
            {
                "value": "Briceni",
                "label": "Briceni",
                "shortCode": "BR"
            },
            {
                "value": "Cahul",
                "label": "Cahul",
                "shortCode": "CA"
            },
            {
                "value": "Cantemir",
                "label": "Cantemir",
                "shortCode": "CT"
            },
            {
                "value": "Călărași",
                "label": "Călărași",
                "shortCode": "CL"
            },
            {
                "value": "Căușeni",
                "label": "Căușeni",
                "shortCode": "CS"
            },
            {
                "value": "Chișinău",
                "label": "Chișinău",
                "shortCode": "CU"
            },
            {
                "value": "Cimișlia",
                "label": "Cimișlia",
                "shortCode": "CM"
            },
            {
                "value": "Criuleni",
                "label": "Criuleni",
                "shortCode": "CR"
            },
            {
                "value": "Dondușeni",
                "label": "Dondușeni",
                "shortCode": "DO"
            },
            {
                "value": "Drochia",
                "label": "Drochia",
                "shortCode": "DR"
            },
            {
                "value": "Dubăsari",
                "label": "Dubăsari",
                "shortCode": "DU"
            },
            {
                "value": "Edineț",
                "label": "Edineț",
                "shortCode": "ED"
            },
            {
                "value": "Fălești",
                "label": "Fălești",
                "shortCode": "FA"
            },
            {
                "value": "Florești",
                "label": "Florești",
                "shortCode": "FL"
            },
            {
                "value": "Găgăuzia",
                "label": "Găgăuzia",
                "shortCode": "GA"
            },
            {
                "value": "Glodeni",
                "label": "Glodeni",
                "shortCode": "GL"
            },
            {
                "value": "Hîncești",
                "label": "Hîncești",
                "shortCode": "HI"
            },
            {
                "value": "Ialoveni",
                "label": "Ialoveni",
                "shortCode": "IA"
            },
            {
                "value": "Leova",
                "label": "Leova",
                "shortCode": "LE"
            },
            {
                "value": "Nisporeni",
                "label": "Nisporeni",
                "shortCode": "NI"
            },
            {
                "value": "Ocnița",
                "label": "Ocnița",
                "shortCode": "OC"
            },
            {
                "value": "Orhei",
                "label": "Orhei",
                "shortCode": "OR"
            },
            {
                "value": "Rezina",
                "label": "Rezina",
                "shortCode": "RE"
            },
            {
                "value": "Rîșcani",
                "label": "Rîșcani",
                "shortCode": "RI"
            },
            {
                "value": "Sîngerei",
                "label": "Sîngerei",
                "shortCode": "SI"
            },
            {
                "value": "Soroca",
                "label": "Soroca",
                "shortCode": "SO"
            },
            {
                "value": "Stânga Nistrului",
                "label": "Stânga Nistrului",
                "shortCode": "SN"
            },
            {
                "value": "Strășeni",
                "label": "Strășeni",
                "shortCode": "ST"
            },
            {
                "value": "Șoldănești",
                "label": "Șoldănești",
                "shortCode": "SD"
            },
            {
                "value": "Ștefan Vodă",
                "label": "Ștefan Vodă",
                "shortCode": "SV"
            },
            {
                "value": "Taraclia",
                "label": "Taraclia",
                "shortCode": "TA"
            },
            {
                "value": "Telenești",
                "label": "Telenești",
                "shortCode": "TE"
            },
            {
                "value": "Ungheni",
                "label": "Ungheni",
                "shortCode": "UN"
            }
        ]
    },
    {
        "countryCode": "+377",
        "value": "Monaco",
        "label": "Monaco",
        "regions": [
            {
                "value": "Colle",
                "label": "Colle",
                "shortCode": "CL"
            },
            {
                "value": "Condamine",
                "label": "Condamine",
                "shortCode": "CO"
            },
            {
                "value": "Fontvieille",
                "label": "Fontvieille",
                "shortCode": "FO"
            },
            {
                "value": "Gare",
                "label": "Gare",
                "shortCode": "GA"
            },
            {
                "value": "Jardin Exotique",
                "label": "Jardin Exotique",
                "shortCode": "JE"
            },
            {
                "value": "Larvotto",
                "label": "Larvotto",
                "shortCode": "LA"
            },
            {
                "value": "Malbousquet",
                "label": "Malbousquet",
                "shortCode": "MA"
            },
            {
                "value": "Monaco-Ville",
                "label": "Monaco-Ville",
                "shortCode": "MO"
            },
            {
                "value": "Moneghetti",
                "label": "Moneghetti",
                "shortCode": "MG"
            },
            {
                "value": "Monte-Carlo",
                "label": "Monte-Carlo",
                "shortCode": "MC"
            },
            {
                "value": "Moulins",
                "label": "Moulins",
                "shortCode": "MU"
            },
            {
                "value": "Port-Hercule",
                "label": "Port-Hercule",
                "shortCode": "PH"
            },
            {
                "value": "Saint-Roman",
                "label": "Saint-Roman",
                "shortCode": "SR"
            },
            {
                "value": "Sainte-Dévote",
                "label": "Sainte-Dévote",
                "shortCode": "SD"
            },
            {
                "value": "Source",
                "label": "Source",
                "shortCode": "SO"
            },
            {
                "value": "Spélugues",
                "label": "Spélugues",
                "shortCode": "SP"
            },
            {
                "value": "Vallon de la Rousse",
                "label": "Vallon de la Rousse",
                "shortCode": "VR"
            }
        ]
    },
    {
        "countryCode": "+976",
        "value": "Mongolia",
        "label": "Mongolia",
        "regions": [
            {
                "value": "Arhangay",
                "label": "Arhangay",
                "shortCode": "073"
            },
            {
                "value": "Bayan-Olgiy",
                "label": "Bayan-Olgiy",
                "shortCode": "071"
            },
            {
                "value": "Bayanhongor",
                "label": "Bayanhongor",
                "shortCode": "069"
            },
            {
                "value": "Bulgan",
                "label": "Bulgan",
                "shortCode": "067"
            },
            {
                "value": "Darhan",
                "label": "Darhan",
                "shortCode": "037"
            },
            {
                "value": "Dornod",
                "label": "Dornod",
                "shortCode": "061"
            },
            {
                "value": "Dornogovi",
                "label": "Dornogovi",
                "shortCode": "063"
            },
            {
                "value": "Dundgovi",
                "label": "Dundgovi",
                "shortCode": "059"
            },
            {
                "value": "Dzavhan",
                "label": "Dzavhan",
                "shortCode": "057"
            },
            {
                "value": "Govi-Altay",
                "label": "Govi-Altay",
                "shortCode": "065"
            },
            {
                "value": "Govi-Sumber",
                "label": "Govi-Sumber",
                "shortCode": "064"
            },
            {
                "value": "Hovd",
                "label": "Hovd",
                "shortCode": "043"
            },
            {
                "value": "Hovsgol",
                "label": "Hovsgol",
                "shortCode": "041"
            },
            {
                "value": "Omnogovi",
                "label": "Omnogovi",
                "shortCode": "053"
            },
            {
                "value": "Ovorhangay",
                "label": "Ovorhangay",
                "shortCode": "055"
            },
            {
                "value": "Selenge",
                "label": "Selenge",
                "shortCode": "049"
            },
            {
                "value": "Suhbaatar",
                "label": "Suhbaatar",
                "shortCode": "051"
            },
            {
                "value": "Tov",
                "label": "Tov",
                "shortCode": "047"
            },
            {
                "value": "Ulaanbaatar",
                "label": "Ulaanbaatar",
                "shortCode": "1"
            },
            {
                "value": "Uvs",
                "label": "Uvs",
                "shortCode": "046"
            },
            {
                "value": "Erdenet",
                "label": "Erdenet",
                "shortCode": "074"
            }
        ]
    },
    {
        "countryCode": "+382",
        "value": "Montenegro",
        "label": "Montenegro",
        "regions": [
            {
                "value": "Andrijevica",
                "label": "Andrijevica",
                "shortCode": "01"
            },
            {
                "value": "Bar",
                "label": "Bar",
                "shortCode": "02"
            },
            {
                "value": "Berane",
                "label": "Berane",
                "shortCode": "03"
            },
            {
                "value": "Bijelo Polje",
                "label": "Bijelo Polje",
                "shortCode": "04"
            },
            {
                "value": "Budva",
                "label": "Budva",
                "shortCode": "05"
            },
            {
                "value": "Cetinje",
                "label": "Cetinje",
                "shortCode": "06"
            },
            {
                "value": "Danilovgrad",
                "label": "Danilovgrad",
                "shortCode": "07"
            },
            {
                "value": "Gusinje",
                "label": "Gusinje",
                "shortCode": "22"
            },
            {
                "value": "Herceg Novi",
                "label": "Herceg Novi",
                "shortCode": "08"
            },
            {
                "value": "Kolašin",
                "label": "Kolašin",
                "shortCode": "09"
            },
            {
                "value": "Kotor",
                "label": "Kotor",
                "shortCode": "10"
            },
            {
                "value": "Mojkovac",
                "label": "Mojkovac",
                "shortCode": "11"
            },
            {
                "value": "Nikšić",
                "label": "Nikšić",
                "shortCode": "12"
            },
            {
                "value": "Petnica",
                "label": "Petnica",
                "shortCode": "23"
            },
            {
                "value": "Plav",
                "label": "Plav",
                "shortCode": "13"
            },
            {
                "value": "Plužine",
                "label": "Plužine",
                "shortCode": "14"
            },
            {
                "value": "Pljevlja",
                "label": "Pljevlja",
                "shortCode": "15"
            },
            {
                "value": "Podgorica",
                "label": "Podgorica",
                "shortCode": "16"
            },
            {
                "value": "Rožaje",
                "label": "Rožaje",
                "shortCode": "17"
            },
            {
                "value": "Šavnik",
                "label": "Šavnik",
                "shortCode": "18"
            },
            {
                "value": "Tivat",
                "label": "Tivat",
                "shortCode": "19"
            },
            {
                "value": "Ulcinj",
                "label": "Ulcinj",
                "shortCode": "20"
            },
            {
                "value": "Žabljak",
                "label": "Žabljak",
                "shortCode": "21"
            }
        ]
    },
    {
        "countryCode": "+1 664",
        "value": "Montserrat",
        "label": "Montserrat",
        "regions": [
            {
                "value": "Saint Anthony",
                "label": "Saint Anthony"
            },
            {
                "value": "Saint Georges",
                "label": "Saint Georges"
            },
            {
                "value": "Saint Peter's",
                "label": "Saint Peter's"
            }
        ]
    },
    {
        "countryCode": "+212",
        "value": "Morocco",
        "label": "Morocco",
        "regions": [
            {
                "value": "Tanger-Tétouan-Al Hoceïma",
                "label": "Tanger-Tétouan-Al Hoceïma",
                "shortCode": "MA-01"
            },
            {
                "value": "L'Oriental",
                "label": "L'Oriental",
                "shortCode": "MA-02"
            },
            {
                "value": "Fès-Meknès",
                "label": "Fès-Meknès",
                "shortCode": "MA-03"
            },
            {
                "value": "Rabat-Salé-Kénitra",
                "label": "Rabat-Salé-Kénitra",
                "shortCode": "MA-04"
            },
            {
                "value": "Béni Mellal-Khénifra",
                "label": "Béni Mellal-Khénifra",
                "shortCode": "MA-05"
            },
            {
                "value": "Casablanca-Settat",
                "label": "Casablanca-Settat",
                "shortCode": "MA-06"
            },
            {
                "value": "Marrakech-Safi",
                "label": "Marrakech-Safi",
                "shortCode": "MA-07"
            },
            {
                "value": "Drâa-Tafilalet",
                "label": "Drâa-Tafilalet",
                "shortCode": "MA-08"
            },
            {
                "value": "Souss-Massa",
                "label": "Souss-Massa",
                "shortCode": "MA-09"
            },
            {
                "value": "Guelmim-Oued Noun",
                "label": "Guelmim-Oued Noun",
                "shortCode": "MA-10"
            },
            {
                "value": "Laâyoune-Sakia El Hamra",
                "label": "Laâyoune-Sakia El Hamra",
                "shortCode": "MA-11"
            },
            {
                "value": "Dakhla-Oued Ed-Dahab",
                "label": "Dakhla-Oued Ed-Dahab",
                "shortCode": "MA-12"
            }
        ]
    },
    {
        "countryCode": "+258",
        "value": "Mozambique",
        "label": "Mozambique",
        "regions": [
            {
                "value": "Cabo Delgado",
                "label": "Cabo Delgado",
                "shortCode": "P"
            },
            {
                "value": "Gaza",
                "label": "Gaza",
                "shortCode": "G"
            },
            {
                "value": "Inhambane",
                "label": "Inhambane",
                "shortCode": "I"
            },
            {
                "value": "Manica",
                "label": "Manica",
                "shortCode": "B"
            },
            {
                "value": "Maputo",
                "label": "Maputo",
                "shortCode": "L"
            },
            {
                "value": "Maputo (City)",
                "label": "Maputo (City)",
                "shortCode": "MPM"
            },
            {
                "value": "Nampula",
                "label": "Nampula",
                "shortCode": "N"
            },
            {
                "value": "Niassa",
                "label": "Niassa",
                "shortCode": "A"
            },
            {
                "value": "Sofala",
                "label": "Sofala",
                "shortCode": "S"
            },
            {
                "value": "Tete",
                "label": "Tete",
                "shortCode": "T"
            },
            {
                "value": "Zambezia",
                "label": "Zambezia",
                "shortCode": "Q"
            }
        ]
    },
    {
        "countryCode": "+95",
        "value": "Myanmar",
        "label": "Myanmar",
        "regions": [
            {
                "value": "Ayeyarwady",
                "label": "Ayeyarwady",
                "shortCode": "07"
            },
            {
                "value": "Bago",
                "label": "Bago",
                "shortCode": "02"
            },
            {
                "value": "Chin",
                "label": "Chin",
                "shortCode": "14"
            },
            {
                "value": "Kachin",
                "label": "Kachin",
                "shortCode": "11"
            },
            {
                "value": "Kayah",
                "label": "Kayah",
                "shortCode": "12"
            },
            {
                "value": "Kayin",
                "label": "Kayin",
                "shortCode": "13"
            },
            {
                "value": "Magway",
                "label": "Magway",
                "shortCode": "03"
            },
            {
                "value": "Mandalay",
                "label": "Mandalay",
                "shortCode": "04"
            },
            {
                "value": "Mon",
                "label": "Mon",
                "shortCode": "15"
            },
            {
                "value": "Nay Pyi Taw",
                "label": "Nay Pyi Taw",
                "shortCode": "18"
            },
            {
                "value": "Rakhine",
                "label": "Rakhine",
                "shortCode": "16"
            },
            {
                "value": "Sagaing",
                "label": "Sagaing",
                "shortCode": "01"
            },
            {
                "value": "Shan",
                "label": "Shan",
                "shortCode": "17"
            },
            {
                "value": "Tanintharyi",
                "label": "Tanintharyi",
                "shortCode": "05"
            },
            {
                "value": "Yangon",
                "label": "Yangon",
                "shortCode": "06"
            }
        ]
    },
    {
        "countryCode": "+264",
        "value": "Namibia",
        "label": "Namibia",
        "regions": [
            {
                "value": "Erongo",
                "label": "Erongo",
                "shortCode": "ER"
            },
            {
                "value": "Hardap",
                "label": "Hardap",
                "shortCode": "HA"
            },
            {
                "value": "Kavango East",
                "label": "Kavango East",
                "shortCode": "KE"
            },
            {
                "value": "Kavango West",
                "label": "Kavango West",
                "shortCode": "KW"
            },
            {
                "value": "Karas",
                "label": "Karas",
                "shortCode": "KA"
            },
            {
                "value": "Khomas",
                "label": "Khomas",
                "shortCode": "KH"
            },
            {
                "value": "Kunene",
                "label": "Kunene",
                "shortCode": "KU"
            },
            {
                "value": "Ohangwena",
                "label": "Ohangwena",
                "shortCode": "OW"
            },
            {
                "value": "Omaheke",
                "label": "Omaheke",
                "shortCode": "OH"
            },
            {
                "value": "Omusati",
                "label": "Omusati",
                "shortCode": "OS"
            },
            {
                "value": "Oshana",
                "label": "Oshana",
                "shortCode": "ON"
            },
            {
                "value": "Oshikoto",
                "label": "Oshikoto",
                "shortCode": "OT"
            },
            {
                "value": "Otjozondjupa",
                "label": "Otjozondjupa",
                "shortCode": "OD"
            },
            {
                "value": "Zambezi",
                "label": "Zambezi",
                "shortCode": "CA"
            }
        ]
    },
    {
        "countryCode": "+674",
        "value": "Nauru",
        "label": "Nauru",
        "regions": [
            {
                "value": "Aiwo",
                "label": "Aiwo",
                "shortCode": "01"
            },
            {
                "value": "Anabar",
                "label": "Anabar",
                "shortCode": "02"
            },
            {
                "value": "Anetan",
                "label": "Anetan",
                "shortCode": "03"
            },
            {
                "value": "Anibare",
                "label": "Anibare",
                "shortCode": "04"
            },
            {
                "value": "Baiti",
                "label": "Baiti",
                "shortCode": "05"
            },
            {
                "value": "Boe",
                "label": "Boe",
                "shortCode": "06"
            },
            {
                "value": "Buada",
                "label": "Buada",
                "shortCode": "07"
            },
            {
                "value": "Denigomodu",
                "label": "Denigomodu",
                "shortCode": "08"
            },
            {
                "value": "Ewa",
                "label": "Ewa",
                "shortCode": "09"
            },
            {
                "value": "Ijuw",
                "label": "Ijuw",
                "shortCode": "10"
            },
            {
                "value": "Meneng",
                "label": "Meneng",
                "shortCode": "11"
            },
            {
                "value": "Nibok",
                "label": "Nibok",
                "shortCode": "12"
            },
            {
                "value": "Uaboe",
                "label": "Uaboe",
                "shortCode": "13"
            },
            {
                "value": "Yaren",
                "label": "Yaren",
                "shortCode": "14"
            }
        ]
    },
    {
        "countryCode": "+977",
        "value": "Nepal",
        "label": "Nepal",
        "regions": [
            {
                "value": "Province No. 1",
                "label": "Province No. 1",
                "shortCode": "1"
            },
            {
                "value": "Madhesh Province",
                "label": "Madhesh Province",
                "shortCode": "2"
            },
            {
                "value": "Bagmati Province",
                "label": "Bagmati Province",
                "shortCode": "3"
            },
            {
                "value": "Gandaki Province",
                "label": "Gandaki Province",
                "shortCode": "4"
            },
            {
                "value": "Lumbini Province",
                "label": "Lumbini Province",
                "shortCode": "5"
            },
            {
                "value": "Karnali Province",
                "label": "Karnali Province",
                "shortCode": "6"
            },
            {
                "value": "Sudurpashchim Province",
                "label": "Sudurpashchim Province",
                "shortCode": "7"
            }
        ]
    },
    {
        "countryCode": "+31",
        "value": "Netherlands",
        "label": "Netherlands",
        "regions": [
            {
                "value": "Drenthe",
                "label": "Drenthe",
                "shortCode": "DR"
            },
            {
                "value": "Flevoland",
                "label": "Flevoland",
                "shortCode": "FL"
            },
            {
                "value": "Friesland",
                "label": "Friesland",
                "shortCode": "FR"
            },
            {
                "value": "Gelderland",
                "label": "Gelderland",
                "shortCode": "GE"
            },
            {
                "value": "Groningen",
                "label": "Groningen",
                "shortCode": "GR"
            },
            {
                "value": "Limburg",
                "label": "Limburg",
                "shortCode": "LI"
            },
            {
                "value": "Noord-Brabant",
                "label": "Noord-Brabant",
                "shortCode": "NB"
            },
            {
                "value": "Noord-Holland",
                "label": "Noord-Holland",
                "shortCode": "NH"
            },
            {
                "value": "Overijssel",
                "label": "Overijssel",
                "shortCode": "OV"
            },
            {
                "value": "Utrecht",
                "label": "Utrecht",
                "shortCode": "UT"
            },
            {
                "value": "Zeeland",
                "label": "Zeeland",
                "shortCode": "ZE"
            },
            {
                "value": "Zuid-Holland",
                "label": "Zuid-Holland",
                "shortCode": "ZH"
            }
        ]
    },
    {
        "countryCode": "+687",
        "value": "New Caledonia",
        "label": "New Caledonia",
        "regions": [
            {
                "value": "Iles Loyaute",
                "label": "Iles Loyaute"
            },
            {
                "value": "Nord",
                "label": "Nord"
            },
            {
                "value": "Sud",
                "label": "Sud"
            }
        ]
    },
    {
        "countryCode": "+64",
        "value": "New Zealand",
        "label": "New Zealand",
        "regions": [
            {
                "value": "Auckland",
                "label": "Auckland",
                "shortCode": "AUK"
            },
            {
                "value": "Bay of Plenty",
                "label": "Bay of Plenty",
                "shortCode": "BOP"
            },
            {
                "value": "Canterbury",
                "label": "Canterbury",
                "shortCode": "CAN"
            },
            {
                "value": "Gisborne",
                "label": "Gisborne",
                "shortCode": "GIS"
            },
            {
                "value": "Hawke's Bay",
                "label": "Hawke's Bay",
                "shortCode": "HKB"
            },
            {
                "value": "Marlborough",
                "label": "Marlborough",
                "shortCode": "MBH"
            },
            {
                "value": "Manawatu-Wanganui",
                "label": "Manawatu-Wanganui",
                "shortCode": "MWT"
            },
            {
                "value": "Northland",
                "label": "Northland",
                "shortCode": "NTL"
            },
            {
                "value": "Nelson",
                "label": "Nelson",
                "shortCode": "NSN"
            },
            {
                "value": "Otago",
                "label": "Otago",
                "shortCode": "OTA"
            },
            {
                "value": "Southland",
                "label": "Southland",
                "shortCode": "STL"
            },
            {
                "value": "Taranaki",
                "label": "Taranaki",
                "shortCode": "TKI"
            },
            {
                "value": "Tasman",
                "label": "Tasman",
                "shortCode": "TAS"
            },
            {
                "value": "Waikato",
                "label": "Waikato",
                "shortCode": "WKO"
            },
            {
                "value": "Wellington",
                "label": "Wellington",
                "shortCode": "WGN"
            },
            {
                "value": "West Coast",
                "label": "West Coast",
                "shortCode": "WTC"
            },
            {
                "value": "Chatham Islands Territory",
                "label": "Chatham Islands Territory",
                "shortCode": "CIT"
            }
        ]
    },
    {
        "countryCode": "+505",
        "value": "Nicaragua",
        "label": "Nicaragua",
        "regions": [
            {
                "value": "Boaco",
                "label": "Boaco",
                "shortCode": "BO"
            },
            {
                "value": "Carazo",
                "label": "Carazo",
                "shortCode": "CA"
            },
            {
                "value": "Chinandega",
                "label": "Chinandega",
                "shortCode": "CI"
            },
            {
                "value": "Chontales",
                "label": "Chontales",
                "shortCode": "CO"
            },
            {
                "value": "Estelí",
                "label": "Estelí",
                "shortCode": "ES"
            },
            {
                "value": "Granada",
                "label": "Granada",
                "shortCode": "GR"
            },
            {
                "value": "Jinotega",
                "label": "Jinotega",
                "shortCode": "JI"
            },
            {
                "value": "León",
                "label": "León",
                "shortCode": "LE"
            },
            {
                "value": "Madriz",
                "label": "Madriz",
                "shortCode": "MD"
            },
            {
                "value": "Managua",
                "label": "Managua",
                "shortCode": "MN"
            },
            {
                "value": "Masaya",
                "label": "Masaya",
                "shortCode": "MS"
            },
            {
                "value": "Matagalpa",
                "label": "Matagalpa",
                "shortCode": "MT"
            },
            {
                "value": "Nueva Segovia",
                "label": "Nueva Segovia",
                "shortCode": "NS"
            },
            {
                "value": "Río San Juan",
                "label": "Río San Juan",
                "shortCode": "SJ"
            },
            {
                "value": "Rivas",
                "label": "Rivas",
                "shortCode": "RI"
            },
            {
                "value": "Atlántico Norte",
                "label": "Atlántico Norte",
                "shortCode": "AN"
            },
            {
                "value": "Atlántico Sur",
                "label": "Atlántico Sur",
                "shortCode": "AS"
            }
        ]
    },
    {
        "countryCode": "+227",
        "value": "Niger",
        "label": "Niger",
        "regions": [
            {
                "value": "Agadez",
                "label": "Agadez",
                "shortCode": "1"
            },
            {
                "value": "Diffa",
                "label": "Diffa",
                "shortCode": "2"
            },
            {
                "value": "Dosso",
                "label": "Dosso",
                "shortCode": "3"
            },
            {
                "value": "Maradi",
                "label": "Maradi",
                "shortCode": "4"
            },
            {
                "value": "Niamey",
                "label": "Niamey",
                "shortCode": "8"
            },
            {
                "value": "Tahoua",
                "label": "Tahoua",
                "shortCode": "5"
            },
            {
                "value": "Tillabéri",
                "label": "Tillabéri",
                "shortCode": "6"
            },
            {
                "value": "Zinder",
                "label": "Zinder",
                "shortCode": "7"
            }
        ]
    },
    {
        "countryCode": "+234",
        "value": "Nigeria",
        "label": "Nigeria",
        "regions": [
            {
                "value": "Abia",
                "label": "Abia",
                "shortCode": "AB"
            },
            {
                "value": "Abuja Federal Capital Territory",
                "label": "Abuja Federal Capital Territory",
                "shortCode": "FC"
            },
            {
                "value": "Adamawa",
                "label": "Adamawa",
                "shortCode": "AD"
            },
            {
                "value": "Akwa Ibom",
                "label": "Akwa Ibom",
                "shortCode": "AK"
            },
            {
                "value": "Anambra",
                "label": "Anambra",
                "shortCode": "AN"
            },
            {
                "value": "Bauchi",
                "label": "Bauchi",
                "shortCode": "BA"
            },
            {
                "value": "Bayelsa",
                "label": "Bayelsa",
                "shortCode": "BY"
            },
            {
                "value": "Benue",
                "label": "Benue",
                "shortCode": "BE"
            },
            {
                "value": "Borno",
                "label": "Borno",
                "shortCode": "BO"
            },
            {
                "value": "Cross River",
                "label": "Cross River",
                "shortCode": "CR"
            },
            {
                "value": "Delta",
                "label": "Delta",
                "shortCode": "DE"
            },
            {
                "value": "Ebonyi",
                "label": "Ebonyi",
                "shortCode": "EB"
            },
            {
                "value": "Edo",
                "label": "Edo",
                "shortCode": "ED"
            },
            {
                "value": "Ekiti",
                "label": "Ekiti",
                "shortCode": "EK"
            },
            {
                "value": "Enugu",
                "label": "Enugu",
                "shortCode": "EN"
            },
            {
                "value": "Gombe",
                "label": "Gombe",
                "shortCode": "GO"
            },
            {
                "value": "Imo",
                "label": "Imo",
                "shortCode": "IM"
            },
            {
                "value": "Jigawa",
                "label": "Jigawa",
                "shortCode": "JI"
            },
            {
                "value": "Kaduna",
                "label": "Kaduna",
                "shortCode": "KD"
            },
            {
                "value": "Kano",
                "label": "Kano",
                "shortCode": "KN"
            },
            {
                "value": "Katsina",
                "label": "Katsina",
                "shortCode": "KT"
            },
            {
                "value": "Kebbi",
                "label": "Kebbi",
                "shortCode": "KE"
            },
            {
                "value": "Kogi",
                "label": "Kogi",
                "shortCode": "KO"
            },
            {
                "value": "Kwara",
                "label": "Kwara",
                "shortCode": "KW"
            },
            {
                "value": "Lagos",
                "label": "Lagos",
                "shortCode": "LA"
            },
            {
                "value": "Nassarawa",
                "label": "Nassarawa",
                "shortCode": "NA"
            },
            {
                "value": "Niger",
                "label": "Niger",
                "shortCode": "NI"
            },
            {
                "value": "Ogun",
                "label": "Ogun",
                "shortCode": "OG"
            },
            {
                "value": "Ondo",
                "label": "Ondo",
                "shortCode": "ON"
            },
            {
                "value": "Osun",
                "label": "Osun",
                "shortCode": "OS"
            },
            {
                "value": "Oyo",
                "label": "Oyo",
                "shortCode": "OY"
            },
            {
                "value": "Plateau",
                "label": "Plateau",
                "shortCode": "PL"
            },
            {
                "value": "Rivers",
                "label": "Rivers",
                "shortCode": "RI"
            },
            {
                "value": "Sokoto",
                "label": "Sokoto",
                "shortCode": "SO"
            },
            {
                "value": "Taraba",
                "label": "Taraba",
                "shortCode": "TA"
            },
            {
                "value": "Yobe",
                "label": "Yobe",
                "shortCode": "YO"
            },
            {
                "value": "Zamfara",
                "label": "Zamfara",
                "shortCode": "ZA"
            }
        ]
    },
    {
        "countryCode": "+683",
        "value": "Niue",
        "label": "Niue",
        "regions": [
            {
                "value": "Niue",
                "label": "Niue"
            }
        ]
    },
    {
        "countryCode": "+672 3",
        "value": "Norfolk Island",
        "label": "Norfolk Island",
        "regions": [
            {
                "value": "Norfolk Island",
                "label": "Norfolk Island"
            }
        ]
    },
    {
        "countryCode": "+1 670",
        "value": "Northern Mariana Islands",
        "label": "Northern Mariana Islands",
        "regions": [
            {
                "value": "Northern Islands",
                "label": "Northern Islands"
            },
            {
                "value": "Rota",
                "label": "Rota"
            },
            {
                "value": "Saipan",
                "label": "Saipan"
            },
            {
                "value": "Tinian",
                "label": "Tinian"
            }
        ]
    },
    {
        "countryCode": "+47",
        "value": "Norway",
        "label": "Norway",
        "regions": [
            {
                "value": "Akershus",
                "label": "Akershus",
                "shortCode": "02"
            },
            {
                "value": "Aust-Agder",
                "label": "Aust-Agder",
                "shortCode": "09"
            },
            {
                "value": "Buskerud",
                "label": "Buskerud",
                "shortCode": "06"
            },
            {
                "value": "Finnmark",
                "label": "Finnmark",
                "shortCode": "20"
            },
            {
                "value": "Hedmark",
                "label": "Hedmark",
                "shortCode": "04"
            },
            {
                "value": "Hordaland",
                "label": "Hordaland",
                "shortCode": "12"
            },
            {
                "value": "Møre og Romsdal",
                "label": "Møre og Romsdal",
                "shortCode": "15"
            },
            {
                "value": "Nordland",
                "label": "Nordland",
                "shortCode": "18"
            },
            {
                "value": "Nord-Trøndelag",
                "label": "Nord-Trøndelag",
                "shortCode": "17"
            },
            {
                "value": "Oppland",
                "label": "Oppland",
                "shortCode": "05"
            },
            {
                "value": "Oslo",
                "label": "Oslo",
                "shortCode": "03"
            },
            {
                "value": "Rogaland",
                "label": "Rogaland",
                "shortCode": "11"
            },
            {
                "value": "Sogn og Fjordane",
                "label": "Sogn og Fjordane",
                "shortCode": "14"
            },
            {
                "value": "Sør-Trøndelag",
                "label": "Sør-Trøndelag",
                "shortCode": "16"
            },
            {
                "value": "Telemark",
                "label": "Telemark",
                "shortCode": "08"
            },
            {
                "value": "Troms",
                "label": "Troms",
                "shortCode": "19"
            },
            {
                "value": "Vest-Agder",
                "label": "Vest-Agder",
                "shortCode": "10"
            },
            {
                "value": "Vestfold",
                "label": "Vestfold",
                "shortCode": "07"
            },
            {
                "value": "Østfold",
                "label": "Østfold",
                "shortCode": "01"
            },
            {
                "value": "Jan Mayen",
                "label": "Jan Mayen",
                "shortCode": "22"
            },
            {
                "value": "Svalbard",
                "label": "Svalbard",
                "shortCode": "21"
            }
        ]
    },
    {
        "countryCode": "+968",
        "value": "Oman",
        "label": "Oman",
        "regions": [
            {
                "value": "Ad Dakhiliyah",
                "label": "Ad Dakhiliyah",
                "shortCode": "DA"
            },
            {
                "value": "Al Buraymi",
                "label": "Al Buraymi",
                "shortCode": "BU"
            },
            {
                "value": "Al Wusta",
                "label": "Al Wusta",
                "shortCode": "WU"
            },
            {
                "value": "Az Zahirah",
                "label": "Az Zahirah",
                "shortCode": "ZA"
            },
            {
                "value": "Janub al Batinah",
                "label": "Janub al Batinah",
                "shortCode": "BS"
            },
            {
                "value": "Janub ash Sharqiyah",
                "label": "Janub ash Sharqiyah",
                "shortCode": "SS"
            },
            {
                "value": "Masqat",
                "label": "Masqat",
                "shortCode": "MA"
            },
            {
                "value": "Musandam",
                "label": "Musandam",
                "shortCode": "MU"
            },
            {
                "value": "Shamal al Batinah",
                "label": "Shamal al Batinah",
                "shortCode": "BJ"
            },
            {
                "value": "Shamal ash Sharqiyah",
                "label": "Shamal ash Sharqiyah",
                "shortCode": "SJ"
            },
            {
                "value": "Zufar",
                "label": "Zufar",
                "shortCode": "ZU"
            }
        ]
    },
    {
        "countryCode": "+92",
        "value": "Pakistan",
        "label": "Pakistan",
        "regions": [
            {
                "value": "Āzād Kashmīr",
                "label": "Āzād Kashmīr",
                "shortCode": "JK"
            },
            {
                "value": "Balōchistān",
                "label": "Balōchistān",
                "shortCode": "BA"
            },
            {
                "value": "Gilgit-Baltistān",
                "label": "Gilgit-Baltistān",
                "shortCode": "GB"
            },
            {
                "value": "Islāmābād",
                "label": "Islāmābād",
                "shortCode": "IS"
            },
            {
                "value": "Khaībar Pakhtūnkhwās",
                "label": "Khaībar Pakhtūnkhwās",
                "shortCode": "KP"
            },
            {
                "value": "Punjāb",
                "label": "Punjāb",
                "shortCode": "PB"
            },
            {
                "value": "Sindh",
                "label": "Sindh",
                "shortCode": "SD"
            },
            {
                "value": "Federally Administered Tribal Areas",
                "label": "Federally Administered Tribal Areas",
                "shortCode": "TA"
            }
        ]
    },
    {
        "countryCode": "+680",
        "value": "Palau",
        "label": "Palau",
        "regions": [
            {
                "value": "Aimeliik",
                "label": "Aimeliik",
                "shortCode": "002"
            },
            {
                "value": "Airai",
                "label": "Airai",
                "shortCode": "004"
            },
            {
                "value": "Angaur",
                "label": "Angaur",
                "shortCode": "010"
            },
            {
                "value": "Hatobohei",
                "label": "Hatobohei",
                "shortCode": "050"
            },
            {
                "value": "Kayangel",
                "label": "Kayangel",
                "shortCode": "100"
            },
            {
                "value": "Koror",
                "label": "Koror",
                "shortCode": "150"
            },
            {
                "value": "Melekeok",
                "label": "Melekeok",
                "shortCode": "212"
            },
            {
                "value": "Ngaraard",
                "label": "Ngaraard",
                "shortCode": "214"
            },
            {
                "value": "Ngarchelong",
                "label": "Ngarchelong",
                "shortCode": "218"
            },
            {
                "value": "Ngardmau",
                "label": "Ngardmau",
                "shortCode": "222"
            },
            {
                "value": "Ngatpang",
                "label": "Ngatpang",
                "shortCode": "224"
            },
            {
                "value": "Ngchesar",
                "label": "Ngchesar",
                "shortCode": "226"
            },
            {
                "value": "Ngeremlengui",
                "label": "Ngeremlengui",
                "shortCode": "227"
            },
            {
                "value": "Ngiwal",
                "label": "Ngiwal",
                "shortCode": "228"
            },
            {
                "value": "Peleliu",
                "label": "Peleliu",
                "shortCode": "350"
            },
            {
                "value": "Sonsoral",
                "label": "Sonsoral",
                "shortCode": "370"
            }
        ]
    },
    {
        "countryCode": "+970",
        "value": "Palestine, State of",
        "label": "Palestine, State of",
        "regions": [
            {
                "value": "Ak Khalīl",
                "label": "Ak Khalīl",
                "shortCode": "HBN"
            },
            {
                "value": "Al Quds",
                "label": "Al Quds",
                "shortCode": "JEM"
            },
            {
                "value": "Arīḩā wal Aghwār",
                "label": "Arīḩā wal Aghwār",
                "shortCode": "JRH"
            },
            {
                "value": "Bayt Laḩm",
                "label": "Bayt Laḩm",
                "shortCode": "BTH"
            },
            {
                "value": "Dayr al Balaḩ",
                "label": "Dayr al Balaḩ",
                "shortCode": "DEB"
            },
            {
                "value": "Ghazzah",
                "label": "Ghazzah",
                "shortCode": "GZA"
            },
            {
                "value": "Janīn",
                "label": "Janīn",
                "shortCode": "JEN"
            },
            {
                "value": "Khān Yūnis",
                "label": "Khān Yūnis",
                "shortCode": "KYS"
            },
            {
                "value": "Nāblus",
                "label": "Nāblus",
                "shortCode": "NBS"
            },
            {
                "value": "Qalqīyah",
                "label": "Qalqīyah",
                "shortCode": "QQA"
            },
            {
                "value": "Rafaḩ",
                "label": "Rafaḩ",
                "shortCode": "RFH"
            },
            {
                "value": "Rām Allāh wal Bīrah",
                "label": "Rām Allāh wal Bīrah",
                "shortCode": "RBH"
            },
            {
                "value": "Salfīt",
                "label": "Salfīt",
                "shortCode": "SLT"
            },
            {
                "value": "Shamāl Ghazzah",
                "label": "Shamāl Ghazzah",
                "shortCode": "NGZ"
            },
            {
                "value": "Ţūbās",
                "label": "Ţūbās",
                "shortCode": "TBS"
            },
            {
                "value": "Ţūlkarm",
                "label": "Ţūlkarm",
                "shortCode": "TKM"
            }
        ]
    },
    {
        "countryCode": "+507",
        "value": "Panama",
        "label": "Panama",
        "regions": [
            {
                "value": "Bocas del Toro",
                "label": "Bocas del Toro",
                "shortCode": "1"
            },
            {
                "value": "Chiriquí",
                "label": "Chiriquí",
                "shortCode": "4"
            },
            {
                "value": "Coclé",
                "label": "Coclé",
                "shortCode": "2"
            },
            {
                "value": "Colón",
                "label": "Colón",
                "shortCode": "3"
            },
            {
                "value": "Darién",
                "label": "Darién",
                "shortCode": "5"
            },
            {
                "value": "Emberá",
                "label": "Emberá",
                "shortCode": "EM"
            },
            {
                "value": "Herrera",
                "label": "Herrera",
                "shortCode": "6"
            },
            {
                "value": "Kuna Yala",
                "label": "Kuna Yala",
                "shortCode": "KY"
            },
            {
                "value": "Los Santos",
                "label": "Los Santos",
                "shortCode": "7"
            },
            {
                "value": "Ngäbe-Buglé",
                "label": "Ngäbe-Buglé",
                "shortCode": "NB"
            },
            {
                "value": "Panamá",
                "label": "Panamá",
                "shortCode": "8"
            },
            {
                "value": "Panamá Oeste",
                "label": "Panamá Oeste",
                "shortCode": "10"
            },
            {
                "value": "Veraguas",
                "label": "Veraguas",
                "shortCode": "9"
            }
        ]
    },
    {
        "countryCode": "+675",
        "value": "Papua New Guinea",
        "label": "Papua New Guinea",
        "regions": [
            {
                "value": "Bougainville",
                "label": "Bougainville",
                "shortCode": "NSB"
            },
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "CPM"
            },
            {
                "value": "Chimbu",
                "label": "Chimbu",
                "shortCode": "CPK"
            },
            {
                "value": "East New Britain",
                "label": "East New Britain",
                "shortCode": "EBR"
            },
            {
                "value": "East Sepik",
                "label": "East Sepik",
                "shortCode": "ESW"
            },
            {
                "value": "Eastern Highlands",
                "label": "Eastern Highlands",
                "shortCode": "EHG"
            },
            {
                "value": "Enga",
                "label": "Enga",
                "shortCode": "EPW"
            },
            {
                "value": "Gulf",
                "label": "Gulf",
                "shortCode": "GPK"
            },
            {
                "value": "Hela",
                "label": "Hela",
                "shortCode": "HLA"
            },
            {
                "value": "Jiwaka",
                "label": "Jiwaka",
                "shortCode": "JWK"
            },
            {
                "value": "Madang",
                "label": "Madang",
                "shortCode": "MOM"
            },
            {
                "value": "Manus",
                "label": "Manus",
                "shortCode": "MRL"
            },
            {
                "value": "Milne Bay",
                "label": "Milne Bay",
                "shortCode": "MBA"
            },
            {
                "value": "Morobe",
                "label": "Morobe",
                "shortCode": "MPL"
            },
            {
                "value": "Port Moresby",
                "label": "Port Moresby",
                "shortCode": "NCD"
            },
            {
                "value": "New Ireland",
                "label": "New Ireland",
                "shortCode": "NIK"
            },
            {
                "value": "Northern",
                "label": "Northern",
                "shortCode": "NPP"
            },
            {
                "value": "Southern Highlands",
                "label": "Southern Highlands",
                "shortCode": "SHM"
            },
            {
                "value": "West New Britain",
                "label": "West New Britain",
                "shortCode": "WBK"
            },
            {
                "value": "West Sepik",
                "label": "West Sepik",
                "shortCode": "SAN"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "WPD"
            },
            {
                "value": "Western Highlands",
                "label": "Western Highlands",
                "shortCode": "WHM"
            }
        ]
    },
    {
        "countryCode": "+595",
        "value": "Paraguay",
        "label": "Paraguay",
        "regions": [
            {
                "value": "Alto Paraguay",
                "label": "Alto Paraguay",
                "shortCode": "16"
            },
            {
                "value": "Alto Parana",
                "label": "Alto Parana",
                "shortCode": "10"
            },
            {
                "value": "Amambay",
                "label": "Amambay",
                "shortCode": "13"
            },
            {
                "value": "Asuncion",
                "label": "Asuncion",
                "shortCode": "ASU"
            },
            {
                "value": "Caaguazu",
                "label": "Caaguazu",
                "shortCode": "5"
            },
            {
                "value": "Caazapa",
                "label": "Caazapa",
                "shortCode": "6"
            },
            {
                "value": "Canindeyu",
                "label": "Canindeyu",
                "shortCode": "14"
            },
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "11"
            },
            {
                "value": "Concepcion",
                "label": "Concepcion",
                "shortCode": "1"
            },
            {
                "value": "Cordillera",
                "label": "Cordillera",
                "shortCode": "3"
            },
            {
                "value": "Boqueron",
                "label": "Boqueron",
                "shortCode": "17"
            },
            {
                "value": "Guaira",
                "label": "Guaira",
                "shortCode": "4"
            },
            {
                "value": "Itapua",
                "label": "Itapua",
                "shortCode": "7"
            },
            {
                "value": "Misiones",
                "label": "Misiones",
                "shortCode": "8"
            },
            {
                "value": "Neembucu",
                "label": "Neembucu",
                "shortCode": "12"
            },
            {
                "value": "Paraguari",
                "label": "Paraguari",
                "shortCode": "9"
            },
            {
                "value": "Presidente Hayes",
                "label": "Presidente Hayes",
                "shortCode": "15"
            },
            {
                "value": "San Pedro",
                "label": "San Pedro",
                "shortCode": "2"
            }
        ]
    },
    {
        "countryCode": "+51",
        "value": "Peru",
        "label": "Peru",
        "regions": [
            {
                "value": "Amazonas",
                "label": "Amazonas",
                "shortCode": "AMA"
            },
            {
                "value": "Ancash",
                "label": "Ancash",
                "shortCode": "ANC"
            },
            {
                "value": "Apurimac",
                "label": "Apurimac",
                "shortCode": "APU"
            },
            {
                "value": "Arequipa",
                "label": "Arequipa",
                "shortCode": "ARE"
            },
            {
                "value": "Ayacucho",
                "label": "Ayacucho",
                "shortCode": "AYA"
            },
            {
                "value": "Cajamarca",
                "label": "Cajamarca",
                "shortCode": "CAJ"
            },
            {
                "value": "Callao",
                "label": "Callao",
                "shortCode": "CAL"
            },
            {
                "value": "Cusco",
                "label": "Cusco",
                "shortCode": "CUS"
            },
            {
                "value": "Huancavelica",
                "label": "Huancavelica",
                "shortCode": "HUV"
            },
            {
                "value": "Huanuco",
                "label": "Huanuco",
                "shortCode": "HUC"
            },
            {
                "value": "Ica",
                "label": "Ica",
                "shortCode": "ICA"
            },
            {
                "value": "Junin",
                "label": "Junin",
                "shortCode": "JUN"
            },
            {
                "value": "La Libertad",
                "label": "La Libertad",
                "shortCode": "LAL"
            },
            {
                "value": "Lambayeque",
                "label": "Lambayeque",
                "shortCode": "LAM"
            },
            {
                "value": "Lima",
                "label": "Lima",
                "shortCode": "LIM"
            },
            {
                "value": "Loreto",
                "label": "Loreto",
                "shortCode": "LOR"
            },
            {
                "value": "Madre de Dios",
                "label": "Madre de Dios",
                "shortCode": "MDD"
            },
            {
                "value": "Moquegua",
                "label": "Moquegua",
                "shortCode": "MOQ"
            },
            {
                "value": "Municipalidad Metropolitana de Lima",
                "label": "Municipalidad Metropolitana de Lima",
                "shortCode": "LMA"
            },
            {
                "value": "Pasco",
                "label": "Pasco",
                "shortCode": "PAS"
            },
            {
                "value": "Piura",
                "label": "Piura",
                "shortCode": "PIU"
            },
            {
                "value": "Puno",
                "label": "Puno",
                "shortCode": "PUN"
            },
            {
                "value": "San Martin",
                "label": "San Martin",
                "shortCode": "SAM"
            },
            {
                "value": "Tacna",
                "label": "Tacna",
                "shortCode": "TAC"
            },
            {
                "value": "Tumbes",
                "label": "Tumbes",
                "shortCode": "TUM"
            },
            {
                "value": "Ucayali",
                "label": "Ucayali",
                "shortCode": "UCA"
            }
        ]
    },
    {
        "countryCode": "+63",
        "value": "Philippines",
        "label": "Philippines",
        "regions": [
            {
                "value": "Abra",
                "label": "Abra",
                "shortCode": "ABR"
            },
            {
                "value": "Agusan del Norte",
                "label": "Agusan del Norte",
                "shortCode": "AGN"
            },
            {
                "value": "Agusan del Sur",
                "label": "Agusan del Sur",
                "shortCode": "AGS"
            },
            {
                "value": "Aklan",
                "label": "Aklan",
                "shortCode": "AKL"
            },
            {
                "value": "Albay",
                "label": "Albay",
                "shortCode": "ALB"
            },
            {
                "value": "Antique",
                "label": "Antique",
                "shortCode": "ANT"
            },
            {
                "value": "Apayao",
                "label": "Apayao",
                "shortCode": "APA"
            },
            {
                "value": "Aurora",
                "label": "Aurora",
                "shortCode": "AUR"
            },
            {
                "value": "Basilan",
                "label": "Basilan",
                "shortCode": "BAS"
            },
            {
                "value": "Bataan",
                "label": "Bataan",
                "shortCode": "BAN"
            },
            {
                "value": "Batanes",
                "label": "Batanes",
                "shortCode": "BTN"
            },
            {
                "value": "Batangas",
                "label": "Batangas",
                "shortCode": "BTG"
            },
            {
                "value": "Benguet",
                "label": "Benguet",
                "shortCode": "BEN"
            },
            {
                "value": "Biliran",
                "label": "Biliran",
                "shortCode": "BIL"
            },
            {
                "value": "Bohol",
                "label": "Bohol",
                "shortCode": "BOH"
            },
            {
                "value": "Bukidnon",
                "label": "Bukidnon",
                "shortCode": "BUK"
            },
            {
                "value": "Bulacan",
                "label": "Bulacan",
                "shortCode": "BUL"
            },
            {
                "value": "Cagayan",
                "label": "Cagayan",
                "shortCode": "CAG"
            },
            {
                "value": "Camarines Norte",
                "label": "Camarines Norte",
                "shortCode": "CAN"
            },
            {
                "value": "Camarines Sur",
                "label": "Camarines Sur",
                "shortCode": "CAS"
            },
            {
                "value": "Camiguin",
                "label": "Camiguin",
                "shortCode": "CAM"
            },
            {
                "value": "Capiz",
                "label": "Capiz",
                "shortCode": "CAP"
            },
            {
                "value": "Catanduanes",
                "label": "Catanduanes",
                "shortCode": "CAT"
            },
            {
                "value": "Cavite",
                "label": "Cavite",
                "shortCode": "CAV"
            },
            {
                "value": "Cebu",
                "label": "Cebu",
                "shortCode": "CEB"
            },
            {
                "value": "Cotabato",
                "label": "Cotabato",
                "shortCode": "NCO"
            },
            {
                "value": "Davao del Norte",
                "label": "Davao del Norte",
                "shortCode": "DAV"
            },
            {
                "value": "Davao del Sur",
                "label": "Davao del Sur",
                "shortCode": "DAS"
            },
            {
                "value": "Davao Occidental",
                "label": "Davao Occidental",
                "shortCode": "DVO"
            },
            {
                "value": "Davao Oriental",
                "label": "Davao Oriental",
                "shortCode": "DAO"
            },
            {
                "value": "Davao de Oro",
                "label": "Davao de Oro",
                "shortCode": "COM"
            },
            {
                "value": "Dinagat Islands",
                "label": "Dinagat Islands",
                "shortCode": "DIN"
            },
            {
                "value": "Eastern Samar",
                "label": "Eastern Samar",
                "shortCode": "EAS"
            },
            {
                "value": "Guimaras",
                "label": "Guimaras",
                "shortCode": "GUI"
            },
            {
                "value": "Ifugao",
                "label": "Ifugao",
                "shortCode": "IFU"
            },
            {
                "value": "Ilocos Norte",
                "label": "Ilocos Norte",
                "shortCode": "ILN"
            },
            {
                "value": "Ilocos Sur",
                "label": "Ilocos Sur",
                "shortCode": "ILS"
            },
            {
                "value": "Iloilo",
                "label": "Iloilo",
                "shortCode": "ILI"
            },
            {
                "value": "Isabela",
                "label": "Isabela",
                "shortCode": "ISA"
            },
            {
                "value": "Kalinga",
                "label": "Kalinga",
                "shortCode": "KAL"
            },
            {
                "value": "La Union",
                "label": "La Union",
                "shortCode": "LUN"
            },
            {
                "value": "Laguna",
                "label": "Laguna",
                "shortCode": "LAG"
            },
            {
                "value": "Lanao del Norte",
                "label": "Lanao del Norte",
                "shortCode": "LAN"
            },
            {
                "value": "Lanao del Sur",
                "label": "Lanao del Sur",
                "shortCode": "LAS"
            },
            {
                "value": "Leyte",
                "label": "Leyte",
                "shortCode": "LEY"
            },
            {
                "value": "Maguindanao",
                "label": "Maguindanao",
                "shortCode": "MAG"
            },
            {
                "value": "Marinduque",
                "label": "Marinduque",
                "shortCode": "MAD"
            },
            {
                "value": "Masbate",
                "label": "Masbate",
                "shortCode": "MAS"
            },
            {
                "value": "Metro Manila",
                "label": "Metro Manila",
                "shortCode": "00"
            },
            {
                "value": "Mindoro Occidental",
                "label": "Mindoro Occidental",
                "shortCode": "MDC"
            },
            {
                "value": "Mindoro Oriental",
                "label": "Mindoro Oriental",
                "shortCode": "MDR"
            },
            {
                "value": "Misamis Occidental",
                "label": "Misamis Occidental",
                "shortCode": "MSC"
            },
            {
                "value": "Misamis Oriental",
                "label": "Misamis Oriental",
                "shortCode": "MSR"
            },
            {
                "value": "Mountain Province",
                "label": "Mountain Province",
                "shortCode": "MOU"
            },
            {
                "value": "Negros Occidental",
                "label": "Negros Occidental",
                "shortCode": "NEC"
            },
            {
                "value": "Negros Oriental",
                "label": "Negros Oriental",
                "shortCode": "NER"
            },
            {
                "value": "Northern Samar",
                "label": "Northern Samar",
                "shortCode": "NSA"
            },
            {
                "value": "Nueva Ecija",
                "label": "Nueva Ecija",
                "shortCode": "NUE"
            },
            {
                "value": "Nueva Vizcaya",
                "label": "Nueva Vizcaya",
                "shortCode": "NUV"
            },
            {
                "value": "Palawan",
                "label": "Palawan",
                "shortCode": "PLW"
            },
            {
                "value": "Pampanga",
                "label": "Pampanga",
                "shortCode": "PAM"
            },
            {
                "value": "Pangasinan",
                "label": "Pangasinan",
                "shortCode": "PAN"
            },
            {
                "value": "Quezon",
                "label": "Quezon",
                "shortCode": "QUE"
            },
            {
                "value": "Quirino",
                "label": "Quirino",
                "shortCode": "QUI"
            },
            {
                "value": "Rizal",
                "label": "Rizal",
                "shortCode": "RIZ"
            },
            {
                "value": "Romblon",
                "label": "Romblon",
                "shortCode": "ROM"
            },
            {
                "value": "Samar",
                "label": "Samar",
                "shortCode": "WSA"
            },
            {
                "value": "Sarangani",
                "label": "Sarangani",
                "shortCode": "SAR"
            },
            {
                "value": "Siquijor",
                "label": "Siquijor",
                "shortCode": "SIG"
            },
            {
                "value": "Sorsogon",
                "label": "Sorsogon",
                "shortCode": "SOR"
            },
            {
                "value": "South Cotabato",
                "label": "South Cotabato",
                "shortCode": "SCO"
            },
            {
                "value": "Southern Leyte",
                "label": "Southern Leyte",
                "shortCode": "SLE"
            },
            {
                "value": "Sultan Kudarat",
                "label": "Sultan Kudarat",
                "shortCode": "AUK"
            },
            {
                "value": "Sulu",
                "label": "Sulu",
                "shortCode": "SLU"
            },
            {
                "value": "Surigao del Norte",
                "label": "Surigao del Norte",
                "shortCode": "SUN"
            },
            {
                "value": "Surigao del Sur",
                "label": "Surigao del Sur",
                "shortCode": "SUR"
            },
            {
                "value": "Tarlac",
                "label": "Tarlac",
                "shortCode": "TAR"
            },
            {
                "value": "Tawi-Tawi",
                "label": "Tawi-Tawi",
                "shortCode": "TAW"
            },
            {
                "value": "Zambales",
                "label": "Zambales",
                "shortCode": "ZMB"
            },
            {
                "value": "Zamboanga del Norte",
                "label": "Zamboanga del Norte",
                "shortCode": "ZAN"
            },
            {
                "value": "Zamboanga del Sur",
                "label": "Zamboanga del Sur",
                "shortCode": "ZAS"
            },
            {
                "value": "Zamboanga Sibugay",
                "label": "Zamboanga Sibugay",
                "shortCode": "ZSI"
            }
        ]
    },
    {
        "countryCode": "+48",
        "value": "Poland",
        "label": "Poland",
        "regions": [
            {
                "value": "Dolnośląskie",
                "label": "Dolnośląskie",
                "shortCode": "02"
            },
            {
                "value": "Kujawsko-pomorskie",
                "label": "Kujawsko-pomorskie",
                "shortCode": "04"
            },
            {
                "value": "Łódzkie",
                "label": "Łódzkie",
                "shortCode": "10"
            },
            {
                "value": "Lubelskie",
                "label": "Lubelskie",
                "shortCode": "06"
            },
            {
                "value": "Lubuskie",
                "label": "Lubuskie",
                "shortCode": "08"
            },
            {
                "value": "Małopolskie",
                "label": "Małopolskie",
                "shortCode": "12"
            },
            {
                "value": "Mazowieckie",
                "label": "Mazowieckie",
                "shortCode": "14"
            },
            {
                "value": "Opolskie",
                "label": "Opolskie",
                "shortCode": "16"
            },
            {
                "value": "Podkarpackie",
                "label": "Podkarpackie",
                "shortCode": "18"
            },
            {
                "value": "Podlaskie",
                "label": "Podlaskie",
                "shortCode": "20"
            },
            {
                "value": "Pomorskie",
                "label": "Pomorskie",
                "shortCode": "22"
            },
            {
                "value": "Śląskie",
                "label": "Śląskie",
                "shortCode": "24"
            },
            {
                "value": "Świętokrzyskie",
                "label": "Świętokrzyskie",
                "shortCode": "26"
            },
            {
                "value": "Warmińsko-mazurskie",
                "label": "Warmińsko-mazurskie",
                "shortCode": "28"
            },
            {
                "value": "Wielkopolskie",
                "label": "Wielkopolskie",
                "shortCode": "30"
            },
            {
                "value": "Zachodniopomorskie",
                "label": "Zachodniopomorskie",
                "shortCode": "32"
            }
        ]
    },
    {
        "countryCode": "+351",
        "value": "Portugal",
        "label": "Portugal",
        "regions": [
            {
                "value": "Açores",
                "label": "Açores",
                "shortCode": "20"
            },
            {
                "value": "Aveiro",
                "label": "Aveiro",
                "shortCode": "01"
            },
            {
                "value": "Beja",
                "label": "Beja",
                "shortCode": "02"
            },
            {
                "value": "Braga",
                "label": "Braga",
                "shortCode": "03"
            },
            {
                "value": "Bragança",
                "label": "Bragança",
                "shortCode": "04"
            },
            {
                "value": "Castelo Branco",
                "label": "Castelo Branco",
                "shortCode": "05"
            },
            {
                "value": "Coimbra",
                "label": "Coimbra",
                "shortCode": "06"
            },
            {
                "value": "Évora",
                "label": "Évora",
                "shortCode": "07"
            },
            {
                "value": "Faro",
                "label": "Faro",
                "shortCode": "08"
            },
            {
                "value": "Guarda",
                "label": "Guarda",
                "shortCode": "09"
            },
            {
                "value": "Leiria",
                "label": "Leiria",
                "shortCode": "10"
            },
            {
                "value": "Lisboa",
                "label": "Lisboa",
                "shortCode": "11"
            },
            {
                "value": "Madeira",
                "label": "Madeira",
                "shortCode": "30"
            },
            {
                "value": "Portalegre",
                "label": "Portalegre",
                "shortCode": "12"
            },
            {
                "value": "Porto",
                "label": "Porto",
                "shortCode": "13"
            },
            {
                "value": "Santarém",
                "label": "Santarém",
                "shortCode": "14"
            },
            {
                "value": "Setúbal",
                "label": "Setúbal",
                "shortCode": "15"
            },
            {
                "value": "Viana do Castelo",
                "label": "Viana do Castelo",
                "shortCode": "16"
            },
            {
                "value": "Vila Real",
                "label": "Vila Real",
                "shortCode": "17"
            },
            {
                "value": "Viseu",
                "label": "Viseu",
                "shortCode": "18"
            }
        ]
    },
    {
        "countryCode": "+1 787, 1 939",
        "value": "Puerto Rico",
        "label": "Puerto Rico",
        "regions": [
            {
                "value": "Adjuntas",
                "label": "Adjuntas"
            },
            {
                "value": "Aguada",
                "label": "Aguada"
            },
            {
                "value": "Aguadilla",
                "label": "Aguadilla"
            },
            {
                "value": "Aguas Buenas",
                "label": "Aguas Buenas"
            },
            {
                "value": "Aibonito",
                "label": "Aibonito"
            },
            {
                "value": "Anasco",
                "label": "Anasco"
            },
            {
                "value": "Arecibo",
                "label": "Arecibo"
            },
            {
                "value": "Arroyo",
                "label": "Arroyo"
            },
            {
                "value": "Barceloneta",
                "label": "Barceloneta"
            },
            {
                "value": "Barranquitas",
                "label": "Barranquitas"
            },
            {
                "value": "Bayamon",
                "label": "Bayamon"
            },
            {
                "value": "Cabo Rojo",
                "label": "Cabo Rojo"
            },
            {
                "value": "Caguas",
                "label": "Caguas"
            },
            {
                "value": "Camuy",
                "label": "Camuy"
            },
            {
                "value": "Canovanas",
                "label": "Canovanas"
            },
            {
                "value": "Carolina",
                "label": "Carolina"
            },
            {
                "value": "Cat",
                "label": "Cat"
            },
            {
                "value": "Ceiba",
                "label": "Ceiba"
            },
            {
                "value": "Ciales",
                "label": "Ciales"
            },
            {
                "value": "Cidra",
                "label": "Cidra"
            },
            {
                "value": "Coamo",
                "label": "Coamo"
            },
            {
                "value": "Comerio",
                "label": "Comerio"
            },
            {
                "value": "Corozal",
                "label": "Corozal"
            },
            {
                "value": "Culebra",
                "label": "Culebra"
            },
            {
                "value": "Dorado",
                "label": "Dorado"
            },
            {
                "value": "Fajardo",
                "label": "Fajardo"
            },
            {
                "value": "Florida",
                "label": "Florida"
            },
            {
                "value": "Guanica",
                "label": "Guanica"
            },
            {
                "value": "Guayama",
                "label": "Guayama"
            },
            {
                "value": "Guayanilla",
                "label": "Guayanilla"
            },
            {
                "value": "Guaynabo",
                "label": "Guaynabo"
            },
            {
                "value": "Gurabo",
                "label": "Gurabo"
            },
            {
                "value": "Hatillo",
                "label": "Hatillo"
            },
            {
                "value": "Hormigueros",
                "label": "Hormigueros"
            },
            {
                "value": "Humacao",
                "label": "Humacao"
            },
            {
                "value": "Isabe",
                "label": "Isabe"
            },
            {
                "value": "Juana Diaz",
                "label": "Juana Diaz"
            },
            {
                "value": "Juncos",
                "label": "Juncos"
            },
            {
                "value": "Lajas",
                "label": "Lajas"
            },
            {
                "value": "Lares",
                "label": "Lares"
            },
            {
                "value": "Las Marias",
                "label": "Las Marias"
            },
            {
                "value": "Las oiza",
                "label": "Las oiza"
            },
            {
                "value": "Luquillo",
                "label": "Luquillo"
            },
            {
                "value": "Manati",
                "label": "Manati"
            },
            {
                "value": "Maricao",
                "label": "Maricao"
            },
            {
                "value": "Maunabo",
                "label": "Maunabo"
            },
            {
                "value": "Mayaguez",
                "label": "Mayaguez"
            },
            {
                "value": "Moca",
                "label": "Moca"
            },
            {
                "value": "Morovis",
                "label": "Morovis"
            },
            {
                "value": "Naguabo",
                "label": "Naguabo"
            },
            {
                "value": "Naranjito",
                "label": "Naranjito"
            },
            {
                "value": "Orocovis",
                "label": "Orocovis"
            },
            {
                "value": "Patillas",
                "label": "Patillas"
            },
            {
                "value": "Penuelas",
                "label": "Penuelas"
            },
            {
                "value": "Ponce",
                "label": "Ponce"
            },
            {
                "value": "Quebradillas",
                "label": "Quebradillas"
            },
            {
                "value": "Rincon",
                "label": "Rincon"
            },
            {
                "value": "Rio Grande",
                "label": "Rio Grande"
            },
            {
                "value": "Sabana linas",
                "label": "Sabana linas"
            },
            {
                "value": "San German",
                "label": "San German"
            },
            {
                "value": "San Juan",
                "label": "San Juan"
            },
            {
                "value": "San Lorenzo",
                "label": "San Lorenzo"
            },
            {
                "value": "San Sebastian",
                "label": "San Sebastian"
            },
            {
                "value": "Santa Isabel",
                "label": "Santa Isabel"
            },
            {
                "value": "Toa Alta",
                "label": "Toa Alta"
            },
            {
                "value": "Toa Baja",
                "label": "Toa Baja"
            },
            {
                "value": "Trujillo Alto",
                "label": "Trujillo Alto"
            },
            {
                "value": "Utuado",
                "label": "Utuado"
            },
            {
                "value": "Vega Alta",
                "label": "Vega Alta"
            },
            {
                "value": "Vega ues",
                "label": "Vega ues"
            },
            {
                "value": "Villalba",
                "label": "Villalba"
            },
            {
                "value": "Yabucoa",
                "label": "Yabucoa"
            },
            {
                "value": "Yauco",
                "label": "Yauco"
            }
        ]
    },
    {
        "countryCode": "+974",
        "value": "Qatar",
        "label": "Qatar",
        "regions": [
            {
                "value": "Ad Dawḩah",
                "label": "Ad Dawḩah",
                "shortCode": "DA"
            },
            {
                "value": "Al Khawr wa adh Dhakhīrah",
                "label": "Al Khawr wa adh Dhakhīrah",
                "shortCode": "KH"
            },
            {
                "value": "Al Wakrah",
                "label": "Al Wakrah",
                "shortCode": "WA"
            },
            {
                "value": "Ar Rayyān",
                "label": "Ar Rayyān",
                "shortCode": "RA"
            },
            {
                "value": "Ash Shamāl",
                "label": "Ash Shamāl",
                "shortCode": "MS"
            },
            {
                "value": "Az̧ Za̧`āyin",
                "label": "Az̧ Za̧`āyin",
                "shortCode": "ZA"
            },
            {
                "value": "Umm Şalāl",
                "label": "Umm Şalāl",
                "shortCode": "US"
            }
        ]
    },
    {
        "countryCode": "+262",
        "value": "Réunion",
        "label": "Réunion",
        "regions": [
            {
                "value": "Réunion",
                "label": "Réunion"
            }
        ]
    },
    {
        "countryCode": "+40",
        "value": "Romania",
        "label": "Romania",
        "regions": [
            {
                "value": "Alba",
                "label": "Alba",
                "shortCode": "RO-AB"
            },
            {
                "value": "Arad",
                "label": "Arad",
                "shortCode": "RO-AR"
            },
            {
                "value": "Arges",
                "label": "Arges",
                "shortCode": "RO-AG"
            },
            {
                "value": "Bacau",
                "label": "Bacau",
                "shortCode": "RO-BC"
            },
            {
                "value": "Bihor",
                "label": "Bihor",
                "shortCode": "RO-BH"
            },
            {
                "value": "Bistrita-Nasaud",
                "label": "Bistrita-Nasaud",
                "shortCode": "RO-BN"
            },
            {
                "value": "Botosani",
                "label": "Botosani",
                "shortCode": "RO-BT"
            },
            {
                "value": "Braila",
                "label": "Braila",
                "shortCode": "RO-BR"
            },
            {
                "value": "Brasov",
                "label": "Brasov",
                "shortCode": "RO-BV"
            },
            {
                "value": "Bucharest",
                "label": "Bucharest",
                "shortCode": "RO-B"
            },
            {
                "value": "Buzau",
                "label": "Buzau",
                "shortCode": "RO-BZ"
            },
            {
                "value": "Calarasi",
                "label": "Calarasi",
                "shortCode": "RO-CL"
            },
            {
                "value": "Caras-Severin",
                "label": "Caras-Severin",
                "shortCode": "RO-CS"
            },
            {
                "value": "Cluj",
                "label": "Cluj",
                "shortCode": "RO-CJ"
            },
            {
                "value": "Constanta",
                "label": "Constanta",
                "shortCode": "RO-CT"
            },
            {
                "value": "Covasna",
                "label": "Covasna",
                "shortCode": "RO-CV"
            },
            {
                "value": "Dambovita",
                "label": "Dambovita",
                "shortCode": "RO-DB"
            },
            {
                "value": "Dolj",
                "label": "Dolj",
                "shortCode": "RO-DJ"
            },
            {
                "value": "Galati",
                "label": "Galati",
                "shortCode": "RO-GL"
            },
            {
                "value": "Giurgiu",
                "label": "Giurgiu",
                "shortCode": "RO-GR"
            },
            {
                "value": "Gorj",
                "label": "Gorj",
                "shortCode": "RO-GJ"
            },
            {
                "value": "Harghita",
                "label": "Harghita",
                "shortCode": "RO-HR"
            },
            {
                "value": "Hunedoara",
                "label": "Hunedoara",
                "shortCode": "RO-HD"
            },
            {
                "value": "Ialomita",
                "label": "Ialomita",
                "shortCode": "RO-IL"
            },
            {
                "value": "Iasi",
                "label": "Iasi",
                "shortCode": "RO-IS"
            },
            {
                "value": "Ilfov",
                "label": "Ilfov",
                "shortCode": "RO-IF"
            },
            {
                "value": "Maramures",
                "label": "Maramures",
                "shortCode": "RO-MM"
            },
            {
                "value": "Mehedinti",
                "label": "Mehedinti",
                "shortCode": "RO-MH"
            },
            {
                "value": "Mures",
                "label": "Mures",
                "shortCode": "RO-MS"
            },
            {
                "value": "Neamt",
                "label": "Neamt",
                "shortCode": "RO-NT"
            },
            {
                "value": "Olt",
                "label": "Olt",
                "shortCode": "RO-OT"
            },
            {
                "value": "Prahova",
                "label": "Prahova",
                "shortCode": "RO-PH"
            },
            {
                "value": "Salaj",
                "label": "Salaj",
                "shortCode": "RO-SJ"
            },
            {
                "value": "Satu Mare",
                "label": "Satu Mare",
                "shortCode": "RO-SM"
            },
            {
                "value": "Sibiu",
                "label": "Sibiu",
                "shortCode": "RO-SB"
            },
            {
                "value": "Suceava",
                "label": "Suceava",
                "shortCode": "RO-SV"
            },
            {
                "value": "Teleorman",
                "label": "Teleorman",
                "shortCode": "RO-TR"
            },
            {
                "value": "Timis",
                "label": "Timis",
                "shortCode": "RO-TM"
            },
            {
                "value": "Tulcea",
                "label": "Tulcea",
                "shortCode": "RO-TL"
            },
            {
                "value": "Valcea",
                "label": "Valcea",
                "shortCode": "RO-VL"
            },
            {
                "value": "Vaslui",
                "label": "Vaslui",
                "shortCode": "RO-VS"
            },
            {
                "value": "Vrancea",
                "label": "Vrancea",
                "shortCode": "RO-VN"
            }
        ]
    },
    {
        "countryCode": "+250",
        "value": "Rwanda",
        "label": "Rwanda",
        "regions": [
            {
                "value": "Kigali",
                "label": "Kigali",
                "shortCode": "01"
            },
            {
                "value": "Eastern",
                "label": "Eastern",
                "shortCode": "02"
            },
            {
                "value": "Northern",
                "label": "Northern",
                "shortCode": "03"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "04"
            },
            {
                "value": "Southern",
                "label": "Southern",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+590",
        "value": "Saint Barthélemy",
        "label": "Saint Barthélemy",
        "regions": [
            {
                "value": "Au Vent",
                "label": "Au Vent",
                "shortCode": "02"
            },
            {
                "value": "Sous le Vent",
                "label": "Sous le Vent",
                "shortCode": "01"
            }
        ]
    },
    {
        "countryCode": "+1 869",
        "value": "Saint Kitts and Nevis",
        "label": "Saint Kitts and Nevis",
        "regions": [
            {
                "value": "Saint Kitts",
                "label": "Saint Kitts",
                "shortCode": "K"
            },
            {
                "value": "Nevis",
                "label": "Nevis",
                "shortCode": "N"
            }
        ]
    },
    {
        "countryCode": "+1 758",
        "value": "Saint Lucia",
        "label": "Saint Lucia",
        "regions": [
            {
                "value": "Anse-la-Raye",
                "label": "Anse-la-Raye",
                "shortCode": "01"
            },
            {
                "value": "Canaries",
                "label": "Canaries",
                "shortCode": "12"
            },
            {
                "value": "Castries",
                "label": "Castries",
                "shortCode": "02"
            },
            {
                "value": "Choiseul",
                "label": "Choiseul",
                "shortCode": "03"
            },
            {
                "value": "Dennery",
                "label": "Dennery",
                "shortCode": "05"
            },
            {
                "value": "Gros Islet",
                "label": "Gros Islet",
                "shortCode": "06"
            },
            {
                "value": "Laborie",
                "label": "Laborie",
                "shortCode": "07"
            },
            {
                "value": "Micoud",
                "label": "Micoud",
                "shortCode": "08"
            },
            {
                "value": "Soufriere",
                "label": "Soufriere",
                "shortCode": "10"
            },
            {
                "value": "Vieux Fort",
                "label": "Vieux Fort",
                "shortCode": "11"
            }
        ]
    },
    {
        "countryCode": "+508",
        "value": "Saint Pierre and Miquelon",
        "label": "Saint Pierre and Miquelon",
        "regions": [
            {
                "value": "Miquelon",
                "label": "Miquelon"
            },
            {
                "value": "Saint Pierre",
                "label": "Saint Pierre"
            }
        ]
    },
    {
        "countryCode": "+1 784",
        "value": "Saint Vincent and the Grenadines",
        "label": "Saint Vincent and the Grenadines",
        "regions": [
            {
                "value": "Charlotte",
                "label": "Charlotte",
                "shortCode": "01"
            },
            {
                "value": "Grenadines",
                "label": "Grenadines",
                "shortCode": "06"
            },
            {
                "value": "Saint Andrew",
                "label": "Saint Andrew",
                "shortCode": "02"
            },
            {
                "value": "Saint David",
                "label": "Saint David",
                "shortCode": "03"
            },
            {
                "value": "Saint George",
                "label": "Saint George",
                "shortCode": "04"
            },
            {
                "value": "Saint Patrick",
                "label": "Saint Patrick",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+685",
        "value": "Samoa",
        "label": "Samoa",
        "regions": [
            {
                "value": "A'ana",
                "label": "A'ana",
                "shortCode": "AA"
            },
            {
                "value": "Aiga-i-le-Tai",
                "label": "Aiga-i-le-Tai",
                "shortCode": "AL"
            },
            {
                "value": "Atua",
                "label": "Atua",
                "shortCode": "AT"
            },
            {
                "value": "Fa'asaleleaga",
                "label": "Fa'asaleleaga",
                "shortCode": "FA"
            },
            {
                "value": "Gaga'emauga",
                "label": "Gaga'emauga",
                "shortCode": "GE"
            },
            {
                "value": "Gagaifomauga",
                "label": "Gagaifomauga",
                "shortCode": "GI"
            },
            {
                "value": "Palauli",
                "label": "Palauli",
                "shortCode": "PA"
            },
            {
                "value": "Satupa'itea",
                "label": "Satupa'itea",
                "shortCode": "SA"
            },
            {
                "value": "Tuamasaga",
                "label": "Tuamasaga",
                "shortCode": "TU"
            },
            {
                "value": "Va'a-o-Fonoti",
                "label": "Va'a-o-Fonoti",
                "shortCode": "VF"
            },
            {
                "value": "Vaisigano",
                "label": "Vaisigano",
                "shortCode": "VS"
            }
        ]
    },
    {
        "countryCode": "+378",
        "value": "San Marino",
        "label": "San Marino",
        "regions": [
            {
                "value": "Acquaviva",
                "label": "Acquaviva",
                "shortCode": "01"
            },
            {
                "value": "Borgo Maggiore",
                "label": "Borgo Maggiore",
                "shortCode": "06"
            },
            {
                "value": "Chiesanuova",
                "label": "Chiesanuova",
                "shortCode": "02"
            },
            {
                "value": "Domagnano",
                "label": "Domagnano",
                "shortCode": "03"
            },
            {
                "value": "Faetano",
                "label": "Faetano",
                "shortCode": "04"
            },
            {
                "value": "Fiorentino",
                "label": "Fiorentino",
                "shortCode": "05"
            },
            {
                "value": "Montegiardino",
                "label": "Montegiardino",
                "shortCode": "08"
            },
            {
                "value": "San Marino",
                "label": "San Marino",
                "shortCode": "07"
            },
            {
                "value": "Serravalle",
                "label": "Serravalle",
                "shortCode": "09"
            }
        ]
    },
    {
        "countryCode": "+966",
        "value": "Saudi Arabia",
        "label": "Saudi Arabia",
        "regions": [
            {
                "value": "'Asir",
                "label": "'Asir",
                "shortCode": "14"
            },
            {
                "value": "Al Bahah",
                "label": "Al Bahah",
                "shortCode": "11"
            },
            {
                "value": "Al Hudud ash Shamaliyah",
                "label": "Al Hudud ash Shamaliyah",
                "shortCode": "08"
            },
            {
                "value": "Al Jawf",
                "label": "Al Jawf",
                "shortCode": "12"
            },
            {
                "value": "Al Madinah al Munawwarah",
                "label": "Al Madinah al Munawwarah",
                "shortCode": "03"
            },
            {
                "value": "Al Qasim",
                "label": "Al Qasim",
                "shortCode": "05"
            },
            {
                "value": "Ar Riyad",
                "label": "Ar Riyad",
                "shortCode": "01"
            },
            {
                "value": "Ash Sharqiyah",
                "label": "Ash Sharqiyah",
                "shortCode": "04"
            },
            {
                "value": "Ha'il",
                "label": "Ha'il",
                "shortCode": "06"
            },
            {
                "value": "Jazan",
                "label": "Jazan",
                "shortCode": "09"
            },
            {
                "value": "Makkah al Mukarramah",
                "label": "Makkah al Mukarramah",
                "shortCode": "02"
            },
            {
                "value": "Najran",
                "label": "Najran",
                "shortCode": "10"
            },
            {
                "value": "Tabuk",
                "label": "Tabuk",
                "shortCode": "07"
            }
        ]
    },
    {
        "countryCode": "+221",
        "value": "Senegal",
        "label": "Senegal",
        "regions": [
            {
                "value": "Dakar",
                "label": "Dakar",
                "shortCode": "DK"
            },
            {
                "value": "Diourbel",
                "label": "Diourbel",
                "shortCode": "DB"
            },
            {
                "value": "Fatick",
                "label": "Fatick",
                "shortCode": "FK"
            },
            {
                "value": "Kaffrine",
                "label": "Kaffrine",
                "shortCode": "KA"
            },
            {
                "value": "Kaolack",
                "label": "Kaolack",
                "shortCode": "KL"
            },
            {
                "value": "Kedougou",
                "label": "Kedougou",
                "shortCode": "KE"
            },
            {
                "value": "Kolda",
                "label": "Kolda",
                "shortCode": "KD"
            },
            {
                "value": "Louga",
                "label": "Louga",
                "shortCode": "LG"
            },
            {
                "value": "Matam",
                "label": "Matam",
                "shortCode": "MT"
            },
            {
                "value": "Saint-Louis",
                "label": "Saint-Louis",
                "shortCode": "SL"
            },
            {
                "value": "Sedhiou",
                "label": "Sedhiou",
                "shortCode": "SE"
            },
            {
                "value": "Tambacounda",
                "label": "Tambacounda",
                "shortCode": "TC"
            },
            {
                "value": "Thies",
                "label": "Thies",
                "shortCode": "TH"
            },
            {
                "value": "Ziguinchor",
                "label": "Ziguinchor",
                "shortCode": "ZG"
            }
        ]
    },
    {
        "countryCode": "+381",
        "value": "Serbia",
        "label": "Serbia",
        "regions": [
            {
                "value": "Beograd (Belgrade)",
                "label": "Beograd (Belgrade)",
                "shortCode": "00"
            },
            {
                "value": "Borski",
                "label": "Borski",
                "shortCode": "14"
            },
            {
                "value": "Braničevski",
                "label": "Braničevski",
                "shortCode": "11"
            },
            {
                "value": "Jablanički",
                "label": "Jablanički",
                "shortCode": "23"
            },
            {
                "value": "Južnobački",
                "label": "Južnobački",
                "shortCode": "06"
            },
            {
                "value": "Južnobanatski",
                "label": "Južnobanatski",
                "shortCode": "04"
            },
            {
                "value": "Kolubarski",
                "label": "Kolubarski",
                "shortCode": "09"
            },
            {
                "value": "Kosovski",
                "label": "Kosovski",
                "shortCode": "25"
            },
            {
                "value": "Kosovsko-Mitrovački",
                "label": "Kosovsko-Mitrovački",
                "shortCode": "28"
            },
            {
                "value": "Kosovsko-Pomoravski",
                "label": "Kosovsko-Pomoravski",
                "shortCode": "29"
            },
            {
                "value": "Mačvanski",
                "label": "Mačvanski",
                "shortCode": "08"
            },
            {
                "value": "Moravički",
                "label": "Moravički",
                "shortCode": "17"
            },
            {
                "value": "Nišavski",
                "label": "Nišavski",
                "shortCode": "20"
            },
            {
                "value": "Pčinjski",
                "label": "Pčinjski",
                "shortCode": "24"
            },
            {
                "value": "Pećki",
                "label": "Pećki",
                "shortCode": "26"
            },
            {
                "value": "Pirotski",
                "label": "Pirotski",
                "shortCode": "22"
            },
            {
                "value": "Podunavski",
                "label": "Podunavski",
                "shortCode": "10"
            },
            {
                "value": "Pomoravski",
                "label": "Pomoravski",
                "shortCode": "13"
            },
            {
                "value": "Prizrenski",
                "label": "Prizrenski",
                "shortCode": "27"
            },
            {
                "value": "Rasinski",
                "label": "Rasinski",
                "shortCode": "19"
            },
            {
                "value": "Raški",
                "label": "Raški",
                "shortCode": "18"
            },
            {
                "value": "Severnobački",
                "label": "Severnobački",
                "shortCode": "01"
            },
            {
                "value": "Severnobanatski",
                "label": "Severnobanatski",
                "shortCode": "03"
            },
            {
                "value": "Srednjebanatski",
                "label": "Srednjebanatski",
                "shortCode": "02"
            },
            {
                "value": "Sremski",
                "label": "Sremski",
                "shortCode": "07"
            },
            {
                "value": "Šumadijski",
                "label": "Šumadijski",
                "shortCode": "12"
            },
            {
                "value": "Toplički",
                "label": "Toplički",
                "shortCode": "21"
            },
            {
                "value": "Zaječarski",
                "label": "Zaječarski",
                "shortCode": "15"
            },
            {
                "value": "Zapadnobački",
                "label": "Zapadnobački",
                "shortCode": "05"
            },
            {
                "value": "Zlatiborski",
                "label": "Zlatiborski",
                "shortCode": "16"
            }
        ]
    },
    {
        "countryCode": "+248",
        "value": "Seychelles",
        "label": "Seychelles",
        "regions": [
            {
                "value": "Anse aux Pins",
                "label": "Anse aux Pins",
                "shortCode": "01"
            },
            {
                "value": "Anse Boileau",
                "label": "Anse Boileau",
                "shortCode": "02"
            },
            {
                "value": "Anse Etoile",
                "label": "Anse Etoile",
                "shortCode": "03"
            },
            {
                "value": "Anse Royale",
                "label": "Anse Royale",
                "shortCode": "05"
            },
            {
                "value": "Anu Cap",
                "label": "Anu Cap",
                "shortCode": "04"
            },
            {
                "value": "Baie Lazare",
                "label": "Baie Lazare",
                "shortCode": "06"
            },
            {
                "value": "Baie Sainte Anne",
                "label": "Baie Sainte Anne",
                "shortCode": "07"
            },
            {
                "value": "Beau Vallon",
                "label": "Beau Vallon",
                "shortCode": "08"
            },
            {
                "value": "Bel Air",
                "label": "Bel Air",
                "shortCode": "09"
            },
            {
                "value": "Bel Ombre",
                "label": "Bel Ombre",
                "shortCode": "10"
            },
            {
                "value": "Cascade",
                "label": "Cascade",
                "shortCode": "11"
            },
            {
                "value": "Glacis",
                "label": "Glacis",
                "shortCode": "12"
            },
            {
                "value": "Grand'Anse Mahe",
                "label": "Grand'Anse Mahe",
                "shortCode": "13"
            },
            {
                "value": "Grand'Anse Praslin",
                "label": "Grand'Anse Praslin",
                "shortCode": "14"
            },
            {
                "value": "La Digue",
                "label": "La Digue",
                "shortCode": "15"
            },
            {
                "value": "La Riviere Anglaise",
                "label": "La Riviere Anglaise",
                "shortCode": "16"
            },
            {
                "value": "Les Mamelles",
                "label": "Les Mamelles",
                "shortCode": "24"
            },
            {
                "value": "Mont Buxton",
                "label": "Mont Buxton",
                "shortCode": "17"
            },
            {
                "value": "Mont Fleuri",
                "label": "Mont Fleuri",
                "shortCode": "18"
            },
            {
                "value": "Plaisance",
                "label": "Plaisance",
                "shortCode": "19"
            },
            {
                "value": "Pointe La Rue",
                "label": "Pointe La Rue",
                "shortCode": "20"
            },
            {
                "value": "Port Glaud",
                "label": "Port Glaud",
                "shortCode": "21"
            },
            {
                "value": "Roche Caiman",
                "label": "Roche Caiman",
                "shortCode": "25"
            },
            {
                "value": "Saint Louis",
                "label": "Saint Louis",
                "shortCode": "22"
            },
            {
                "value": "Takamaka",
                "label": "Takamaka",
                "shortCode": "23"
            }
        ]
    },
    {
        "countryCode": "+232",
        "value": "Sierra Leone",
        "label": "Sierra Leone",
        "regions": [
            {
                "value": "Eastern",
                "label": "Eastern",
                "shortCode": "E"
            },
            {
                "value": "Northern",
                "label": "Northern",
                "shortCode": "N"
            },
            {
                "value": "Southern",
                "label": "Southern",
                "shortCode": "S"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "W"
            }
        ]
    },
    {
        "countryCode": "+65",
        "value": "Singapore",
        "label": "Singapore",
        "regions": [
            {
                "value": "Central Singapore",
                "label": "Central Singapore",
                "shortCode": "01"
            },
            {
                "value": "North East",
                "label": "North East",
                "shortCode": "02"
            },
            {
                "value": "North West",
                "label": "North West",
                "shortCode": "03"
            },
            {
                "value": "South East",
                "label": "South East",
                "shortCode": "04"
            },
            {
                "value": "South West",
                "label": "South West",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+421",
        "value": "Slovakia",
        "label": "Slovakia",
        "regions": [
            {
                "value": "Banskobystricky",
                "label": "Banskobystricky",
                "shortCode": "BC"
            },
            {
                "value": "Bratislavsky",
                "label": "Bratislavsky",
                "shortCode": "BL"
            },
            {
                "value": "Kosicky",
                "label": "Kosicky",
                "shortCode": "KI"
            },
            {
                "value": "Nitriansky",
                "label": "Nitriansky",
                "shortCode": "NI"
            },
            {
                "value": "Presovsky",
                "label": "Presovsky",
                "shortCode": "PV"
            },
            {
                "value": "Trenciansky",
                "label": "Trenciansky",
                "shortCode": "TC"
            },
            {
                "value": "Trnavsky",
                "label": "Trnavsky",
                "shortCode": "TA"
            },
            {
                "value": "Zilinsky",
                "label": "Zilinsky",
                "shortCode": "ZI"
            }
        ]
    },
    {
        "countryCode": "+386",
        "value": "Slovenia",
        "label": "Slovenia",
        "regions": [
            {
                "value": "Ajdovscina",
                "label": "Ajdovscina",
                "shortCode": "001"
            },
            {
                "value": "Apace",
                "label": "Apace",
                "shortCode": "195"
            },
            {
                "value": "Beltinci",
                "label": "Beltinci",
                "shortCode": "002"
            },
            {
                "value": "Benedikt",
                "label": "Benedikt",
                "shortCode": "148"
            },
            {
                "value": "Bistrica ob Sotli",
                "label": "Bistrica ob Sotli",
                "shortCode": "149"
            },
            {
                "value": "Bled",
                "label": "Bled",
                "shortCode": "003"
            },
            {
                "value": "Bloke",
                "label": "Bloke",
                "shortCode": "150"
            },
            {
                "value": "Bohinj",
                "label": "Bohinj",
                "shortCode": "004"
            },
            {
                "value": "Borovnica",
                "label": "Borovnica",
                "shortCode": "005"
            },
            {
                "value": "Bovec",
                "label": "Bovec",
                "shortCode": "006"
            },
            {
                "value": "Braslovce",
                "label": "Braslovce",
                "shortCode": "151"
            },
            {
                "value": "Brda",
                "label": "Brda",
                "shortCode": "007"
            },
            {
                "value": "Brezice",
                "label": "Brezice",
                "shortCode": "009"
            },
            {
                "value": "Brezovica",
                "label": "Brezovica",
                "shortCode": "008"
            },
            {
                "value": "Cankova",
                "label": "Cankova",
                "shortCode": "152"
            },
            {
                "value": "Celje",
                "label": "Celje",
                "shortCode": "011"
            },
            {
                "value": "Cerklje na Gorenjskem",
                "label": "Cerklje na Gorenjskem",
                "shortCode": "012"
            },
            {
                "value": "Cerknica",
                "label": "Cerknica",
                "shortCode": "013"
            },
            {
                "value": "Cerkno",
                "label": "Cerkno",
                "shortCode": "014"
            },
            {
                "value": "Cerkvenjak",
                "label": "Cerkvenjak",
                "shortCode": "153"
            },
            {
                "value": "Cirkulane",
                "label": "Cirkulane",
                "shortCode": "196"
            },
            {
                "value": "Crensovci",
                "label": "Crensovci",
                "shortCode": "015"
            },
            {
                "value": "Crna na Koroskem",
                "label": "Crna na Koroskem",
                "shortCode": "016"
            },
            {
                "value": "Crnomelj",
                "label": "Crnomelj",
                "shortCode": "017"
            },
            {
                "value": "Destrnik",
                "label": "Destrnik",
                "shortCode": "018"
            },
            {
                "value": "Divaca",
                "label": "Divaca",
                "shortCode": "019"
            },
            {
                "value": "Dobje",
                "label": "Dobje",
                "shortCode": "154"
            },
            {
                "value": "Dobrepolje",
                "label": "Dobrepolje",
                "shortCode": "020"
            },
            {
                "value": "Dobrna",
                "label": "Dobrna",
                "shortCode": "155"
            },
            {
                "value": "Dobrova-Polhov Gradec",
                "label": "Dobrova-Polhov Gradec",
                "shortCode": "021"
            },
            {
                "value": "Dobrovnik",
                "label": "Dobrovnik",
                "shortCode": "156"
            },
            {
                "value": "Dol pri Ljubljani",
                "label": "Dol pri Ljubljani",
                "shortCode": "022"
            },
            {
                "value": "Dolenjske Toplice",
                "label": "Dolenjske Toplice",
                "shortCode": "157"
            },
            {
                "value": "Domzale",
                "label": "Domzale",
                "shortCode": "023"
            },
            {
                "value": "Dornava",
                "label": "Dornava",
                "shortCode": "024"
            },
            {
                "value": "Dravograd",
                "label": "Dravograd",
                "shortCode": "025"
            },
            {
                "value": "Duplek",
                "label": "Duplek",
                "shortCode": "026"
            },
            {
                "value": "Gorenja Vas-Poljane",
                "label": "Gorenja Vas-Poljane",
                "shortCode": "027"
            },
            {
                "value": "Gorisnica",
                "label": "Gorisnica",
                "shortCode": "028"
            },
            {
                "value": "Gorje",
                "label": "Gorje",
                "shortCode": "207"
            },
            {
                "value": "Gornja Radgona",
                "label": "Gornja Radgona",
                "shortCode": "029"
            },
            {
                "value": "Gornji Grad",
                "label": "Gornji Grad",
                "shortCode": "030"
            },
            {
                "value": "Gornji Petrovci",
                "label": "Gornji Petrovci",
                "shortCode": "031"
            },
            {
                "value": "Grad",
                "label": "Grad",
                "shortCode": "158"
            },
            {
                "value": "Grosuplje",
                "label": "Grosuplje",
                "shortCode": "032"
            },
            {
                "value": "Hajdina",
                "label": "Hajdina",
                "shortCode": "159"
            },
            {
                "value": "Hoce-Slivnica",
                "label": "Hoce-Slivnica",
                "shortCode": "160"
            },
            {
                "value": "Hodos",
                "label": "Hodos",
                "shortCode": "161"
            },
            {
                "value": "Horjul",
                "label": "Horjul",
                "shortCode": "162"
            },
            {
                "value": "Hrastnik",
                "label": "Hrastnik",
                "shortCode": "034"
            },
            {
                "value": "Hrpelje-Kozina",
                "label": "Hrpelje-Kozina",
                "shortCode": "035"
            },
            {
                "value": "Idrija",
                "label": "Idrija",
                "shortCode": "036"
            },
            {
                "value": "Ig",
                "label": "Ig",
                "shortCode": "037"
            },
            {
                "value": "Ilirska Bistrica",
                "label": "Ilirska Bistrica",
                "shortCode": "038"
            },
            {
                "value": "Ivancna Gorica",
                "label": "Ivancna Gorica",
                "shortCode": "039"
            },
            {
                "value": "Izola",
                "label": "Izola",
                "shortCode": "040"
            },
            {
                "value": "Jesenice",
                "label": "Jesenice",
                "shortCode": "041"
            },
            {
                "value": "Jursinci",
                "label": "Jursinci",
                "shortCode": "042"
            },
            {
                "value": "Kamnik",
                "label": "Kamnik",
                "shortCode": "043"
            },
            {
                "value": "Kanal",
                "label": "Kanal",
                "shortCode": "044"
            },
            {
                "value": "Kidricevo",
                "label": "Kidricevo",
                "shortCode": "045"
            },
            {
                "value": "Kobarid",
                "label": "Kobarid",
                "shortCode": "046"
            },
            {
                "value": "Kobilje",
                "label": "Kobilje",
                "shortCode": "047"
            },
            {
                "value": "Kocevje",
                "label": "Kocevje",
                "shortCode": "048"
            },
            {
                "value": "Komen",
                "label": "Komen",
                "shortCode": "049"
            },
            {
                "value": "Komenda",
                "label": "Komenda",
                "shortCode": "164"
            },
            {
                "value": "Koper",
                "label": "Koper",
                "shortCode": "050"
            },
            {
                "value": "Kodanjevica na Krki",
                "label": "Kodanjevica na Krki",
                "shortCode": "197"
            },
            {
                "value": "Kostel",
                "label": "Kostel",
                "shortCode": "165"
            },
            {
                "value": "Kozje",
                "label": "Kozje",
                "shortCode": "051"
            },
            {
                "value": "Kranj",
                "label": "Kranj",
                "shortCode": "052"
            },
            {
                "value": "Kranjska Gora",
                "label": "Kranjska Gora",
                "shortCode": "053"
            },
            {
                "value": "Krizevci",
                "label": "Krizevci",
                "shortCode": "166"
            },
            {
                "value": "Krsko",
                "label": "Krsko",
                "shortCode": "054"
            },
            {
                "value": "Kungota",
                "label": "Kungota",
                "shortCode": "055"
            },
            {
                "value": "Kuzma",
                "label": "Kuzma",
                "shortCode": "056"
            },
            {
                "value": "Lasko",
                "label": "Lasko",
                "shortCode": "057"
            },
            {
                "value": "Lenart",
                "label": "Lenart",
                "shortCode": "058"
            },
            {
                "value": "Lendava",
                "label": "Lendava",
                "shortCode": "059"
            },
            {
                "value": "Litija",
                "label": "Litija",
                "shortCode": "060"
            },
            {
                "value": "Ljubljana",
                "label": "Ljubljana",
                "shortCode": "061"
            },
            {
                "value": "Ljubno",
                "label": "Ljubno",
                "shortCode": "062"
            },
            {
                "value": "Ljutomer",
                "label": "Ljutomer",
                "shortCode": "063"
            },
            {
                "value": "Log-Dragomer",
                "label": "Log-Dragomer",
                "shortCode": "208"
            },
            {
                "value": "Logatec",
                "label": "Logatec",
                "shortCode": "064"
            },
            {
                "value": "Loska Dolina",
                "label": "Loska Dolina",
                "shortCode": "065"
            },
            {
                "value": "Loski Potok",
                "label": "Loski Potok",
                "shortCode": "066"
            },
            {
                "value": "Lovrenc na Pohorju",
                "label": "Lovrenc na Pohorju",
                "shortCode": "167"
            },
            {
                "value": "Lukovica",
                "label": "Lukovica",
                "shortCode": "068"
            },
            {
                "value": "Luce",
                "label": "Luce",
                "shortCode": "067"
            },
            {
                "value": "Majsperk",
                "label": "Majsperk",
                "shortCode": "069"
            },
            {
                "value": "Makole",
                "label": "Makole",
                "shortCode": "198"
            },
            {
                "value": "Maribor",
                "label": "Maribor",
                "shortCode": "070"
            },
            {
                "value": "Markovci",
                "label": "Markovci",
                "shortCode": "168"
            },
            {
                "value": "Medvode",
                "label": "Medvode",
                "shortCode": "071"
            },
            {
                "value": "Menges",
                "label": "Menges",
                "shortCode": "072"
            },
            {
                "value": "Metlika",
                "label": "Metlika",
                "shortCode": "073"
            },
            {
                "value": "Mezica",
                "label": "Mezica",
                "shortCode": "074"
            },
            {
                "value": "Miklavz na Dravskem Polju",
                "label": "Miklavz na Dravskem Polju",
                "shortCode": "169"
            },
            {
                "value": "Miren-Kostanjevica",
                "label": "Miren-Kostanjevica",
                "shortCode": "075"
            },
            {
                "value": "Mirna",
                "label": "Mirna",
                "shortCode": "212"
            },
            {
                "value": "Mirna Pec",
                "label": "Mirna Pec",
                "shortCode": "170"
            },
            {
                "value": "Mislinja",
                "label": "Mislinja",
                "shortCode": "076"
            },
            {
                "value": "Mokronog-Trebelno",
                "label": "Mokronog-Trebelno",
                "shortCode": "199"
            },
            {
                "value": "Moravce",
                "label": "Moravce",
                "shortCode": "077"
            },
            {
                "value": "Moravske Toplice",
                "label": "Moravske Toplice",
                "shortCode": "078"
            },
            {
                "value": "Mozirje",
                "label": "Mozirje",
                "shortCode": "079"
            },
            {
                "value": "Murska Sobota",
                "label": "Murska Sobota",
                "shortCode": "080"
            },
            {
                "value": "Naklo",
                "label": "Naklo",
                "shortCode": "082"
            },
            {
                "value": "Nazarje",
                "label": "Nazarje",
                "shortCode": "083"
            },
            {
                "value": "Nova Gorica",
                "label": "Nova Gorica",
                "shortCode": "084"
            },
            {
                "value": "Novo Mesto",
                "label": "Novo Mesto",
                "shortCode": "085"
            },
            {
                "value": "Odranci",
                "label": "Odranci",
                "shortCode": "086"
            },
            {
                "value": "Ormoz",
                "label": "Ormoz",
                "shortCode": "087"
            },
            {
                "value": "Osilnica",
                "label": "Osilnica",
                "shortCode": "088"
            },
            {
                "value": "Pesnica",
                "label": "Pesnica",
                "shortCode": "089"
            },
            {
                "value": "Piran",
                "label": "Piran",
                "shortCode": "090"
            },
            {
                "value": "Pivka",
                "label": "Pivka",
                "shortCode": "091"
            },
            {
                "value": "Podcetrtek",
                "label": "Podcetrtek",
                "shortCode": "092"
            },
            {
                "value": "Podlehnik",
                "label": "Podlehnik",
                "shortCode": "172"
            },
            {
                "value": "Podvelka",
                "label": "Podvelka",
                "shortCode": "093"
            },
            {
                "value": "Poljcane",
                "label": "Poljcane",
                "shortCode": "200"
            },
            {
                "value": "Postojna",
                "label": "Postojna",
                "shortCode": "094"
            },
            {
                "value": "Prebold",
                "label": "Prebold",
                "shortCode": "174"
            },
            {
                "value": "Preddvor",
                "label": "Preddvor",
                "shortCode": "095"
            },
            {
                "value": "Prevalje",
                "label": "Prevalje",
                "shortCode": "175"
            },
            {
                "value": "Ptuj",
                "label": "Ptuj",
                "shortCode": "096"
            },
            {
                "value": "Race-Fram",
                "label": "Race-Fram",
                "shortCode": "098"
            },
            {
                "value": "Radece",
                "label": "Radece",
                "shortCode": "099"
            },
            {
                "value": "Radenci",
                "label": "Radenci",
                "shortCode": "100"
            },
            {
                "value": "Radlje ob Dravi",
                "label": "Radlje ob Dravi",
                "shortCode": "101"
            },
            {
                "value": "Radovljica",
                "label": "Radovljica",
                "shortCode": "102"
            },
            {
                "value": "Ravne na Koroskem",
                "label": "Ravne na Koroskem",
                "shortCode": "103"
            },
            {
                "value": "Razkrizje",
                "label": "Razkrizje",
                "shortCode": "176"
            },
            {
                "value": "Recica ob Savinji",
                "label": "Recica ob Savinji",
                "shortCode": "209"
            },
            {
                "value": "Rence-Vogrsko",
                "label": "Rence-Vogrsko",
                "shortCode": "201"
            },
            {
                "value": "Ribnica",
                "label": "Ribnica",
                "shortCode": "104"
            },
            {
                "value": "Ribnica na Poboriu",
                "label": "Ribnica na Poboriu",
                "shortCode": "177"
            },
            {
                "value": "Rogaska Slatina",
                "label": "Rogaska Slatina",
                "shortCode": "106"
            },
            {
                "value": "Rogasovci",
                "label": "Rogasovci",
                "shortCode": "105"
            },
            {
                "value": "Rogatec",
                "label": "Rogatec",
                "shortCode": "107"
            },
            {
                "value": "Ruse",
                "label": "Ruse",
                "shortCode": "108"
            },
            {
                "value": "Salovci",
                "label": "Salovci",
                "shortCode": "033"
            },
            {
                "value": "Selnica ob Dravi",
                "label": "Selnica ob Dravi",
                "shortCode": "178"
            },
            {
                "value": "Semic",
                "label": "Semic",
                "shortCode": "109"
            },
            {
                "value": "Sempeter-Vrtojba",
                "label": "Sempeter-Vrtojba",
                "shortCode": "183"
            },
            {
                "value": "Sencur",
                "label": "Sencur",
                "shortCode": "117"
            },
            {
                "value": "Sentilj",
                "label": "Sentilj",
                "shortCode": "118"
            },
            {
                "value": "Sentjernej",
                "label": "Sentjernej",
                "shortCode": "119"
            },
            {
                "value": "Sentjur",
                "label": "Sentjur",
                "shortCode": "120"
            },
            {
                "value": "Sentrupert",
                "label": "Sentrupert",
                "shortCode": "211"
            },
            {
                "value": "Sevnica",
                "label": "Sevnica",
                "shortCode": "110"
            },
            {
                "value": "Sezana",
                "label": "Sezana",
                "shortCode": "111"
            },
            {
                "value": "Skocjan",
                "label": "Skocjan",
                "shortCode": "121"
            },
            {
                "value": "Skofja Loka",
                "label": "Skofja Loka",
                "shortCode": "122"
            },
            {
                "value": "Skofljica",
                "label": "Skofljica",
                "shortCode": "123"
            },
            {
                "value": "Slovenj Gradec",
                "label": "Slovenj Gradec",
                "shortCode": "112"
            },
            {
                "value": "Slovenska Bistrica",
                "label": "Slovenska Bistrica",
                "shortCode": "113"
            },
            {
                "value": "Slovenske Konjice",
                "label": "Slovenske Konjice",
                "shortCode": "114"
            },
            {
                "value": "Smarje pri elsah",
                "label": "Smarje pri elsah",
                "shortCode": "124"
            },
            {
                "value": "Smarjeske Toplice",
                "label": "Smarjeske Toplice",
                "shortCode": "206"
            },
            {
                "value": "Smartno ob Paki",
                "label": "Smartno ob Paki",
                "shortCode": "125"
            },
            {
                "value": "Smartno pri Litiji",
                "label": "Smartno pri Litiji",
                "shortCode": "194"
            },
            {
                "value": "Sodrazica",
                "label": "Sodrazica",
                "shortCode": "179"
            },
            {
                "value": "Solcava",
                "label": "Solcava",
                "shortCode": "180"
            },
            {
                "value": "Sostanj",
                "label": "Sostanj",
                "shortCode": "126"
            },
            {
                "value": "Sredisce ob Dravi",
                "label": "Sredisce ob Dravi",
                "shortCode": "202"
            },
            {
                "value": "Starse",
                "label": "Starse",
                "shortCode": "115"
            },
            {
                "value": "Store",
                "label": "Store",
                "shortCode": "127"
            },
            {
                "value": "Straza",
                "label": "Straza",
                "shortCode": "203"
            },
            {
                "value": "Sveta Ana",
                "label": "Sveta Ana",
                "shortCode": "181"
            },
            {
                "value": "Sveta Trojica v Slovenskih Goricah",
                "label": "Sveta Trojica v Slovenskih Goricah",
                "shortCode": "204"
            },
            {
                "value": "Sveta Andraz v Slovenskih Goricah",
                "label": "Sveta Andraz v Slovenskih Goricah",
                "shortCode": "182"
            },
            {
                "value": "Sveti Jurij",
                "label": "Sveti Jurij",
                "shortCode": "116"
            },
            {
                "value": "Sveti Jurij v Slovenskih Goricah",
                "label": "Sveti Jurij v Slovenskih Goricah",
                "shortCode": "210"
            },
            {
                "value": "Sveti Tomaz",
                "label": "Sveti Tomaz",
                "shortCode": "205"
            },
            {
                "value": "Tabor",
                "label": "Tabor",
                "shortCode": "184"
            },
            {
                "value": "Tisina",
                "label": "Tisina",
                "shortCode": "010"
            },
            {
                "value": "Tolmin",
                "label": "Tolmin",
                "shortCode": "128"
            },
            {
                "value": "Trbovlje",
                "label": "Trbovlje",
                "shortCode": "129"
            },
            {
                "value": "Trebnje",
                "label": "Trebnje",
                "shortCode": "130"
            },
            {
                "value": "Trnovska Vas",
                "label": "Trnovska Vas",
                "shortCode": "185"
            },
            {
                "value": "Trzin",
                "label": "Trzin",
                "shortCode": "186"
            },
            {
                "value": "Trzic",
                "label": "Trzic",
                "shortCode": "131"
            },
            {
                "value": "Turnisce",
                "label": "Turnisce",
                "shortCode": "132"
            },
            {
                "value": "Velenje",
                "label": "Velenje",
                "shortCode": "133"
            },
            {
                "value": "Velika Polana",
                "label": "Velika Polana",
                "shortCode": "187"
            },
            {
                "value": "Velike Lasce",
                "label": "Velike Lasce",
                "shortCode": "134"
            },
            {
                "value": "Verzej",
                "label": "Verzej",
                "shortCode": "188"
            },
            {
                "value": "Videm",
                "label": "Videm",
                "shortCode": "135"
            },
            {
                "value": "Vipava",
                "label": "Vipava",
                "shortCode": "136"
            },
            {
                "value": "Vitanje",
                "label": "Vitanje",
                "shortCode": "137"
            },
            {
                "value": "Vodice",
                "label": "Vodice",
                "shortCode": "138"
            },
            {
                "value": "Vojnik",
                "label": "Vojnik",
                "shortCode": "139"
            },
            {
                "value": "Vransko",
                "label": "Vransko",
                "shortCode": "189"
            },
            {
                "value": "Vrhnika",
                "label": "Vrhnika",
                "shortCode": "140"
            },
            {
                "value": "Vuzenica",
                "label": "Vuzenica",
                "shortCode": "141"
            },
            {
                "value": "Zagorje ob Savi",
                "label": "Zagorje ob Savi",
                "shortCode": "142"
            },
            {
                "value": "Zavrc",
                "label": "Zavrc",
                "shortCode": "143"
            },
            {
                "value": "Zrece",
                "label": "Zrece",
                "shortCode": "144"
            },
            {
                "value": "Zalec",
                "label": "Zalec",
                "shortCode": "190"
            },
            {
                "value": "Zelezniki",
                "label": "Zelezniki",
                "shortCode": "146"
            },
            {
                "value": "Zetale",
                "label": "Zetale",
                "shortCode": "191"
            },
            {
                "value": "Ziri",
                "label": "Ziri",
                "shortCode": "147"
            },
            {
                "value": "Zirovnica",
                "label": "Zirovnica",
                "shortCode": "192"
            },
            {
                "value": "Zuzemberk",
                "label": "Zuzemberk",
                "shortCode": "193"
            }
        ]
    },
    {
        "countryCode": "+677",
        "value": "Solomon Islands",
        "label": "Solomon Islands",
        "regions": [
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "CE"
            },
            {
                "value": "Choiseul",
                "label": "Choiseul",
                "shortCode": "CH"
            },
            {
                "value": "Guadalcanal",
                "label": "Guadalcanal",
                "shortCode": "GU"
            },
            {
                "value": "Honiara",
                "label": "Honiara",
                "shortCode": "CT"
            },
            {
                "value": "Isabel",
                "label": "Isabel",
                "shortCode": "IS"
            },
            {
                "value": "Makira-Ulawa",
                "label": "Makira-Ulawa",
                "shortCode": "MK"
            },
            {
                "value": "Malaita",
                "label": "Malaita",
                "shortCode": "ML"
            },
            {
                "value": "Rennell and Bellona",
                "label": "Rennell and Bellona",
                "shortCode": "RB"
            },
            {
                "value": "Temotu",
                "label": "Temotu",
                "shortCode": "TE"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "WE"
            }
        ]
    },
    {
        "countryCode": "+252",
        "value": "Somalia",
        "label": "Somalia",
        "regions": [
            {
                "value": "Awdal",
                "label": "Awdal",
                "shortCode": "AW"
            },
            {
                "value": "Bakool",
                "label": "Bakool",
                "shortCode": "BK"
            },
            {
                "value": "Banaadir",
                "label": "Banaadir",
                "shortCode": "BN"
            },
            {
                "value": "Bari",
                "label": "Bari",
                "shortCode": "BR"
            },
            {
                "value": "Bay",
                "label": "Bay",
                "shortCode": "BY"
            },
            {
                "value": "Galguduud",
                "label": "Galguduud",
                "shortCode": "GA"
            },
            {
                "value": "Gedo",
                "label": "Gedo",
                "shortCode": "GE"
            },
            {
                "value": "Hiiraan",
                "label": "Hiiraan",
                "shortCode": "HI"
            },
            {
                "value": "Jubbada Dhexe",
                "label": "Jubbada Dhexe",
                "shortCode": "JD"
            },
            {
                "value": "Jubbada Hoose",
                "label": "Jubbada Hoose",
                "shortCode": "JH"
            },
            {
                "value": "Mudug",
                "label": "Mudug",
                "shortCode": "MU"
            },
            {
                "value": "Nugaal",
                "label": "Nugaal",
                "shortCode": "NU"
            },
            {
                "value": "Sanaag",
                "label": "Sanaag",
                "shortCode": "SA"
            },
            {
                "value": "Shabeellaha Dhexe",
                "label": "Shabeellaha Dhexe",
                "shortCode": "SD"
            },
            {
                "value": "Shabeellaha Hoose",
                "label": "Shabeellaha Hoose",
                "shortCode": "SH"
            },
            {
                "value": "Sool",
                "label": "Sool",
                "shortCode": "SO"
            },
            {
                "value": "Togdheer",
                "label": "Togdheer",
                "shortCode": "TO"
            },
            {
                "value": "Woqooyi Galbeed",
                "label": "Woqooyi Galbeed",
                "shortCode": "WO"
            }
        ]
    },
    {
        "countryCode": "+27",
        "value": "South Africa",
        "label": "South Africa",
        "regions": [
            {
                "value": "Eastern Cape",
                "label": "Eastern Cape",
                "shortCode": "EC"
            },
            {
                "value": "Free State",
                "label": "Free State",
                "shortCode": "FS"
            },
            {
                "value": "Gauteng",
                "label": "Gauteng",
                "shortCode": "GT"
            },
            {
                "value": "KwaZulu-Natal",
                "label": "KwaZulu-Natal",
                "shortCode": "NL"
            },
            {
                "value": "Limpopo",
                "label": "Limpopo",
                "shortCode": "LP"
            },
            {
                "value": "Mpumalanga",
                "label": "Mpumalanga",
                "shortCode": "MP"
            },
            {
                "value": "Northern Cape",
                "label": "Northern Cape",
                "shortCode": "NC"
            },
            {
                "value": "North West",
                "label": "North West",
                "shortCode": "NW"
            },
            {
                "value": "Western Cape",
                "label": "Western Cape",
                "shortCode": "WC"
            }
        ]
    },
    {
        "countryCode": "+211",
        "value": "South Sudan",
        "label": "South Sudan",
        "regions": [
            {
                "value": "Central Equatoria",
                "label": "Central Equatoria",
                "shortCode": "CE"
            },
            {
                "value": "Eastern Equatoria",
                "label": "Eastern Equatoria",
                "shortCode": "EE"
            },
            {
                "value": "Jonglei",
                "label": "Jonglei",
                "shortCode": "JG"
            },
            {
                "value": "Lakes",
                "label": "Lakes",
                "shortCode": "LK"
            },
            {
                "value": "Northern Bahr el Ghazal",
                "label": "Northern Bahr el Ghazal",
                "shortCode": "BN"
            },
            {
                "value": "Unity",
                "label": "Unity",
                "shortCode": "UY"
            },
            {
                "value": "Upper Nile",
                "label": "Upper Nile",
                "shortCode": "NU"
            },
            {
                "value": "Warrap",
                "label": "Warrap",
                "shortCode": "WR"
            },
            {
                "value": "Western Bahr el Ghazal",
                "label": "Western Bahr el Ghazal",
                "shortCode": "BW"
            },
            {
                "value": "Western Equatoria",
                "label": "Western Equatoria",
                "shortCode": "EW"
            }
        ]
    },
    {
        "countryCode": "+34",
        "value": "Spain",
        "label": "Spain",
        "regions": [
            {
                "value": "Albacete",
                "label": "Albacete",
                "shortCode": "AB"
            },
            {
                "value": "Alicante",
                "label": "Alicante",
                "shortCode": "A"
            },
            {
                "value": "Almería",
                "label": "Almería",
                "shortCode": "AL"
            },
            {
                "value": "Araba/Álava",
                "label": "Araba/Álava",
                "shortCode": "VI"
            },
            {
                "value": "Asturias",
                "label": "Asturias",
                "shortCode": "O"
            },
            {
                "value": "Ávila",
                "label": "Ávila",
                "shortCode": "AV"
            },
            {
                "value": "Badajoz",
                "label": "Badajoz",
                "shortCode": "BA"
            },
            {
                "value": "Barcelona",
                "label": "Barcelona",
                "shortCode": "B"
            },
            {
                "value": "Bizkaia",
                "label": "Bizkaia",
                "shortCode": "BI"
            },
            {
                "value": "Burgos",
                "label": "Burgos",
                "shortCode": "BU"
            },
            {
                "value": "Cáceres",
                "label": "Cáceres",
                "shortCode": "CC"
            },
            {
                "value": "Cádiz",
                "label": "Cádiz",
                "shortCode": "CA"
            },
            {
                "value": "Cantabria",
                "label": "Cantabria",
                "shortCode": "S"
            },
            {
                "value": "Castellón/Castelló",
                "label": "Castellón/Castelló",
                "shortCode": "CS"
            },
            {
                "value": "Ceuta",
                "label": "Ceuta",
                "shortCode": "CE"
            },
            {
                "value": "Ciudad Real",
                "label": "Ciudad Real",
                "shortCode": "CR"
            },
            {
                "value": "Córdoba",
                "label": "Córdoba",
                "shortCode": "CO"
            },
            {
                "value": "A Coruña",
                "label": "A Coruña",
                "shortCode": "C"
            },
            {
                "value": "Cuenca",
                "label": "Cuenca",
                "shortCode": "CU"
            },
            {
                "value": "Gipuzkoa",
                "label": "Gipuzkoa",
                "shortCode": "SS"
            },
            {
                "value": "Girona",
                "label": "Girona",
                "shortCode": "GI"
            },
            {
                "value": "Granada",
                "label": "Granada",
                "shortCode": "GR"
            },
            {
                "value": "Guadalajara",
                "label": "Guadalajara",
                "shortCode": "GU"
            },
            {
                "value": "Huelva",
                "label": "Huelva",
                "shortCode": "H"
            },
            {
                "value": "Huesca",
                "label": "Huesca",
                "shortCode": "HU"
            },
            {
                "value": "Illes Balears",
                "label": "Illes Balears",
                "shortCode": "PM"
            },
            {
                "value": "Jaén",
                "label": "Jaén",
                "shortCode": "J"
            },
            {
                "value": "León",
                "label": "León",
                "shortCode": "LE"
            },
            {
                "value": "Lleida",
                "label": "Lleida",
                "shortCode": "L"
            },
            {
                "value": "Lugo",
                "label": "Lugo",
                "shortCode": "LU"
            },
            {
                "value": "Madrid",
                "label": "Madrid",
                "shortCode": "M"
            },
            {
                "value": "Málaga",
                "label": "Málaga",
                "shortCode": "MA"
            },
            {
                "value": "Melilla",
                "label": "Melilla",
                "shortCode": "ML"
            },
            {
                "value": "Murcia",
                "label": "Murcia",
                "shortCode": "MU"
            },
            {
                "value": "Navarra/Nafarroa",
                "label": "Navarra/Nafarroa",
                "shortCode": "NA"
            },
            {
                "value": "Ourense",
                "label": "Ourense",
                "shortCode": "OR"
            },
            {
                "value": "Palencia",
                "label": "Palencia",
                "shortCode": "P"
            },
            {
                "value": "Las Palmas",
                "label": "Las Palmas",
                "shortCode": "GC"
            },
            {
                "value": "Pontevedra",
                "label": "Pontevedra",
                "shortCode": "PO"
            },
            {
                "value": "La Rioja",
                "label": "La Rioja",
                "shortCode": "LO"
            },
            {
                "value": "Salamanca",
                "label": "Salamanca",
                "shortCode": "SA"
            },
            {
                "value": "Santa Cruz de Tenerife",
                "label": "Santa Cruz de Tenerife",
                "shortCode": "TF"
            },
            {
                "value": "Segovia",
                "label": "Segovia",
                "shortCode": "SG"
            },
            {
                "value": "Sevilla",
                "label": "Sevilla",
                "shortCode": "SE"
            },
            {
                "value": "Soria",
                "label": "Soria",
                "shortCode": "SO"
            },
            {
                "value": "Tarragona",
                "label": "Tarragona",
                "shortCode": "T"
            },
            {
                "value": "Teruel",
                "label": "Teruel",
                "shortCode": "TE"
            },
            {
                "value": "Toledo",
                "label": "Toledo",
                "shortCode": "TO"
            },
            {
                "value": "Valencia/València",
                "label": "Valencia/València",
                "shortCode": "V"
            },
            {
                "value": "Valladolid",
                "label": "Valladolid",
                "shortCode": "VA"
            },
            {
                "value": "Zamora",
                "label": "Zamora",
                "shortCode": "ZA"
            },
            {
                "value": "Zaragoza",
                "label": "Zaragoza",
                "shortCode": "Z"
            }
        ]
    },
    {
        "countryCode": "+94",
        "value": "Sri Lanka",
        "label": "Sri Lanka",
        "regions": [
            {
                "value": "Basnahira",
                "label": "Basnahira",
                "shortCode": "1"
            },
            {
                "value": "Dakunu",
                "label": "Dakunu",
                "shortCode": "3"
            },
            {
                "value": "Madhyama",
                "label": "Madhyama",
                "shortCode": "2"
            },
            {
                "value": "Naegenahira",
                "label": "Naegenahira",
                "shortCode": "5"
            },
            {
                "value": "Sabaragamuwa",
                "label": "Sabaragamuwa",
                "shortCode": "9"
            },
            {
                "value": "Uturu",
                "label": "Uturu",
                "shortCode": "4"
            },
            {
                "value": "Uturumaeda",
                "label": "Uturumaeda",
                "shortCode": "7"
            },
            {
                "value": "Vayamba",
                "label": "Vayamba",
                "shortCode": "6"
            },
            {
                "value": "Uva",
                "label": "Uva",
                "shortCode": "8"
            }
        ]
    },
    {
        "countryCode": "+249",
        "value": "Sudan",
        "label": "Sudan",
        "regions": [
            {
                "value": "Al Bahr al Ahmar",
                "label": "Al Bahr al Ahmar",
                "shortCode": "RS"
            },
            {
                "value": "Al Jazirah",
                "label": "Al Jazirah",
                "shortCode": "GZ"
            },
            {
                "value": "Al Khartum",
                "label": "Al Khartum",
                "shortCode": "KH"
            },
            {
                "value": "Al Qadarif",
                "label": "Al Qadarif",
                "shortCode": "GD"
            },
            {
                "value": "An Nil al Abyad",
                "label": "An Nil al Abyad",
                "shortCode": "NW"
            },
            {
                "value": "An Nil al Azraq",
                "label": "An Nil al Azraq",
                "shortCode": "NB"
            },
            {
                "value": "Ash Shamaliyah",
                "label": "Ash Shamaliyah",
                "shortCode": "NO"
            },
            {
                "value": "Gharb Darfur",
                "label": "Gharb Darfur",
                "shortCode": "DW"
            },
            {
                "value": "Gharb Kurdufan",
                "label": "Gharb Kurdufan",
                "shortCode": "GK"
            },
            {
                "value": "Janub Darfur",
                "label": "Janub Darfur",
                "shortCode": "DS"
            },
            {
                "value": "Janub Kurdufan",
                "label": "Janub Kurdufan",
                "shortCode": "KS"
            },
            {
                "value": "Kassala",
                "label": "Kassala",
                "shortCode": "KA"
            },
            {
                "value": "Nahr an Nil",
                "label": "Nahr an Nil",
                "shortCode": "NR"
            },
            {
                "value": "Shamal Darfur",
                "label": "Shamal Darfur",
                "shortCode": "DN"
            },
            {
                "value": "Sharq Darfur",
                "label": "Sharq Darfur",
                "shortCode": "DE"
            },
            {
                "value": "Shiamal Kurdufan",
                "label": "Shiamal Kurdufan",
                "shortCode": "KN"
            },
            {
                "value": "Sinnar",
                "label": "Sinnar",
                "shortCode": "SI"
            },
            {
                "value": "Wasat Darfur Zalinjay",
                "label": "Wasat Darfur Zalinjay",
                "shortCode": "DC"
            }
        ]
    },
    {
        "countryCode": "+597",
        "value": "Suriname",
        "label": "Suriname",
        "regions": [
            {
                "value": "Brokopondo",
                "label": "Brokopondo",
                "shortCode": "BR"
            },
            {
                "value": "Commewijne",
                "label": "Commewijne",
                "shortCode": "CM"
            },
            {
                "value": "Coronie",
                "label": "Coronie",
                "shortCode": "CR"
            },
            {
                "value": "Marowijne",
                "label": "Marowijne",
                "shortCode": "MA"
            },
            {
                "value": "Nickerie",
                "label": "Nickerie",
                "shortCode": "NI"
            },
            {
                "value": "Para",
                "label": "Para",
                "shortCode": "PR"
            },
            {
                "value": "Paramaribo",
                "label": "Paramaribo",
                "shortCode": "PM"
            },
            {
                "value": "Saramacca",
                "label": "Saramacca",
                "shortCode": "SA"
            },
            {
                "value": "Sipaliwini",
                "label": "Sipaliwini",
                "shortCode": "SI"
            },
            {
                "value": "Wanica",
                "label": "Wanica",
                "shortCode": "WA"
            }
        ]
    },
    {
        "countryCode": "+46",
        "value": "Sweden",
        "label": "Sweden",
        "regions": [
            {
                "value": "Blekinge",
                "label": "Blekinge",
                "shortCode": "K"
            },
            {
                "value": "Dalarna",
                "label": "Dalarna",
                "shortCode": "W"
            },
            {
                "value": "Gävleborg",
                "label": "Gävleborg",
                "shortCode": "X"
            },
            {
                "value": "Gotland",
                "label": "Gotland",
                "shortCode": "I"
            },
            {
                "value": "Halland",
                "label": "Halland",
                "shortCode": "N"
            },
            {
                "value": "Jämtland",
                "label": "Jämtland",
                "shortCode": "Z"
            },
            {
                "value": "Jönköping",
                "label": "Jönköping",
                "shortCode": "F"
            },
            {
                "value": "Kalmar",
                "label": "Kalmar",
                "shortCode": "H"
            },
            {
                "value": "Kronoberg",
                "label": "Kronoberg",
                "shortCode": "G"
            },
            {
                "value": "Norrbotten",
                "label": "Norrbotten",
                "shortCode": "BD"
            },
            {
                "value": "Örebro",
                "label": "Örebro",
                "shortCode": "T"
            },
            {
                "value": "Östergötland",
                "label": "Östergötland",
                "shortCode": "E"
            },
            {
                "value": "Skåne",
                "label": "Skåne",
                "shortCode": "M"
            },
            {
                "value": "Södermanland",
                "label": "Södermanland",
                "shortCode": "D"
            },
            {
                "value": "Stockholm",
                "label": "Stockholm",
                "shortCode": "AB"
            },
            {
                "value": "Uppsala",
                "label": "Uppsala",
                "shortCode": "C"
            },
            {
                "value": "Värmland",
                "label": "Värmland",
                "shortCode": "S"
            },
            {
                "value": "Västerbotten",
                "label": "Västerbotten",
                "shortCode": "AC"
            },
            {
                "value": "Västernorrland",
                "label": "Västernorrland",
                "shortCode": "Y"
            },
            {
                "value": "Västmanland",
                "label": "Västmanland",
                "shortCode": "U"
            },
            {
                "value": "Västra Götaland",
                "label": "Västra Götaland",
                "shortCode": "O"
            }
        ]
    },
    {
        "countryCode": "+41",
        "value": "Switzerland",
        "label": "Switzerland",
        "regions": [
            {
                "value": "Aargau",
                "label": "Aargau",
                "shortCode": "AG"
            },
            {
                "value": "Appenzell Ausserrhoden",
                "label": "Appenzell Ausserrhoden",
                "shortCode": "AR"
            },
            {
                "value": "Appenzell Innerhoden",
                "label": "Appenzell Innerhoden",
                "shortCode": "AI"
            },
            {
                "value": "Basel-Landschaft",
                "label": "Basel-Landschaft",
                "shortCode": "BL"
            },
            {
                "value": "Basel-Stadt",
                "label": "Basel-Stadt",
                "shortCode": "BS"
            },
            {
                "value": "Bern",
                "label": "Bern",
                "shortCode": "BE"
            },
            {
                "value": "Fribourg",
                "label": "Fribourg",
                "shortCode": "FR"
            },
            {
                "value": "Genève",
                "label": "Genève",
                "shortCode": "GE"
            },
            {
                "value": "Glarus",
                "label": "Glarus",
                "shortCode": "GL"
            },
            {
                "value": "Graubünden",
                "label": "Graubünden",
                "shortCode": "GR"
            },
            {
                "value": "Jura",
                "label": "Jura",
                "shortCode": "JU"
            },
            {
                "value": "Luzern",
                "label": "Luzern",
                "shortCode": "LU"
            },
            {
                "value": "Neuchâtel",
                "label": "Neuchâtel",
                "shortCode": "NE"
            },
            {
                "value": "Nidwalden",
                "label": "Nidwalden",
                "shortCode": "NW"
            },
            {
                "value": "Obwalden",
                "label": "Obwalden",
                "shortCode": "OW"
            },
            {
                "value": "Sankt Gallen",
                "label": "Sankt Gallen",
                "shortCode": "SG"
            },
            {
                "value": "Schaffhausen",
                "label": "Schaffhausen",
                "shortCode": "SH"
            },
            {
                "value": "Schwyz",
                "label": "Schwyz",
                "shortCode": "SZ"
            },
            {
                "value": "Solothurn",
                "label": "Solothurn",
                "shortCode": "SO"
            },
            {
                "value": "Thurgau",
                "label": "Thurgau",
                "shortCode": "TG"
            },
            {
                "value": "Ticino",
                "label": "Ticino",
                "shortCode": "TI"
            },
            {
                "value": "Uri",
                "label": "Uri",
                "shortCode": "UR"
            },
            {
                "value": "Valais",
                "label": "Valais",
                "shortCode": "VS"
            },
            {
                "value": "Vaud",
                "label": "Vaud",
                "shortCode": "VD"
            },
            {
                "value": "Zug",
                "label": "Zug",
                "shortCode": "ZG"
            },
            {
                "value": "Zürich",
                "label": "Zürich",
                "shortCode": "ZH"
            }
        ]
    },
    {
        "countryCode": "+886",
        "value": "Taiwan",
        "label": "Taiwan",
        "regions": [
            {
                "value": "Changhua",
                "label": "Changhua",
                "shortCode": "CHA"
            },
            {
                "value": "Chiayi",
                "label": "Chiayi",
                "shortCode": "CYQ"
            },
            {
                "value": "Hsinchu",
                "label": "Hsinchu",
                "shortCode": "HSQ"
            },
            {
                "value": "Hualien",
                "label": "Hualien",
                "shortCode": "HUA"
            },
            {
                "value": "Kaohsiung",
                "label": "Kaohsiung",
                "shortCode": "KHH"
            },
            {
                "value": "Keelung",
                "label": "Keelung",
                "shortCode": "KEE"
            },
            {
                "value": "Kinmen",
                "label": "Kinmen",
                "shortCode": "KIN"
            },
            {
                "value": "Lienchiang",
                "label": "Lienchiang",
                "shortCode": "LIE"
            },
            {
                "value": "Miaoli",
                "label": "Miaoli",
                "shortCode": "MIA"
            },
            {
                "value": "Nantou",
                "label": "Nantou",
                "shortCode": "NAN"
            },
            {
                "value": "Penghu",
                "label": "Penghu",
                "shortCode": "PEN"
            },
            {
                "value": "New Taipei",
                "label": "New Taipei",
                "shortCode": "NWT"
            },
            {
                "value": "Pingtung",
                "label": "Pingtung",
                "shortCode": "PIF"
            },
            {
                "value": "Taichung",
                "label": "Taichung",
                "shortCode": "TXG"
            },
            {
                "value": "Tainan",
                "label": "Tainan",
                "shortCode": "TNN"
            },
            {
                "value": "Taipei",
                "label": "Taipei",
                "shortCode": "TPE"
            },
            {
                "value": "Taitung",
                "label": "Taitung",
                "shortCode": "TTT"
            },
            {
                "value": "Taoyuan",
                "label": "Taoyuan",
                "shortCode": "TAO"
            },
            {
                "value": "Yilan",
                "label": "Yilan",
                "shortCode": "ILA"
            },
            {
                "value": "Yunlin",
                "label": "Yunlin",
                "shortCode": "YUN"
            }
        ]
    },
    {
        "countryCode": "+992",
        "value": "Tajikistan",
        "label": "Tajikistan",
        "regions": [
            {
                "value": "Dushanbe",
                "label": "Dushanbe",
                "shortCode": "DU"
            },
            {
                "value": "Kŭhistoni Badakhshon",
                "label": "Kŭhistoni Badakhshon",
                "shortCode": "GB"
            },
            {
                "value": "Khatlon",
                "label": "Khatlon",
                "shortCode": "KT"
            },
            {
                "value": "Sughd",
                "label": "Sughd",
                "shortCode": "SU"
            }
        ]
    },
    {
        "countryCode": "+66",
        "value": "Thailand",
        "label": "Thailand",
        "regions": [
            {
                "value": "Amnat Charoen",
                "label": "Amnat Charoen",
                "shortCode": "37"
            },
            {
                "value": "Ang Thong",
                "label": "Ang Thong",
                "shortCode": "15"
            },
            {
                "value": "Bueng Kan",
                "label": "Bueng Kan",
                "shortCode": "38"
            },
            {
                "value": "Buri Ram",
                "label": "Buri Ram",
                "shortCode": "31"
            },
            {
                "value": "Chachoengsao",
                "label": "Chachoengsao",
                "shortCode": "24"
            },
            {
                "value": "Chai Nat",
                "label": "Chai Nat",
                "shortCode": "18"
            },
            {
                "value": "Chaiyaphum",
                "label": "Chaiyaphum",
                "shortCode": "36"
            },
            {
                "value": "Chanthaburi",
                "label": "Chanthaburi",
                "shortCode": "22"
            },
            {
                "value": "Chiang Mai",
                "label": "Chiang Mai",
                "shortCode": "50"
            },
            {
                "value": "Chiang Rai",
                "label": "Chiang Rai",
                "shortCode": "57"
            },
            {
                "value": "Chon Buri",
                "label": "Chon Buri",
                "shortCode": "20"
            },
            {
                "value": "Chumphon",
                "label": "Chumphon",
                "shortCode": "86"
            },
            {
                "value": "Kalasin",
                "label": "Kalasin",
                "shortCode": "46"
            },
            {
                "value": "Kamphaeng Phet",
                "label": "Kamphaeng Phet",
                "shortCode": "62"
            },
            {
                "value": "Kanchanaburi",
                "label": "Kanchanaburi",
                "shortCode": "71"
            },
            {
                "value": "Khon Kaen",
                "label": "Khon Kaen",
                "shortCode": "40"
            },
            {
                "value": "Krabi",
                "label": "Krabi",
                "shortCode": "81"
            },
            {
                "value": "Krung Thep Mahanakhon (Bangkok)",
                "label": "Krung Thep Mahanakhon (Bangkok)",
                "shortCode": "10"
            },
            {
                "value": "Lampang",
                "label": "Lampang",
                "shortCode": "52"
            },
            {
                "value": "Lamphun",
                "label": "Lamphun",
                "shortCode": "51"
            },
            {
                "value": "Loei",
                "label": "Loei",
                "shortCode": "42"
            },
            {
                "value": "Lop Buri",
                "label": "Lop Buri",
                "shortCode": "16"
            },
            {
                "value": "Mae Hong Son",
                "label": "Mae Hong Son",
                "shortCode": "58"
            },
            {
                "value": "Maha Sarakham",
                "label": "Maha Sarakham",
                "shortCode": "44"
            },
            {
                "value": "Mukdahan",
                "label": "Mukdahan",
                "shortCode": "49"
            },
            {
                "value": "Nakhon Nayok",
                "label": "Nakhon Nayok",
                "shortCode": "26"
            },
            {
                "value": "Nakhon Phathom",
                "label": "Nakhon Phathom",
                "shortCode": "73"
            },
            {
                "value": "Nakhon Phanom",
                "label": "Nakhon Phanom",
                "shortCode": "48"
            },
            {
                "value": "Nakhon Ratchasima",
                "label": "Nakhon Ratchasima",
                "shortCode": "30"
            },
            {
                "value": "Nakhon Sawan",
                "label": "Nakhon Sawan",
                "shortCode": "60"
            },
            {
                "value": "Nakhon Si Thammarat",
                "label": "Nakhon Si Thammarat",
                "shortCode": "80"
            },
            {
                "value": "Nan",
                "label": "Nan",
                "shortCode": "55"
            },
            {
                "value": "Narathiwat",
                "label": "Narathiwat",
                "shortCode": "96"
            },
            {
                "value": "Nong Bua Lam Phu",
                "label": "Nong Bua Lam Phu",
                "shortCode": "39"
            },
            {
                "value": "Nong Khai",
                "label": "Nong Khai",
                "shortCode": "43"
            },
            {
                "value": "Nonthaburi",
                "label": "Nonthaburi",
                "shortCode": "12"
            },
            {
                "value": "Pathum Thani",
                "label": "Pathum Thani",
                "shortCode": "13"
            },
            {
                "value": "Pattani",
                "label": "Pattani",
                "shortCode": "94"
            },
            {
                "value": "Phangnga",
                "label": "Phangnga",
                "shortCode": "82"
            },
            {
                "value": "Phatthalung",
                "label": "Phatthalung",
                "shortCode": "93"
            },
            {
                "value": "Phayao",
                "label": "Phayao",
                "shortCode": "56"
            },
            {
                "value": "Phetchabun",
                "label": "Phetchabun",
                "shortCode": "67"
            },
            {
                "value": "Phetchaburi",
                "label": "Phetchaburi",
                "shortCode": "76"
            },
            {
                "value": "Phichit",
                "label": "Phichit",
                "shortCode": "66"
            },
            {
                "value": "Phitsanulok",
                "label": "Phitsanulok",
                "shortCode": "65"
            },
            {
                "value": "Phra Nakhon Si Ayutthaya",
                "label": "Phra Nakhon Si Ayutthaya",
                "shortCode": "14"
            },
            {
                "value": "Phrae",
                "label": "Phrae",
                "shortCode": "54"
            },
            {
                "value": "Phuket",
                "label": "Phuket",
                "shortCode": "83"
            },
            {
                "value": "Prachin Buri",
                "label": "Prachin Buri",
                "shortCode": "25"
            },
            {
                "value": "Prachuap Khiri Khan",
                "label": "Prachuap Khiri Khan",
                "shortCode": "77"
            },
            {
                "value": "Ranong",
                "label": "Ranong",
                "shortCode": "85"
            },
            {
                "value": "Ratchaburi",
                "label": "Ratchaburi",
                "shortCode": "70"
            },
            {
                "value": "Rayong",
                "label": "Rayong",
                "shortCode": "21"
            },
            {
                "value": "Roi Et",
                "label": "Roi Et",
                "shortCode": "45"
            },
            {
                "value": "Sa Kaeo",
                "label": "Sa Kaeo",
                "shortCode": "27"
            },
            {
                "value": "Sakon Nakhon",
                "label": "Sakon Nakhon",
                "shortCode": "47"
            },
            {
                "value": "Samut Prakan",
                "label": "Samut Prakan",
                "shortCode": "11"
            },
            {
                "value": "Samut Sakhon",
                "label": "Samut Sakhon",
                "shortCode": "74"
            },
            {
                "value": "Samut Songkhram",
                "label": "Samut Songkhram",
                "shortCode": "75"
            },
            {
                "value": "Saraburi",
                "label": "Saraburi",
                "shortCode": "19"
            },
            {
                "value": "Satun",
                "label": "Satun",
                "shortCode": "91"
            },
            {
                "value": "Sing Buri",
                "label": "Sing Buri",
                "shortCode": "17"
            },
            {
                "value": "Si Sa ket",
                "label": "Si Sa ket",
                "shortCode": "33"
            },
            {
                "value": "Songkhla",
                "label": "Songkhla",
                "shortCode": "90"
            },
            {
                "value": "Sukhothai",
                "label": "Sukhothai",
                "shortCode": "64"
            },
            {
                "value": "Suphan Buri",
                "label": "Suphan Buri",
                "shortCode": "72"
            },
            {
                "value": "Surat Thani",
                "label": "Surat Thani",
                "shortCode": "84"
            },
            {
                "value": "Surin",
                "label": "Surin",
                "shortCode": "32"
            },
            {
                "value": "Tak",
                "label": "Tak",
                "shortCode": "63"
            },
            {
                "value": "Trang",
                "label": "Trang",
                "shortCode": "92"
            },
            {
                "value": "Trat",
                "label": "Trat",
                "shortCode": "23"
            },
            {
                "value": "Ubon Ratchathani",
                "label": "Ubon Ratchathani",
                "shortCode": "34"
            },
            {
                "value": "Udon Thani",
                "label": "Udon Thani",
                "shortCode": "41"
            },
            {
                "value": "Uthai Thani",
                "label": "Uthai Thani",
                "shortCode": "61"
            },
            {
                "value": "Uttaradit",
                "label": "Uttaradit",
                "shortCode": "53"
            },
            {
                "value": "Yala",
                "label": "Yala",
                "shortCode": "95"
            },
            {
                "value": "Yasothon",
                "label": "Yasothon",
                "shortCode": "35"
            }
        ]
    },
    {
        "countryCode": "+228",
        "value": "Togo",
        "label": "Togo",
        "regions": [
            {
                "value": "Centre",
                "label": "Centre",
                "shortCode": "C"
            },
            {
                "value": "Kara",
                "label": "Kara",
                "shortCode": "K"
            },
            {
                "value": "Maritime",
                "label": "Maritime",
                "shortCode": "M"
            },
            {
                "value": "Plateaux",
                "label": "Plateaux",
                "shortCode": "P"
            },
            {
                "value": "Savannes",
                "label": "Savannes",
                "shortCode": "S"
            }
        ]
    },
    {
        "countryCode": "+690",
        "value": "Tokelau",
        "label": "Tokelau",
        "regions": [
            {
                "value": "Atafu",
                "label": "Atafu"
            },
            {
                "value": "Fakaofo",
                "label": "Fakaofo"
            },
            {
                "value": "Nukunonu",
                "label": "Nukunonu"
            }
        ]
    },
    {
        "countryCode": "+676",
        "value": "Tonga",
        "label": "Tonga",
        "regions": [
            {
                "value": "'Eua",
                "label": "'Eua",
                "shortCode": "01"
            },
            {
                "value": "Ha'apai",
                "label": "Ha'apai",
                "shortCode": "02"
            },
            {
                "value": "Niuas",
                "label": "Niuas",
                "shortCode": "03"
            },
            {
                "value": "Tongatapu",
                "label": "Tongatapu",
                "shortCode": "04"
            },
            {
                "value": "Vava'u",
                "label": "Vava'u",
                "shortCode": "05"
            }
        ]
    },
    {
        "countryCode": "+1 868",
        "value": "Trinidad and Tobago",
        "label": "Trinidad and Tobago",
        "regions": [
            {
                "value": "Arima",
                "label": "Arima",
                "shortCode": "ARI"
            },
            {
                "value": "Chaguanas",
                "label": "Chaguanas",
                "shortCode": "CHA"
            },
            {
                "value": "Couva-Tabaquite-Talparo",
                "label": "Couva-Tabaquite-Talparo",
                "shortCode": "CTT"
            },
            {
                "value": "Diefo Martin",
                "label": "Diefo Martin",
                "shortCode": "DMN"
            },
            {
                "value": "Mayaro-Rio Claro",
                "label": "Mayaro-Rio Claro",
                "shortCode": "MRC"
            },
            {
                "value": "Penal-Debe",
                "label": "Penal-Debe",
                "shortCode": "PED"
            },
            {
                "value": "Point Fortin",
                "label": "Point Fortin",
                "shortCode": "PTF"
            },
            {
                "value": "Port-of-Spain",
                "label": "Port-of-Spain",
                "shortCode": "POS"
            },
            {
                "value": "Princes Town",
                "label": "Princes Town",
                "shortCode": "PRT"
            },
            {
                "value": "San Fernando",
                "label": "San Fernando",
                "shortCode": "SFO"
            },
            {
                "value": "San Juan-Laventille",
                "label": "San Juan-Laventille",
                "shortCode": "SJL"
            },
            {
                "value": "Sangre Grande",
                "label": "Sangre Grande",
                "shortCode": "SGE"
            },
            {
                "value": "Siparia",
                "label": "Siparia",
                "shortCode": "SIP"
            },
            {
                "value": "Tobago",
                "label": "Tobago",
                "shortCode": "TOB"
            },
            {
                "value": "Tunapuna-Piarco",
                "label": "Tunapuna-Piarco",
                "shortCode": "TUP"
            }
        ]
    },
    {
        "countryCode": "+216",
        "value": "Tunisia",
        "label": "Tunisia",
        "regions": [
            {
                "value": "Ariana",
                "label": "Ariana",
                "shortCode": "12"
            },
            {
                "value": "Beja",
                "label": "Beja",
                "shortCode": "31"
            },
            {
                "value": "Ben Arous",
                "label": "Ben Arous",
                "shortCode": "13"
            },
            {
                "value": "Bizerte",
                "label": "Bizerte",
                "shortCode": "23"
            },
            {
                "value": "Gabes",
                "label": "Gabes",
                "shortCode": "81"
            },
            {
                "value": "Gafsa",
                "label": "Gafsa",
                "shortCode": "71"
            },
            {
                "value": "Jendouba",
                "label": "Jendouba",
                "shortCode": "32"
            },
            {
                "value": "Kairouan",
                "label": "Kairouan",
                "shortCode": "41"
            },
            {
                "value": "Kasserine",
                "label": "Kasserine",
                "shortCode": "42"
            },
            {
                "value": "Kebili",
                "label": "Kebili",
                "shortCode": "73"
            },
            {
                "value": "Kef",
                "label": "Kef",
                "shortCode": "33"
            },
            {
                "value": "Mahdia",
                "label": "Mahdia",
                "shortCode": "53"
            },
            {
                "value": "Medenine",
                "label": "Medenine",
                "shortCode": "82"
            },
            {
                "value": "Monastir",
                "label": "Monastir",
                "shortCode": "52"
            },
            {
                "value": "Nabeul",
                "label": "Nabeul",
                "shortCode": "21"
            },
            {
                "value": "Sfax",
                "label": "Sfax",
                "shortCode": "61"
            },
            {
                "value": "Sidi Bouzid",
                "label": "Sidi Bouzid",
                "shortCode": "43"
            },
            {
                "value": "Siliana",
                "label": "Siliana",
                "shortCode": "34"
            },
            {
                "value": "Sousse",
                "label": "Sousse",
                "shortCode": "51"
            },
            {
                "value": "Tataouine",
                "label": "Tataouine",
                "shortCode": "83"
            },
            {
                "value": "Tozeur",
                "label": "Tozeur",
                "shortCode": "72"
            },
            {
                "value": "Tunis",
                "label": "Tunis",
                "shortCode": "11"
            },
            {
                "value": "Zaghouan",
                "label": "Zaghouan",
                "shortCode": "22"
            }
        ]
    },
    {
        "countryCode": "+90",
        "value": "Turkey",
        "label": "Turkey",
        "regions": [
            {
                "value": "Adana",
                "label": "Adana",
                "shortCode": "01"
            },
            {
                "value": "Adiyaman",
                "label": "Adiyaman",
                "shortCode": "02"
            },
            {
                "value": "Afyonkarahisar",
                "label": "Afyonkarahisar",
                "shortCode": "03"
            },
            {
                "value": "Agri",
                "label": "Agri",
                "shortCode": "04"
            },
            {
                "value": "Aksaray",
                "label": "Aksaray",
                "shortCode": "68"
            },
            {
                "value": "Amasya",
                "label": "Amasya",
                "shortCode": "05"
            },
            {
                "value": "Ankara",
                "label": "Ankara",
                "shortCode": "06"
            },
            {
                "value": "Antalya",
                "label": "Antalya",
                "shortCode": "07"
            },
            {
                "value": "Ardahan",
                "label": "Ardahan",
                "shortCode": "75"
            },
            {
                "value": "Artvin",
                "label": "Artvin",
                "shortCode": "08"
            },
            {
                "value": "Aydin",
                "label": "Aydin",
                "shortCode": "09"
            },
            {
                "value": "Balikesir",
                "label": "Balikesir",
                "shortCode": "10"
            },
            {
                "value": "Bartin",
                "label": "Bartin",
                "shortCode": "74"
            },
            {
                "value": "Batman",
                "label": "Batman",
                "shortCode": "72"
            },
            {
                "value": "Bayburt",
                "label": "Bayburt",
                "shortCode": "69"
            },
            {
                "value": "Bilecik",
                "label": "Bilecik",
                "shortCode": "11"
            },
            {
                "value": "Bingol",
                "label": "Bingol",
                "shortCode": "12"
            },
            {
                "value": "Bitlis",
                "label": "Bitlis",
                "shortCode": "13"
            },
            {
                "value": "Bolu",
                "label": "Bolu",
                "shortCode": "14"
            },
            {
                "value": "Burdur",
                "label": "Burdur",
                "shortCode": "15"
            },
            {
                "value": "Bursa",
                "label": "Bursa",
                "shortCode": "16"
            },
            {
                "value": "Canakkale",
                "label": "Canakkale",
                "shortCode": "17"
            },
            {
                "value": "Cankiri",
                "label": "Cankiri",
                "shortCode": "18"
            },
            {
                "value": "Corum",
                "label": "Corum",
                "shortCode": "19"
            },
            {
                "value": "Denizli",
                "label": "Denizli",
                "shortCode": "20"
            },
            {
                "value": "Diyarbakir",
                "label": "Diyarbakir",
                "shortCode": "21"
            },
            {
                "value": "Duzce",
                "label": "Duzce",
                "shortCode": "81"
            },
            {
                "value": "Edirne",
                "label": "Edirne",
                "shortCode": "22"
            },
            {
                "value": "Elazig",
                "label": "Elazig",
                "shortCode": "23"
            },
            {
                "value": "Erzincan",
                "label": "Erzincan",
                "shortCode": "24"
            },
            {
                "value": "Erzurum",
                "label": "Erzurum",
                "shortCode": "25"
            },
            {
                "value": "Eskisehir",
                "label": "Eskisehir",
                "shortCode": "26"
            },
            {
                "value": "Gaziantep",
                "label": "Gaziantep",
                "shortCode": "27"
            },
            {
                "value": "Giresun",
                "label": "Giresun",
                "shortCode": "28"
            },
            {
                "value": "Gumushane",
                "label": "Gumushane",
                "shortCode": "29"
            },
            {
                "value": "Hakkari",
                "label": "Hakkari",
                "shortCode": "30"
            },
            {
                "value": "Hatay",
                "label": "Hatay",
                "shortCode": "31"
            },
            {
                "value": "Igdir",
                "label": "Igdir",
                "shortCode": "76"
            },
            {
                "value": "Isparta",
                "label": "Isparta",
                "shortCode": "32"
            },
            {
                "value": "Istanbul",
                "label": "Istanbul",
                "shortCode": "34"
            },
            {
                "value": "Izmir",
                "label": "Izmir",
                "shortCode": "35"
            },
            {
                "value": "Kahramanmaras",
                "label": "Kahramanmaras",
                "shortCode": "46"
            },
            {
                "value": "Karabuk",
                "label": "Karabuk",
                "shortCode": "78"
            },
            {
                "value": "Karaman",
                "label": "Karaman",
                "shortCode": "70"
            },
            {
                "value": "Kars",
                "label": "Kars",
                "shortCode": "36"
            },
            {
                "value": "Kastamonu",
                "label": "Kastamonu",
                "shortCode": "37"
            },
            {
                "value": "Kayseri",
                "label": "Kayseri",
                "shortCode": "38"
            },
            {
                "value": "Kilis",
                "label": "Kilis",
                "shortCode": "79"
            },
            {
                "value": "Kirikkale",
                "label": "Kirikkale",
                "shortCode": "71"
            },
            {
                "value": "Kirklareli",
                "label": "Kirklareli",
                "shortCode": "39"
            },
            {
                "value": "Kirsehir",
                "label": "Kirsehir",
                "shortCode": "40"
            },
            {
                "value": "Kocaeli",
                "label": "Kocaeli",
                "shortCode": "41"
            },
            {
                "value": "Konya",
                "label": "Konya",
                "shortCode": "42"
            },
            {
                "value": "Kutahya",
                "label": "Kutahya",
                "shortCode": "43"
            },
            {
                "value": "Malatya",
                "label": "Malatya",
                "shortCode": "44"
            },
            {
                "value": "Manisa",
                "label": "Manisa",
                "shortCode": "45"
            },
            {
                "value": "Mardin",
                "label": "Mardin",
                "shortCode": "47"
            },
            {
                "value": "Mersin",
                "label": "Mersin",
                "shortCode": "33"
            },
            {
                "value": "Mugla",
                "label": "Mugla",
                "shortCode": "48"
            },
            {
                "value": "Mus",
                "label": "Mus",
                "shortCode": "49"
            },
            {
                "value": "Nevsehir",
                "label": "Nevsehir",
                "shortCode": "50"
            },
            {
                "value": "Nigde",
                "label": "Nigde",
                "shortCode": "51"
            },
            {
                "value": "Ordu",
                "label": "Ordu",
                "shortCode": "52"
            },
            {
                "value": "Osmaniye",
                "label": "Osmaniye",
                "shortCode": "80"
            },
            {
                "value": "Rize",
                "label": "Rize",
                "shortCode": "53"
            },
            {
                "value": "Sakarya",
                "label": "Sakarya",
                "shortCode": "54"
            },
            {
                "value": "Samsun",
                "label": "Samsun",
                "shortCode": "55"
            },
            {
                "value": "Sanliurfa",
                "label": "Sanliurfa",
                "shortCode": "63"
            },
            {
                "value": "Siirt",
                "label": "Siirt",
                "shortCode": "56"
            },
            {
                "value": "Sinop",
                "label": "Sinop",
                "shortCode": "57"
            },
            {
                "value": "Sirnak",
                "label": "Sirnak",
                "shortCode": "73"
            },
            {
                "value": "Sivas",
                "label": "Sivas",
                "shortCode": "58"
            },
            {
                "value": "Tekirdag",
                "label": "Tekirdag",
                "shortCode": "59"
            },
            {
                "value": "Tokat",
                "label": "Tokat",
                "shortCode": "60"
            },
            {
                "value": "Trabzon",
                "label": "Trabzon",
                "shortCode": "61"
            },
            {
                "value": "Tunceli",
                "label": "Tunceli",
                "shortCode": "62"
            },
            {
                "value": "Usak",
                "label": "Usak",
                "shortCode": "64"
            },
            {
                "value": "Van",
                "label": "Van",
                "shortCode": "65"
            },
            {
                "value": "Yalova",
                "label": "Yalova",
                "shortCode": "77"
            },
            {
                "value": "Yozgat",
                "label": "Yozgat",
                "shortCode": "66"
            },
            {
                "value": "Zonguldak",
                "label": "Zonguldak",
                "shortCode": "67"
            }
        ]
    },
    {
        "countryCode": "+993",
        "value": "Turkmenistan",
        "label": "Turkmenistan",
        "regions": [
            {
                "value": "Ahal",
                "label": "Ahal",
                "shortCode": "A"
            },
            {
                "value": "Asgabat",
                "label": "Asgabat",
                "shortCode": "S"
            },
            {
                "value": "Balkan",
                "label": "Balkan",
                "shortCode": "B"
            },
            {
                "value": "Dashoguz",
                "label": "Dashoguz",
                "shortCode": "D"
            },
            {
                "value": "Lebap",
                "label": "Lebap",
                "shortCode": "L"
            },
            {
                "value": "Mary",
                "label": "Mary",
                "shortCode": "M"
            }
        ]
    },
    {
        "countryCode": "+1 649",
        "value": "Turks and Caicos Islands",
        "label": "Turks and Caicos Islands",
        "regions": [
            {
                "value": "Turks and Caicos Islands",
                "label": "Turks and Caicos Islands"
            }
        ]
    },
    {
        "countryCode": "+688",
        "value": "Tuvalu",
        "label": "Tuvalu",
        "regions": [
            {
                "value": "Funafuti",
                "label": "Funafuti",
                "shortCode": "FUN"
            },
            {
                "value": "Nanumanga",
                "label": "Nanumanga",
                "shortCode": "NMG"
            },
            {
                "value": "Nanumea",
                "label": "Nanumea",
                "shortCode": "NMA"
            },
            {
                "value": "Niutao",
                "label": "Niutao",
                "shortCode": "NIT"
            },
            {
                "value": "Nui",
                "label": "Nui",
                "shortCode": "NUI"
            },
            {
                "value": "Nukufetau",
                "label": "Nukufetau",
                "shortCode": "NKF"
            },
            {
                "value": "Nukulaelae",
                "label": "Nukulaelae",
                "shortCode": "NKL"
            },
            {
                "value": "Vaitupu",
                "label": "Vaitupu",
                "shortCode": "VAU"
            }
        ]
    },
    {
        "countryCode": "+256",
        "value": "Uganda",
        "label": "Uganda",
        "regions": [
            {
                "value": "Abim",
                "label": "Abim",
                "shortCode": "317"
            },
            {
                "value": "Adjumani",
                "label": "Adjumani",
                "shortCode": "301"
            },
            {
                "value": "Amolatar",
                "label": "Amolatar",
                "shortCode": "314"
            },
            {
                "value": "Amuria",
                "label": "Amuria",
                "shortCode": "216"
            },
            {
                "value": "Amuru",
                "label": "Amuru",
                "shortCode": "319"
            },
            {
                "value": "Apac",
                "label": "Apac",
                "shortCode": "302"
            },
            {
                "value": "Arua",
                "label": "Arua",
                "shortCode": "303"
            },
            {
                "value": "Budaka",
                "label": "Budaka",
                "shortCode": "217"
            },
            {
                "value": "Bududa",
                "label": "Bududa",
                "shortCode": "223"
            },
            {
                "value": "Bugiri",
                "label": "Bugiri",
                "shortCode": "201"
            },
            {
                "value": "Bukedea",
                "label": "Bukedea",
                "shortCode": "224"
            },
            {
                "value": "Bukwa",
                "label": "Bukwa",
                "shortCode": "218"
            },
            {
                "value": "Buliisa",
                "label": "Buliisa",
                "shortCode": "419"
            },
            {
                "value": "Bundibugyo",
                "label": "Bundibugyo",
                "shortCode": "401"
            },
            {
                "value": "Bushenyi",
                "label": "Bushenyi",
                "shortCode": "402"
            },
            {
                "value": "Busia",
                "label": "Busia",
                "shortCode": "202"
            },
            {
                "value": "Butaleja",
                "label": "Butaleja",
                "shortCode": "219"
            },
            {
                "value": "Dokolo",
                "label": "Dokolo",
                "shortCode": "318"
            },
            {
                "value": "Gulu",
                "label": "Gulu",
                "shortCode": "304"
            },
            {
                "value": "Hoima",
                "label": "Hoima",
                "shortCode": "403"
            },
            {
                "value": "Ibanda",
                "label": "Ibanda",
                "shortCode": "416"
            },
            {
                "value": "Iganga",
                "label": "Iganga",
                "shortCode": "203"
            },
            {
                "value": "Isingiro",
                "label": "Isingiro",
                "shortCode": "417"
            },
            {
                "value": "Jinja",
                "label": "Jinja",
                "shortCode": "204"
            },
            {
                "value": "Kaabong",
                "label": "Kaabong",
                "shortCode": "315"
            },
            {
                "value": "Kabale",
                "label": "Kabale",
                "shortCode": "404"
            },
            {
                "value": "Kabarole",
                "label": "Kabarole",
                "shortCode": "405"
            },
            {
                "value": "Kaberamaido",
                "label": "Kaberamaido",
                "shortCode": "213"
            },
            {
                "value": "Kalangala",
                "label": "Kalangala",
                "shortCode": "101"
            },
            {
                "value": "Kaliro",
                "label": "Kaliro",
                "shortCode": "220"
            },
            {
                "value": "Kampala",
                "label": "Kampala",
                "shortCode": "102"
            },
            {
                "value": "Kamuli",
                "label": "Kamuli",
                "shortCode": "205"
            },
            {
                "value": "Kamwenge",
                "label": "Kamwenge",
                "shortCode": "413"
            },
            {
                "value": "Kanungu",
                "label": "Kanungu",
                "shortCode": "414"
            },
            {
                "value": "Kapchorwa",
                "label": "Kapchorwa",
                "shortCode": "206"
            },
            {
                "value": "Kasese",
                "label": "Kasese",
                "shortCode": "406"
            },
            {
                "value": "Katakwi",
                "label": "Katakwi",
                "shortCode": "207"
            },
            {
                "value": "Kayunga",
                "label": "Kayunga",
                "shortCode": "112"
            },
            {
                "value": "Kibaale",
                "label": "Kibaale",
                "shortCode": "407"
            },
            {
                "value": "Kiboga",
                "label": "Kiboga",
                "shortCode": "103"
            },
            {
                "value": "Kiruhura",
                "label": "Kiruhura",
                "shortCode": "418"
            },
            {
                "value": "Kisoro",
                "label": "Kisoro",
                "shortCode": "408"
            },
            {
                "value": "Kitgum",
                "label": "Kitgum",
                "shortCode": "305"
            },
            {
                "value": "Koboko",
                "label": "Koboko",
                "shortCode": "316"
            },
            {
                "value": "Kotido",
                "label": "Kotido",
                "shortCode": "306"
            },
            {
                "value": "Kumi",
                "label": "Kumi",
                "shortCode": "208"
            },
            {
                "value": "Kyenjojo",
                "label": "Kyenjojo",
                "shortCode": "415"
            },
            {
                "value": "Lira",
                "label": "Lira",
                "shortCode": "307"
            },
            {
                "value": "Luwero",
                "label": "Luwero",
                "shortCode": "104"
            },
            {
                "value": "Lyantonde",
                "label": "Lyantonde",
                "shortCode": "116"
            },
            {
                "value": "Manafwa",
                "label": "Manafwa",
                "shortCode": "221"
            },
            {
                "value": "Maracha",
                "label": "Maracha",
                "shortCode": "320"
            },
            {
                "value": "Masaka",
                "label": "Masaka",
                "shortCode": "105"
            },
            {
                "value": "Masindi",
                "label": "Masindi",
                "shortCode": "409"
            },
            {
                "value": "Mayuge",
                "label": "Mayuge",
                "shortCode": "214"
            },
            {
                "value": "Mbale",
                "label": "Mbale",
                "shortCode": "209"
            },
            {
                "value": "Mbarara",
                "label": "Mbarara",
                "shortCode": "410"
            },
            {
                "value": "Mityana",
                "label": "Mityana",
                "shortCode": "114"
            },
            {
                "value": "Moroto",
                "label": "Moroto",
                "shortCode": "308"
            },
            {
                "value": "Moyo",
                "label": "Moyo",
                "shortCode": "309"
            },
            {
                "value": "Mpigi",
                "label": "Mpigi",
                "shortCode": "106"
            },
            {
                "value": "Mubende",
                "label": "Mubende",
                "shortCode": "107"
            },
            {
                "value": "Mukono",
                "label": "Mukono",
                "shortCode": "108"
            },
            {
                "value": "Nakapiripirit",
                "label": "Nakapiripirit",
                "shortCode": "311"
            },
            {
                "value": "Nakaseke",
                "label": "Nakaseke",
                "shortCode": "115"
            },
            {
                "value": "Nakasongola",
                "label": "Nakasongola",
                "shortCode": "109"
            },
            {
                "value": "Namutumba",
                "label": "Namutumba",
                "shortCode": "222"
            },
            {
                "value": "Nebbi",
                "label": "Nebbi",
                "shortCode": "310"
            },
            {
                "value": "Ntungamo",
                "label": "Ntungamo",
                "shortCode": "411"
            },
            {
                "value": "Oyam",
                "label": "Oyam",
                "shortCode": "321"
            },
            {
                "value": "Pader",
                "label": "Pader",
                "shortCode": "312"
            },
            {
                "value": "Pallisa",
                "label": "Pallisa",
                "shortCode": "210"
            },
            {
                "value": "Rakai",
                "label": "Rakai",
                "shortCode": "110"
            },
            {
                "value": "Rukungiri",
                "label": "Rukungiri",
                "shortCode": "412"
            },
            {
                "value": "Sembabule",
                "label": "Sembabule",
                "shortCode": "111"
            },
            {
                "value": "Sironko",
                "label": "Sironko",
                "shortCode": "215"
            },
            {
                "value": "Soroti",
                "label": "Soroti",
                "shortCode": "211"
            },
            {
                "value": "Tororo",
                "label": "Tororo",
                "shortCode": "212"
            },
            {
                "value": "Wakiso",
                "label": "Wakiso",
                "shortCode": "113"
            },
            {
                "value": "Yumbe",
                "label": "Yumbe",
                "shortCode": "313"
            }
        ]
    },
    {
        "countryCode": "+380",
        "value": "Ukraine",
        "label": "Ukraine",
        "regions": [
            {
                "value": "Cherkaska oblast",
                "label": "Cherkaska oblast",
                "shortCode": "71"
            },
            {
                "value": "Chernihivska oblast",
                "label": "Chernihivska oblast",
                "shortCode": "74"
            },
            {
                "value": "Chernivetska oblast",
                "label": "Chernivetska oblast",
                "shortCode": "77"
            },
            {
                "value": "Dnipropetrovska oblast",
                "label": "Dnipropetrovska oblast",
                "shortCode": "12"
            },
            {
                "value": "Donetska oblast",
                "label": "Donetska oblast",
                "shortCode": "14"
            },
            {
                "value": "Ivano-Frankivska oblast",
                "label": "Ivano-Frankivska oblast",
                "shortCode": "26"
            },
            {
                "value": "Kharkivska oblast",
                "label": "Kharkivska oblast",
                "shortCode": "63"
            },
            {
                "value": "Khersonska oblast",
                "label": "Khersonska oblast",
                "shortCode": "65"
            },
            {
                "value": "Khmelnytska oblast",
                "label": "Khmelnytska oblast",
                "shortCode": "68"
            },
            {
                "value": "Kyivska oblast",
                "label": "Kyivska oblast",
                "shortCode": "32"
            },
            {
                "value": "Kirovohradska oblast",
                "label": "Kirovohradska oblast",
                "shortCode": "35"
            },
            {
                "value": "Luhanska oblast",
                "label": "Luhanska oblast",
                "shortCode": "09"
            },
            {
                "value": "Lvivska oblast",
                "label": "Lvivska oblast",
                "shortCode": "46"
            },
            {
                "value": "Mykolaivska oblast",
                "label": "Mykolaivska oblast",
                "shortCode": "48"
            },
            {
                "value": "Odeska oblast",
                "label": "Odeska oblast",
                "shortCode": "51"
            },
            {
                "value": "Poltavska oblast",
                "label": "Poltavska oblast",
                "shortCode": "53"
            },
            {
                "value": "Rivnenska oblast",
                "label": "Rivnenska oblast",
                "shortCode": "56"
            },
            {
                "value": "Sumska oblast",
                "label": "Sumska oblast",
                "shortCode": "59"
            },
            {
                "value": "Ternopilska oblast",
                "label": "Ternopilska oblast",
                "shortCode": "61"
            },
            {
                "value": "Vinnytska oblast",
                "label": "Vinnytska oblast",
                "shortCode": "05"
            },
            {
                "value": "Volynska oblast",
                "label": "Volynska oblast",
                "shortCode": "07"
            },
            {
                "value": "Zakarpatska oblast",
                "label": "Zakarpatska oblast",
                "shortCode": "21"
            },
            {
                "value": "Zaporizka oblast",
                "label": "Zaporizka oblast",
                "shortCode": "23"
            },
            {
                "value": "Zhytomyrska oblast",
                "label": "Zhytomyrska oblast",
                "shortCode": "18"
            },
            {
                "value": "Avtonomna Respublika Krym",
                "label": "Avtonomna Respublika Krym",
                "shortCode": "43"
            },
            {
                "value": "Kyiv",
                "label": "Kyiv",
                "shortCode": "30"
            },
            {
                "value": "Sevastopol",
                "label": "Sevastopol",
                "shortCode": "40"
            }
        ]
    },
    {
        "countryCode": "+971",
        "value": "United Arab Emirates",
        "label": "United Arab Emirates",
        "regions": [
            {
                "value": "Abu Dhabi",
                "label": "Abu Dhabi",
                "shortCode": "AZ"
            },
            {
                "value": "Ajman",
                "label": "Ajman",
                "shortCode": "AJ"
            },
            {
                "value": "Dubai",
                "label": "Dubai",
                "shortCode": "DU"
            },
            {
                "value": "Fujairah",
                "label": "Fujairah",
                "shortCode": "FU"
            },
            {
                "value": "Ras al Khaimah",
                "label": "Ras al Khaimah",
                "shortCode": "RK"
            },
            {
                "value": "Sharjah",
                "label": "Sharjah",
                "shortCode": "SH"
            },
            {
                "value": "Umm Al Quwain",
                "label": "Umm Al Quwain",
                "shortCode": "UQ"
            }
        ]
    },
    {
        "countryCode": "+44",
        "value": "United Kingdom",
        "label": "United Kingdom",
        "regions": [
            {
                "value": "Aberdeen City",
                "label": "Aberdeen City",
                "shortCode": "ABE"
            },
            {
                "value": "Aberdeenshire",
                "label": "Aberdeenshire",
                "shortCode": "ABD"
            },
            {
                "value": "Angus",
                "label": "Angus",
                "shortCode": "ANS"
            },
            {
                "value": "Antrim and Newtownabbey",
                "label": "Antrim and Newtownabbey",
                "shortCode": "ANN"
            },
            {
                "value": "Ards and North Down",
                "label": "Ards and North Down",
                "shortCode": "AND"
            },
            {
                "value": "Argyll and Bute",
                "label": "Argyll and Bute",
                "shortCode": "AGB"
            },
            {
                "value": "Armagh City, Banbridge and Craigavon",
                "label": "Armagh City, Banbridge and Craigavon",
                "shortCode": "ABC"
            },
            {
                "value": "Barking and Dagenham",
                "label": "Barking and Dagenham",
                "shortCode": "BDG"
            },
            {
                "value": "Barnet",
                "label": "Barnet",
                "shortCode": "BNE"
            },
            {
                "value": "Barnsley",
                "label": "Barnsley",
                "shortCode": "BNS"
            },
            {
                "value": "Bath and North East Somerset",
                "label": "Bath and North East Somerset",
                "shortCode": "BAS"
            },
            {
                "value": "Bedford",
                "label": "Bedford",
                "shortCode": "BDF"
            },
            {
                "value": "Belfast City",
                "label": "Belfast City",
                "shortCode": "BFS"
            },
            {
                "value": "Berkshire",
                "label": "Berkshire",
                "shortCode": "BRK"
            },
            {
                "value": "Bexley",
                "label": "Bexley",
                "shortCode": "BEX"
            },
            {
                "value": "Birmingham",
                "label": "Birmingham",
                "shortCode": "BIR"
            },
            {
                "value": "Blackburn with Darwen",
                "label": "Blackburn with Darwen",
                "shortCode": "BBD"
            },
            {
                "value": "Blackpool",
                "label": "Blackpool",
                "shortCode": "BPL"
            },
            {
                "value": "Blaenau Gwent",
                "label": "Blaenau Gwent",
                "shortCode": "BGW"
            },
            {
                "value": "Bolton",
                "label": "Bolton",
                "shortCode": "BOL"
            },
            {
                "value": "Bournemouth, Christchurch and Poole",
                "label": "Bournemouth, Christchurch and Poole",
                "shortCode": "BCP"
            },
            {
                "value": "Bracknell Forest",
                "label": "Bracknell Forest",
                "shortCode": "BRC"
            },
            {
                "value": "Bradford",
                "label": "Bradford",
                "shortCode": "BRD"
            },
            {
                "value": "Brent",
                "label": "Brent",
                "shortCode": "BEN"
            },
            {
                "value": "Bridgend",
                "label": "Bridgend",
                "shortCode": "BGE"
            },
            {
                "value": "Brighton and Hove",
                "label": "Brighton and Hove",
                "shortCode": "BNH"
            },
            {
                "value": "Bristol, City of",
                "label": "Bristol, City of",
                "shortCode": "BST"
            },
            {
                "value": "Bromley",
                "label": "Bromley",
                "shortCode": "BRY"
            },
            {
                "value": "Buckinghamshire",
                "label": "Buckinghamshire",
                "shortCode": "BKM"
            },
            {
                "value": "Bury",
                "label": "Bury",
                "shortCode": "BUR"
            },
            {
                "value": "Caerphilly",
                "label": "Caerphilly",
                "shortCode": "CAY"
            },
            {
                "value": "Calderdale",
                "label": "Calderdale",
                "shortCode": "CLD"
            },
            {
                "value": "Cambridgeshire",
                "label": "Cambridgeshire",
                "shortCode": "CAM"
            },
            {
                "value": "Camden",
                "label": "Camden",
                "shortCode": "CMD"
            },
            {
                "value": "Cardiff",
                "label": "Cardiff",
                "shortCode": "CRF"
            },
            {
                "value": "Carmarthenshire",
                "label": "Carmarthenshire",
                "shortCode": "CMN"
            },
            {
                "value": "Causeway Coast and Glens",
                "label": "Causeway Coast and Glens",
                "shortCode": "CCG"
            },
            {
                "value": "Central Bedfordshire",
                "label": "Central Bedfordshire",
                "shortCode": "CBF"
            },
            {
                "value": "Ceredigion",
                "label": "Ceredigion",
                "shortCode": "CGN"
            },
            {
                "value": "Cheshire East",
                "label": "Cheshire East",
                "shortCode": "CHE"
            },
            {
                "value": "Cheshire West and Chester",
                "label": "Cheshire West and Chester",
                "shortCode": "CHW"
            },
            {
                "value": "Clackmannanshire",
                "label": "Clackmannanshire",
                "shortCode": "CLK"
            },
            {
                "value": "Conwy",
                "label": "Conwy",
                "shortCode": "CWY"
            },
            {
                "value": "Cornwall",
                "label": "Cornwall",
                "shortCode": "CON"
            },
            {
                "value": "Coventry",
                "label": "Coventry",
                "shortCode": "COV"
            },
            {
                "value": "Croydon",
                "label": "Croydon",
                "shortCode": "CRY"
            },
            {
                "value": "Cumbria",
                "label": "Cumbria",
                "shortCode": "CMA"
            },
            {
                "value": "Darlington",
                "label": "Darlington",
                "shortCode": "DAL"
            },
            {
                "value": "Denbighshire",
                "label": "Denbighshire",
                "shortCode": "DEN"
            },
            {
                "value": "Derby",
                "label": "Derby",
                "shortCode": "DER"
            },
            {
                "value": "Derbyshire",
                "label": "Derbyshire",
                "shortCode": "DBY"
            },
            {
                "value": "Derry and Strabane",
                "label": "Derry and Strabane",
                "shortCode": "DRS"
            },
            {
                "value": "Devon",
                "label": "Devon",
                "shortCode": "DEV"
            },
            {
                "value": "Doncaster",
                "label": "Doncaster",
                "shortCode": "DNC"
            },
            {
                "value": "Dorset",
                "label": "Dorset",
                "shortCode": "DOR"
            },
            {
                "value": "Dudley",
                "label": "Dudley",
                "shortCode": "DUD"
            },
            {
                "value": "Dumfries and Galloway",
                "label": "Dumfries and Galloway",
                "shortCode": "DGY"
            },
            {
                "value": "Dundee City",
                "label": "Dundee City",
                "shortCode": "DND"
            },
            {
                "value": "Durham, County",
                "label": "Durham, County",
                "shortCode": "DUR"
            },
            {
                "value": "Ealing",
                "label": "Ealing",
                "shortCode": "EAL"
            },
            {
                "value": "East Ayrshire",
                "label": "East Ayrshire",
                "shortCode": "EAY"
            },
            {
                "value": "East Dunbartonshire",
                "label": "East Dunbartonshire",
                "shortCode": "EDU"
            },
            {
                "value": "East Lothian",
                "label": "East Lothian",
                "shortCode": "ELN"
            },
            {
                "value": "East Renfrewshire",
                "label": "East Renfrewshire",
                "shortCode": "ERW"
            },
            {
                "value": "East Riding of Yorkshire",
                "label": "East Riding of Yorkshire",
                "shortCode": "ERY"
            },
            {
                "value": "East Sussex",
                "label": "East Sussex",
                "shortCode": "ESX"
            },
            {
                "value": "Edinburgh, City of",
                "label": "Edinburgh, City of",
                "shortCode": "EDH"
            },
            {
                "value": "Eilean Siar",
                "label": "Eilean Siar",
                "shortCode": "ELS"
            },
            {
                "value": "Enfield",
                "label": "Enfield",
                "shortCode": "ENF"
            },
            {
                "value": "Essex",
                "label": "Essex",
                "shortCode": "ESS"
            },
            {
                "value": "Falkirk",
                "label": "Falkirk",
                "shortCode": "FAL"
            },
            {
                "value": "Fermanagh and Omagh",
                "label": "Fermanagh and Omagh",
                "shortCode": "FMO"
            },
            {
                "value": "Fife",
                "label": "Fife",
                "shortCode": "FIF"
            },
            {
                "value": "Flintshire",
                "label": "Flintshire",
                "shortCode": "FLN"
            },
            {
                "value": "Gateshead",
                "label": "Gateshead",
                "shortCode": "GAT"
            },
            {
                "value": "Glasgow City",
                "label": "Glasgow City",
                "shortCode": "GLG"
            },
            {
                "value": "Gloucestershire",
                "label": "Gloucestershire",
                "shortCode": "GLS"
            },
            {
                "value": "Greenwich",
                "label": "Greenwich",
                "shortCode": "GRE"
            },
            {
                "value": "Gwynedd",
                "label": "Gwynedd",
                "shortCode": "GWN"
            },
            {
                "value": "Hackney",
                "label": "Hackney",
                "shortCode": "HCK"
            },
            {
                "value": "Halton",
                "label": "Halton",
                "shortCode": "HAL"
            },
            {
                "value": "Hammersmith and Fulham",
                "label": "Hammersmith and Fulham",
                "shortCode": "HMF"
            },
            {
                "value": "Hampshire",
                "label": "Hampshire",
                "shortCode": "HAM"
            },
            {
                "value": "Haringey",
                "label": "Haringey",
                "shortCode": "HRY"
            },
            {
                "value": "Harrow",
                "label": "Harrow",
                "shortCode": "HRW"
            },
            {
                "value": "Hartlepool",
                "label": "Hartlepool",
                "shortCode": "HPL"
            },
            {
                "value": "Havering",
                "label": "Havering",
                "shortCode": "HAV"
            },
            {
                "value": "Herefordshire",
                "label": "Herefordshire",
                "shortCode": "HEF"
            },
            {
                "value": "Hertfordshire",
                "label": "Hertfordshire",
                "shortCode": "HRT"
            },
            {
                "value": "Highland",
                "label": "Highland",
                "shortCode": "HLD"
            },
            {
                "value": "Hillingdon",
                "label": "Hillingdon",
                "shortCode": "HIL"
            },
            {
                "value": "Hounslow",
                "label": "Hounslow",
                "shortCode": "HNS"
            },
            {
                "value": "Inverclyde",
                "label": "Inverclyde",
                "shortCode": "IVC"
            },
            {
                "value": "Isle of Anglesey",
                "label": "Isle of Anglesey",
                "shortCode": "AGY"
            },
            {
                "value": "Isle of Wight",
                "label": "Isle of Wight",
                "shortCode": "IOW"
            },
            {
                "value": "Isles of Scilly",
                "label": "Isles of Scilly",
                "shortCode": "IOS"
            },
            {
                "value": "Islington",
                "label": "Islington",
                "shortCode": "ISL"
            },
            {
                "value": "Kensington and Chelsea",
                "label": "Kensington and Chelsea",
                "shortCode": "KEC"
            },
            {
                "value": "Kent",
                "label": "Kent",
                "shortCode": "KEN"
            },
            {
                "value": "Kingston upon Hull",
                "label": "Kingston upon Hull",
                "shortCode": "KHL"
            },
            {
                "value": "Kingston upon Thames",
                "label": "Kingston upon Thames",
                "shortCode": "KTT"
            },
            {
                "value": "Kirklees",
                "label": "Kirklees",
                "shortCode": "KIR"
            },
            {
                "value": "Knowsley",
                "label": "Knowsley",
                "shortCode": "KWL"
            },
            {
                "value": "Lambeth",
                "label": "Lambeth",
                "shortCode": "LBH"
            },
            {
                "value": "Lancashire",
                "label": "Lancashire",
                "shortCode": "LAN"
            },
            {
                "value": "Leeds",
                "label": "Leeds",
                "shortCode": "LDS"
            },
            {
                "value": "Leicester",
                "label": "Leicester",
                "shortCode": "LCE"
            },
            {
                "value": "Leicestershire",
                "label": "Leicestershire",
                "shortCode": "LEC"
            },
            {
                "value": "Lewisham",
                "label": "Lewisham",
                "shortCode": "LEW"
            },
            {
                "value": "Lincolnshire",
                "label": "Lincolnshire",
                "shortCode": "LIN"
            },
            {
                "value": "Lisburn and Castlereagh",
                "label": "Lisburn and Castlereagh",
                "shortCode": "LBC"
            },
            {
                "value": "Liverpool",
                "label": "Liverpool",
                "shortCode": "LIV"
            },
            {
                "value": "London, City of",
                "label": "London, City of",
                "shortCode": "LND"
            },
            {
                "value": "Luton",
                "label": "Luton",
                "shortCode": "LUT"
            },
            {
                "value": "Manchester",
                "label": "Manchester",
                "shortCode": "MAN"
            },
            {
                "value": "Medway",
                "label": "Medway",
                "shortCode": "MDW"
            },
            {
                "value": "Merthyr Tydfil",
                "label": "Merthyr Tydfil",
                "shortCode": "MTY"
            },
            {
                "value": "Merton",
                "label": "Merton",
                "shortCode": "MRT"
            },
            {
                "value": "Mid and East Antrim",
                "label": "Mid and East Antrim",
                "shortCode": "MEA"
            },
            {
                "value": "Mid-Ulster",
                "label": "Mid-Ulster",
                "shortCode": "MUL"
            },
            {
                "value": "Middlesbrough",
                "label": "Middlesbrough",
                "shortCode": "MDB"
            },
            {
                "value": "Midlothian",
                "label": "Midlothian",
                "shortCode": "MLN"
            },
            {
                "value": "Milton Keynes",
                "label": "Milton Keynes",
                "shortCode": "MIK"
            },
            {
                "value": "Monmouthshire",
                "label": "Monmouthshire",
                "shortCode": "MON"
            },
            {
                "value": "Moray",
                "label": "Moray",
                "shortCode": "MRY"
            },
            {
                "value": "Neath Port Talbot",
                "label": "Neath Port Talbot",
                "shortCode": "NTL"
            },
            {
                "value": "Newcastle upon Tyne",
                "label": "Newcastle upon Tyne",
                "shortCode": "NET"
            },
            {
                "value": "Newham",
                "label": "Newham",
                "shortCode": "NWM"
            },
            {
                "value": "Newport",
                "label": "Newport",
                "shortCode": "NWP"
            },
            {
                "value": "Newry, Mourne and Down",
                "label": "Newry, Mourne and Down",
                "shortCode": "NMD"
            },
            {
                "value": "Norfolk",
                "label": "Norfolk",
                "shortCode": "NFK"
            },
            {
                "value": "North Ayrshire",
                "label": "North Ayrshire",
                "shortCode": "NAY"
            },
            {
                "value": "North East Lincolnshire",
                "label": "North East Lincolnshire",
                "shortCode": "NEL"
            },
            {
                "value": "North Lanarkshire",
                "label": "North Lanarkshire",
                "shortCode": "NLK"
            },
            {
                "value": "North Lincolnshire",
                "label": "North Lincolnshire",
                "shortCode": "NLN"
            },
            {
                "value": "North Somerset",
                "label": "North Somerset",
                "shortCode": "NSM"
            },
            {
                "value": "North Tyneside",
                "label": "North Tyneside",
                "shortCode": "NTY"
            },
            {
                "value": "North Yorkshire",
                "label": "North Yorkshire",
                "shortCode": "NYK"
            },
            {
                "value": "Northamptonshire",
                "label": "Northamptonshire",
                "shortCode": "NTH"
            },
            {
                "value": "Northumberland",
                "label": "Northumberland",
                "shortCode": "NBL"
            },
            {
                "value": "Nottingham",
                "label": "Nottingham",
                "shortCode": "NGM"
            },
            {
                "value": "Nottinghamshire",
                "label": "Nottinghamshire",
                "shortCode": "NTT"
            },
            {
                "value": "Oldham",
                "label": "Oldham",
                "shortCode": "OLD"
            },
            {
                "value": "Orkney Islands",
                "label": "Orkney Islands",
                "shortCode": "ORK"
            },
            {
                "value": "Oxfordshire",
                "label": "Oxfordshire",
                "shortCode": "OXF"
            },
            {
                "value": "Pembrokeshire",
                "label": "Pembrokeshire",
                "shortCode": "PEM"
            },
            {
                "value": "Perth and Kinross",
                "label": "Perth and Kinross",
                "shortCode": "PKN"
            },
            {
                "value": "Peterborough",
                "label": "Peterborough",
                "shortCode": "PTE"
            },
            {
                "value": "Plymouth",
                "label": "Plymouth",
                "shortCode": "PLY"
            },
            {
                "value": "Portsmouth",
                "label": "Portsmouth",
                "shortCode": "POR"
            },
            {
                "value": "Powys",
                "label": "Powys",
                "shortCode": "POW"
            },
            {
                "value": "Reading",
                "label": "Reading",
                "shortCode": "RDG"
            },
            {
                "value": "Redbridge",
                "label": "Redbridge",
                "shortCode": "RDB"
            },
            {
                "value": "Redcar and Cleveland",
                "label": "Redcar and Cleveland",
                "shortCode": "RCC"
            },
            {
                "value": "Renfrewshire",
                "label": "Renfrewshire",
                "shortCode": "RFW"
            },
            {
                "value": "Rhondda Cynon Taff",
                "label": "Rhondda Cynon Taff",
                "shortCode": "RCT"
            },
            {
                "value": "Richmond upon Thames",
                "label": "Richmond upon Thames",
                "shortCode": "RIC"
            },
            {
                "value": "Rochdale",
                "label": "Rochdale",
                "shortCode": "RCH"
            },
            {
                "value": "Rotherham",
                "label": "Rotherham",
                "shortCode": "ROT"
            },
            {
                "value": "Rutland",
                "label": "Rutland",
                "shortCode": "RUT"
            },
            {
                "value": "Salford",
                "label": "Salford",
                "shortCode": "SLF"
            },
            {
                "value": "Sandwell",
                "label": "Sandwell",
                "shortCode": "SAW"
            },
            {
                "value": "Scottish Borders",
                "label": "Scottish Borders",
                "shortCode": "SCB"
            },
            {
                "value": "Sefton",
                "label": "Sefton",
                "shortCode": "SFT"
            },
            {
                "value": "Sheffield",
                "label": "Sheffield",
                "shortCode": "SHF"
            },
            {
                "value": "Shetland Islands",
                "label": "Shetland Islands",
                "shortCode": "ZET"
            },
            {
                "value": "Shropshire",
                "label": "Shropshire",
                "shortCode": "SHR"
            },
            {
                "value": "Slough",
                "label": "Slough",
                "shortCode": "SLG"
            },
            {
                "value": "Solihull",
                "label": "Solihull",
                "shortCode": "SOL"
            },
            {
                "value": "Somerset",
                "label": "Somerset",
                "shortCode": "SOM"
            },
            {
                "value": "South Ayrshire",
                "label": "South Ayrshire",
                "shortCode": "SAY"
            },
            {
                "value": "South Gloucestershire",
                "label": "South Gloucestershire",
                "shortCode": "SGC"
            },
            {
                "value": "South Lanarkshire",
                "label": "South Lanarkshire",
                "shortCode": "SLK"
            },
            {
                "value": "South Tyneside",
                "label": "South Tyneside",
                "shortCode": "STY"
            },
            {
                "value": "Southampton",
                "label": "Southampton",
                "shortCode": "STH"
            },
            {
                "value": "Southend-on-Sea",
                "label": "Southend-on-Sea",
                "shortCode": "SOS"
            },
            {
                "value": "Southwark",
                "label": "Southwark",
                "shortCode": "SWK"
            },
            {
                "value": "St. Helens",
                "label": "St. Helens",
                "shortCode": "SHN"
            },
            {
                "value": "Staffordshire",
                "label": "Staffordshire",
                "shortCode": "STS"
            },
            {
                "value": "Stirling",
                "label": "Stirling",
                "shortCode": "STG"
            },
            {
                "value": "Stockport",
                "label": "Stockport",
                "shortCode": "SKP"
            },
            {
                "value": "Stockton-on-Tees",
                "label": "Stockton-on-Tees",
                "shortCode": "STT"
            },
            {
                "value": "Stoke-on-Trent",
                "label": "Stoke-on-Trent",
                "shortCode": "STE"
            },
            {
                "value": "Suffolk",
                "label": "Suffolk",
                "shortCode": "SFK"
            },
            {
                "value": "Sunderland",
                "label": "Sunderland",
                "shortCode": "SND"
            },
            {
                "value": "Surrey",
                "label": "Surrey",
                "shortCode": "SRY"
            },
            {
                "value": "Sutton",
                "label": "Sutton",
                "shortCode": "STN"
            },
            {
                "value": "Swansea",
                "label": "Swansea",
                "shortCode": "SWA"
            },
            {
                "value": "Swindon",
                "label": "Swindon",
                "shortCode": "SWD"
            },
            {
                "value": "Tameside",
                "label": "Tameside",
                "shortCode": "TAM"
            },
            {
                "value": "Telford and Wrekin",
                "label": "Telford and Wrekin",
                "shortCode": "TFW"
            },
            {
                "value": "Thurrock",
                "label": "Thurrock",
                "shortCode": "THR"
            },
            {
                "value": "Torbay",
                "label": "Torbay",
                "shortCode": "TOB"
            },
            {
                "value": "Torfaen",
                "label": "Torfaen",
                "shortCode": "TOF"
            },
            {
                "value": "Tower Hamlets",
                "label": "Tower Hamlets",
                "shortCode": "TWH"
            },
            {
                "value": "Trafford",
                "label": "Trafford",
                "shortCode": "TRF"
            },
            {
                "value": "Vale of Glamorgan, The",
                "label": "Vale of Glamorgan, The",
                "shortCode": "VGL"
            },
            {
                "value": "Wakefield",
                "label": "Wakefield",
                "shortCode": "WKF"
            },
            {
                "value": "Walsall",
                "label": "Walsall",
                "shortCode": "WLL"
            },
            {
                "value": "Waltham Forest",
                "label": "Waltham Forest",
                "shortCode": "WFT"
            },
            {
                "value": "Wandsworth",
                "label": "Wandsworth",
                "shortCode": "WND"
            },
            {
                "value": "Warrington",
                "label": "Warrington",
                "shortCode": "WRT"
            },
            {
                "value": "Warwickshire",
                "label": "Warwickshire",
                "shortCode": "WAR"
            },
            {
                "value": "West Berkshire",
                "label": "West Berkshire",
                "shortCode": "WBK"
            },
            {
                "value": "West Dunbartonshire",
                "label": "West Dunbartonshire",
                "shortCode": "WDU"
            },
            {
                "value": "West Lothian",
                "label": "West Lothian",
                "shortCode": "WLN"
            },
            {
                "value": "West Sussex",
                "label": "West Sussex",
                "shortCode": "WSX"
            },
            {
                "value": "Westminster",
                "label": "Westminster",
                "shortCode": "WSM"
            },
            {
                "value": "Wigan",
                "label": "Wigan",
                "shortCode": "WGN"
            },
            {
                "value": "Wiltshire",
                "label": "Wiltshire",
                "shortCode": "WIL"
            },
            {
                "value": "Windsor and Maidenhead",
                "label": "Windsor and Maidenhead",
                "shortCode": "WNM"
            },
            {
                "value": "Wirral",
                "label": "Wirral",
                "shortCode": "WRL"
            },
            {
                "value": "Wokingham",
                "label": "Wokingham",
                "shortCode": "WOK"
            },
            {
                "value": "Wolverhampton",
                "label": "Wolverhampton",
                "shortCode": "WLV"
            },
            {
                "value": "Worcestershire",
                "label": "Worcestershire",
                "shortCode": "WOR"
            },
            {
                "value": "Wrexham",
                "label": "Wrexham",
                "shortCode": "WRX"
            },
            {
                "value": "York",
                "label": "York",
                "shortCode": "YOR"
            }
        ]
    },
    {
        "countryCode": "+1",
        "value": "United States",
        "label": "United States",
        "regions": [
            {
                "value": "Alabama",
                "label": "Alabama",
                "shortCode": "AL"
            },
            {
                "value": "Alaska",
                "label": "Alaska",
                "shortCode": "AK"
            },
            {
                "value": "American Samoa",
                "label": "American Samoa",
                "shortCode": "AS"
            },
            {
                "value": "Arizona",
                "label": "Arizona",
                "shortCode": "AZ"
            },
            {
                "value": "Arkansas",
                "label": "Arkansas",
                "shortCode": "AR"
            },
            {
                "value": "California",
                "label": "California",
                "shortCode": "CA"
            },
            {
                "value": "Colorado",
                "label": "Colorado",
                "shortCode": "CO"
            },
            {
                "value": "Connecticut",
                "label": "Connecticut",
                "shortCode": "CT"
            },
            {
                "value": "Delaware",
                "label": "Delaware",
                "shortCode": "DE"
            },
            {
                "value": "District of Columbia",
                "label": "District of Columbia",
                "shortCode": "DC"
            },
            {
                "value": "Micronesia",
                "label": "Micronesia",
                "shortCode": "FM"
            },
            {
                "value": "Florida",
                "label": "Florida",
                "shortCode": "FL"
            },
            {
                "value": "Georgia",
                "label": "Georgia",
                "shortCode": "GA"
            },
            {
                "value": "Guam",
                "label": "Guam",
                "shortCode": "GU"
            },
            {
                "value": "Hawaii",
                "label": "Hawaii",
                "shortCode": "HI"
            },
            {
                "value": "Idaho",
                "label": "Idaho",
                "shortCode": "ID"
            },
            {
                "value": "Illinois",
                "label": "Illinois",
                "shortCode": "IL"
            },
            {
                "value": "Indiana",
                "label": "Indiana",
                "shortCode": "IN"
            },
            {
                "value": "Iowa",
                "label": "Iowa",
                "shortCode": "IA"
            },
            {
                "value": "Kansas",
                "label": "Kansas",
                "shortCode": "KS"
            },
            {
                "value": "Kentucky",
                "label": "Kentucky",
                "shortCode": "KY"
            },
            {
                "value": "Louisiana",
                "label": "Louisiana",
                "shortCode": "LA"
            },
            {
                "value": "Maine",
                "label": "Maine",
                "shortCode": "ME"
            },
            {
                "value": "Marshall Islands",
                "label": "Marshall Islands",
                "shortCode": "MH"
            },
            {
                "value": "Maryland",
                "label": "Maryland",
                "shortCode": "MD"
            },
            {
                "value": "Massachusetts",
                "label": "Massachusetts",
                "shortCode": "MA"
            },
            {
                "value": "Michigan",
                "label": "Michigan",
                "shortCode": "MI"
            },
            {
                "value": "Minnesota",
                "label": "Minnesota",
                "shortCode": "MN"
            },
            {
                "value": "Mississippi",
                "label": "Mississippi",
                "shortCode": "MS"
            },
            {
                "value": "Missouri",
                "label": "Missouri",
                "shortCode": "MO"
            },
            {
                "value": "Montana",
                "label": "Montana",
                "shortCode": "MT"
            },
            {
                "value": "Nebraska",
                "label": "Nebraska",
                "shortCode": "NE"
            },
            {
                "value": "Nevada",
                "label": "Nevada",
                "shortCode": "NV"
            },
            {
                "value": "New Hampshire",
                "label": "New Hampshire",
                "shortCode": "NH"
            },
            {
                "value": "New Jersey",
                "label": "New Jersey",
                "shortCode": "NJ"
            },
            {
                "value": "New Mexico",
                "label": "New Mexico",
                "shortCode": "NM"
            },
            {
                "value": "New York",
                "label": "New York",
                "shortCode": "NY"
            },
            {
                "value": "North Carolina",
                "label": "North Carolina",
                "shortCode": "NC"
            },
            {
                "value": "North Dakota",
                "label": "North Dakota",
                "shortCode": "ND"
            },
            {
                "value": "Northern Mariana Islands",
                "label": "Northern Mariana Islands",
                "shortCode": "MP"
            },
            {
                "value": "Ohio",
                "label": "Ohio",
                "shortCode": "OH"
            },
            {
                "value": "Oklahoma",
                "label": "Oklahoma",
                "shortCode": "OK"
            },
            {
                "value": "Oregon",
                "label": "Oregon",
                "shortCode": "OR"
            },
            {
                "value": "Palau",
                "label": "Palau",
                "shortCode": "PW"
            },
            {
                "value": "Pennsylvania",
                "label": "Pennsylvania",
                "shortCode": "PA"
            },
            {
                "value": "Puerto Rico",
                "label": "Puerto Rico",
                "shortCode": "PR"
            },
            {
                "value": "Rhode Island",
                "label": "Rhode Island",
                "shortCode": "RI"
            },
            {
                "value": "South Carolina",
                "label": "South Carolina",
                "shortCode": "SC"
            },
            {
                "value": "South Dakota",
                "label": "South Dakota",
                "shortCode": "SD"
            },
            {
                "value": "Tennessee",
                "label": "Tennessee",
                "shortCode": "TN"
            },
            {
                "value": "Texas",
                "label": "Texas",
                "shortCode": "TX"
            },
            {
                "value": "Utah",
                "label": "Utah",
                "shortCode": "UT"
            },
            {
                "value": "Vermont",
                "label": "Vermont",
                "shortCode": "VT"
            },
            {
                "value": "Virgin Islands",
                "label": "Virgin Islands",
                "shortCode": "VI"
            },
            {
                "value": "Virginia",
                "label": "Virginia",
                "shortCode": "VA"
            },
            {
                "value": "Washington",
                "label": "Washington",
                "shortCode": "WA"
            },
            {
                "value": "West Virginia",
                "label": "West Virginia",
                "shortCode": "WV"
            },
            {
                "value": "Wisconsin",
                "label": "Wisconsin",
                "shortCode": "WI"
            },
            {
                "value": "Wyoming",
                "label": "Wyoming",
                "shortCode": "WY"
            },
            {
                "value": "Armed Forces Americas",
                "label": "Armed Forces Americas",
                "shortCode": "AA"
            },
            {
                "value": "Armed Forces Europe, Canada, Africa and Middle East",
                "label": "Armed Forces Europe, Canada, Africa and Middle East",
                "shortCode": "AE"
            },
            {
                "value": "Armed Forces Pacific",
                "label": "Armed Forces Pacific",
                "shortCode": "AP"
            }
        ]
    },
    {
        "countryCode": "+598",
        "value": "Uruguay",
        "label": "Uruguay",
        "regions": [
            {
                "value": "Artigas",
                "label": "Artigas",
                "shortCode": "AR"
            },
            {
                "value": "Canelones",
                "label": "Canelones",
                "shortCode": "CA"
            },
            {
                "value": "Cerro Largo",
                "label": "Cerro Largo",
                "shortCode": "CL"
            },
            {
                "value": "Colonia",
                "label": "Colonia",
                "shortCode": "CO"
            },
            {
                "value": "Durazno",
                "label": "Durazno",
                "shortCode": "DU"
            },
            {
                "value": "Flores",
                "label": "Flores",
                "shortCode": "FS"
            },
            {
                "value": "Florida",
                "label": "Florida",
                "shortCode": "FD"
            },
            {
                "value": "Lavalleja",
                "label": "Lavalleja",
                "shortCode": "LA"
            },
            {
                "value": "Maldonado",
                "label": "Maldonado",
                "shortCode": "MA"
            },
            {
                "value": "Montevideo",
                "label": "Montevideo",
                "shortCode": "MO"
            },
            {
                "value": "Paysandú",
                "label": "Paysandú",
                "shortCode": "PA"
            },
            {
                "value": "Río Negro",
                "label": "Río Negro",
                "shortCode": "RN"
            },
            {
                "value": "Rivera",
                "label": "Rivera",
                "shortCode": "RV"
            },
            {
                "value": "Rocha",
                "label": "Rocha",
                "shortCode": "RO"
            },
            {
                "value": "Salto",
                "label": "Salto",
                "shortCode": "SA"
            },
            {
                "value": "San José",
                "label": "San José",
                "shortCode": "SJ"
            },
            {
                "value": "Soriano",
                "label": "Soriano",
                "shortCode": "SO"
            },
            {
                "value": "Tacuarembó",
                "label": "Tacuarembó",
                "shortCode": "TA"
            },
            {
                "value": "Treinta y Tres",
                "label": "Treinta y Tres",
                "shortCode": "TT"
            }
        ]
    },
    {
        "countryCode": "+998",
        "value": "Uzbekistan",
        "label": "Uzbekistan",
        "regions": [
            {
                "value": "Toshkent shahri",
                "label": "Toshkent shahri",
                "shortCode": "TK"
            },
            {
                "value": "Andijon",
                "label": "Andijon",
                "shortCode": "AN"
            },
            {
                "value": "Buxoro",
                "label": "Buxoro",
                "shortCode": "BU"
            },
            {
                "value": "Farg‘ona",
                "label": "Farg‘ona",
                "shortCode": "FA"
            },
            {
                "value": "Jizzax",
                "label": "Jizzax",
                "shortCode": "JI"
            },
            {
                "value": "Namangan",
                "label": "Namangan",
                "shortCode": "NG"
            },
            {
                "value": "Navoiy",
                "label": "Navoiy",
                "shortCode": "NW"
            },
            {
                "value": "Qashqadaryo (Qarshi)",
                "label": "Qashqadaryo (Qarshi)",
                "shortCode": "QA"
            },
            {
                "value": "Samarqand",
                "label": "Samarqand",
                "shortCode": "SA"
            },
            {
                "value": "Sirdaryo (Guliston)",
                "label": "Sirdaryo (Guliston)",
                "shortCode": "SI"
            },
            {
                "value": "Surxondaryo (Termiz)",
                "label": "Surxondaryo (Termiz)",
                "shortCode": "SU"
            },
            {
                "value": "Toshkent wiloyati",
                "label": "Toshkent wiloyati",
                "shortCode": "TO"
            },
            {
                "value": "Xorazm (Urganch)",
                "label": "Xorazm (Urganch)",
                "shortCode": "XO"
            },
            {
                "value": "Qoraqalpog‘iston Respublikasi (Nukus)",
                "label": "Qoraqalpog‘iston Respublikasi (Nukus)",
                "shortCode": "QR"
            }
        ]
    },
    {
        "countryCode": "+678",
        "value": "Vanuatu",
        "label": "Vanuatu",
        "regions": [
            {
                "value": "Malampa",
                "label": "Malampa",
                "shortCode": "MAP"
            },
            {
                "value": "Pénama",
                "label": "Pénama",
                "shortCode": "PAM"
            },
            {
                "value": "Sanma",
                "label": "Sanma",
                "shortCode": "SAM"
            },
            {
                "value": "Shéfa",
                "label": "Shéfa",
                "shortCode": "SEE"
            },
            {
                "value": "Taféa",
                "label": "Taféa",
                "shortCode": "TAE"
            },
            {
                "value": "Torba",
                "label": "Torba",
                "shortCode": "TOB"
            }
        ]
    },
    {
        "countryCode": "+84",
        "value": "Vietnam",
        "label": "Vietnam",
        "regions": [
            {
                "value": "An Giang",
                "label": "An Giang",
                "shortCode": "44"
            },
            {
                "value": "Bà Rịa - Vũng Tàu",
                "label": "Bà Rịa - Vũng Tàu",
                "shortCode": "43"
            },
            {
                "value": "Bình Dương",
                "label": "Bình Dương",
                "shortCode": "57"
            },
            {
                "value": "Bình Phước",
                "label": "Bình Phước",
                "shortCode": "58"
            },
            {
                "value": "Bình Định",
                "label": "Bình Định",
                "shortCode": "31"
            },
            {
                "value": "Bình Thuận",
                "label": "Bình Thuận",
                "shortCode": "40"
            },
            {
                "value": "Bạc Liêu",
                "label": "Bạc Liêu",
                "shortCode": "55"
            },
            {
                "value": "Bắc Giang",
                "label": "Bắc Giang",
                "shortCode": "54"
            },
            {
                "value": "Bắc Kạn",
                "label": "Bắc Kạn",
                "shortCode": "53"
            },
            {
                "value": "Bắc Ninh",
                "label": "Bắc Ninh",
                "shortCode": "56"
            },
            {
                "value": "Bến Tre",
                "label": "Bến Tre",
                "shortCode": "50"
            },
            {
                "value": "Cao Bằng",
                "label": "Cao Bằng",
                "shortCode": "04"
            },
            {
                "value": "Cà Mau",
                "label": "Cà Mau",
                "shortCode": "59"
            },
            {
                "value": "Đắk Lắk",
                "label": "Đắk Lắk",
                "shortCode": "33"
            },
            {
                "value": "Đắk Nông",
                "label": "Đắk Nông",
                "shortCode": "72"
            },
            {
                "value": "Điện Biên",
                "label": "Điện Biên",
                "shortCode": "71"
            },
            {
                "value": "Đồng Nai",
                "label": "Đồng Nai",
                "shortCode": "39"
            },
            {
                "value": "Đồng Tháp",
                "label": "Đồng Tháp",
                "shortCode": "45"
            },
            {
                "value": "Gia Lai",
                "label": "Gia Lai",
                "shortCode": "30"
            },
            {
                "value": "Hà Giang",
                "label": "Hà Giang",
                "shortCode": "03"
            },
            {
                "value": "Hà Nam",
                "label": "Hà Nam",
                "shortCode": "63"
            },
            {
                "value": "Hà Tây",
                "label": "Hà Tây",
                "shortCode": "15"
            },
            {
                "value": "Hà Tĩnh",
                "label": "Hà Tĩnh",
                "shortCode": "23"
            },
            {
                "value": "Hải Dương",
                "label": "Hải Dương",
                "shortCode": "61"
            },
            {
                "value": "Hậu Giang",
                "label": "Hậu Giang",
                "shortCode": "73"
            },
            {
                "value": "Hòa Bình",
                "label": "Hòa Bình",
                "shortCode": "14"
            },
            {
                "value": "Hưng Yên",
                "label": "Hưng Yên",
                "shortCode": "66"
            },
            {
                "value": "Khánh Hòa",
                "label": "Khánh Hòa",
                "shortCode": "34"
            },
            {
                "value": "Kiên Giang",
                "label": "Kiên Giang",
                "shortCode": "47"
            },
            {
                "value": "Kon Tum",
                "label": "Kon Tum",
                "shortCode": "28"
            },
            {
                "value": "Lai Châu",
                "label": "Lai Châu",
                "shortCode": "01"
            },
            {
                "value": "Lâm Đồng",
                "label": "Lâm Đồng",
                "shortCode": "35"
            },
            {
                "value": "Lạng Sơn",
                "label": "Lạng Sơn",
                "shortCode": "09"
            },
            {
                "value": "Lào Cai",
                "label": "Lào Cai",
                "shortCode": "02"
            },
            {
                "value": "Long An",
                "label": "Long An",
                "shortCode": "41"
            },
            {
                "value": "Nam Định",
                "label": "Nam Định",
                "shortCode": "67"
            },
            {
                "value": "Nghệ An",
                "label": "Nghệ An",
                "shortCode": "22"
            },
            {
                "value": "Ninh Bình",
                "label": "Ninh Bình",
                "shortCode": "18"
            },
            {
                "value": "Ninh Thuận",
                "label": "Ninh Thuận",
                "shortCode": "36"
            },
            {
                "value": "Phú Thọ",
                "label": "Phú Thọ",
                "shortCode": "68"
            },
            {
                "value": "Phú Yên",
                "label": "Phú Yên",
                "shortCode": "32"
            },
            {
                "value": "Quảng Bình",
                "label": "Quảng Bình",
                "shortCode": "24"
            },
            {
                "value": "Quảng Nam",
                "label": "Quảng Nam",
                "shortCode": "27"
            },
            {
                "value": "Quảng Ngãi",
                "label": "Quảng Ngãi",
                "shortCode": "29"
            },
            {
                "value": "Quảng Ninh",
                "label": "Quảng Ninh",
                "shortCode": "13"
            },
            {
                "value": "Quảng Trị",
                "label": "Quảng Trị",
                "shortCode": "25"
            },
            {
                "value": "Sóc Trăng",
                "label": "Sóc Trăng",
                "shortCode": "52"
            },
            {
                "value": "Sơn La",
                "label": "Sơn La",
                "shortCode": "05"
            },
            {
                "value": "Tây Ninh",
                "label": "Tây Ninh",
                "shortCode": "37"
            },
            {
                "value": "Thái Bình",
                "label": "Thái Bình",
                "shortCode": "20"
            },
            {
                "value": "Thái Nguyên",
                "label": "Thái Nguyên",
                "shortCode": "69"
            },
            {
                "value": "Thanh Hóa",
                "label": "Thanh Hóa",
                "shortCode": "21"
            },
            {
                "value": "Thừa Thiên–Huế",
                "label": "Thừa Thiên–Huế",
                "shortCode": "26"
            },
            {
                "value": "Tiền Giang",
                "label": "Tiền Giang",
                "shortCode": "46"
            },
            {
                "value": "Trà Vinh",
                "label": "Trà Vinh",
                "shortCode": "51"
            },
            {
                "value": "Tuyên Quang",
                "label": "Tuyên Quang",
                "shortCode": "07"
            },
            {
                "value": "Vĩnh Long",
                "label": "Vĩnh Long",
                "shortCode": "49"
            },
            {
                "value": "Vĩnh Phúc",
                "label": "Vĩnh Phúc",
                "shortCode": "70"
            },
            {
                "value": "Yên Bái",
                "label": "Yên Bái",
                "shortCode": "06"
            },
            {
                "value": "Cần Thơ",
                "label": "Cần Thơ",
                "shortCode": "CT"
            },
            {
                "value": "Đà Nẵng",
                "label": "Đà Nẵng",
                "shortCode": "DN"
            },
            {
                "value": "Hà Nội",
                "label": "Hà Nội",
                "shortCode": "HN"
            },
            {
                "value": "Hải Phòng",
                "label": "Hải Phòng",
                "shortCode": "HP"
            },
            {
                "value": "Hồ Chí Minh (Sài Gòn)",
                "label": "Hồ Chí Minh (Sài Gòn)",
                "shortCode": "SG"
            }
        ]
    },
    {
        "countryCode": "+681",
        "value": "Wallis and Futuna",
        "label": "Wallis and Futuna",
        "regions": [
            {
                "value": "Alo",
                "label": "Alo",
                "shortCode": "ALO"
            },
            {
                "value": "Sigave",
                "label": "Sigave",
                "shortCode": "SIG"
            },
            {
                "value": "Wallis",
                "label": "Wallis",
                "shortCode": "WAL"
            }
        ]
    },
    {
        "countryCode": "+967",
        "value": "Yemen",
        "label": "Yemen",
        "regions": [
            {
                "value": "Abyān",
                "label": "Abyān",
                "shortCode": "AB"
            },
            {
                "value": "'Adan",
                "label": "'Adan",
                "shortCode": "AD"
            },
            {
                "value": "Aḑ Ḑāli'",
                "label": "Aḑ Ḑāli'",
                "shortCode": "DA"
            },
            {
                "value": "Al Bayḑā'",
                "label": "Al Bayḑā'",
                "shortCode": "BA"
            },
            {
                "value": "Al Ḩudaydah",
                "label": "Al Ḩudaydah",
                "shortCode": "HU"
            },
            {
                "value": "Al Jawf",
                "label": "Al Jawf",
                "shortCode": "JA"
            },
            {
                "value": "Al Mahrah",
                "label": "Al Mahrah",
                "shortCode": "MR"
            },
            {
                "value": "Al Maḩwīt",
                "label": "Al Maḩwīt",
                "shortCode": "MW"
            },
            {
                "value": "'Amrān",
                "label": "'Amrān",
                "shortCode": "AM"
            },
            {
                "value": "Dhamār",
                "label": "Dhamār",
                "shortCode": "DH"
            },
            {
                "value": "Ḩaḑramawt",
                "label": "Ḩaḑramawt",
                "shortCode": "HD"
            },
            {
                "value": "Ḩajjah",
                "label": "Ḩajjah",
                "shortCode": "HJ"
            },
            {
                "value": "Ibb",
                "label": "Ibb",
                "shortCode": "IB"
            },
            {
                "value": "Laḩij",
                "label": "Laḩij",
                "shortCode": "LA"
            },
            {
                "value": "Ma'rib",
                "label": "Ma'rib",
                "shortCode": "MA"
            },
            {
                "value": "Raymah",
                "label": "Raymah",
                "shortCode": "RA"
            },
            {
                "value": "Şā‘dah",
                "label": "Şā‘dah",
                "shortCode": "SD"
            },
            {
                "value": "Şan‘ā'",
                "label": "Şan‘ā'",
                "shortCode": "SN"
            },
            {
                "value": "Shabwah",
                "label": "Shabwah",
                "shortCode": "SH"
            },
            {
                "value": "Tā‘izz",
                "label": "Tā‘izz",
                "shortCode": "TA"
            }
        ]
    },
    {
        "countryCode": "+260",
        "value": "Zambia",
        "label": "Zambia",
        "regions": [
            {
                "value": "Central",
                "label": "Central",
                "shortCode": "02"
            },
            {
                "value": "Copperbelt",
                "label": "Copperbelt",
                "shortCode": "08"
            },
            {
                "value": "Eastern",
                "label": "Eastern",
                "shortCode": "03"
            },
            {
                "value": "Luapula",
                "label": "Luapula",
                "shortCode": "04"
            },
            {
                "value": "Lusaka",
                "label": "Lusaka",
                "shortCode": "09"
            },
            {
                "value": "Muchinga",
                "label": "Muchinga",
                "shortCode": "10"
            },
            {
                "value": "Northern",
                "label": "Northern",
                "shortCode": "05"
            },
            {
                "value": "North-Western",
                "label": "North-Western",
                "shortCode": "06"
            },
            {
                "value": "Southern",
                "label": "Southern",
                "shortCode": "07"
            },
            {
                "value": "Western",
                "label": "Western",
                "shortCode": "01"
            }
        ]
    },
    {
        "countryCode": "+263",
        "value": "Zimbabwe",
        "label": "Zimbabwe",
        "regions": [
            {
                "value": "Bulawayo",
                "label": "Bulawayo",
                "shortCode": "BU"
            },
            {
                "value": "Harare",
                "label": "Harare",
                "shortCode": "HA"
            },
            {
                "value": "Manicaland",
                "label": "Manicaland",
                "shortCode": "MA"
            },
            {
                "value": "Mashonaland Central",
                "label": "Mashonaland Central",
                "shortCode": "MC"
            },
            {
                "value": "Mashonaland East",
                "label": "Mashonaland East",
                "shortCode": "ME"
            },
            {
                "value": "Mashonaland West",
                "label": "Mashonaland West",
                "shortCode": "MW"
            },
            {
                "value": "Masvingo",
                "label": "Masvingo",
                "shortCode": "MV"
            },
            {
                "value": "Matabeleland North",
                "label": "Matabeleland North",
                "shortCode": "MN"
            },
            {
                "value": "Matabeleland South",
                "label": "Matabeleland South",
                "shortCode": "MS"
            },
            {
                "value": "Midlands",
                "label": "Midlands",
                "shortCode": "MI"
            }
        ]
    }
]
